const slokas = [

    {
        "CatID": [
            {
                "title": "అర్జున విషాద యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/01.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/01.png'),
                "index":1,
                "introduction": [
                    {
                        "para": "దాయాదులైన కౌరవులు, పాండవుల మధ్య మొదలవ్వబోతున్న మహాభారత సంగ్రామ యుద్ధ భూమియందు భగవద్గీత చెప్పబడింది. ఈ భారీ యుద్ధానికి దారి తీసిన పరిణామాల యొక్క వివరణాత్మక వర్ణన ఈ పుస్తకం యొక్క ఉపోద్ఘాతం అధ్యాయంలో, భగవద్గీత సమయ పరిస్థితి అనే భాగంలో చెప్పబడింది."
                    },
                    {
                        "para": "ధృతరాష్ట్ర మహారాజు, అతని మంత్రి సంజయునికి మధ్య జరిగిన సంభాషణ రూపంలో భగవద్గీత విశదీకరింపబడటం మొదలు అవుతుంది. ధృతరాష్ట్రుడు అంధుడైన కారణం చేత, తానే స్వయంగా యుద్ధభూమి యందు లేడు, అందుకే సంజయుడు అతనికి యుద్ధ రంగ విశేషాలని యథాతథంగా చెప్పుచున్నాడు. సంజయుడు, మహాభారతాన్ని రచించిన మహాత్ముడు, వేద వ్యాసుని శిష్యుడు. వేద వ్యాసునికి సుదూరంలో జరిగే విషయాలని చూసే దివ్య శక్తి వుంది. తన గురువుగారి కృప వలన సంజయుడికి కూడా ఆ దివ్య శక్తి ప్రాప్తించింది. అందుకే సంజయుడు దూరంనించే యుద్ధ భూమిలో జరిగేవన్నీ చూడగలుగుతున్నాడు."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "ధృతరాష్ట్రుడు పలికెను: ఓ సంజయా, ధర్మభూమి అయిన కురుక్షేత్రం లో కూడియుండి, యుద్ధానికి సన్నద్ధమైన నా పుత్రులు మరియు పాండు పుత్రులు ఏమి చేసారు?",
                        "description": [
                            {
                                "des": "ధృతరాష్ట్ర ఉవాచ ।"
                            },
                            {
                                "des": "ధర్మ క్షేత్రే కురుక్షేత్రే సమవేతా యుయుత్సవః ।"
                            },
                            {
                                "des": "మామకాః పాండవాశ్చైవ కిమకుర్వత సంజయ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను: సైనిక వ్యూహాత్మకంగా నిలిపి ఉన్న పాండవ సైన్యాన్ని చూచిన దుర్యోధనుడు తన గురువు ద్రోణాచార్యుడిని సమీపించి ఈ విధంగా పలికెను.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "దృష్ట్వా తు పాండవానీకం వ్యూఢం దుర్యోధనస్తదా ।"
                            },
                            {
                                "des": "ఆచార్యముపసంగమ్య రాజా వచనమబ్రవీత్ ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "దుర్యోధనుడు పలికెను:  గౌరవనీయులైన గురువర్యా! మీ ప్రియ శిష్యుడు, ద్రుపద పుత్రుడిచే అత్యంత వ్యూహాత్మకంగా నిలుప బడిన ఈ పాండవుల మహా సైన్యాన్ని చూడుము.",
                        "description": [
                            {
                                "des": "పశ్యైతాం పాండుపుత్రాణామ్ ఆచార్య మహతీం చమూమ్ ।"
                            },
                            {
                                "des": "వ్యూఢాం ద్రుపదపుత్రేణ తవ శిష్యేణ ధీమతా ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4-6 శ్లోకాలు",
                        "bhavam": "వారి పక్షాన సైన్యంలో ఉన్న ఎంతోమంది శక్తివంతమైన యోధులను చూడండి - యుయుధానుడు, విరాటుడు మరియు ద్రుపదుడు వంటి వారు గొప్ప ధనుస్సులను ధరించి ఉన్నారు మరియు వారు భీమార్జునులతో సమానమైన వారు. అక్కడున్న పరాక్రమవంతులైన ధృష్టకేతుడు, చెకితానుడు, వీరుడైన కాశీరాజు, పురుజిత్తు, కుంతిభోజుడు మరియు శైబ్యుడు - వీరందరూ ఉత్తమ పురుషులే. వారి సైన్యంలో ఉన్నటువంటి - ధైర్యశాలి యుధామన్యుడు, వీరుడైన ఉత్తమౌజుడు, సుభద్ర కుమారుడు, ద్రౌపది పుత్రులు - వీరందరూ యుద్ధ వీరులే.",
                        "description": [
                            {
                                "des": "అత్ర శూరా మహేష్వాసా భీమార్జునసమా యుధి ।"
                            },
                            {
                                "des": "యుయుధానో విరాటశ్చ ద్రుపదశ్చ మహారథః ।। 4 ।।"
                            },
                            {
                                "des": "ధృష్టకేతుశ్చేకితానః కాశీరాజశ్చ వీర్యవాన్ ।"
                            },
                            {
                                "des": "పురుజిత్ కుంతిభోజశ్చ శైబ్యశ్చ నరపుంగవః ।। 5 ।।"
                            },
                            {
                                "des": "యుధామన్యుశ్చ విక్రాంత ఉత్తమౌజాశ్చ వీర్యవాన్ ।"
                            },
                            {
                                "des": "సౌభద్రో ద్రౌపదేయాశ్చ సర్వ ఏవ మహారథాః ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఓ బ్రాహ్మణోత్తమా, మన పక్షం లో ఉన్న ప్రధాన యోధుల గురించి కూడా వినుము, వీరు నాయకులుగా అత్యంత యోగ్యమైన వారు. మీ ఎరుకకై ఇప్పుడు వీరి గురించి తెలుపుచున్నాను.",
                        "description": [
                            {
                                "des": "అస్మాకం తు విశిష్టా యే తాన్నిబోధ ద్విజోత్తమ ।"
                            },
                            {
                                "des": "నాయకా మమ సైన్యస్య సంజ్ఞార్థం తాన్ బ్రవీమి తే ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "మీరును, భీష్ముడు, కర్ణుడు, కృపాచార్యుడు, అశ్వత్థామ, వికర్ణుడు మరియు భూరిశ్రవుడు - వీరందరూ  ఎప్పటికీ యుద్ధములో విజయులే.",
                        "description": [
                            {
                                "des": "భవాన్ భీష్మశ్చ కర్ణశ్చ కృపశ్చ సమితింజయః ।"
                            },
                            {
                                "des": "అశ్వత్థామా వికర్ణశ్చ సౌమదత్తిస్తథైవ చ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "ఇంకా చాలా మంది వీరయోధులు నా కోసం ప్రాణాలు అర్పించటానికి సిద్దంగా వున్నారు. అనేక ఆయుధములతో  ఉన్న వీరందరూ యుద్దవిద్య లో ప్రావీణ్యం కలవారే.",
                        "description": [
                            {
                                "des": "అన్యే చ బహవః శూరా మదర్థే త్యక్తజీవితాః ।"
                            },
                            {
                                "des": "నానాశస్త్ర ప్రహరణాః సర్వే యుద్ధవిశారదాః ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "మన సైనిక బలం అపరిమితమైనది మరియు మనం భీష్మ పితామహుడిచే రక్షింపబడుతున్నాము, కానీ, భీముడిచే రక్షింపబడుచున్న పాండవసైన్యం పరిమితమైనది.",
                        "description": [
                            {
                                "des": "అపర్యాప్తం తదస్మాకం బలం భీష్మాభిరక్షితం।"
                            },
                            {
                                "des": "పర్యాప్తం త్విదమేతేషాం బలం భీమాభిరక్షితం ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "కావున, కౌరవ సేనా నాయకులందరికీ, మీమీ వ్యూహాత్మక స్థానాలను పరిరక్షిస్తూ భీష్మ పితామహుడికి పూర్తి సహకారం అందించమని పిలుపునిస్తున్నాను.",
                        "description": [
                            {
                                "des": "అయనేషు చ సర్వేషు యథాభాగమవస్థితాః ।"
                            },
                            {
                                "des": "భీష్మమేవాభిరక్షంతు భవంతః సర్వ ఏవ హి ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "అప్పుడు, కురు వంశ వృద్ద పితామహుడు, మహోన్నత మూలపురుషుడు అయిన భీష్ముడు, సింహంలా గర్జించి, తన శంఖాన్ని పెద్ద శబ్దంతో పూరించాడు; ఇది దుర్యోధనుడికి హర్షమును కలుగచేసింది.",
                        "description": [
                            {
                                "des": "తస్య సంజనయన్ హర్షం కురువృద్ధః పితామహః ।"
                            },
                            {
                                "des": "సింహనాదం వినద్యోచ్చైః శంఖం దధ్మౌ ప్రతాపవాన్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఆ తరువాత శంఖములు, డోళ్ళు, ఢంకాలు, భేరీలు, కొమ్ము వాద్యములు ఒక్కసారిగా మ్రోగినవి, అవన్నీ కలిసిన శబ్దం భయానకముగా ఉండెను.",
                        "description": [
                            {
                                "des": "తతః శంఖాశ్చ భేర్యశ్చ పణవానకగోముఖాః ।"
                            },
                            {
                                "des": "సహసైవాభ్యహన్యంత స శబ్దస్తుములోఽభవత్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఆ తరువాత, పాండవ సైన్యం మధ్య లోనుండి, తెల్లని గుఱ్ఱములు పూన్చి ఉన్న ఒక అద్భుతమైన రథం లో కూర్చుని ఉన్న, మాధవుడు మరియు అర్జునుడు తమ దివ్య శంఖాలని పూరించారు.",
                        "description": [
                            {
                                "des": "తతః శ్వేతైర్హయైర్యుక్తే మహతి స్యందనే స్థితౌ ।"
                            },
                            {
                                "des": "మాధవః పాండవశ్చైవ దివ్యౌ శంఖౌ ప్రదధ్మతుః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "హృషీకేశుడు 'పాంచజన్యం' అనబడే శంఖాన్ని పూరించాడు. అర్జునుడు దేవదత్తాన్ని పూరించాడు. గొప్పగా భుజించే వాడు, అత్యంత కష్టమైన పనులను చేయునట్టి భీముడు 'పౌండ్రం' అనబడే బ్రహ్మాండమైన శంఖమును పూరించెను.",
                        "description": [
                            {
                                "des": "పాంచజన్యం హృషీకేశో దేవదత్తం ధనంజయః ।"
                            },
                            {
                                "des": "పౌండ్రం దధ్మౌ మహాశంఖం భీమకర్మా వృకోదరః ।। 15 ।।"
                            },
                        ]
                    },
                    {
                        "slokam": "16-18 శ్లోకాలు",
                        "bhavam": "ఓ భూమండలాన్ని పాలించేవాడా! యుధిష్ఠిర మహారాజు అనంతవిజయాన్ని పూరించాడు. నకుల సహదేవులు, సుఘోష మణిపుష్పకములను పూరించారు. గొప్ప  విలుకాడైన  కాశీ రాజు, మహారథుడైన శిఖండి, ధృష్టద్యుమ్నుడు, విరాటుడు, అజేయుడైన సాత్యకి, ద్రుపదుడు, ద్రౌపది యొక్క ఐదుగురు కుమారులు; భుజబలము కలవాడు, సుభద్రా పుత్రుడు అయిన అభిమన్యుడు, వీరందరూ తమ తమ శంఖములను పూరించారు.",
                        "description": [
                            {
                                "des": "అనంతవిజయం రాజా కుంతీపుత్రో యుధిష్ఠిరః ।"
                            },
                            {
                                "des": "నకులః సహదేవశ్చ సుఘోషమణిపుష్పకౌ ।। 16 ।।"
                            },
                            {
                                "des": "కాశ్యశ్చ పరమేష్వాసః శిఖండీ చ మహారథః ।"
                            },
                            {
                                "des": "ధృష్టద్యుమ్నో విరాటశ్చ సాత్యకిశ్చాపరాజితః ।। 17 ।।"
                            },
                            {
                                "des": "ద్రుపదో ద్రౌపదేయాశ్చ సర్వశః పృథివీపతే ।"
                            },
                            {
                                "des": "సౌభద్రశ్చ మహాబాహుః శంఖాన్ దధ్ముః పృథక్ పృథక్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఓ ధృతరాష్ట్రా, ఆ భీకరమైన శబ్దానికి భూమ్యాకాశములు దద్దరిల్లెను; అది మీ తనయుల హృదయాలను బ్రద్దలు చేసెను.",
                        "description": [
                            {
                                "des": "స ఘోషో ధార్తరాష్ట్రాణాం హృదయాని వ్యదారయత్ ।"
                            },
                            {
                                "des": "నభశ్చ పృథివీం చైవ తుములో ఽభ్యనునాదయన్ ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఆ సమయంలో, తన రథం జెండా పై హనుమంతుని చిహ్నం కలిగివున్న పాండు పుత్రుడు అర్జునుడు, తన ధనుస్సుని తీసుకున్నాడు. సమరానికి ఎదురుగా నిలిచిఉన్న మీ పుత్రులను చూసి, ఓ రాజా, అర్జునుడు శ్రీ కృష్ణుడితో ఇలా అన్నాడు.",
                        "description": [
                            {
                                "des": "అథ వ్యవస్థితాన్ దృష్ట్వా ధార్తరాష్ట్రాన్ కపిధ్వజః ।"
                            },
                            {
                                "des": "ప్రవృత్తే శస్త్రసంపాతే ధనురుద్యమ్య పాండవః ।। 20 ।।"
                            },
                            {
                                "des": "హృషీకేశం తదా వాక్యం ఇదమాహ మహీపతే ।"
                            }
                        ]
                    },
                    {
                        "slokam": "21-22 శ్లోకాలు",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు. అచ్యుతా (శ్రీ కృష్ణా), దయచేసి నా రథాన్ని రెండు సైన్యాల మధ్యలో నిలుపుము. ఈ మహా పోరాటంలో, రణరంగంలో నిలిచియున్న ఎవరెవరితో యుద్ధం చేయవలసి ఉన్నదో నేను పరీక్షించాలి.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "సెనయోరుభయోర్మధ్యే రథం స్థాపయ మేఽచ్యుత ।। 21 ।।"
                            },
                            {
                                "des": "యావదేతాన్ నిరీక్షేఽహం యోద్దుకామానవస్థితాన్ ।"
                            },
                            {
                                "des": "కైర్మయా సహ యోద్ధవ్యమ్ అస్మిన్ రణసముద్యమే ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "దుర్బుద్ధిగల ధృతరాష్ట్రుని పుత్రున్ని సంతోషపెట్టడం కొరకు అతని పక్షాన యుద్ధానికి వచ్చియున్న అందరిని ఒకసారి నాకు చూడాలనిపిస్తున్నది.",
                        "description": [
                            {
                                "des": "యోత్స్యమానాన వేక్షేఽహం య ఏతేఽత్ర సమాగతాః ।"
                            },
                            {
                                "des": "ధార్తరాష్ట్రస్య దుర్బుద్దేః యుద్దే ప్రియచికీర్షవః ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "సంజయుడు ఇలా అన్నాడు: ఓ ధృతరాష్ట్రా, ఈ విధంగా, నిద్రని జయించిన వాడైన, అర్జునుడు కోరిన విధంగా, శ్రీ కృష్ణుడు ఆ వైభవోపేతమైన రథమును రెండు సైన్యముల మధ్యకు నడిపించి నిలిపెను",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఏవముక్తో హృషీకేశో గుడాకేశేన భారత ।"
                            },
                            {
                                "des": "సేనయోరుభయోర్మధ్యే స్థాపయిత్వా రథోత్తమమ్ ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "భీష్ముడు, ద్రోణాచార్యుడు మరియు ఇతర రాజుల సమక్షంలో, శ్రీ కృష్ణుడు ఇలా అన్నాడు, ఓ పార్థా, ఇక్కడ కూడి ఉన్న కురు వంశస్థులను చూడుము.",
                        "description": [
                            {
                                "des": "భీష్మద్రోణప్రముఖతః సర్వేషాం చ మహీక్షితామ్ ।"
                            },
                            {
                                "des": "ఉవాచ పార్థ పశ్యైతాన్ సమవేతాన్ కురూనితి ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "అక్కడ అర్జునుడు రెండు సైన్యములలో కూడా ఉన్న తన తండ్రులను, తాతలను, గురువులను, మేనమామలను, సోదరులను, దాయాదులను, పుత్రులను, మనుమలను, మిత్రులను, మామలను ఇంకా శ్రేయోభిలాశులను చూచెను.",
                        "description": [
                            {
                                "des": "తత్రాపశ్యత్ స్థితాన్ పార్థః పిత్రూ నథ పితామహాన్ ।"
                            },
                            {
                                "des": "ఆచార్యాన్మాతులాన్భ్రాతూన్ పుత్రాన్ పౌత్రాన్ సఖీం స్తథా ।। 26 ।।"
                            },
                            {
                                "des": "శ్వశురాన్ సుహృదశ్చైవ సేనాయోరుభయోరపి ।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "అక్కడ ఉన్న తన అందరు బంధువులని చూసిన కుంతీ పుత్రుడు అర్జునుడు, కారుణ్యం తో నిండినవాడై, తీవ్ర విచారానికి లోనై ఈ విధంగా పలికెను.",
                        "description": [
                            {
                                "des": "తాన్ సమీక్ష్య స కౌంతేయః సర్వాన్ బంధూనవస్థితాన్ ।। 27 ।।"
                            },
                            {
                                "des": "కృపయా పరయావిష్టో విషీదన్నిదమబ్రవీత్ ।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు: ఓ కృష్ణా, యుద్ధానికి బారులు తీరి ఒకరినొకరు చంపుకోటానికి పూనుకుంటున్న నా బంధువులను చూసి, నా అవయవాలు పట్టు తప్పుతున్నాయి, ఇంకా నా నోరు ఎండిపోతోంది.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "దృష్ట్వేమం స్వజనం కృష్ణ యుయుత్సుం సముపస్థితమ్ ।। 28 ।।"
                            },
                            {
                                "des": "సీదంతి మమ గాత్రాణి ముఖం చ పరిశుష్యతి ।"
                            }
                        ]
                    },
                    {
                        "slokam": "29-31 శ్లోకాలు",
                        "bhavam": "నా శరీరమంతా వణుకుచున్నది; వెంట్రుకలు నిక్కబొడుచుకుంటున్నాయి.  నా విల్లు, గాండీవం, చేజారి పోతున్నది ఇంకా నా చర్మమంతా తపించిపోవుచున్నది. నా మనస్సు ఏమీ తోచని స్థితిలో అయోమయంగా తిరుగుతున్నది. ఇక నన్ను నేను స్థిరంగా ఉంచుకోలేకపోతున్నాను. ఓ కృష్ణా, కేశి రాక్షసుడను సంహరించినవాడా (కేశవః), అంతటా అశుభ శకునములే కనపడుతున్నాయి. ఈ యుద్ధంలో సొంత బంధువులనే చంపుకోవటం వలన, మంచి ఎలా కలుగుతుందో నేను చూడలేకున్నాను.",
                        "description": [
                            {
                                "des": "వేపథుశ్చ శరీరే మే రోమహర్షశ్చ జాయతే ।। 29 ।।"
                            },
                            {
                                "des": "గాండీవం స్రంసతే హస్తాత్ త్వక్చైవ పరిదహ్యతే ।"
                            },
                            {
                                "des": "న చ శక్నోమ్యవస్థాతుం భ్రమతీవ చ మే మనః ।। 30 ।।"
                            },
                            {
                                "des": "నిమిత్తాని చ పశ్యామి విపరీతాని కేశవ ।"
                            },
                            {
                                "des": "న చ శ్రేయోఽనుపశ్యామి హత్వా స్వజనమాహవే  ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32-33 శ్లోకాలు",
                        "bhavam": "ఓ కృష్ణా, నాకు విజయం కానీ, రాజ్యం కానీ, వాటివల్ల వచ్చే సుఖం కానీ అక్కరలేదు. మనం ఎవరికోసమైతే ఇదంతా కోరుకుంటున్నామో వారే మన ఎదురుగా యుద్ధం కోసం ఉన్నప్పుడు,  రాజ్యం వలన కానీ, సుఖాల వలన కానీ, ఇక ఈ జీవితం వలన కానీ ప్రయోజనం ఏముంది?",
                        "description": [
                            {
                                "des": "న కాంక్షే విజయం కృష్ణ న చ రాజ్యం సుఖాని చ ।"
                            },
                            {
                                "des": "కిం నో రాజ్యేన గోవింద కిం భోగైర్జీవితేన వా ।। 32 ।।"
                            },
                            {
                                "des": "యేషామర్థే కాంక్షితం నో రాజ్యం భోగాః సుఖాని చ ।"
                            },
                            {
                                "des": "త ఇమేఽవస్థితా యుద్ధే ప్రాణాంస్త్యక్త్వా ధనాని చ ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34-35 శ్లోకాలు",
                        "bhavam": "గురువులు, తండ్రులు, కొడుకులు, మేనమామలు, మనుమలు, మామలు, బావ మరుదులు ఇంకా ఇతర బంధువులు, ప్రాణాలను, ధనాన్ని పణంగా పెట్టి మరీ, ఇక్కడ చేరి వున్నారు.  ఓ మధుసూదనా, నా మీద దాడి చేసిననూ నేను వీరిని చంపను. ధృతరాష్ట్రుని పుత్రులని సంహరించి, ముల్లోకముల పై ఆధిపత్యం సాధించినా, ఏం తృప్తి ఉంటుంది మనకు, ఇక ఈ భూమండలము కోసమైతే ఏమి చెప్పను?",
                        "description": [
                            {
                                "des": "ఆచార్యాః పితరః పుత్రాస్తథైవ చ పితామహాః ।"
                            },
                            {
                                "des": "మాతులాః శ్వశురాః పౌత్రాః శ్యాలాః సంబంధినస్తథా ।। 34 ।।"
                            },
                            {
                                "des": "ఏతాన్న హంతుమిఛ్చామి ఘ్నఽతోపి మధుసూదన ।"
                            },
                            {
                                "des": "అపి త్రైలోక్య రాజ్యస్య హేతోః కిం ను మహీకృతే ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36-37 శ్లోకాలు",
                        "bhavam": "ఓ జనార్ధనా (సర్వ భూతముల సంరక్షకుడు, పోషకుడు అయినవాడా), ధృతరాష్ట్ర తనయులను చంపి మనము ఎలా సంతోషముగా ఉండగలము? వారు దుర్మార్గపు దురాక్రమణదారు లయినా, వారిని సంహరిస్తే  మనకు పాపం తప్పకుండా చుట్టుకుంటుంది. కాబట్టి ధృతరాష్ట్రుని పుత్రులను, స్నేహితులను చంపటం మనకు తగదు. ఓ మాధవా (కృష్ణా), మన సొంత వారినే చంపుకుని మనం సుఖం గా ఎలా ఉండగలము?",
                        "description": [
                            {
                                "des": "నిహత్య ధార్తరాష్ట్రాన్నః కా ప్రీతిః  స్యాజ్జనార్దన ।"
                            },
                            {
                                "des": "పాపమేవాశ్రయేదస్మాన్ హత్వైతానాతతాయినః ।। 36 ।।"
                            },
                            {
                                "des": "తస్మాన్నార్హా వయం హంతుం ధార్తరాష్ట్రాన్ స్వబాంధవాన్ ।"
                            },
                            {
                                "des": "స్వజనం హి కథం హత్వా సుఖినః స్యామ మాధవ ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38-39 శ్లోకాలు",
                        "bhavam": "దురాశచే వారి ఆలోచనలు భ్రష్టు పట్టి, బంధువులను సర్వనాశనం చేయటం లో గానీ, మిత్రులపై కక్ష తీర్చుకుని విశ్వాసఘాతుకత్వం చేయటం లో గాని, వారు దోషం చూడటం లేదు. కానీ, ఓ జనార్ధనా, మనవారినే చంపటం లో ఉన్న దోషాన్ని చక్కగా చూడగలిగిన మనము, ఈ పాపపు పని నుండి ఎందుకు తప్పుకోకూడదు?",
                        "description": [
                            {
                                "des": "యద్యప్యేతే న పశ్యంతి లోభోపహతచేతసః ।"
                            },
                            {
                                "des": "కులక్షయకృతం దోషం మిత్రద్రోహే చ పాతకమ్ ।। 38 ।।"
                            },
                            {
                                "des": "కథం న జ్ఞేయమస్మాభిః పాపాదస్మాన్నివర్తితుమ్ ।"
                            },
                            {
                                "des": "కులక్షయకృతం దోషం ప్రపశ్యద్భిర్జనార్ధన ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "వంశము నాశనమయినప్పుడు, వంశాచారములన్నీ లుప్తమవును; మిగిలిన కుటుంబసభ్యులు అధర్మపరులు అగుదురు.",
                        "description": [
                            {
                                "des": "కులక్షయే ప్రణశ్యంతి కులధర్మాః సనాతనాః ।"
                            },
                            {
                                "des": "ధర్మే నష్టే కులం కృత్స్నమ్ అధర్మోఽభిభవత్యుత ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "దుర్గుణాలు ప్రబలిపోవటం వలన, ఓ కృష్ణా, కుల స్త్రీలు నీతి తప్పిన వారు అగుదురు, మరియు స్త్రీల యొక్క అనైతిక ప్రవర్తన వలన, ఓ వృష్ణి వంశస్తుడా, అవాంఛిత సంతానం జన్మిస్తారు.",
                        "description": [
                            {
                                "des": "అధర్మాభిభవాత్ కృష్ణ ప్రదుష్యంతి కులస్త్రియః ।"
                            },
                            {
                                "des": "స్త్రీషు దుష్టాసు వార్ష్ణేయ జాయతే వర్ణసంకరః ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42 వ శ్లోకం",
                        "bhavam": "అవాంఛిత సంతానం పెరగటం వలన కులమునకు, కుల నాశనము చేసిన వారికి కూడా నరకము ప్రాప్తించును. శ్రాద్ద తర్పణములు లుప్తమయిన కారణముగా ఆ భ్రష్టుపట్టిన వంశ పూర్వీకులు కూడా పతనమవుదురు.",
                        "description": [
                            {
                                "des": "సంకరో నరకాయైవ కులఘ్నానాం కులస్య చ ।"
                            },
                            {
                                "des": "పతంతి పితరో హ్యేషాం లుప్తపిండోదకక్రియాః ।। 42 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "43 వ శ్లోకం",
                        "bhavam": "కుటుంబ ఆచారము నాశనము చేసి, అవాంఛిత సంతానం పెంపొందటానికి కారణమైన వారి దుష్ట చేష్టల వలన అనేకానేక సామాజిక, కుటుంబ సంక్షేమ ధర్మములు నశించిపోవును.",
                        "description": [
                            {
                                "des": "దోషైరేతైః కులఘ్నానాం వర్ణసంకరకారకైః ।"
                            },
                            {
                                "des": "ఉత్సాద్యంతే జాతిధర్మాః కులధర్మాశ్చ శాశ్వతాః ।। 43 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "44 వ శ్లోకం",
                        "bhavam": "ఓ జనార్ధనా (కృష్ణా), కులాచారములను నాశనం చేసిన వారు నిరవధికముగా నరకములోనే ఉంటారని, నేను పండితుల నుండి వినియున్నాను;",
                        "description": [
                            {
                                "des": "ఉత్సన్నకులధర్మాణామ్ మనుష్యాణాం జనార్ధన ।"
                            },
                            {
                                "des": "నరకేఽనియతం వాసో భవతీత్యనుశుశ్రుమ ।। 44 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "45-46 శ్లోకాలు",
                        "bhavam": "అయ్యో! ఎంత ఆశ్చర్యం, ఈ మహాపాపం చేయటానికి నిశ్చయించాము. రాజ్య సుఖములపై కాంక్ష తో మన బంధువులనే చంపటానికి సిద్దపడ్డాము. ఆయుధాలు చేతిలో ఉన్న ధృతరాష్ట్రుని పుత్రులు, ఆయుధాలు లేకుండా ప్రతిఘటించకుండా ఉన్న నన్ను యుద్ధభూమిలో చంపివేసినా, దీనికంటే మేలే.",
                        "description": [
                            {
                                "des": "అహో బత మహత్పాపం కర్తుం వ్యవసితా వయమ్ ।"
                            },
                            {
                                "des": "యద్రాజ్యసుఖలోభేన హంతుం స్వజనముద్యతాః ।। 45 ।।"
                            },
                            {
                                "des": "యది మామప్రతీకారమశస్త్రం శస్త్రపాణయః ।"
                            },
                            {
                                "des": "ధార్తరాష్ట్రా రణే హన్యుః తన్మే క్షేమతరం భవేత్ ।। 46 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "47 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను: ఈ విధంగా పలికిన అర్జునుడు, దీనస్థితిలో, తీవ్ర శోకసంతుప్తుడై తన బాణాలను, ధనుస్సును పక్కన జారవిడిచి, రథం లో కూలబడ్డాడు.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఏవముక్త్వార్జునః సంఖ్యే రథోపస్థ ఉపావిశత్ ।"
                            },
                            {
                                "des": "విసృజ్య సశరం చాపం శోకసంవిగ్నమానసః ।। 47 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "సంఖ్య యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/02.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/02.png'),
                "index":2,
                "introduction": [
                    {
                        "para": "ఈ అధ్యాయములో అర్జునుడు, పరిస్థితిని తట్టుకోవడంలో ఉన్న తన పూర్తి అశక్తతని పునరుద్ఘాటించి, ఆసన్నమైన యుద్దంలో తన విధిని నిర్వర్తించడానికి నిరాకరించాడు. ఆ తరువాత శ్రీ కృష్ణుడిని తన ఆధ్యాత్మిక గురువు గా ఉండమని పద్ధతి ప్రకారముగా, మర్యాదపూర్వకంగా ప్రాధేయపడి, తను ఉన్న ఈ పరిస్థితిలో ఏమి చెయ్యాలో తనకు దిశానిర్దేశము చేయమని శ్రీ కృష్ణుడిని బ్రతిమాలతాడు. శరీరము నశించినా, నశించిపోని, మరణము లేని ఆత్మ గురించి చెప్పటం ద్వారా దివ్య జ్ఞానాన్ని విశదీకరించటం ప్రారంభిస్తాడు, ఆ పరమాత్మ. ఒక మనిషి పాత బట్టలు తీసివేసి కొత్త బట్టలు ఎలాగైతే వేసుకుంటాడో ఆత్మ అనేది కేవలం ఒక జీవిత కాలం నుండి ఇంకో జీవిత కాలానికి శరీరాలను మార్చుకుంటుంది. ఆ తరువాత శ్రీ కృష్ణుడు సామాజిక భాధ్యతల గురించి ప్రస్తావిస్తాడు. ధర్మాన్ని పరిరక్షించడానికి యుద్ధం చేయవలసిన తన క్షత్రియ భాద్యతలను అర్జునుడికి గుర్తుచేస్తాడు. సామాజిక భాధ్యతని నిర్వర్తించటం ఒక పవిత్రమైన ధర్మమని, అది ఉత్తమ గతుల వైపు దారి చూపుతుందని, అదేసమయంలో, కర్తవ్య ఉల్లంఘన వలన అవమానము, తలవంపు, అపకీర్తి కలుగుతాయని చెప్తాడు."
                    },
                    {
                        "para": "అర్జునుడిని లౌకిక స్థాయి నుండి పైకి తీసిన శ్రీ కృష్ణుడు, తదుపరి, కర్మ శాస్త్రాన్ని లోతుగా విశదీకరిస్తాడు. కర్మ ఫలాలపై అనురక్తి పెంచుకోకుండా కర్మలను ఆచరించమని అర్జునుడికి సూచిస్తాడు. ప్రతిఫలాన్ని ఆశించకుండా కర్మలని ఆచరించడాన్ని 'బుద్ధి యోగము' అన్నాడు. బుద్దిని ఉపయోగించి మనము కర్మ ప్రతిఫల కాంక్షని నిగ్రహించాలి. ఇలాంటి దృక్పథంతో పని చేస్తే, బంధాన్ని కలిగించే కర్మలే, బంధ-నాశక కర్మలుగా మారిపోయి, అర్జునుడు దుఃఖ రహిత స్థితిని చేరుకుంటాడు."
                    },
                    {
                        "para": "దివ్య జ్ఞానం లో ఉన్న వారి లక్షణాల గురించి అర్జునుడు అడుగుతాడు. దానికి జవాబుగా, శ్రీ కృష్ణుడు, ఆధ్యాత్మిక జ్ఞానం లో ఉన్న వారు మోహము, భయం, కోపములకు అతీతంగా ఎలా ఉంటారో విశదీకరించాడు. వారు సుఖః-దుఃఖాలను సమానంగా స్వీకరిస్తూ, అన్ని పరిస్థితులలో ప్రశాంతంగా ఉంటారు; వారి ఇంద్రియములు నిగ్రహించబడి ఉంటాయి; వారి మనస్సు ఎప్పుడూ భగవంతునిలో లీనమై ఉంటుంది; మానసిక క్లేశములైన - కామము, క్రోధము, లోభములు - ఎలా ఎదుగుతాయో, వాటిని ఎలా నిర్మూలించవచ్చో, దశల వారీగా శ్రీ కృష్ణుడు విశదీకరిస్తాడు."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను : జాలి నిండినవాడై, శోకతప్త హృదయంతో, కంటి నిండా నీరు నిండిపోయున్న అర్జునుడిని చూసిన, శ్రీ కృష్ణుడు ఈ విధంగా పలికెను",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "తం తథా కృపయావిష్టమశ్రుపూర్ణాకులేక్షణమ్  ।"
                            },
                            {
                                "des": "విషీదంతమిదం వాక్యమువాచ మధుసూదనః ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇట్లనెను: ప్రియమైన అర్జునా, ఇలాంటి క్లిష్ట సమయంలో ఈ చిత్త భ్రాంతి ఎట్లా దాపురించింది? ఇది గౌరవనీయ వ్యక్తికి తగదు. ఇది ఉత్తమ గతులకు దారి తీసేది కాకపోగా, అపకీర్తి పాలుజేస్తుంది.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "కుతస్త్వాకశ్మలమిదం విషమే సముపస్థితమ్  ।"
                            },
                            {
                                "des": "అనార్యజుష్టమస్వర్గ్యమ్ అకీర్తికరమర్జున ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "ఓ పార్థా, ఈ యొక్క పిరికి తనమునకు లొంగిపోవటం నీకు తగదు. ఈ నీచమైన హృదయ దౌర్బల్యం విడిచిపెట్టి, యుద్ధానికి లెమ్ము, ఓ శత్రువులను జయించేవాడా.",
                        "description": [
                            {
                                "des": "క్లైబ్యం మా స్మ గమః పార్థ నైతత్త్వయ్యుపపద్యతే ।"
                            },

                            {
                                "des": "క్షుద్రం హృదయ దౌర్బల్యం త్యక్త్వోత్తిష్ఠ పరంతప ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు: ఓ మధుసూదనా, పూజ్యులైన భీష్ముడు, ద్రోణాచార్యుడు వంటి వారి మీద యుద్ధంలో నేను బాణాలు ఎలా విడువగలను? ఓ, శత్రువులను నాశనం చేసేవాడా.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "కథం భీష్మమహం సంఖ్యే ద్రోణం చ మధుసూదన  ।"
                            },
                            {
                                "des": "ఇషుభి ప్రతియోత్స్యామి పూజార్హవరిసూదన ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "నా గురువులైన ఈ పెద్దలను సంహరించి ఈ భోగాలని అనుభవించటం కంటే యాచకుడిగా బ్రతకటం మేలు. వీరిని చంపితే, మనము అనుభవించే ఈ సంపద, భోగాలు, రక్తం తో కళంకితమై ఉంటాయి.",
                        "description": [
                            {
                                "des": "గురూనహత్వా హి మహానుభావాన్"
                            },
                            {
                                "des": "శ్రేయో భోక్తుం భైక్ష్యమపీహ లోకే।"
                            },
                            {
                                "des": "హత్వార్థకామాంస్తు గురూనిహైవ  "
                            },
                            {
                                "des": "భుంజీయ భోగాన్ రుధిరప్రదిగ్ధాన్ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "ఈ యుద్ధం యొక్క ఎలాంటి ఫలితం మనకు మేలైనదో కూడా తెలియదు - వాళ్ళను జయించడమా లేదా వారిచే జయింపబడటమా. వారిని చంపిన తరువాత కూడా మనకు జీవించాలని అనిపించదు. అయినా, వారు ధృతరాష్ట్రుని పక్షం లో చేరి, మన ఎదురుగా యుద్ధభూమిలో నిలిచి ఉన్నారు.",
                        "description": [
                            {
                                "des": "న చైతద్విద్మః కతరన్నో గరీయో"
                            },
                            {
                                "des": "యద్వా జయేమ యది వా నో జయేయుః ।"
                            },
                            {
                                "des": "యానేవ హత్వా న జిజీవిషామః  "
                            },
                            {
                                "des": "తేఽవస్థితాః ప్రముఖే ధార్తరాష్ట్రాః ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "నా కర్తవ్యం ఏమిటో నాకు తెలియటంలేదు మరియు ఆందోళన, పిరికితనము నన్ను ఆవహించాయి. నేను నీ శిష్యుడను, నీకు శరణాగతుడను. నాకు నిజముగా ఏది శేయస్కరమో దానిని ఉపదేశించుము.",
                        "description": [
                            {
                                "des": "కార్పణ్యదోషో పహతస్వభావః"
                            },
                            {
                                "des": "పృచ్చామి త్వాం ధర్మ సమ్మూఢచేతాః ।"
                            },
                            {
                                "des": "యచ్చ్రేయః స్యాన్నిశ్చితం బ్రూహి తన్మే "
                            },
                            {
                                "des": "శిష్యస్తేఽహం శాధి మాం త్వాం ప్రపన్నమ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "నా ఇంద్రియములను శుష్కింప చేసే ఈ శోకమును పోగొట్టే ఉపాయమేదీ తోచటం లేదు. నేను ఈ భూమిపై సుసంపన్నమైన, ఎదురులేని రాజ్యాన్ని గెలిచినా, దేవతల వంటి అధిపత్యము పొందినా, ఈ శోకమును తొలగించుకోలేను.",
                        "description": [
                            {
                                "des": "న హి ప్రపశ్యామి మమాపనుద్యాత్"
                            },
                            {
                                "des": "యఛ్చోకముఛ్చోషణమింద్రియాణామ్ ।"
                            },
                            {
                                "des": "అవాప్య భూమావసపత్నమృద్ధం"
                            },
                            {
                                "des": "రాజ్యం సురాణామపి చాధిపత్యమ్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను: ఈ విధంగా అన్న గుడాకేశుడు, శత్రువులను శిక్షించేవాడు, హృషీకేశునితో : గోవిందా, నేను యుద్ధం చేయను అంటూ మౌనముగా అయిపోయాడు.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఏవముక్త్వా హృషీకేశం గుడాకేశః పరంతప ।"
                            },
                            {
                                "des": "న యోత్స్య ఇతి గోవిందముక్త్వా తూష్ణీం బభూవ హ   ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "ఓ ధృతరాష్ట్రా! ఆ తరువాత, ఇరు సేనల మధ్యలో, శోకసంతుప్తుడైన అర్జునుడితో శ్రీ కృష్ణుడు మందహాసముతో ఇట్లు పలికెను",
                        "description": [
                            {
                                "des": "తమువాచ హృషికేశః ప్రహసన్నివ భారత ।"
                            },

                            {
                                "des": "సేనయోరుభయోర్మధ్యే విషీదంతమిదం వచః ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "భగవంతుడు ఇలా అన్నాడు: నీవు ప్రాజ్ఞత తో కూడిన మాటలు మాట్లాడుతున్నావు కానీ శోకింప కూడని దాని కోసం శోకిస్తున్నావు. చనిపోయిన వారి గురించి గానీ బ్రతికున్న వారి గురించి గానీ, వివేకవంతులు శోకింపరు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "అశోచ్యానన్వశోచస్త్వం ప్రజ్ఞావాదాంశ్చ భాషసే"
                            },
                            {
                                "des": "గతాసూనగతాసూంశ్చ నానుశోచంతి పండితాః  ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "నేను కానీ, నీవు కానీ, ఈ రాజులందరూ కానీ లేని సమయము లేదు; ఇక ముందు కూడా మనము ఉండకుండా ఉండము.",
                        "description": [
                            {
                                "des": "న త్వేవాహం జాతు నాసం న త్వం నేమే జనాధిపాః ।"
                            },
                            {
                                "des": "న చైవ న భవిష్యామః సర్వే వయమతః పరమ్  ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఏ విధంగానయితే దేహంలో ఉన్న జీవాత్మ వరుసగా బాల్యము, యౌవనం, ముసలితనముల గుండా సాగిపోతుందో, అదేవిధముగా మరణ సమయంలో, జీవాత్మ మరియొక దేహము (శరీరము) లోనికి ప్రవేశిస్తుంది. వివేకవంతులు ఈ విషయమున ఆందోళన పడరు.",
                        "description": [
                            {
                                "des": "దేహినోఽస్మిన్ యథా దేహే కౌమారం యౌవనం జరా ।"
                            },
                            {
                                "des": "తథా దేహాంతరప్రాప్తిః ధీరస్తత్ర న ముహ్యతి ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఓ కుంతీ పుత్రా, ఇంద్రియ-విషయములతో సంయోగము వలన ఇంద్రియములకు క్షణభంగురమైన, అనిత్యమైన సుఖ-దుఃఖాలు కలిగినట్లు అనిపిస్తుంది. ఇవి అనిత్యములు; ఇవి వేసవి, చలికాలములలా వచ్చిపోతుంటాయి. ఓ భరత వంశీయుడా, కలత చెందకుండా వీటిని సహించటం నేర్చుకోవాలి.",
                        "description": [
                            {
                                "des": "మాత్రాస్పర్శాస్తు కౌంతేయ శీతోష్ణసుఖదుఃఖదాః ।"
                            },
                            {
                                "des": "ఆగమాపాయినోనిత్యాః తాంస్తితిక్షస్వ భారత ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, పురుష శ్రేష్ఠుడా, సుఖదుఃఖముల చే ప్రభావితం కాకుండా, రెండిటిలో చలించకుండా నిశ్చలముగా ఉన్నవాడు మోక్షమునకు అర్హుడవుతాడు.",
                        "description": [
                            {
                                "des": "యం హి న వ్యథయంత్యేతే పురుషం పురుషర్షభ ।"
                            },
                            {
                                "des": " సమదుఃఖసుఖం ధీరం సోఽమృతత్వాయ కల్పతే ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "క్షణభంగురమైన దానికి స్థిరత్వం లేదు మరియు శాశ్వతమైన దానికి అంతం లేదు. ఈ రెండింటి స్వభావాన్ని అధ్యయనం చేసిన తత్త్వజ్ఞానులు ఈ విషయాన్ని యథార్థముగా గమనించి ఉన్నారు.",
                        "description": [
                            {
                                "des": "నాసతో విద్యతే భావో నాభావో విద్యతే సతః ।"
                            },
                            {
                                "des": "ఉభయోరపి దృష్టొంఽతః త్వనయోస్తత్త్వదర్శిభిః ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "శరీరమంతయు వ్యాపించి ఉన్న అది నాశనం చేయబడలేనిదని తెలుసుకొనుము. ఎవ్వరూ కూడా అనశ్వరమైన ఆత్మను నశింపచేయలేరు.",
                        "description": [
                            {
                                "des": "అవినాశి తు తద్విద్ధి యేన సర్వమిదం తతమ్ ।"
                            },
                            {
                                "des": "వినాశమవ్యయస్యాస్య న కశ్చిత్ కర్తుమర్హతి ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "ఈ భౌతిక శరీరము మాత్రమే నశించునది; కానీ అందున్న జీవాత్మ నాశరహితమైనది, కొలవశక్యము కానిది మరియు సనాతనమైనది (నిత్యమైనది). కావున, ఓ భరత వంశీయుడా, యుద్ధం చేయుము.",
                        "description": [
                            {
                                "des": "అంతవంత ఇమే దేహా నిత్యస్యోక్తాః శరీరిణః ।"
                            },
                            {
                                "des": "అనాశినోఽప్రమేయస్య తస్మాద్యుధ్యస్వ భారత ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఆత్మకి ఇతరులను చంపును అని అనికోనేవాడు, ఆత్మ ఇతరులచే చంపబడేది అనుకొనేవాడు ఇద్దరూ అజ్ఞానులే. నిజానికి ఆత్మ ఎవ్వరినీ చంపదు, ఎవ్వరిచేతనూ చంపబడదు.",
                        "description": [
                            {
                                "des": "య ఏనం వేత్తి హంతారం యశ్చైనం మన్యతే హతం ।"
                            },
                            {
                                "des": "ఉభౌ తౌ న విజానీతో నాయం హంతి న హన్యతే ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": " ఆత్మ పుట్టుక లేదు, ఎన్నటికీ మరణం కూడా ఉండదు. ఒకప్పుడు ఉండి, ఇకముందు ఎప్పుడైనా ఉండకుండా ఉండదు. ఆత్మ జన్మ లేనిది, నిత్యమైనది, శాశ్వతమైనది మరియు వయోరహితమైనది. శరీరం నశించిపోయినప్పుడు అది నశించదు.",
                        "description": [
                            {
                                "des": "న జాయతే మ్రియతే వా కదాచిత్"
                            },
                            {
                                "des": "నాయం భూత్వా భవితా వా న భూయః"
                            },
                            {
                                "des": "అజో నిత్యః శాశ్వతోఽయం పురాణో"
                            },
                            {
                                "des": "న హన్యతే హన్యమానే శరీరే ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "ఓ పార్థ, ఆత్మ నాశనం చేయబడలేదు, నిత్యమైనది, జనన-మరణములు లేనిది అని తెలిసినవాడు, ఎట్లా చంపును (ఎవరినైనా)? ఎట్లా చంప కారణం అవ్వగలడు?",
                        "description": [
                            {
                                "des": "వేదావినాశినం నిత్యం య ఏనమజమవ్యయమ్ ।"
                            },
                            {
                                "des": "కథం స పురుషః పార్థ కం ఘాతయతి హంతి కమ్  ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఎలాగైతే మానవుడు, జీర్ణమైపోయిన పాత బట్టలను త్యజించి కొత్త బట్టలను ధరించునో అదే విధముగా జీవాత్మ, మరణ సమయములో పాత శరీరమును వీడి కొత్త శరీరమును స్వీకరించును.",
                        "description": [
                            {
                                "des": "వాసాంసి జీర్ణాని యథా విహాయ"
                            },
                            {
                                "des": "నవాని గృహ్ణాతి నరోఽపరాణి ।"
                            },
                            {
                                "des": "తథా శరీరాణి విహాయ జీర్ణా"
                            },
                            {
                                "des": "న్యన్యాని సంయాతి నవాని దేహీ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఈ ఆత్మను, ఆయుధములు ఛేదింపలేవు, అగ్ని కాల్చలేదు, నీరు తడపలేదు, గాలి అరిపోవునట్లు చేయలేదు.",
                        "description": [
                            {
                                "des": "నైనం ఛిందంతి శస్త్రాణి నైనం దహతి పావకః ।"
                            },

                            {
                                "des": "న చైనం క్లేదయంత్యాపో న శోషయతి మారుతః ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "ఆత్మ, ఛేదింపబడలేదు మరియు దహింపబడదు; అది (నీటిచే) తడుపబడదు, దానిని ఎండించుటకును సాధ్యం కాదు. అది నిత్యము, సర్వ వ్యాపి, మార్చలేనిది, పరివర్తనలేనిది మరియు సనాతనమైనది.",
                        "description": [
                            {
                                "des": "అచ్ఛేద్యోఽయమదాహ్యోఽయమ్ అక్లేద్యోఽశోష్య ఏవ చ ।"
                            },
                            {
                                "des": "నిత్యః సర్వగతః స్థాణుః అచలోఽయం సనాతనః ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "ఆత్మ అనేది అవ్యక్తమైనది (కనిపించనిది), ఊహాతీతమైనది మరియు మార్పులేనిది. ఇది తెలుసుకొని నీవు శరీరం కోసము శోకించవలదు.",
                        "description": [
                            {
                                "des": "అవ్యక్తోఽయమచింత్యోఽయమ్ అవికార్యోఽయముచ్యతే ।"
                            },
                            {
                                "des": "తస్మాదేవం విదిత్వైనం నానుశోచితుమర్హసి ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "కానీ ఒకవేళ నీవు, ఆత్మ పదే పదే జనన మరణములకు లోనగుతుంది అని అనుకున్నా సరే, ఓ మహా బాహువులు కలవాడా, ఇలా శోకించటము తగదు.",
                        "description": [
                            {
                                "des": "అథ చైనం నిత్యజాతం నిత్యం వా మన్యసే మృతమ్ ।"
                            },
                            {
                                "des": "తథాపి త్వం మహాబాహో నైవం శోచితుమర్హసి ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "పుట్టిన వానికి మరణం తప్పదు, మరణించినవానికి మరల పుట్టుక తప్పదు. కాబట్టి ఈ అనివార్యమైన దాని కోసం నీవు శోకించ వద్దు.",
                        "description": [
                            {
                                "des": "జాతస్య హి ధ్రువో మృత్యుః ధ్రువం జన్మ మృతస్య చ ।"
                            },
                            {
                                "des": "తస్మాదపరిహార్యేఽర్థే న త్వం శోచితుమర్హసి  ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "ఓ భరత వంశీయుడా, సృష్టింపబడిన ప్రాణులన్నీ పుట్టుక ముందు అవ్యక్తములు, జీవిత కాలంలో వ్యక్తములు, మరల మరణించిన పిదప అవ్యక్తములు. కావున శోకించుట ఎందులకు?",
                        "description": [
                            {
                                "des": "అవ్యక్తాదీని భూతాని వ్యక్తమధ్యాని భారత ।"
                            },
                            {
                                "des": "అవ్యక్తనిధనాన్యేవ తత్ర కా పరిదేవనా ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "కొందరు ఈ ఆత్మని ఆశ్చర్యమైనదిగా చూస్తారు, కొందరు ఆశ్చర్యమైనదిగా వర్ణిస్తారు, కొందరు ఆత్మ ఆశ్చర్యమైనదని వింటారు, మరికొందరు, విన్న తరువాత కూడా దీని గురించి ఏమాత్రం అర్థం చేసుకోలేరు",
                        "description": [
                            {
                                "des": "ఆశ్చర్యవత్పశ్యతి కశ్చిదేనమ్"
                            },
                            {
                                "des": "ఆశ్చర్యవద్వదతి తథైవ చాన్యః । "
                            },
                            {
                                "des": "ఆశ్చర్యవచ్చైనమన్యః శృణోతి "
                            },
                            {
                                "des": "శ్రుత్వాప్యేనం వేద న చైవ కశ్చిత్  ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, దేహమునందు ఉండెడి ఆత్మ చావులేనిది; కాబట్టి ఏ ప్రాణి గురించి కూడా నీవు శోకించుట తగదు.",
                        "description": [
                            {
                                "des": "దేహీ నిత్యమవధ్యోఽయం దేహే సర్వస్య భారత ।"
                            },
                            {
                                "des": "తస్మాత్ సర్వాణి భూతాని న త్వం శోచితుమర్హసి  ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "ఇంకా, నీ యొక్క క్షత్రియ స్వ-ధర్మమమును అనుసరించి నీవు చలింపరాదు. నిజానికి, ఒక క్షత్రియుడికి ధర్మ పరిరక్షణకు యుద్ధం చేయటమనే దాని కన్నా మించిన కర్తవ్యం లేదు.",
                        "description": [
                            {
                                "des": "స్వధర్మమపి చావేక్ష్య న వికంపితుమర్హసి ।"
                            },
                            {
                                "des": "ధర్మ్యాద్ధి యుద్ధాచ్చ్రేయోఽన్యత్ క్షత్రియస్య న విద్యతే ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "ఓ పార్థ, ధర్మాన్ని పరిరక్షించే అవకాశాలు, కోరుకోకుండానే దొరికిన, క్షత్రియులు అదృష్టవంతులు. ఇది వారికి స్వర్గమునకు తెరిచి ఉన్న ద్వారము.",
                        "description": [
                            {
                                "des": "యదృచ్ఛయా చోపపన్నం స్వర్గద్వారమపావృతమ్ ।"
                            },
                            {
                                "des": "సుఖినః క్షత్రియాః పార్థ లభంతే యుద్ధమీదృశమ్ ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "కానీ ఒకవేళ నీవు స్వధర్మాన్ని, కీర్తిని విడిచి, ఈ ధర్మ యుద్ధాన్ని చేయటానికి నిరాకరిస్తే, తప్పకుండా పాపాన్ని చేసినవాడివవుతావు.",
                        "description": [
                            {
                                "des": "అథ చేత్త్వమిమం ధర్మ్యం సంగ్రామం న కరిష్యసి ।"
                            },
                            {
                                "des": "తతః స్వధర్మం కీర్తిం చ హిత్వా పాపమవాప్స్యసి  ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "జనులు నిన్ను పిరికివాడు, పారిపోయిన సైనికుడు అని అంటారు. గౌరవప్రదమైన వ్యక్తికి అపకీర్తి అనేది మరణము కన్నా నీచమైనది. ",
                        "description": [
                            {
                                "des": "అకీర్తిం చాపి భూతాని"
                            },
                            {
                                "des": "కథయిష్యంతి తేఽవ్యయామ్"
                            },
                            {
                                "des": "సంభావితస్య చాకీర్తిః "
                            },
                            {
                                "des": "మరణాదతిరిచ్యతే ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "ఏ మహారథుల దృష్టిలో నీవు గొప్పవాడివో, వారే, నీవు యుద్ధభూమి నుండి భయముతో పారిపోయావనుకుంటారు. అలా వారికి నీ మీద ఉన్న గౌరవం పోగొట్టుకుంటావు.",
                        "description": [
                            {
                                "des": "భయాద్రణాదుపరతం మంస్యంతే త్వాం మహారథాః ।"
                            },
                            {
                                "des": "యేషాం చ త్వం బహుమతో భూత్వా యాస్యసి లాఘవమ్ ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "నీ శత్రువులు నిన్ను అపకీర్తి పాలు చేసి క్రూరమైన మాటలతో అవమానిస్తారు, దీనితో నీ గొప్పతనం చులకనయిపోతుంది. అయ్యో, దీని కంటే ఎక్కువ బాధాకరమైనది ఏమైనా ఉందా?",
                        "description": [
                            {
                                "des": "అవాచ్యవాదాంశ్చ బహూన్ వదిష్యన్తి తవాహితాః ।"
                            },
                            {
                                "des": "నిందంతస్తవ సామర్థ్యమ్ తతో దుఃఖతరం ను కిమ్  ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "యుద్ధం చేస్తే నీవు, యుద్ధ రంగంలో వీర మరణం పొంది స్వర్గానికి పోయెదవు లేదా విజయుడవై ఈ రాజ్యమును అనుభవించెదవు. కావున, కృత నిశ్చయుడవై లెమ్ము, ఓ కుంతీ పుత్రుడా, యుద్ధానికి తయారుకమ్ము.",
                        "description": [
                            {
                                "des": "హతో వా ప్రాప్స్యసి స్వర్గం జిత్వా వా భోక్షసే మహీమ్ ।"
                            },
                            {
                                "des": "తస్మాదుత్తిష్ఠ కౌంతేయ యుద్ధాయ కృతనిశ్చయః  ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "సుఖ-దుఃఖాలని, లాభ-నష్టాలని సమానంగా తీసుకుంటూ - కర్తవ్య నిర్వహణగా యుద్ధం చెయుము. నీ భాద్యతలని ఈ విధంగా నిర్వర్తించటం వలన నీకు ఎన్నటికీ పాపం అంటదు.",
                        "description": [
                            {
                                "des": "సుఖదుఃఖే సమే కృత్వా లాభాలాభౌ జయాజయౌ ।"
                            },
                            {
                                "des": "తతో యుద్ధాయ యుజ్యస్వ నైవం పాపమవాప్స్యసి  ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "ఇప్పటివరకు నేను నీకు సాంఖ్య యోగం, అంటే, ఆత్మ తత్త్వం గురించి విశ్లేషణాత్మక జ్ఞానమును, వివరించాను. ఇప్పుడు వినుము, ఓ పార్థ, నేను బుద్ది యోగాన్ని విశదీకరిస్తాను. ఇలాంటి అవగాహనతో పని చేసినప్పుడు నీవు కర్మ బంధములనుండి విముక్తి పొందెదవు.",
                        "description": [
                            {
                                "des": "ఏషా తేఽభిహితా సాంఖ్యే"
                            },
                            {
                                "des": "బుద్ధిర్యోగే త్విమాం శృణు ।"
                            },
                            {
                                "des": "బుధ్ధ్యా యుక్తో యయా పార్థ"
                            },
                            {
                                "des": "కర్మబంధం ప్రహాస్యసి  ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "ఈ దృక్పథంతో పనిచేసినప్పుడు, ఎలాంటి నష్టము కానీ వ్యతిరేక ఫలితములు కానీ కలుగవు. కొద్దిగా సాధన చేసినా అది మనలని పెద్ద ప్రమాదాలనుండి కాపాడును.",
                        "description": [
                            {
                                "des": "నేహాభిక్రమనాశోఽస్తి ప్రత్యవాయో న విద్యతే ।"
                            },
                            {
                                "des": "స్వల్పమప్యస్య ధర్మస్య త్రాయతే మహతో భయాత్ ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "ఓ కురు వంశస్తుడా, ఈ దారిలో ఉన్న వారి బుద్ది ధృడంగా/స్థిరంగా ఉంటుంది, వారి లక్ష్యము ఒక్కటే. కానీ, స్థిరంగాలేని వారి బుద్ది పరిపరి విధములగా ఉంటుంది.",
                        "description": [
                            {
                                "des": "వ్యవసాయాత్మికా బుద్దిరేకేహ కురునందన ।"
                            },
                            {
                                "des": "బహుశాఖా హ్యనంతాశ్చ బుద్ధయోఽవ్యవసాయినామ్   ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42-43 శ్లోకాలు",
                        "bhavam": "పరిమితమైన అవగాహన కలవారు, స్వర్గ లోక ప్రాప్తి కోసం, డాంభికమైన కర్మకాండలను సూచించే వేదాల్లో చెప్పబడిన సమ్మోహపరచే, మాటలకు ఆకర్షితులై, అందులో ఇంకా ఏమీ ఉన్నత స్థాయి ఉపదేశం లేదనుకుంటారు. తమకు ఇంద్రియ సుఖాలని ప్రాప్తింపచేసే వేదాల్లోని ఆ భాగాలని కీర్తిస్తూ, ఉన్నత జన్మ, ఐశ్వర్యం, ఇంద్రియ భోగాలు, స్వర్గలోక ప్రాప్తి మొదలగువంటి వాటి కోసం ఆడంబరమైన కర్మకాండలు చేస్తుంటారు.",
                        "description": [
                            {
                                "des": "యామిమాం పుష్పితాం వాచం ప్రవదంత్యవిపశ్చితః ।"
                            },
                            {
                                "des": "వేదవాదరతాః పార్థ నాన్యదస్తీతి వాదినః  ।। 42 ।।"
                            },
                            {
                                "des": "కామాత్మానః స్వర్గపరా జన్మకర్మఫలప్రదామ్ ।"
                            },
                            {
                                "des": "క్రియావిశేషబహులాం భోగైశ్వర్యగతిం ప్రతి ।। 43 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "44 వ శ్లోకం",
                        "bhavam": "ప్రాపంచిక భోగాలు, సుఖాల పై మిక్కిలి మమకారంతో, వారి బుద్ధి చిత్తభ్రాంతికి లోనయ్యి, భగవద్ప్రాప్తి పథం లో సాఫల్యానికి కావలసిన ధృడ సంకల్పాన్ని వారు కలిగి ఉండలేరు.",
                        "description": [
                            {
                                "des": "భోగైశ్వర్యప్రసక్తానాం తయాపహృతచేతసామ్ ।"
                            },
                            {
                                "des": "వ్యవసాయాత్మికా బుద్ధిః సమాధౌ న విధీయతే ।। 44 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "45 వ శ్లోకం",
                        "bhavam": "అర్జునా, వేదములు భౌతిక ప్రకృతి యొక్క త్రి-గుణాత్మకమైన విషయ సంబంధమై వివరించును. నీవు ఈ త్రిగుణములకు అతీతంగా స్వచ్ఛమైన ఆధ్యాత్మిక జ్ఞాన స్థితిలో ఉండుము. ద్వందముల నుండి విడివడి, నిత్యమూ పరమ సత్యం లో స్థితమై ఉండి, మరియు భౌతిక లాభాలు, భద్రత ల గురించి పట్టించుకోకుండా ఆత్మ భావన యందే స్థితుడవై ఉండుము.",
                        "description": [
                            {
                                "des": "త్రైగుణ్యవిషయా వేదా నిస్త్రైగుణ్యో భవార్జున ।"
                            },
                            {
                                "des": "నిర్ద్వంద్వో నిత్యసత్వస్థో నిర్యోగక్షేమ ఆత్మవాన్ ।। 45 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "46 వ శ్లోకం",
                        "bhavam": "ఒక చిన్న నీటి బావితో తీరే అన్ని ప్రయోజనాలు సహజంగానే ఒక పెద్ద నీటి కొలను తో తీరుతాయి. ఆ విధంగానే పరమ సత్యాన్ని ఎరిగి భగవత్ ప్రాప్తి నొందిన వాడు అన్ని వేదముల లక్ష్యాన్ని నెరవేరుస్తాడు.",
                        "description": [
                            {
                                "des": "యావానర్థ ఉదపానే సర్వతః సంప్లుతోదకే ।"
                            },
                            {
                                "des": "తావాన్సర్వేషు వేదేషు బ్రాహ్మణస్య విజానతః ।। 46 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "47 వ శ్లోకం",
                        "bhavam": "శాస్త్ర విహిత కర్తవ్య కర్మను ఆచరించుటయందే నీకు అధికారము కలదు, కానీ ఆ కర్మ ఫలముల పైన నీకు హక్కు లేదు. నీవే కర్మ ఫలములకు హేతువు అని ఎప్పుడూ అనుకోకు మరియు చేయవలసిన కర్మలు మానుటలో ఆసక్తి ఉండరాదు.",
                        "description": [
                            {
                                "des": "కర్మణ్యేవాధికారస్తే మా ఫలేషు కదాచన ।"
                            },
                            {
                                "des": "మా కర్మఫలహేతుర్భూః మా తే సంగోఽస్త్వకర్మణి ।। 47 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "48 వ శ్లోకం",
                        "bhavam": "జయాపజయముల పట్ల మమకారాసక్తి విడిచిపెట్టి, నీ కర్తవ్య నిర్వహణలో స్థిరముగా ఉండుము, ఓ అర్జునా. ఇటువంటి సమత్వ బుద్దియే యోగము అనబడుతుంది.",
                        "description": [
                            {
                                "des": "యోగస్థఃకురు కర్మాణి సంగం త్యక్త్వా ధనంజయ ।"
                            },
                            {
                                "des": "సిద్ధ్య సిద్ధ్యోః సమో భూత్వా సమత్వం యోగ ఉచ్యతే  ।। 48 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "49 వ శ్లోకం",
                        "bhavam": "దివ్యమైన ఆధ్యాత్మిక జ్ఞానమునే ఆశ్రయించుము. ఓ అర్జునా, ఫలాపేక్షతో చేసే పనులను త్యజించుము; బుద్ధిని అధ్యాత్మిక దివ్య జ్ఞానం లో స్థిరంగా ఉంచి చేసే పనుల కన్నా, అవి నిమ్న స్థాయికి చెందినవి. తమ కర్మ ఫలములను భోగించగోరే వారు లోభులు/పిసినారులు.",
                        "description": [
                            {
                                "des": "దూరేణ హ్యవరం కర్మ బుద్ధియోగాద్ధనంజయ ।"
                            },
                            {
                                "des": "బుద్ధౌ శరణమన్విచ్ఛ కృపణాః ఫలహేతవః ।। 49 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "50 వ శ్లోకం",
                        "bhavam": "వివేకముతో ఈ కర్మ శాస్త్రమును ఆచరణలో పెట్టినవాడు ఈ జన్మ లోనే పుణ్య పాపములను రెంటినీ త్యజించును. కాబట్టి నైపుణ్యం తో (సరియైన దృక్పథం తో) పని చేయటం అనే, యోగ అభ్యాసము చేయుము.",
                        "description": [
                            {
                                "des": "బుద్ధియుక్తో జహాతీహ ఉభే సుకృతదుష్కృతే ।"
                            },
                            {
                                "des": "తస్మాద్యోగాయ యుజ్యస్వ యోగః కర్మసు కౌశలమ్ ।। 50 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "51 వ శ్లోకం",
                        "bhavam": "జ్ఞానులు, సమత్వ బుద్ది కలిగి ఉండి, జననమరణ చక్రంలో బంధించే కర్మ ఫలములపై మమకార-ఆసక్తులను త్యజించి ఉంటారు. ఇలాంటి భావన తో పని చేయటం వలన దుఃఖరహితమైన స్థితిని పొందెదరు.",
                        "description": [
                            {
                                "des": "కర్మజం బుద్ధియుక్తా హి ఫలం త్వక్త్వా మనీషిణః ।"
                            },
                            {
                                "des": "జన్మబంధవినిర్ముక్తాః పదం గచ్ఛంత్యనామయమ్ ।। 51 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "52 వ శ్లోకం",
                        "bhavam": "మోహమనే ఊబి నుండి నీ బుద్ధి బయటపడినప్పుడే నీవు ఇప్పటి వరకు విన్న దాని గురించి, ఇక వినబోయేదాని గురించి వైరాగ్యం కలుగుతుంది. (ఇహపర లోక భోగముల విషయంలో).",
                        "description": [
                            {
                                "des": "యదా తే మోహకలిలం బుద్ధిర్వ్యతితరిష్యతి ।"
                            },
                            {
                                "des": "తదా గంతాసి నిర్వేదం శ్రోతవ్యస్య శ్రుతస్య చ ।। 52 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "53 వ శ్లోకం",
                        "bhavam": "కామ్య కర్మ కాండలను చెప్పే వేద విభాగాల వైపు ఆకర్షితం కాకుండా నీ బుద్ధి ఎప్పుడైతే భగవంతుని యందే నిశ్చలంగా ఉంటుందో అప్పుడు సంపూర్ణమైన యోగ స్థితిని పొందెదవు.",
                        "description": [
                            {
                                "des": "శృతివిప్రతి పన్నా తే యదా స్థాస్యతి నిశ్చలా ।"
                            },

                            {
                                "des": "సమాధావచలా బుద్ధిస్తదా యోగామవాప్స్యసి ।। 53 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "54 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : ఓ కేశవా, భగవత్ ధ్యాస నందే స్థిరముగా ఉన్న (స్థితప్రజ్ఞుని) వాని ప్రవృత్తి ఎలా ఉంటుంది? జ్ఞానోదయం అయిన వ్యక్తి ఎలా మాట్లాడును? అతను ఎలా కూర్చొనును? అతను ఎలా నడుచును?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "స్థితప్రజ్ఞస్య కా భాషా సమాధిస్థస్య కేశవ ।"
                            },

                            {
                                "des": "స్థితధీః కిం ప్రభాషేత కిమాసీత వ్రజేత కిమ్ ।। 54 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "55 వ శ్లోకం",
                        "bhavam": "భగవానుడు పలికెను : ఓ పార్థ, మనస్సుని వేధించే అన్నీ స్వార్ధ ప్రయోజనాలను, ఇంద్రియవాంఛలను త్యజించి ఆత్మ జ్ఞానం లో సంతుష్టుడు అయినప్పుడు, ఆ వ్యక్తిని స్థిత ప్రజ్ఞుడు అంటారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ప్రజహాతి యదా కామాన్ సర్వాన్ పార్థ మనోగతాన్ ।"
                            },

                            {
                                "des": "ఆత్మన్యేవాత్మనా తుష్టః స్థితప్రజ్ఞస్తదోచ్యతే ।। 55 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "56 వ శ్లోకం",
                        "bhavam": "దుఃఖముల నడుమ కూడా కలతచెందని వాడు, సుఖముల కోసం ప్రాకులాడని వాడు; మమకారము, భయము, క్రోధము విడిచిన వాడిని స్థిత-ప్రజ్ఞుడైన ముని అని అంటారు.",
                        "description": [
                            {
                                "des": "దుఃఖేష్వనుద్విగ్నమనాః సుఖేషు విగతస్పృహః ।"
                            },
                            {
                                "des": "వీతరాగభయక్రోధః స్థితధీర్మునిరుచ్యతే ।। 56 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "57 వ శ్లోకం",
                        "bhavam": "ఎవరైతే అన్నీ పరిస్థితులలో మమకారం/ఆసక్తి లేకుండా ఉంటాడో, సౌభాగ్యానికి హర్షమునొందకుండా మరియు కష్టాలకు క్రుంగిపోకుండా ఉంటాడో, అతను పరిపూర్ణ జ్ఞానం తో ఉన్న ముని.",
                        "description": [
                            {
                                "des": "యః సర్వత్రానభిస్నేహః తత్తత్ ప్రాప్య శుభాశుభమ్ ।"
                            },

                            {
                                "des": "నాభినందంతి న ద్వేష్టి తస్య ప్రజ్ఞా ప్రతిష్ఠితా ।। 57 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "58 వ శ్లోకం",
                        "bhavam": "తాబేలు తన పైచిప్ప లోనికి, దాని అంగములను ఉపసంహరించుకున్నట్టుగా, ఇంద్రియములను వాటి విషయార్ధముల నుండి వెనుకకు మరల్చగలిగిన వాడు, దివ్యమైన ఆధ్యాత్మిక జ్ఞానంలో స్థిరచిత్తుడగును.",
                        "description": [
                            {
                                "des": "యదా సంహరతే చాయం కూర్మోంఽగానీవ సర్వశః ।"
                            },
                            {
                                "des": "ఇంద్రియాణీంద్రియార్థేభ్యః తస్య ప్రజ్ఞా ప్రతిష్ఠితా ।। 58 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "59 వ శ్లోకం",
                        "bhavam": "సాధకులు ఇంద్రియములను భోగ వస్తు/విషయముల నుండి నియంత్రించినా, ఇంద్రియ విషయముల మీద రుచి ఉండిపోతుంది. కానీ, భగవత్ తత్వాన్ని అర్థం చేసుకున్నప్పుడు ఆ రుచి కూడా అంతమగును.",
                        "description": [
                            {
                                "des": "విషయా వినివర్తంతే నిరాహారస్య దేహినః ।"
                            },
                            {
                                "des": "రసవర్జం రసోఽప్యస్య పరం దృష్ట్వా నివర్తతే।। 59 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "60 వ శ్లోకం",
                        "bhavam": "ఇంద్రియములు ఎంత బలవత్తరమైనవి, అల్లకల్లోలమైనవి అంటే, ఓ కుంతీ పుత్రుడా, వివేకము కలిగి, స్వీయ నియంత్రణ పాటించే సాధకుని మనస్సుని కూడా బలవంతంగా లాక్కోనిపోగలవు.",
                        "description": [
                            {
                                "des": "యతతో హ్యపి కౌంతేయ పురుషస్య విపశ్చితః ।"
                            },

                            {
                                "des": "ఇంద్రియాణి ప్రమాథీని హరంతి ప్రసభం మనః ।। 60 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "61 వ శ్లోకం",
                        "bhavam": "ఎవరైతే తమ ఇంద్రియములను వశమునందు ఉంచుకొని, మనస్సుని నాయందే ఎల్లప్పుడూ లగ్నం చేయుదురో, వారు సంపూర్ణ జ్ఞానంలో స్థితులై ఉన్నట్టు.",
                        "description": [
                            {
                                "des": "తాని సర్వాణి సంయమ్య యుక్త ఆసీత మత్పరః ।"
                            },
                            {
                                "des": "వశే హి యస్యేంద్రియాణి తస్య ప్రజ్ఞా ప్రతిష్ఠితాః  ।। 61 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "62 వ శ్లోకం",
                        "bhavam": "ఇంద్రియ విషయముల మీద చింతన చేయటం వలన వాటి మీద మమకారాసక్తి పెరుగుతుంది. ఈ ఆసక్తి కోరికలను కలుగ చేస్తుంది, ఆ కోరికల నుండే క్రోధం ఉత్పన్నమవుతుంది.",
                        "description": [
                            {
                                "des": "ధ్యాయతో విషయాన్ పుంసః సంగస్తేషూపజాయతే ।"
                            },
                            {
                                "des": "సంగాత్ సంజాయతే కామః కామాత్ క్రోధోఽభిజాయతే ।। 62 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "63 వ శ్లోకం",
                        "bhavam": "కోపం అనేది విచక్షణా రాహిత్యానికి దారి తీస్తుంది, అది స్మృతి (జ్ఞాపకశక్తి) భ్రమని కలుగ చేస్తుంది. స్మృతిభ్రమ కలిగినప్పుడు బుద్ధి నశిస్తుంది. బుద్ధి నశించినప్పుడు మనుష్యుడు పతనమౌతాడు.",
                        "description": [
                            {
                                "des": "క్రోధాద్భవతి సమ్మోహః సమ్మోహాత్ స్మృతివిభ్రమః ।"
                            },

                            {
                                "des": "స్మృతిభ్రంశాద్బుద్ధి నాశో బుద్ధినాశాత్ ప్రణశ్యతి  ।। 63 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "64 వ శ్లోకం",
                        "bhavam": "ఇంద్రియ విషయ/వస్తువులను వాడేటప్పుడు కూడా మనస్సుని నియంత్రించినవాడై, మమకార-ద్వేష రహితంగా ఉన్నవాడు భగవంతుని కృపకు పాత్రుడగును.",
                        "description": [
                            {
                                "des": "రాగద్వేషవియుక్తైస్తు విషయానింద్రియైశ్చరన్ ।"
                            },

                            {
                                "des": "ఆత్మవశ్యైర్విధేయాత్మా ప్రసాదమధిగచ్ఛతి  ।। 64 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "65 వ శ్లోకం",
                        "bhavam": "భగవత్ కృప ద్వారా అన్ని దుఃఖాలు తొలిగిపోయే పరమ శాంతి లభిస్తుంది. అలా ప్రసన్న చిత్తం తో ఉన్నవాని బుద్ధి శీఘ్రము గానే భగవంతునియందు స్థిరముగా నిలుస్తుంది.",
                        "description": [
                            {
                                "des": "ప్రసాదే సర్వ దుఃఖానాం హానిరస్యోపజాయతే ।"
                            },
                            {
                                "des": "ప్రసన్నచేతసో హ్యాశు బుద్ధిః పర్యవతిష్ఠతే ।। 65 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "66 వ శ్లోకం",
                        "bhavam": "మనస్సు, ఇంద్రియములను నియంత్రించని క్రమశిక్షణ లేనివానికి, స్థిరమైన బుద్ధి కాని, నిలకడైన భగవత్ ధ్యాస కాని ఉండవు. ఎవడైతే మనస్సుతో భగవంతుని యందు ఎన్నడూ ఐక్యమవడో వానికి శాంతి ఉండదు. మనశ్శాంతి లోపించినవాడు సంతోషంగా ఎలా ఉండగలడు?",
                        "description": [
                            {
                                "des": "నాస్తి బుద్ధిరయుక్తస్య న చాయుక్తస్య భావనా । "
                            },
                            {
                                "des": "న చాభావయతః శాంతిః అశాంతస్య కుతః సుఖమ్ ।। 66 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "67 వ శ్లోకం",
                        "bhavam": "ఎలాగైతే బలమైన గాలి, నీటిలో నావను దాని దిశ నుండి పక్కకు నెట్టివేస్తుందో, ఏ ఒక్క ఇంద్రియము పైన గాని మనస్సు కేంద్రీకృతమయినచో అది బుద్ధిని హరించి వేస్తుంది.",
                        "description": [
                            {
                                "des": "ఇంద్రియాణాం హి చరతాం యన్మనోఽనువిధీయతే ।"
                            },

                            {
                                "des": "తదస్య హరతి ప్రజ్ఞాం వాయుర్నావమివాంభసి ।। 67 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "68 వ శ్లోకం",
                        "bhavam": "కాబట్టి, ఓ అర్జునా, శక్తివంతమైన బాహువులు కలవాడా, ఇంద్రియములను ఇంద్రియార్ధములనుండి పూర్తిగా నిగ్రహించిన వ్యక్తి ఆధ్యాత్మిక జ్ఞానం లో స్థిరముగా ఉంటాడు.",
                        "description": [
                            {
                                "des": "తస్మాద్యస్య మహాబాహో నిగృహీతాని సర్వశః ।"
                            },
                            {
                                "des": "ఇంద్రియాణీంద్రియార్థేభ్యః తస్య ప్రజ్ఞా ప్రతిష్ఠితా।। 68 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "69 వ శ్లోకం",
                        "bhavam": "సర్వ భూతములకు ఏది పగలో అది పండితునికి అజ్ఞానపు రాత్రి, మరియు సర్వ భూతములకు ఏది రాత్రియో అది అంతర్ముఖులైన జ్ఞానులకు పగలు.",
                        "description": [
                            {
                                "des": "యా నిశా సర్వభూతానాం తస్యాం జాగర్తి సంయమీ ।"
                            },
                            {
                                "des": "యస్యాం జాగ్రతి భూతాని సా నిశా పశ్యతో మునేః ।। 69 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "70 వ శ్లోకం",
                        "bhavam": "ఎన్నో నదులు తనలో నిత్యం కలుస్తున్నా, ఎలాగైతే సముద్రం నిశ్చలంగా/ప్రశాంతంగా ఉంటుందో, అదేవిధంగా ఎన్నో వాంఛనీయ వస్తువులు తన చుట్టూ వస్తూనే ఉన్నా, చలించని యోగి శాంతిని పొందుతాడు; కోరికలను సంతృప్తిపరచుకోవటానికే కృషి చేసే వ్యక్తి ఇది పొందడు.",
                        "description": [
                            {
                                "des": "ఆపూర్యమాణమచలప్రతిష్ఠం"
                            },
                            {
                                "des": "సముద్రమాపః ప్రవిశంతి యద్వత్"
                            },
                            {
                                "des": "తద్వత్ కామా యం ప్రవిశంతి సర్వే"
                            },
                            {
                                "des": "స శాంతిమాప్నోతి న కామకామీ।। 70 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "71 వ శ్లోకం",
                        "bhavam": "ఎవరైతే అన్ని ప్రాపంచిక కోరికలను త్యజించి, అత్యాశ లేకుండా, నేను/నాది అన్న భావన లేకుండా, అహంకార రహితముగా ఉంటాడో, అలాంటి వానికి పరిపూర్ణమైన ప్రశాంతత లభిస్తుంది.",
                        "description": [
                            {
                                "des": "విహాయ కామాన్యః సర్వాన్పుమాంశ్చరతి నిఃస్పృహః ।"
                            },
                            {
                                "des": "నిర్మమో నిరహంకారః స శాంతిమధిగచ్ఛతి ।। 71 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "72 వ శ్లోకం",
                        "bhavam": "ఓ పార్థ, జ్ఞానోదయం కలిగిన జీవాత్మ స్థితి ఎలా ఉంటుందంటే, ఒకసారి జ్ఞానోదయం కలిగిన తరువాత ఇక మళ్లీ అది మాయలో పడదు. మరణ సమయంలో కూడా ఈ వివేకం తో స్థిరంగా ఉన్న ఇటువంటి వ్యక్తి, జనన మరణ చక్రం నుండి విముక్తి పొంది, ఆ భగవంతుని దివ్య ధామానికి చేరుకుంటాడు.",
                        "description": [
                            {
                                "des": "ఏషా బ్రాహ్మీ స్థితిః పార్థ నైనాం ప్రాప్య విముహ్యతి ।"
                            },
                            {
                                "des": "స్థిత్వాస్యామంతకాలేఽపి బ్రహ్మనిర్వాణమృచ్ఛతి ।। 72 ।।"
                            }
                        ]
                    }



                ]
            },
            {
                "title": "కర్మ యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/03.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/03.png'),
                "index":3,
                "introduction": [
                    {
                        "para": "ఈ అధ్యాయంలో, శ్రీ కృష్ణుడు, అన్ని ప్రాణులూ తమ తమ ప్రకృతి సిద్ధమైన స్వాభావిక లక్షణంచే ఏదో ఒక పని చేస్తూనే ఉంటాయనీ, మరియు ఎవరూ కూడా ఒక క్షణం కూడా కర్మలు చేయకుండా ఉండలేరనీ, వివరిస్తున్నాడు. ఏవో కాషాయి వస్త్రాలు ధరించి బాహ్యంగా సన్యాసం ప్రదర్శిస్తూ, లోలోన ఇంద్రియ వస్తువుల పై చింతనచేసే వారు కపటులు. బాహ్యంగా కర్మలు ఆచరిస్తూనే ఉన్నా, లోనుండి మమకార రాహిత్యంతో ఉండే, కర్మ యోగము ఆచరించే వారు, వారికన్నా ఉన్నతమైన వారు. భగవంతుని సృష్టి వ్యవస్థలో ప్రతి ప్రాణికి తన వంతుగా నిర్వర్తించే భాద్యతలు ఉంటాయని శ్రీ కృష్ణుడు వక్కాణిస్తున్నాడు. మనము చేయవలసిన ధర్మాన్ని భగవంతుడు ఇచ్చిన కర్తవ్యం గా చేసినప్పుడు ఆ పని 'యజ్ఞం' అవుతుంది. యజ్ఞం చేయటం సహజంగానే దేవతలకు ప్రీతి కలిగిస్తుంది, దాంతో వారు భౌతిక అభ్యుదయం ప్రసాదిస్తారు. అలాంటి యజ్ఞం వానలు కురిపిస్తుంది, వానలతో జీవనోపాధి కోసం అవసరమైన ధాన్యం వస్తుంది. ఈ చక్రంలో తమ భాద్యత ని స్వీకరించటానికి నిరాకరించిన వారు పాపిష్టులు; వారు తమ ఇంద్రియ లౌల్యం కోసమే జీవించేవారు మరియు వారి జీవితాలు వ్యర్ధమైనవి."
                    },
                    {
                        "para": "ఆత్మ యందే స్థితులై ఉండే జ్ఞానోదయమైనవారు, సామాన్య జనులలా కాకుండా, తమ శారీరిక భాధ్యతలను నిర్వర్తించే అవసరం లేదు, ఎందుకంటే వారు ఉన్నతమైన ఆత్మ స్థాయి విధులు నిర్వర్తిస్తారు. కానీ వారు తమ సామాజిక విధులను విస్మరిస్తే, అది వారి అడుగు జాడలలో నడిచే సామాన్య జనుల మనస్సులలో కలత కలిగిస్తుంది. కాబట్టి అందరూ అనుకరించటానికి, ప్రపంచానికి ఒక మంచి ఉదాహరణ చూపటం కోసం జ్ఞానులు, ఎలాంటి స్వార్ధ ప్రయోజనం లేకుండా కర్మలు ఆచరిస్తూనే ఉండాలి. ఇది, పరిపక్వత లేకుండా అకాలంగా తమ విధులను త్యజించే వారిని నిరోధిస్తుంది. ఈ ప్రయోజనం కోసమే జ్ఞానోదయమైన జనక మహారాజు వంటి రాజులు, తమ విధులను నిర్వర్తించారు."
                    },
                    {
                        "para": "తమకు ఇష్టం లేకపోయినా, ఏదో బలవంతమైన ప్రభావం చేతనా అన్నట్టు, జనులు ఎందుకు పాపపు కర్మలను చేస్తారు అని తదుపరి అర్జునుడు ప్రశ్నిస్తాడు. ప్రపంచంలో అన్నిటినీ నాశనం చేసే పాపిష్టి శత్రువు కామమే అని, ఆ పరమాత్మ వివరిస్తాడు. నిప్పు పొగచే, అద్దం దుమ్ముచే కప్పి వేయబడ్డట్టుగా, కోరికలు జ్ఞానాన్ని కప్పివేసి, బుద్ధిని దూరంగా లాగేస్తాయి. తదుపరి, శ్రీ కృష్ణుడు, పాప స్వరూపమైన, కోరికలు అనే శత్రువుని సంహరించమని మరియు తన ఇంద్రియములు, మనస్సు, బుద్ధిని నియంత్రణ లోకి తెమ్మని, అర్జునుడికి శంఖారావ పిలుపునిస్తున్నాడు"
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1-2 శ్లోకాలు",
                        "bhavam": "అర్జునుడు ఇలా పలికెను : ఓ జనార్ధనా, జ్ఞానం అనేది కర్మ కంటే శ్రేష్ఠ మయినదయితే మరి నన్ను ఈ ఘోరమైన యుద్ధం ఎందుకు చేయమంటున్నావు? నీ అస్పష్టమైన ఉపదేశం తో నా బుద్ధి అయోమయం లో పడిపోయింది. దేనివలన అయితే నాకు అత్యుత్తమ శ్రేయస్సు కలుగుతుందో దయచేసి ఆ ఒక్క మార్గాన్ని నిశ్చయాత్మకంగా ఉపదేశించుము.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "జ్యాయసీ చేత్కర్మణస్తే మతా బుద్ధిర్జనార్దన ।"
                            },
                            {
                                "des": "తత్కిం కర్మణి ఘోరే మాం నియోజయసి కేశవ ।। 1 ।।"
                            },
                            {
                                "des": "వ్యామిశ్రేణేవ వాక్యేన బుద్ధిం మోహయసీవ మే ।"
                            },
                            {
                                "des": "తదేకం వద నిశ్చిత్య యేన శ్రేయోఽహమాప్నుయామ్ ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "భగవంతుడు ఈ విధంగా పలికెను : ఓ పాపరహితుడా, భగవత్-ప్రాప్తి (జ్ఞానోదయము) కి కల రెండు మార్గములు ఇంతకు పూర్వమే నాచే చెప్పబడినవి : ధ్యాన నిష్ఠయందు ఆసక్తి కలవారికి జ్ఞాన మార్గము; పనుల పట్ల ఆసక్తి కలవారికి కర్మ మార్గము.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "లోకేఽస్మిన్ ద్వివిధా నిష్ఠా పురా ప్రోక్తా మయానఘ ।"
                            },
                            {
                                "des": "జ్ఞానయోగేన సాంఖ్యానాం కర్మయోగేన యోగినామ్ ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "మనుష్యుడు కర్మలను ఆచరింపకుండా ఉండి కర్మ బంధము (ప్రతిక్రియ) ల నుండి విముక్తి పొందలేడు. అలాగే, కేవలం బాహ్య (భౌతిక) సన్యాసము ద్వారా జ్ఞాన సిద్ధిని పొందజాలడు.",
                        "description": [
                            {
                                "des": "న కర్మణామనారంభాత్ నైష్కర్మ్యం పురుషోఽశ్నుతే ।"
                            },
                            {
                                "des": "న చ సన్న్యసనాదేవ సిద్ధిం సమధిగచ్ఛతి ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "ఎవ్వరూకూడా ఒక్క క్షణం కూడా కర్మను ఆచరించకుండా ఉండలేరు. నిజానికి, అన్ని ప్రాణులు తమతమ ప్రకృతి జనితమైన స్వభావాలచే (త్రి-గుణములు) ప్రేరితమై కర్మలు చేయవలసియే ఉండును.",
                        "description": [
                            {
                                "des": "న హి కశ్చిత్ క్షణమపి జాతు తిష్ఠత్యకర్మకృత్ ।"
                            },
                            {
                                "des": "కార్యతే హ్యవశః కర్మ సర్వః ప్రకృతిజైర్గుణైః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "బాహ్యమైన కర్మేంద్రియములను అదుపులో ఉంచినా, మనస్సులో మాత్రం ఇంద్రియ విషయముల పైనే చింతన చేస్తూ ఉండే వారు తమని తామే మోసం చేసుకునే వారు, అలాంటి వారు కపటులు అనబడుతారు.",
                        "description": [
                            {
                                "des": "కర్మేంద్రియాణి సంయమ్య య ఆస్తే మనసా స్మరన్ ।"
                            },
                            {
                                "des": "ఇంద్రియార్థాన్ విమూఢాత్మా మిథ్యాచారః స ఉచ్యతే ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "కానీ, అర్జునా, తమ జ్ఞానేంద్రియములను మనస్సుతో అదుపు చేసి, కర్మేంద్రియములతో మమకార/ఆసక్తులు లేకుండా పనిచేసే కర్మ యోగులు, నిజంగా ఏంతో శ్రేష్ఠులు.",
                        "description": [
                            {
                                "des": "యస్త్వింద్రియాణి మనసా నియమ్యారభతేఽర్జున ।"
                            },
                            {
                                "des": "కర్మేంద్రియైః కర్మయోగమసక్తః స విశిష్యతే ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "కాబట్టి నీవు వేదముల అనుగుణంగా విధింపబడ్డ కర్తవ్యమును నిర్వర్తించాలి, ఎందుకంటే పనులు చేయటం అనేది క్రియారాహిత్యము (ఊరికే వుండడము) కన్నా ఉత్తమమైనది. క్రియాకలాపములను విడిచి పెట్టడం వలన శరీర నిర్వహణ కూడా సాధ్యం కాదు.",
                        "description": [
                            {
                                "des": "నియతం కురు కర్మ త్వం కర్మ జ్యాయో హ్యకర్మణః ।"
                            },
                            {
                                "des": "శరీరయాత్రాపి చ తే న ప్రసిద్ధ్యేదకర్మణః ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "పనులని ఒక యజ్ఞం లాగా, భగవత్ అర్పితంగా చేయాలి, లేదా, ఆ పనులు మనలను ఈ జగత్తులో కర్మబంధములలో కట్టివేస్తాయి. కాబట్టి, ఓ కుంతీ పుత్రుడా, నీకు నిర్దేశింపబడిన విధులను, వాటి ఫలితములపై ఆసక్తి లేకుండా, ఈశ్వర తృప్తి కోసం నిర్వర్తించుము.",
                        "description": [
                            {
                                "des": "యజ్ఞార్ధాత్ కర్మణోఽన్యత్ర లోకోఽయం కర్మబంధనః ।"
                            },
                            {
                                "des": "తదర్థం కర్మ కౌంతేయ ముక్తసంగః సమాచర ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "సృష్టి ప్రారంభంలో, బ్రహ్మ దేవుడు, మానవజాతిని వాటి విధులతో పాటుగా సృష్టించి ఇలా చెప్పాడు, ఈ యజ్ఞములను ఆచరించటం ద్వారా వృద్ది చెందండి. ఇవే మీ సమస్త కోరికలను తీరుస్తాయి.",
                        "description": [
                            {
                                "des": "సహయజ్ఞాః ప్రజాః సృష్ట్వా పురోవాచ ప్రజాపతిః ।"
                            },
                            {
                                "des": "అనేన ప్రసవిష్యధ్వమేష వోఽస్త్విష్టకామధుక్ ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "మీ యజ్ఞముల ద్వారా దేవతలు ప్రీతి చెందుతారు. దేవతల, మనుష్యుల పరస్పర సహకారం వలన అందరికీ శేయస్సు/సౌభాగ్యం కలుగుతుంది.",
                        "description": [
                            {
                                "des": "దేవాన్ భావయతానేన తే దేవా భావయంతు వః ।"
                            },
                            {
                                "des": "పరస్పరం భావయంతః శ్రేయః పరమవాప్స్యథ ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "యజ్ఞములు చేయటము వలన తృప్తి చెందిన దేవతలు, జీవిత నిర్వహణకు అవసరమైన అన్నింటిని ప్రసాదిస్తారు. తమకు ఇవ్వబడిన దానిని, దేవతలకు తిరిగి నివేదించకుండా, తామే అనుభవించే వారు, నిజానికి దొంగలే.",
                        "description": [
                            {
                                "des": "ఇష్టాన్ భోగాన్ హి వో దేవా దాస్యంతే యజ్ఞభావితాః ।"
                            },
                            {
                                "des": "తైర్ధత్తానప్రదాయైభ్యో యో భుంక్తే స్తేన ఏవ సః ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "యజ్ఞములో మొదట నివేదించగా మిగిలిన ఆహారమునే భుజించే, ఆధ్యాత్మిక మనసున్న సత్పురుషులు సర్వ పాపముల నుండి ముక్తులవుతారు. తమ భోగమునకే అన్నం వండుకునే వారు పాపమునే భుజింతురు.",
                        "description": [
                            {
                                "des": "యజ్ఞశిష్టాశినః సంతో ముచ్యంతే సర్వకిల్బిషైః ।"
                            },
                            {
                                "des": "భుంజతే తే త్వఘం పాపా యే పచంత్యాత్మకారణాత్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ప్రాణులు అన్నీ ఆహారం వలననే జీవిస్తాయి మరియు ఆహారం వర్షముల వలన ఉత్పన్నమవుతుంది. యజ్ఞములు చేయటం వలన వానలు కురుస్తాయి మరియు నిర్దేశింపబడిన కర్తవ్యముల (విహిత కర్మలు) ఆచరణచే యజ్ఞము జనిస్తుంది.",
                        "description": [
                            {
                                "des": "అన్నాద్భవంతి భూతాని పర్జన్యాదన్నసంభవః ।"
                            },
                            {
                                "des": "యజ్ఞాద్భవతి పర్జన్యో యజ్ఞః కర్మసముద్భవః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "మానవుల విహిత కర్మలు (కర్తవ్యములు) వేదములలో చెప్పబడ్డాయి, మరియు వేదములు ఆ భగవంతుని నుండే వ్యక్తమయ్యాయి. కాబట్టి సర్వ వ్యాపి అయిన భగవంతుడు నిత్యము యజ్ఞ కార్యములలో స్థితుడైఉంటాడు.",
                        "description": [
                            {
                                "des": "కర్మ బ్రహ్మోద్భవం విద్ధి బ్రహ్మాక్షరసముధ్భవమ్ ।।"
                            },
                            {
                                "des": "తస్మాత్ సర్వగతం బ్రహ్మ నిత్యం యజ్ఞే ప్రతిష్ఠితమ్ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "వేదములచే నిర్దేశించబడిన ఈ యజ్ఞ చక్రములో తన భాద్యతను నెరవేర్చని వారు పాపులు. వారు తమ ఇంద్రియ భోగముల కోసమే జీవిస్తారు; అట్టి వారి జీవితము వ్యర్థం.",
                        "description": [
                            {
                                "des": "ఏవం ప్రవర్తితం చక్రం నానువర్తయతీహ యః ।"
                            },
                            {
                                "des": "అఘాయురింద్రియారామో మోఘం పార్థ స జీవతి ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "కానీ ఎవరైతే ఆత్మయందే రమింతురో, పరిపూర్ణ జ్ఞానంతో, ఆత్మ యందే సంతుష్టులుగా ఉందురో, వారికి ఎట్టి కర్తవ్యమూ ఉండదు.",
                        "description": [
                            {
                                "des": "యస్త్వాత్మరతిరేవ స్యాదాత్మతృప్తశ్చ మానవః ।"
                            },
                            {
                                "des": "ఆత్మన్యేవ చ సంతుష్టః తస్య కార్యం న విద్యతే ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "ఇటువంటి ఆత్మ జ్ఞానులైన వారు తమ విధులను (కర్మలను) చేయటం వలన కానీ, చేయకపోవటం వలన కానీ, వారికి వచ్చేది, పోయేవి (లాభనష్టాలు) ఏమీ ఉండవు. తమ స్వార్థ ప్రయోజనం కోసం వారు ఇతర జీవుల మీద ఆధార పడవలసిన అవసరమూ లేదు.",
                        "description": [
                            {
                                "des": "నైవ తస్య కృతేనార్థో నాకృతేనేహ కశ్చన ।"
                            },
                            {
                                "des": "న చాస్య సర్వభూతేషు కశ్చిదర్థవ్యపాశ్రయః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "కాబట్టి, మమకార బంధాలను విడిచిపెట్టి, ఆసక్తి రహితుడవై, నీ పనులను ఒక కర్తవ్యములాగా నిర్వహించుము. కర్మ ఫలములపై ఆసక్తి లేకుండా పని చేయటం వలన మానవుడు ఆ పరమాత్మను చేరుకోగలడు.",
                        "description": [
                            {
                                "des": "తస్మాత్ అసక్తః సతతం కార్యం కర్మ సమాచర ।"
                            },
                            {
                                "des": "అసక్తో హ్యాచరన్ కర్మ పరమాప్నోతి పూరుషః ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20-21 శ్లోకాలు",
                        "bhavam": "తమ ధర్మములను (విహిత కర్మలను) నిర్వర్తించటం ద్వారానే, జనక మహారాజు వంటి వారు సిద్దిని పొందితిరి. ప్రపంచానికి ఒక చక్కటి ఆదర్శం చూపటానికి నీవు కూడా నీ కర్తవ్య నిర్వహణ చేయాలి. గొప్పవారు చేసే పనులను సామాన్య జనులు అనుకరిస్తారు. వారు నెలకొల్పిన ప్రమాణాన్నే, ప్రపంచమంతా అనుసరిస్తారు.",
                        "description": [
                            {
                                "des": "కర్మణైవ హి సంసిద్ధిమాస్థితా జనకాదయః ।"
                            },
                            {
                                "des": "లోకసంగ్రహమేవాపి సంపశ్యన్ కర్తుమర్హసి ।। 20 ।।"
                            },
                            {
                                "des": "యద్యదాచరతి శ్రేష్ఠః తత్త దేవేతరో జనః ।"
                            },
                            {
                                "des": "స యత్ప్రమాణం కురుతే లోకస్తదనువర్తతే ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఈ మూడు లోకాల్లో నాకు చేయవలసిన కర్తవ్యం ఏమీ లేదు, అర్జునా, నాకు పొందవలసినది ఏమీ లేదు, సాధించవలసినదీ లేదు. అయినా నేను చేయవలిసిన విధులను చేస్తూనే ఉంటాను.",
                        "description": [
                            {
                                "des": "న మే పార్థాస్తి కర్తవ్యం త్రిషు లోకేషు కించన ।"
                            },
                            {
                                "des": "నానవాప్తమవాప్తవ్యం వర్త ఏవ చ కర్మణి ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "నేను నా విహిత కర్మలను జాగ్రత్తగా చేయనిచో, ఓ పార్థా, అందరు మనుష్యులు నా దారినే అన్ని విధాలుగా అనుసరిస్తారు.",
                        "description": [
                            {
                                "des": "యది హ్యయం న వర్తేయం జాతు కర్మణ్యతంద్రితః ।"
                            },
                            {
                                "des": "మమ వర్త్మానువర్తంతే మనుష్యాః పార్థ సర్వశః ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "నేను నా కర్తవ్యములను చేయకపోతే, ఈ సమస్త లోకాలు నాశనమవుతాయి. జరిగే అల్లకల్లోలానికి నేనే బాధ్యుడనవుతాను, మరియు మానవ జాతికి శాంతి లేకుండా అవుతుంది.",
                        "description": [
                            {
                                "des": "ఉత్సీదేయురిమే లోకా న కుర్యాం కర్మ చేదహమ్ ।"
                            },
                            {
                                "des": "సంకరస్య చ కర్తా స్యాముపహన్యామిమాః ప్రజాః ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "అజ్ఞానులు కర్మ ఫలముల యందు ఆసక్తి/మమకారం తో తమ విధులను నిర్వర్తించినట్లుగా, ఓ భరత వంశీయుడా, జ్ఞానులు కూడా (లోకహితం కోసం), జనులకు సరియైన మార్గదర్శకం చేయటం కోసం తమ కర్మలను ఆచరించాలి.",
                        "description": [
                            {
                                "des": "సక్తాః కర్మణ్యవిద్వాంసో యథా కుర్వంతి భారత ।"
                            },
                            {
                                "des": "కుర్యాద్విద్వాంస్తథాసక్తః చికీర్షుర్లోకసంగ్రహమ్ ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "కర్మలను ఆచరించకుండా ప్రేరేపించటం ద్వారా, ఫలాసక్తి తో కర్మలను చేసే అజ్ఞానుల బుద్ధిని, జ్ఞానులు భ్రమకు గురిచేయరాదు. అంతేకాక, జ్ఞానోదయ స్థితిలో తమ విధులను నిర్వర్తిస్తూ, అజ్ఞానులకు కూడా విహిత కర్మలను చేయటానికి స్ఫూర్తినివ్వవలెను.",
                        "description": [
                            {
                                "des": "న బుద్దిభేదం జనయేదజ్ఞానాం కర్మసంగినామ్ ।"
                            },
                            {
                                "des": "జోషయేత్ సర్వకర్మాణి విద్వాన్ యుక్తః సమాచరన్ ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "అన్ని కార్యములు కూడా ప్రకృతి త్రిగుణముల చేతనే చేయబడును. కానీ, అజ్ఞానంలో, జీవాత్మ, తను ఈ శరీరమే అన్న భ్రమ తో, తనే కర్తను (చేసేవాడిని) అని అనుకుంటుంది.",
                        "description": [
                            {
                                "des": "ప్రకృతేః క్రియమాణాని గుణైః కర్మాణి సర్వశః ।"
                            },
                            {
                                "des": "అహంకారవిమూఢాత్మా కర్తాఽహమితి మన్యతే ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "ఓ మహా బాహువులున్న అర్జునా, జ్ఞానులు జీవాత్మను, గుణములు, కర్మ నుండి వేరుగా చూస్తారు. గుణములే (ఇంద్రియములు, మనస్సు రూపంలో ఉన్న) గుణముల యందు (ఇంద్రియ గ్రాహ్య విషయ వస్తు రూపంలో) కదులుతున్నవని తెలుసుకుని వాటి యందు ఆసక్తులు కారు.",
                        "description": [
                            {
                                "des": "తత్త్వవిత్తు మహాబాహో గుణకర్మవిభాగయోః ।"
                            },
                            {
                                "des": "గుణా గుణేషు వర్తంత ఇతి మత్వా న సజ్జతే ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "గుణముల ప్రవృత్తిచే భ్రమకు లోనయిన వారు, వారి కర్మ ఫలముల యందు ఆసక్తులవుతారు. కానీ, ఈ సత్యములను అర్థం చేసుకున్న జ్ఞానులు, ఇది తెలియని అజ్ఞానులను కలవర పరచరాదు.",
                        "description": [
                            {
                                "des": "ప్రకృతేర్గుణ సమ్మూఢాః సజ్జంతే గుణకర్మసు ।"
                            },
                            {
                                "des": "తానకృత్స్నవిదో మందాన్ కృత్స్నవిన్న విచాలయేత్ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "అన్ని కార్యములను నాకు అర్పితముగా చేసి, పరమేశ్వరుడైన నాయందే నిరంతరం నీ ధ్యాస ఉంచుము. ఆశ, స్వార్ధ చింతన విడిచి మరియు మానసిక శోకము వీడినవాడివై, యుద్ధం చేయుము!",
                        "description": [
                            {
                                "des": "మయి సర్వాణి కర్మాణి సన్న్యస్యాధ్యాత్మచేతసా ।"
                            },
                            {
                                "des": "నిరాశీర్నిర్మమో భూత్వా యుధ్యస్వ విగతజ్వరః ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "పూర్తి శ్రద్ధ, విశ్వాసంతో, దోష విచారణ లేకుండా, నా ఈ బోధను పాటించే వారు కర్మ బంధముల నుండి విముక్తులవుతారు.",
                        "description": [
                            {
                                "des": "యే మే మతమిదం నిత్యమనుతిష్ఠంతి మానవాః ।"
                            },
                            {
                                "des": "శ్రద్ధావంతోఽనసూయంతో ముచ్యంతే తేఽపి కర్మభిః ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "కానీ, నా ఈ బోధనలో లోపాలను వెతికేవారు, జ్ఞానం-విచక్షణలు లోపించి, ఈ సిద్ధాంతములను నిర్లక్ష్యముచేసి తమ భ్రష్టత్వాన్ని కోరి తెచ్చుకుంటారు.",
                        "description": [
                            {
                                "des": "యే త్వేతదభ్యసూయంతో నానుతిష్ఠంతి మే మతమ్ ।"
                            },
                            {
                                "des": "సర్వజ్ఞాన విమూఢాంస్తాన్ విద్ధి నష్టానచేతసః ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "వివేకవంతులు కూడా తమ ప్రకృతి స్వభావం అనుసరించి పనులు చేస్తారు. అన్ని ప్రాణులు తమ తమ సహజ ప్రవృత్తికి అనుగుణంగా నడుచుకుంటాయి. దీనిని నిగ్రహించటం వల్ల ఏమి ప్రయోజనం?",
                        "description": [
                            {
                                "des": "సదృశం చేష్టతే స్వస్యాః ప్రకృతేః జ్ఞానవానపి ।"
                            },
                            {
                                "des": "ప్రకృతిం యాంతి భూతాని నిగ్రహః కిం కరిష్యతి ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఇంద్రియములు సహజంగానే ఇంద్రియ వస్తు/విషయములపై రాగ ద్వేషములు కలిగి ఉంటాయి, కానీ వాటికి వశము కాకూడదు, ఎందుకంటే ఇవే మనకు ప్రతిబంధకములు మరియు శత్రువులు.",
                        "description": [
                            {
                                "des": "ఇంద్రియస్యేంద్రియస్యార్థే రాగద్వేషౌ వ్యవస్థితౌ ।"
                            },
                            {
                                "des": "తయోర్న వశమాగచ్చేత్ తౌ హ్యస్య పరిపన్థినౌ ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "ఇతరుల ధర్మాన్ని చక్కగా చేయటం కన్నా, లోపాలతో కూడి ఉన్నా సరే, తన సహజ ధర్మాన్ని నిర్వర్తించటమే అత్యుత్తమము. నిజానికి, స్వధర్మాన్ని నిర్వర్తించటంలో మరణించినా మంచిదే, కానీ ఇతరుల మార్గం (ఇతర ధర్మాన్ని చేయటం) అనుసరించటం ప్రమాదకరమైనది.",
                        "description": [
                            {
                                "des": "శ్రేయాన్ స్వధర్మో విగుణః పరధర్మాత్ స్వనుష్ఠితాత్ ।"
                            },
                            {
                                "des": "స్వధర్మే నిధనం శ్రేయః పరధర్మో భయావహః ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : ఓ వృష్ణి వంశీయుడా (శ్రీ కృష్ణా), ఎందుకు ఒక వ్యక్తి అయిష్టంగానయినా, బలవంతంగా ఏదోశక్తి చేపించినట్టు, పాపపు పనులు చేయటానికి ప్రేరేపింపబడును?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "అథ కేన ప్రయుక్తోఽయం పాపం చరతి పూరుషః ।"
                            },
                            {
                                "des": "అనిచ్ఛన్నపి వార్ష్ణేయ బలాదివ నియోజితః ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: రజో గుణము నుండి ఉత్పన్నమయ్యే కామమే (కోరికలు, వాంఛలు), తదుపరి క్రోధముగా పరిణామం చెందుతుంది. దీనిని లోకంలో సర్వనాశనం చేసే పాపిష్టి దాన్నిగా తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "కామ ఏష క్రోధ ఏష రజోగుణసముధ్భవః ।"
                            },
                            {
                                "des": "మహాశనో మహాపాప్మా విధ్ధ్యేనమిహ వైరిణమ్ ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "నిప్పు పొగచే కప్పబడినట్టుగా, దుమ్ము చే అద్దం మసకబారినట్టుగా, గర్భాయశము చే భ్రూణ శిశువు ఆచ్ఛాదింపబడ్డట్టుగా - ఒక వ్యక్తి యొక్క జ్ఞానము, కామము (కోరిక) చే కమ్మివేయబడుతుంది.",
                        "description": [
                            {
                                "des": "ధూమేనావ్రియతే వహ్నిః యథాదర్శో మలేన చ ।"
                            },
                            {
                                "des": "యథోల్బేనావృతో గర్భస్తథా తేనేదమావృతమ్ ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "అత్యంత వివేకవంతుల జ్ఞానం కూడా కోరికల రూపంలో ఉన్న శత్రువు చే కప్పివేయబడుతుంది, ఇది ఎప్పటికీ తృప్తిపఱుచలేనిది, అగ్నిలాగ మండుతూనే ఉంటుంది, ఓ కుంతీ పుత్రుడా.",
                        "description": [
                            {
                                "des": "ఆవృతం జ్ఞానమేతేన జ్ఞానినో నిత్యవైరిణా ।"
                            },
                            {
                                "des": "కామరూపేణ కౌంతేయ దుష్పూరేణానలేన చ ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "ఇంద్రియములు, మనస్సు, బుద్ధి - ఇవి కోరికల మూల స్థానం అని చెప్పబడును. వాటి ద్వారా అది, వ్యక్తి జ్ఞానాన్ని మరుగుపరుస్తుంది మరియు జీవాత్మని భ్రమకి గురి చేస్తుంది",
                        "description": [
                            {
                                "des": "ఇంద్రియాణి మనో బుద్ధిరస్యాధిష్ఠానముచ్యతే ।"
                            },
                            {
                                "des": "ఏతైర్విమోహయత్యేష జ్ఞానమావృత్య దేహినమ్ ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "కాబట్టి ఓ భరత శ్రేష్టుడా, మొదట్లోనే ఇంద్రియములను నియంత్రణ లోనికి తెచ్చి, జ్ఞాన విజ్ఞానములను నశింపచేసే ఈ పరమ పాపిష్టి కామము (కోరికలు) అనే శత్రువును నిర్మూలించుము.",
                        "description": [
                            {
                                "des": "తస్మాత్ త్వమింద్రియాణ్యాదౌ నియమ్య భరతర్షభ ।"
                            },
                            {
                                "des": "పాప్మానం ప్రజహి హ్యేనం జ్ఞానవిజ్ఞాననాశనమ్ ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42 వ శ్లోకం",
                        "bhavam": "స్థూల శరీరం కన్నా ఇంద్రియములు ఉన్నతమైనవి, ఇంద్రియముల కన్నా మనస్సు ఉన్నతమైనది. మనస్సు కన్నా ఉన్నతమైనది బుద్ధి మరియు బుద్ధి కన్నా మరింత ఉన్నతమైనది ఆత్మ.",
                        "description": [
                            {
                                "des": "ఇంద్రియాణి పరాణ్యాహుః ఇంద్రియేభ్యః పరం మనః ।"
                            },
                            {
                                "des": "మనసస్తు పరా బుద్ధిః యో బుద్ధేః పరతస్తు సః ।। 42 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "43 వ శ్లోకం",
                        "bhavam": "ఈ విధంగా జీవాత్మ అనేది భౌతికమైన బుద్ధి కన్నా ఉన్నతమైనది అని తెలుసుకొని, ఓ మహాబాహువులు కలవాడా, నిన్ను (ఇంద్రియమనోబుద్ధులను), నీవు (ఆత్మ శక్తి ద్వారా) వశపరుచుకోనుము, మరియు కామమనే బలీయమైన శత్రువును సంహరింపుము.",
                        "description": [
                            {
                                "des": "ఏవం బుద్ధేః పరం బుద్ధ్వా సంస్తభ్యాత్మానమాత్మనా ।"
                            },
                            {
                                "des": "జహి శత్రుం మహాబాహో కామరూపం దురాసదమ్ ।। 43 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "జ్ఞాన యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/04.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/04.png'),
                "index":4,
                "introduction": [
                    {
                        "para": "నాలుగవ అధ్యాయంలో, తను ఉపదేశించే ఈ జ్ఞానంపై, దాని యొక్క సనాతనమైన మూలాన్ని తెలియచేయటం ద్వారా, అర్జునుడి విశ్వాసాన్ని ధృఢపరుస్తున్నాడు, శ్రీ కృష్ణుడు. ఈ సనాతనమైన శాస్త్రాన్ని తాను ప్రారంభంలో సూర్య భగవానుడికి చెప్పానని, ఆ తరువాత పరంపరగా మహాత్ములైన రాజులకు అందించబడింది అని కృష్ణుడు వివరించాడు. ఇప్పుడు అదే మహోన్నతమైన యోగ శాస్త్రమును, తన ప్రియ మిత్రుడు, భక్తుడు అయిన అర్జునుడికి తెలియపరుస్తున్నాడు. ఇప్పుడు కళ్ళెదురుగా ఉన్న శ్రీ కృష్ణుడు, అప్పుడెప్పుడో సూర్య భగవానునికి ఈ శాస్త్రాన్ని ఎలా చెప్పాడని అర్జునుడు అడుగుతాడు. జవాబుగా శ్రీ కృష్ణుడు తన అవతార దివ్య రహస్యాన్ని తెలియపరుస్తాడు. భగవంతుడు సనాతనుడు, పుట్టుకలేని వాడు అయినా, తన యోగమాయా శక్తి చే, ధర్మాన్ని పరిరక్షించటానికి, ఈ భూలోకం లోకి దిగివస్తాడని చెప్తాడు. కానీ, ఆయన జన్మ, కర్మలు దివ్యమైనవి, అవి ఎన్నటికీ భౌతిక దోషములచే కళంకితం కావు. ఈ రహస్యం తెలిసినవారు, ధృడవిశ్వాసంతో భక్తిలో నిమగ్నమవుతారు, మరియు ఆయనను పొందిన తరువాత, ఈ లోకంలో తిరిగి జన్మనెత్తరు."
                    },
                    {
                        "para": "తదుపరి, ఈ అధ్యాయం, కర్మల స్వభావాన్ని విశదీకరిస్తుంది మరియు - కర్మ, అకర్మ మరియు వికర్మ అనబడే మూడు సూత్రాలను వివరిస్తుంది. కర్మ యోగులు ఏంతో నిమగ్నమయిన పనులలో ఉన్నా ఏవిధంగా అకర్మ స్థితిలో ఉంటారో, తద్వారా ఎలా కర్మ బంధాలలో చిక్కుకోరో ఇది వివరిస్తుంది. ఈ విజ్ఞానంతో ప్రాచీన మునులు - జయాపజయాలతో సంబంధం లేకుండా, సుఖ-దుఃఖాలను ఒకేలాగ పరిగణిస్తూ, కేవలం ఒక యజ్ఞం లాగా భగవంతుని ప్రీతి కోసం తమ పనులను/కర్మలను ఆచరించేవారు. యజ్ఞం అనేది చాలా విధాలుగా ఉంటుంది, అందులో చాలా రకాలు ఇక్కడ చెప్పబడ్డాయి. యజ్ఞం అనేది సరిగ్గా అర్పణచేయబడ్డప్పుడు దాని అవశేషం అమృతంలా అవుతుంది. అలాంటి అమృతం స్వీకరించినప్పుడు, కర్తలు మలిన శుద్ధి చేయబడుతారు. కాబట్టి యజ్ఞం అనేది ఎప్పుడైనా సరియైన దృక్పథం తో, సరియైన జ్ఞానం తో చెయ్యబడాలి. ఈ జ్ఞానమనే నావ సహాయంతో మహా పాపాత్ములు కూడా లౌకిక దుఃఖ సాగరాన్ని దాటవచ్చు. పరమ సత్యాన్ని ఎరిగిన ఒక నిజమైన ఆధ్యాత్మిక గురువు ద్వారా, ఇటువంటి జ్ఞానాన్నినేర్చుకోవాలి. అర్జునుడి గురువుగా, అతన్ని జ్ఞానమనే ఖడ్గం తీసుకుని తన హృదయంలో జనించిన సందేహాలని ముక్కలుగా ఖండించి, లేచి తన కర్తవ్యాన్ని నిర్వర్తించమంటున్నాడు, శ్రీ కృష్ణుడు"
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "శ్రీ కృష్ణ పరమాత్మ ఇలా అన్నాడు: నేను ఈ యొక్క సనాతనమైన యోగ శాస్త్రమును సూర్య భగవానుడైన వివస్వానుడికి చెప్పాను. అతను మనువుకి, మనువు ఇక్ష్వాకునికి దీనిని ఉపదేశించారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ఇమం వివస్వతే యోగం ప్రోక్తవానహమవ్యయమ్ ।"
                            },
                            {
                                "des": "వివస్వాన్మనవే ప్రాహ మనురిక్ష్వాకవేఽబ్రవీత్ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "ఓ శత్రువులను జయించేవాడా, రాజర్షులు ఈ విధముగా యోగ శాస్త్రమును పరంపరలో పొందినారు. కానీ కాలగమనంలో అది ఈ లోకంలో లుప్తమైపోయినది (క్షీణించి పోయినది).",
                        "description": [
                            {
                                "des": "ఏవం పరంపరాప్రాప్తమిమం రాజర్షయో విదుః ।"
                            },
                            {
                                "des": "స కాలేనేహ మహతా యోగో నష్టః పరంతప ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "అదే ప్రాచీనమైన పరమ రహస్యమైన, ఈ యోగ విజ్ఞాన శాస్త్రమును నేను నీకు ఈరోజు తెలియచేస్తున్నాను. ఎందుకంటే, నీవు నా మిత్రుడవు మరియు భక్తుడవు, ఈ అలౌకిక జ్ఞానాన్ని అర్థం చేసుకోగలవాడవు.",
                        "description": [
                            {
                                "des": "స ఏవాయం మయా తేఽద్య యోగః ప్రోక్తః పురాతనః ।"
                            },
                            {
                                "des": "భక్తోఽసి మే సఖా చేతి రహస్యం హ్యేతదుత్తమమ్ ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు : నీవు వివస్వనుడి తరువాత ఏంతో కాలానికి పుట్టావు. మరి నీవు ఈ విద్యని అతనికి ప్రారంభంలోనే ఉపదేశించావు, అంటే నేను దాన్ని ఎలా అర్థం చేసుకోవాలి?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "అపరం భవతో జన్మ పరం జన్మ వివస్వతః ।"
                            },
                            {
                                "des": "కథమేతద్విజానీయాం త్వమాదౌ ప్రోక్తవానితి ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా అన్నాడు: మన ఇద్దరికీ ఎన్నో జన్మలు గడచినవి. ఓ అర్జునా, నీవు వాటిని మరిచిపోయావు, కానీ, అవన్నీ నాకు జ్ఞాపకం ఉన్నాయి, ఓ పరంతపా.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "బహూని మే వ్యతీతాని జన్మాని తవ చార్జున ।"
                            },
                            {
                                "des": "తాన్యహం వేద సర్వాణి న త్వం వేత్థ పరంతప ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "నేను పుట్టుకలేని వాడిని అయిఉండి కూడా, సమస్త ప్రాణులకు ప్రభువునై ఉండి కూడా, నాశములేని వాడినై ఉండి కూడా, నేను ఈ లోకంలో నా దివ్య శక్తి, యోగమాయచే కనిపిస్తుంటాను.",
                        "description": [
                            {
                                "des": "అజోఽపి సన్నవ్యయాత్మా భూతానామీశ్వరోఽపి సన్ ।"
                            },
                            {
                                "des": "ప్రకృతిం స్వామధిష్ఠాయ సంభవామ్యాత్మమాయయా ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఎప్పుడెప్పుడైతే ధర్మము క్షీణించునో, అధర్మము ప్రబలునో, ఓ అర్జునా, ఆ సమయంలో నన్ను నేను భూలోకంలో సృజించుకుంటాను.",
                        "description": [
                            {
                                "des": "యదా యదా హి ధర్మస్య గ్లానిర్భవతి భారత ।"
                            },
                            {
                                "des": "అభ్యుత్థానమధర్మస్య తదాత్మానం సృజామ్యహమ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "ధర్మాత్ములను కాపాడటానికి, దుష్టులను నిర్మూలించటానికి, మరియు ధర్మ సూత్రములను తిరిగి స్థాపించటానికి నేను ఈ లోకంలో ప్రతి యుగము నందు అవతరిస్తాను.",
                        "description": [
                            {
                                "des": "పరిత్రాణాయ సాధూనాం వినాశాయ చ దుష్కృతామ్ ।"
                            },
                            {
                                "des": "ధర్మసంస్థాపనార్థాయ సంభవామి యుగే యుగే ।। 8 ।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "నా యొక్క జన్మ మరియు కర్మల దివ్య స్వభావాన్ని ఎవరైతే అర్థంచేసుకుంటారో, ఓ అర్జునా, వారు తమ దేహం విడిచిపెట్టిన తరువాత తిరిగి జన్మనెత్తరు, నా నిత్యశాశ్వత ధామానికే వస్తారు.",
                        "description": [
                            {
                                "des": "జన్మ కర్మ చ మే దివ్యమ్ ఏవం యో వేత్తి తత్త్వతః ।"
                            },
                            {
                                "des": "త్యక్త్వా దేహం పునర్జన్మ నైతి మామేతి సొఽర్జున ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "రాగ-ద్వేష-క్రోధ రహితముగా ఉండి, నాయందే సంపూర్ణంగా స్థితులై ఉండి, నన్నే ఆశ్రయించి ఎంతో మంది ఇంతకు పూర్వం నా యొక్క జ్ఞానం చే పవిత్రులైనారు మరియు ఆ విధంగా నా దివ్య ప్రేమను పొందారు.",
                        "description": [
                            {
                                "des": "వీతరాగభయక్రోధా మన్మయా మాముపాశ్రితాః ।"
                            },
                            {
                                "des": "బహావో జ్ఞానతపసా పూతా మద్భావమాగతాః ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "నాకు ఏ ప్రకారంగా మనుజులు శరణాగతి చేస్తారో, నేను వారికి ఆ విధంగా ప్రతిస్పందిస్తాను. తెలిసినా, తెలియకపోయినా, అందరూ నా మార్గాన్ని అనుసరించాల్సిందే, ఓ అర్జునా.",
                        "description": [
                            {
                                "des": "యే యథా మాం ప్రపద్యంతే తాంస్తథైవ భజామ్యహమ్"
                            },
                            {
                                "des": "మమ వర్త్మానువర్తంతే మనుష్యాః పార్థ సర్వశః ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "ఈ లోకంలో భౌతిక(లౌకిక) కర్మలలో విజయం కోసం కోరికతో ఉండేవారు దేవతలను పూజిస్తారు, ఎందుకంటే భౌతిక ప్రతిఫలాలు త్వరగానే సిద్ధిస్తాయి.",
                        "description": [
                            {
                                "des": "కాంక్షంతః కర్మణాం సిద్ధిం యజంత ఇహ దేవతాః ।"
                            },
                            {
                                "des": "క్షిప్రం హి మానుషే లోకే సిద్ధిర్భవతి కర్మజా ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "జనుల గుణములు, కార్యకలాపముల ఆధారంగా, నాలుగు రకాల వృత్తి ధర్మములు నా చేత సృష్టించబడ్డాయి. ఈ వ్యవస్థకి నేనే సృష్టికర్త అయినా నన్ను అకర్తగా మరియు సనాతనునిగా తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "చాతుర్వర్ణం మయా సృష్టం గుణకర్మవిభాగశః ।"
                            },
                            {
                                "des": "తస్య కర్తారమపి మాం విద్ధ్యకర్తారమవ్యయమ్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "కర్మలు నన్ను అంటవు, నేను కర్మఫలముల యందు కూడా ఆసక్తుడను కాదు. ఎవరైతే నన్ను ఈవిధంగా తెలుసుకుందురో, వారు కర్మ బంధములలో చిక్కుకోరు.",
                        "description": [
                            {
                                "des": "న మాం కర్మాణి లింపంతి న మే కర్మఫలే స్పృహా ।"
                            },
                            {
                                "des": "ఇతి మాం యోఽభిజానాతి కర్మభిర్న స బధ్యతే ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఈ సత్యమును తెలుసుకొని, ప్రాచీన సమయంలో మోక్షము పొందగోరిన వారు కూడా, తమ కర్మలను ఆచరించారు. కాబట్టి, ప్రాచీన మునుల అడుగుజాడలలో నడుస్తూ, నీవు కూడా నీ కర్తవ్యమును నిర్వర్తించుము.",
                        "description": [
                            {
                                "des": "ఏవం జ్ఞాత్వా కృతం కర్మ పూర్వైరపి ముముక్షుభిః ।"
                            },
                            {
                                "des": "కురు కర్మైవ తస్మాత్త్వం పూర్వైః పూర్వతరం కృతమ్ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "కర్మ అంటే ఏమిటి? అకర్మ అంటే ఏమిటి? వివేకవంతులు కూడా దీనిని అర్థం చేసుకోవటంలో తికమకపడుతున్నారు. ఇప్పుడు నేను నీకు కర్మ రహస్యం వివరిస్తాను, దీనిని తెలుసుకోవటం ద్వారా, నిన్ను నీవు భౌతిక బంధముల నుండి విడిపించుకోవచ్చు.",
                        "description": [
                            {
                                "des": "కిం కర్మ కిమకర్మేతి కవయోఽప్యత్ర మోహితాః ।"
                            },
                            {
                                "des": "తత్తే కర్మ ప్రవక్ష్యామి యద్ జ్ఞాత్వా మోక్ష్యసేఽశుభాత్ ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "కర్మ, వికర్మ, అకర్మ - నీవు ఈ మూడింటి యొక్క స్వభావాన్ని గురించి తప్పకుండా తెలుసుకోవాలి – వీటి గురించి ఉన్న యదార్థం నిగూఢమైనది మరియు అర్థం చేసుకోవటానికి క్లిష్టమైనది.",
                        "description": [
                            {
                                "des": "కర్మణో హ్యపి బోద్ధవ్యం బోద్ధవ్యం చ వికర్మణః ।"
                            },
                            {
                                "des": "అకర్మణశ్చ బోద్ధవ్యం గహనా కర్మణో గతిః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "ఎవరైతే అకర్మ యందు కర్మను మరియు కర్మ యందు అకర్మను దర్శించుదురో వారు మానవులలో నిజమైన బుద్ధిశాలురు. వారు సమస్త కర్మలను చేస్తూనేవున్నా, వారు యోగులు మరియు వారి సమస్త కర్మలను చేయువారు.",
                        "description": [
                            {
                                "des": "కర్మణ్యకర్మ యః పశ్యేత్ అకర్మణి చ కర్మ యః ।"
                            },
                            {
                                "des": "స బుద్దిమాన్మనుశ్యేషు స యుక్తః కృత్స్నకర్మకృత్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఎవరి యొక్క సమస్త కర్మలు భౌతిక సుఖాల వాంఛలకు అతీతంగా ఉంటాయో మరియు ఎవరైతే తమ సమస్త కర్మల ప్రతిక్రియలను జ్ఞానాగ్నిలో భస్మం చేసారో అట్టివారు, జ్ఞానోదయమైన మునులచే, పండితులు అనబడుతారు.",
                        "description": [
                            {
                                "des": "యస్య సర్వే సమారంభాః కామసంకల్పవర్జితాః ।"
                            },
                            {
                                "des": "జ్ఞానాగ్నిదగ్ధకర్మాణం తమాహుః పండితం బుధాః ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఇటువంటి జనులు, తమ కర్మ ఫలములపై ఆసక్తి/మమకారం త్యజించిన పిదప, ఎల్లప్పుడూ తృప్తి తో ఉంటారు మరియు బాహ్య వస్తు-విషయములపై ఆధారపడరు. కర్మలలో నిమగ్నమయి ఉన్నా, వారు ఏమి చేయనట్టే.",
                        "description": [
                            {
                                "des": "త్యక్త్వా కర్మఫలాసంగం నిత్యతృప్తో నిరాశ్రయః ।"
                            },
                            {
                                "des": "కర్మణ్యభిప్రవృత్తోఽపి నైవ కించిత్ కరోతి సః ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "ఆశారహితుడై ఉండి, ఏదీ నాది అన్న భావన లేకుండా, మనసు ఇంద్రియములు పూర్తి నియంత్రణలో ఉంచుకున్నవానికి, శరీరం తో కర్మలు చేస్తూనే ఉన్నా ఏ పాపము అంటదు.",
                        "description": [
                            {
                                "des": "నిరాశీర్యతచిత్తాత్మా త్యక్తసర్వపరిగ్రహః ।"
                            },
                            {
                                "des": "శారీరం కేవలం కర్మ కుర్వన్నాప్నోతి కిల్బిషమ్ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "అప్రయత్నముగానే లభించిన దానితో సంతృప్తి చెంది, అసూయారహితులై, వారు జీవన ద్వందములకు (సుఖ-దుఃఖాలు, లాభ-నష్టాలు వంటివి) అతీతులై ఉంటారు. అన్ని విధముల పనులు చేస్తూనే ఉన్నా, గెలుపు-ఓటమిలలో సమత్వ బుద్ధి తో ఉండి, వారు తమ కర్మలచే బంధింపబడరు.",
                        "description": [
                            {
                                "des": "యదృచ్ఛాలాభసంతుష్టో ద్వంద్వాతీతో విమత్సరః ।"
                            },
                            {
                                "des": "సమః సిద్ధావసిద్దౌ చ కృత్వాపి న నిబధ్యతే ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "అటువంటి వారు ప్రాపంచిక అనుబంధాల నుండి విముక్తి చేయబడుతారు మరియు వారి బుద్ది దివ్య ఆధ్యాత్మిక జ్ఞానంలో స్థితమై ఉంటుంది. వారు చేసే ప్రతి పని, యజ్ఞం (భగవత్ అర్పితము) గా ఉంటుంది కాబట్టి వారు అన్ని రకాల కర్మ ప్రతిచర్య నుండి విముక్తి చేయబడుతారు.",
                        "description": [
                            {
                                "des": "గతసంగస్య ముక్తస్య జ్ఞానవస్థితచేతసః ।"
                            },
                            {
                                "des": "యజ్ఞాయాచరతః కర్మ సమగ్రం ప్రవిలీయతే ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "సంపూర్ణ భగవత్ ధ్యాస లోనే ఉన్న వారికి, హోమ ద్రవ్యము బ్రహ్మమే, దానిని యజ్ఞంలో సమర్పించడానికి ఉపయోగించే స్రువము వంటివి బ్రహ్మమే, యజ్ఞ కర్మ బ్రహ్మమే, యజ్ఞాగ్ని కూడా బ్రహ్మమే. ప్రతిదాన్నీ కూడా ఆవిధంగా భగవంతునిగా చూసే వారు భగవంతుడిని సునాయాసంగా పొందుతారు.",
                        "description": [
                            {
                                "des": "బ్రహ్మార్పణం బ్రహ్మా హవిర్బ్రహ్మాగ్నౌ బ్రహ్మణా హుతమ్ ।"
                            },
                            {
                                "des": "బ్రహ్మైవ తేన గంతవ్యం బ్రహ్మకర్మసమాధినా ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "కొంతమంది యోగులు భౌతికమైన వస్తువులు సమర్పిస్తూ దేవతలను పూజిస్తారు. మరికొంతమంది పరమ సత్యమనే అగ్నిలో తమ ఆత్మనే సమర్పిస్తూ సంపూర్ణంగా ఆరాధిస్తారు.",
                        "description": [
                            {
                                "des": "దైవమేవాపరే యజ్ఞం యోగినః పర్యుపాసతే ।"
                            },
                            {
                                "des": "బ్రహ్మాగ్నావపరే యజ్ఞం యజ్ఞేనైవోపజుహ్వతి ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "మరికొందరు శ్రవణ మరియు ఇతర ఇంద్రియములను ఇంద్రియనిగ్రహణ అనే యజ్ఞాగ్నిలో సమర్పిస్తారు. మరికొందరు శబ్దాది ఇతర ఇంద్రియ విషయములను ఇంద్రియాగ్నిలో ఆహుతిగా సమర్పిస్తారు.",
                        "description": [
                            {
                                "des": "శ్రోత్రాదీనీంద్రియాణ్యన్యే సంయమాగ్నిషు జుహ్వతి ।"
                            },
                            {
                                "des": "శబ్దాదీన్విషయానన్య ఇంద్రియాగ్నిషు జుహ్వతి ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "కొందరు, జ్ఞానము చే ప్రేరణ నొంది, తమ ఇంద్రియ క్రియాకలాపములన్నిటిని మరియు తమ ప్రాణ శక్తిని కూడా, నిగ్రహించిన మనస్సు యొక్క అగ్ని లో సమర్పిస్తారు.",
                        "description": [
                            {
                                "des": "సర్వాణీంద్రియకర్మాణి ప్రాణకర్మాణి చాపరే ।"
                            },
                            {
                                "des": "ఆత్మసంయమయోగాగ్నౌ జుహ్వతి జ్ఞానదీపితే ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "కొందరు తమ సంపదని యజ్ఞంలా సమర్పిస్తారు, మరికొందరు కఠినమైన నిష్ఠలను యజ్ఞంలా సమర్పిస్తారు. కొందరు ఎనిమిదంచెల యోగాభ్యాసాన్ని ఆచరిస్తారు, మరికొందరు, కఠినమైన నిష్ఠలను ఆచరిస్తూ వేద శాస్త్రాలని చదువుతూ జ్ఞానాన్ని పెంచుకోవటమే యజ్ఞం లా చేస్తారు.",
                        "description": [
                            {
                                "des": "ద్రవ్యయజ్ఞాస్తపోయజ్ఞా యోగయజ్ఞాస్తథాపరే ।"
                            },
                            {
                                "des": "స్వాధ్యాయజ్ఞానయజ్ఞాశ్చ యతయః సంశితవ్రతాః ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29-30 శ్లోకాలు",
                        "bhavam": "మరికొందరు లోనికి వచ్చే శ్వాస యందు బయటకు వెళ్ళే శ్వాసను యజ్ఞముగా సమర్పిస్తారు; వేరొకరు బయటకు వెళ్ళే శ్వాస యందు లోనికి వెళ్ళే శ్వాసను సమర్పిస్తారు. కొందరు ప్రాణ శక్తి నియంత్రణ లో నిమగ్నమై, ప్రాణాయామాన్ని నిష్ఠతో అభ్యాసం చేస్తూ లోనికివచ్చే, బయటకు వెళ్ళే శ్వాసల నియంత్రణ చేస్తుంటారు. ఇంకా మరికొందరు, ఆహారాన్ని తగ్గించి, శ్వాసను ప్రాణ శక్తి లో యజ్ఞం గా సమర్పిస్తారు. ఇటువంటి యజ్ఞం తెలిసినవారంతా ఇటువంటి పరిక్రియల ద్వారా తమ తమ మలినముల నుండి శుద్ధి చేయబడుతారు.",
                        "description": [
                            {
                                "des": "అపానే జుహ్వతి ప్రాణం ప్రాణేఽపానం తథాపరే ।"
                            },
                            {
                                "des": "ప్రాణాపానగతీ రుధ్వా ప్రాణాయామపరాయణాః ।। 29 ।।"
                            },
                            {
                                "des": "అపరే నియతేహారాః ప్రాణాన్ ప్రాణేషు జుహ్వతి ।"
                            },
                            {
                                "des": "సర్వేఽప్యేతే యజ్ఞవిదో యజ్ఞక్షపిత కల్మషాః ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "యజ్ఞము యొక్క రహస్యము తెలిసినవారు, దానిని ఆచరించి, అమృతతుల్యమైన దాని శేషము స్వీకరించి, పరమ సత్యం దిశగా పురొగమిస్తారు. ఓ కురు వంశ శ్రేష్టుడా, ఏ విధమైన యజ్ఞము చేయని వారు, ఈ లోకంలో గాని, పరలోకంలో గాని ఎటువంటి సుఖమును పొందజాలరు.",
                        "description": [
                            {
                                "des": "యజ్ఞశిష్టామృతభుజో యాంతి బ్రహ్మ సనాతనమ్ ।"
                            },
                            {
                                "des": "నాయం లోకోఽస్త్యయజ్ఞస్య కుతోఽన్యః కురుసత్తమ ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "ఇలాంటి వివిధ రకాల యజ్ఞములు అన్నీ వేదముల యందు వివరించబడ్డాయి. అవి విభిన్న రకాల పనుల నుండి ఉద్భవించినవి అని తెలుసుకొనుము. ఈ జ్ఞానమే, నీ యొక్క భౌతిక బంధ చిక్కుముడిని ఖండించివేస్తుంది.",
                        "description": [
                            {
                                "des": "ఏవం బహువిధా యజ్ఞా వితతా బ్రహ్మణో ముఖే ।"
                            },
                            {
                                "des": "కర్మజాన్ విద్ధి తాన్ సర్వాన్ ఏవం జ్ఞాత్వా విమోక్ష్యసే ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "ఓ శత్రువులను లోబరుచుకొనే వాడా, యాంత్రికముగా ద్రవ్యముతో చేసే యజ్ఞము కన్నా జ్ఞానంతో చేసే యజ్ఞము ఏంతో శ్రేష్ఠమైనది. ఏదేమైనా, ఓ పార్థ, అన్ని యజ్ఞ కర్మలు జ్ఞానమునందే పరిసమాప్తమగును.",
                        "description": [
                            {
                                "des": "శ్రేయాన్ ద్రవ్యమయాద్యజ్ఞాత్ జ్ఞానయజ్ఞః పరంతప ।"
                            },
                            {
                                "des": "సర్వం కర్మాఖిలం పార్థ జ్ఞానే పరిసమాప్యతే ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఒక ఆధ్యాత్మిక గురువుని చేరి పరమ సత్యమును నేర్చుకొనుము. వినయంతో ఆయనను ప్రశ్నలు అడుగుతూ మరియు ఆయనకు సేవ చేయుము. అటువంటి మహాత్ముడైన జ్ఞాని నీకు జ్ఞానోపదేశం చేయగలడు ఎందుకంటే అతను స్వయంగా యథార్థమును దర్శించినవాడు.",
                        "description": [
                            {
                                "des": "తద్విద్ధి ప్రణిపాతేన పరిప్రశ్నేన సేవయా ।"
                            },
                            {
                                "des": "ఉపదేక్ష్యంతి తే జ్ఞానం జ్ఞానినస్తత్త్వదర్శినః ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "ఈ మార్గాన్ని అనుసరిస్తూ మరియు గురువు ద్వారా జ్ఞానోదయం సాధించిన పిమ్మట, ఓ అర్జునా, నీవు మరల మోహం లో పడిపోవు. ఈ జ్ఞాన ప్రకాశంతో, నీవు సమస్త ప్రాణులు భగవంతుని భాగాలే (అంశలే) అని , అవి నా యందే స్థితమై ఉన్నాయని గ్రహిస్తావు.",
                        "description": [
                            {
                                "des": "యజ్జ్ఞాత్వా న పునర్మోహమ్ ఏవం యాస్యసి పాండవ ।"
                            },
                            {
                                "des": "యేన భూతాన్యశేషేణ ద్రక్ష్యస్యాత్మన్యథో మయి ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "పాపాత్ములందరి కంటే పరమ పాపిష్ఠి వారు అని పరిగణించబడిన వారు కూడా ఈ ప్రాపంచిక భవసాగరాన్ని ఆధ్యాత్మిక దివ్య జ్ఞానమనే పడవలో స్థితులై ఉండి దాటిపోవచ్చు.",
                        "description": [
                            {
                                "des": "అపి చేదసి పాపేభ్యః సర్వేభ్యః పాపకృత్తమః ।"
                            },
                            {
                                "des": "సర్వం జ్ఞానప్లవేనైవ వృజినం సంతరిష్యసి ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "ఎలాగైతే ప్రజ్వలించే అగ్ని కట్టెలను భస్మము చేయునో, ఓ అర్జునా, జ్ఞానాగ్ని కూడా భౌతిక కర్మల నుండి జనించే ప్రతిక్రియలన్నిటిని భస్మము చేయును.",
                        "description": [
                            {
                                "des": "యథైధాంసి సమిద్ధోఽగ్నిః భస్మసాత్కురుతేఽర్జున ।"
                            },
                            {
                                "des": "జ్ఞానాగ్నిః సర్వకర్మాణి భస్మసాత్కురుతే తథా ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "దివ్య ఆధ్యాత్మిక జ్ఞానం కంటే పవిత్రమొనర్చేది ఈ లోకంలో వేరే ఏమీ లేదు. చాలా కాలం యోగ సాధన తో అంతఃకరణ శుద్ది సాధించిన తరువాత, కాల క్రమంలో ఈ జ్ఞానం సాధకుని హృదయంలో పొందబడుతుంది.",
                        "description": [
                            {
                                "des": "న హి జ్ఞానేన సదృశం పవిత్రమిహ విద్యతే ।"
                            },
                            {
                                "des": "తత్స్వయం యోగసంసిద్దః కాలేనాత్మని విందతి ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "గాఢమైన శ్రద్ధావిశ్వాసాలు కలవారు మరియు తమ మనో-ఇంద్రియములను నియంత్రణ చేసే అభ్యాసము చేసినవారు దివ్య ఆధ్యాత్మిక జ్ఞానాన్ని సముపార్జించుకుంటారు. ఇటువంటి శ్రేష్ఠమైన అలౌకిక జ్ఞానం తో వారు అతిత్వరగా శాశ్వతమైన పరమ శాంతి ని పొందుతారు.",
                        "description": [
                            {
                                "des": "శ్రద్ధావాన్ లభతే జ్ఞానం తత్పరః సంయతేంద్రియః ।"
                            },
                            {
                                "des": "జ్ఞానం లబ్ధ్వా పరామ్ శాంతిమచిరేణాధిగచ్ఛతి ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "జ్ఞానము, విశ్వాసము రెండూ లేని వారు మరియు అనుమానం పడే స్వభావం కలవారు, పతనమైపోతారు. విశ్వాసములేక, సందేహించే వారికి ఈ లోకంలో ఇంకా పర లోకంలో కూడా సుఖం ఉండదు.",
                        "description": [
                            {
                                "des": "అజ్ఞశ్చాశ్రద్ధధానశ్చ సంశయాత్మా వినశ్యతి ।"
                            },
                            {
                                "des": "నాయం లోకోఽస్తి న పరో న సుఖం సంశయాత్మనః ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, యోగాగ్ని లో కర్మలను త్యజించి, జ్ఞానం తో తమ అన్ని సందేహాల నివృత్తి చేయబడి, ఆత్మ జ్ఞానమందే స్థితులైన వారిని కర్మలు బంధించవు.",
                        "description": [
                            {
                                "des": "యోగసన్న్యస్తకర్మాణం జ్ఞానసంఛిన్నసంశయమ్ ।"
                            },
                            {
                                "des": "ఆత్మవంతం న కర్మాణి నిబధ్నంతి ధనంజయ ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42 వ శ్లోకం",
                        "bhavam": "కాబట్టి, జ్ఞానమనే ఖడ్గంతో నీ హృదయంలో జనించిన సందేహాలను ముక్కలు చేయుము. ఓ భరత వంశీయుడా, కర్మ యోగం లో స్థితుడవై ఉండుము. లెమ్ము, నీ కర్తవ్య నిర్వహణ చేయుము.",
                        "description": [
                            {
                                "des": "తస్మాదజ్ఞానసంభూతం హృత్-స్థం జ్ఞానాసినాత్మనః ।"
                            },
                            {
                                "des": "ఛిత్త్వైనం సంశయం యోగమాతిష్ఠోత్తిష్ఠ భారత ।। 42 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "కర్మ సన్యాస యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/05.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/05.png'),
                "index":5,
                "introduction": [
                    {
                        "para": "ఈ అధ్యాయం 'కర్మ సన్యాస' (పనులను త్యజించటం) మార్గాన్ని 'కర్మ యోగ' (భక్తి యుక్తంగా పనిచేయటం) మార్గంతో పోల్చి చూపుతుంది. రెండూ కూడా ఒకే లక్ష్యం దిశగా దారితీస్తాయని, మనం వీటిలో దేనినైనా ఎంచుకోవచ్చు అని శ్రీ కృష్ణుడు వివరిస్తున్నాడు. కానీ, మనస్సు ఎంతో పరిశుద్ధమైనదిగా ఉంటే తప్ప కర్మ సన్యాసం అనేది పరిపూర్ణంగా/దోషరహితంగా చేయలేము, మరియు భక్తి తో పనిచేయటం ద్వారానే చిత్త శుద్ధి సాధించవచ్చు. కాబట్టి, కర్మ యోగమే సాధారణంగా చాలామందికి సరియైన దారి. కర్మ యోగులు తమ ప్రాపంచిక విధులను పవిత్రమైన బుద్దితో, ఫలాసక్తి విడిచి, భగవత్ అర్పితముగా చేస్తారు. ఈ విధముగా, తామరాకుకు నీటి తడి అంటనట్టు, వారికి పాపము అంటదు. జ్ఞాన ప్రకాశంచే వారు ఈ శరీరము అనేది, ఆత్మ వసించే నవ ద్వారాల నగరమని తెలుసుకుంటారు. ఈ విధంగా, వారు తాము కర్తలము కాము అని, తాము భోక్తలము కూడా కాము అని తెలుసుకుంటారు. వారు అందరి పట్ల సమత్వ దృష్టి కలిగి ఉంటారు; ఒక బ్రాహ్మణుడు, ఆవు, ఏనుగు, కుక్క, చండాలుడు అందరినీ సమానంగా చూస్తారు. అటువంటి నిజమైన జ్ఞానులైన జనులు దోషరహిత మైన దైవీ గుణాలు పెంపొందించుకొంటారు మరియు పరమ సత్యము యందు స్థితులై ఉంటారు. ప్రాపంచిక జనులు, ఇంద్రియ వస్తువిషయముల నుండి వచ్చే సుఖాల కోసం ఏంతో శ్రమిస్తారు, కానీ, అవే నిజముగా దుఃఖ హేతువులు అని తెలుసుకోరు. కానీ, కర్మ యోగులు వాటి యందు ఆసక్తి కలిగి ఉండరు; ప్రతిగా, తమలోనే ఉన్న భగవంతుని ఆనందాన్ని ఆస్వాదిస్తారు."
                    },
                    {
                        "para": "ఈ అధ్యాయం, తదుపరి, కర్మ సన్యాస మార్గాన్ని వివరిస్తుంది. కర్మ సన్యాసులు ఇంద్రియమనోబుద్ధుల నియంత్రణకు ఎన్నో నిష్ఠలు పాటిస్తారు. వారు బాహ్యమైన భోగ సంబంధ అన్ని తలంపులని త్యజించి, కామ, క్రోధ, భయముల నుండి స్వేచ్చ పొందుతారు. ఈ నియమనిష్ఠలన్నిటినీ భగవత్ భక్తితో సంపూర్ణము చేసి, శాశ్వతమైన శాంతిని పొందుతారు."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "అర్జునుడు అన్నాడు : ఓ శ్రీ కృష్ణా, నీవు కర్మ సన్యాసమును (పనులను త్యజించుట) ప్రశంసించావు మరియు కర్మ యోగమును (భక్తితో పనిచేయుట) కూడా చేయమన్నావు. ఈ రెంటిలో ఏది శ్రేయస్కరమో ఖచ్చితముగా తేల్చి చెప్పుము.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "సన్న్యాసం కర్మణాం కృష్ణ పునర్యోగం చ శంససి ।"
                            },
                            {
                                "des": "యఛ్చ్రేయ ఏతయోరేకం తన్మే బ్రూహి సునిశ్చితమ్ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "భగవానుడు పలికెను: కర్మ సన్యాస (పనులను త్యజించుట) మార్గము మరియు కర్మ యోగ (భక్తి తో పనిచేయుట) మార్గము రెండూ సర్వోన్నత లక్ష్యం వైపు దారి తీస్తాయి. కానీ, కర్మ యోగము అనేది కర్మ సన్యాసము కంటే శ్రేష్ఠమైనది.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "సన్యాసః కర్మయోగశ్చ నిఃశ్రేయసకరావుభౌ ।"
                            },
                            {
                                "des": "తయోస్తు కర్మసంన్యాసాత్కర్మయోగో విశిష్యతే ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "దేనినీ ద్వేషింపక, దేనినీ ఆశించక ఉన్న కర్మ యోగులను నిత్య సన్యాసులుగా తెలుసుకొనవలెను. అన్ని రకాల ద్వందములకు అతీతంగా ఉండి, వారు భౌతిక బంధాల నుండి సునాయాసముగా విముక్తులవుతారు.",
                        "description": [
                            {
                                "des": "జ్ఞేయః స నిత్యసంన్యాసీ యో న ద్వేష్టి న కాంక్షతి ।"
                            },
                            {
                                "des": "నిర్ద్వందో హి మహాబాహో సుఖం బంధాత్ప్రముచ్యతే ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "అజ్ఞానులు మాత్రమే సాంఖ్యము (కర్మలను త్యజించుట లేదా కర్మ సన్యాసము) మరియు కర్మ యోగము (భక్తి తో పని చేయటము) భిన్నమైనవి అని చెప్తారు. ఈ రెంటిలో ఏ ఒక్క మార్గమును అవలంబించినా ఈ రెండింటి ఫలమును పొందవచ్చు అని యదార్థముగా తెలిసినవారు చెప్తారు.",
                        "description": [
                            {
                                "des": "సాంఖ్యయోగౌ పృథగ్బాలాః ప్రవదంతి న పండితాః ।"
                            },
                            {
                                "des": "ఏకమప్యాస్థితః సమ్యక్ ఉభయోర్విందతే ఫలమ్ ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "కర్మ సన్యాసము ద్వారా పొందగలిగే అత్యున్నత స్థితిని భక్తి తో కర్మలను ఆచరించటం ద్వారా కూడా పొందవచ్చు. కాబట్టి, కర్మ సన్యాసము మరియు కర్మ యోగము ఒక్కటే అని చూసినవాడే నిజముగా ఉన్నదున్నట్టుగా చూసినట్టు.",
                        "description": [
                            {
                                "des": "యత్సాంఖ్యై: ప్రాప్యతే స్థానం తద్యోగైరపి గమ్యతే ।"
                            },
                            {
                                "des": "ఏకం సాఖ్యం చ యోగం చ యః పశ్యతి స పశ్యతి ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "భక్తి యుక్తముగా పని చేయకుండా (కర్మ యోగము) పరిపూర్ణ కర్మ సన్యాసము ను చేరుకొనుట చాలా కష్టము, ఓ గొప్ప బాహువులు కలవాడా, కానీ, కర్మ యోగములో నిష్ణాతుడైన ముని శీఘ్రముగా పరమాత్మ ను పొందును.",
                        "description": [
                            {
                                "des": "సంన్యాసస్తు మహాబాహో దుఃఖమాప్తుమయోగతః ।"
                            },
                            {
                                "des": "యోగయుక్తో మునిర్బ్రహ్మా నచిరేణాధిగచ్ఛతి ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "పరిశుద్ధమైన అంతఃకరణ కలిగి, ఇంద్రియ-మనస్సులను నియంత్రణ చేసే కర్మ యోగులు, ప్రతి ప్రాణిలో ఆత్మల పరమాత్మను దర్శిస్తారు. అన్ని రకాల పనులు చేస్తూనే ఉన్నా వారు కర్మబంధాలలో లో చిక్కుకోరు.",
                        "description": [
                            {
                                "des": "యోగయుక్తో విశుద్ధాత్మా విజితాత్మా జితేంద్రియః ।"
                            },
                            {
                                "des": "సర్వభూతాత్మభూతాత్మా కుర్వన్నపి న లిప్యతే ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8-9 శ్లోకాలు",
                        "bhavam": "కర్మ యోగములో ధృఢ సంకల్పంతో స్థితులై ఉన్న వారు - చూస్తున్నప్పుడూ, వింటున్నప్పుడూ, స్పృశిస్తున్నప్పుడు, వాసన చూస్తున్నప్పుడూ, కదులుతున్నప్పుడూ, నిద్రిస్తున్నప్పుడూ, శ్వాస క్రియలప్పుడూ, మాట్లాడుతున్నప్పుడూ, విసర్జిస్తున్నప్పుడూ, తీసుకుంటున్నప్పుడూ, కన్నులు తెరుస్తున్నప్పుడూ, మూస్తున్నప్పుడూ - చేసేది నేను కాదు అన్ని ఎల్లప్పుడూ భావింతురు. ప్రాకృతిక ఇంద్రియములే వాటి వాటి విషయములలో కదులుతున్నట్లు, దివ్య ఆధ్యాత్మిక జ్ఞానం తో గ్రహిస్తారు.",
                        "description": [
                            {
                                "des": "నైవ కించిత్ కరోమీతి యుక్తో మన్యేత తత్త్వవిత్"
                            },
                            {
                                "des": "పశ్యన్ శృణ్వన్ స్పృశన్ జిఘ్రన్నశ్నన్ గచ్ఛన్ స్వపన్ శ్వసన్ ।। 8 ।"
                            },
                            {
                                "des": "ప్రలపన్ విసృజన్ గృహ్ణన్నున్మిషన్ నిమిషన్నపి ।"
                            },
                            {
                                "des": "ఇంద్రియాణీంద్రియార్థేషు వర్తంత ఇతి ధారయన్ ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "సమస్త మమకార ఆసక్తులు త్యజించి, భగవంతునికే తమ అన్ని కర్మలు అంకితం చేసేవారు, తామరాకు నీటిచే తడి అవ్వనట్టు, పాపముచే తాకబడరు.",
                        "description": [
                            {
                                "des": "బ్రహ్మణ్యాధాయ కర్మాణి సంగం త్యక్త్వా కరోతి యః ।"
                            },
                            {
                                "des": "లిప్యతే న స పాపేన పద్మపత్రమివాంభసా ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "యోగులు, మమకారాసక్తిని విడిచిపెట్టి, కేవలం ఆత్మ శుద్ధి కోసం మాత్రమే, శరీరము, మనస్సు, ఇంద్రియములు, మనస్సు లతో కర్మలను ఆచరిస్తూ ఉంటారు.",
                        "description": [
                            {
                                "des": "కాయేన మనసా బుద్ధ్యా కేవలైరింద్రియైరపి ।"
                            },
                            {
                                "des": "యోగినః కర్మ కుర్వంతి సంగం త్యక్త్వాత్మశుద్ధయే ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "అన్ని క్రియాకలాపముల ఫలములను భగవంతునికే అర్పితము చేసి, కర్మ యోగులు శాశ్వతమైన శాంతిని పొందుతారు. అదే సమయంలో, తమ కామముచే (కోరికలచే) ప్రేరేపింపబడి, స్వార్థ ప్రయోజనం కోసం పని చేసే వారు, కర్మ బంధములలో చిక్కుకుంటారు ఎందుకంటే వారు కర్మ ఫలములపై ఆసక్తి కలిగి ఉంటారు.",
                        "description": [
                            {
                                "des": "యుక్తః కర్మఫలం త్యక్త్వా శాంతిమాప్నోతి నైష్ఠికీమ్ ।"
                            },
                            {
                                "des": "అయుక్తః కామకారేణ ఫలే సక్తో నిబధ్యతే ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఆత్మ నిగ్రహము, వైరాగ్యము ఉన్న జీవాత్మలు, తాము దేనికీ కర్త కాదని, దేనికీ కారణము కాదని తెలుసుకొని ఈ యొక్క తొమ్మిది ద్వారములు కల నగరములో సంతోషంగా ఉంటారు.",
                        "description": [
                            {
                                "des": "సర్వకర్మాణి మనసా సన్న్యస్యాస్తే సుఖం వశీ ।"
                            },
                            {
                                "des": "నవద్వారే పురే దేహీ నైవ కుర్వన్న కారయన్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "కర్తుత్వ భావన కానీ, కర్మల స్వభావం కానీ భగవంతునిచే సృష్టించబడవు. కర్మ ఫలములను సృష్టించేది కూడా ఆయన కాదు. భౌతిక ప్రకృతి గుణములే వీటన్నిటిని ప్రవర్తిల్లచేయును.",
                        "description": [
                            {
                                "des": "న కర్తృత్వం న కర్మాణి లోకస్య సృజతి ప్రభుః ।"
                            },
                            {
                                "des": "న కర్మఫలసంయోగం స్వభావస్తు ప్రవర్తతే ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "సర్వాంతర్యామి అయిన భగవంతుడు, ఏ ఒక్కని పాపపు లేదా పుణ్య కర్మల యందు కూడా పాలు పంచుకోడు. జీవుల వివేకము అజ్ఞానముచే కప్పబడిపోవటం వలన వారు భ్రమకు లోనగుతున్నారు.",
                        "description": [
                            {
                                "des": "నాదత్తే కస్యచిత్పాపం న చైవ సుకృతం విభుః"
                            },
                            {
                                "des": "అజ్ఞానేనావృతం జ్ఞానం తేన ముహ్యంతి జంతవః ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "కానీ, ఎవరికైతే దివ్య ఆధ్యాత్మిక జ్ఞానముచే, ఆత్మ పట్ల అజ్ఞానం నాశనం చేయబడునో, వారికి, సూర్యుడు పగటి పూట అన్నింటినీ ప్రకాశింపచేసినట్టు, ఆ జ్ఞానము వారికి పరమాత్మను ప్రకాశింపచేయును.",
                        "description": [
                            {
                                "des": "జ్ఞానేన తు తదజ్ఞానం యేషాం నాశితమాత్మనః ।"
                            },
                            {
                                "des": "తేషామాదిత్యవత్ జ్ఞానం ప్రకాశయతి తత్పరమ్ ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "తమ బుద్ధి భగవంతుని యందే స్థితులైనవారు, సంపూర్ణముగా భగవంతుని యందే నిమగ్నమైన వారు, ఆయనే పరమ లక్ష్యమని ధృఢ విశ్వాసం కలవారు - వారి పాపములు జ్ఞాన కిరణాలచే నిర్మూలింపబడి, త్వరిత గతిన, మరలా తిరిగిరాని స్థితిని పొందుతారు.",
                        "description": [
                            {
                                "des": "తద్బుద్ధయస్తదాత్మానః తన్నిష్ఠాస్తత్పరాయణాః ।"
                            },
                            {
                                "des": "గచ్ఛంత్యపునరావృత్తిం జ్ఞాననిర్ధూతకల్మషాః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "నిజమైన పండితులు, దివ్య జ్ఞాన చక్షువులతో - ఓ బ్రాహ్మణుడిని, ఓ ఆవుని, ఓ ఏనుగుని, ఓ కుక్కని, ఓ చండాలుడిని సమ-దృష్టితో చూస్తారు.",
                        "description": [
                            {
                                "des": "విద్యావినయసంపన్నే బ్రాహ్మణే గవి హస్తిని ।"
                            },
                            {
                                "des": "శుని చైవ శ్వపాకే చ పండితాః సమదర్శినః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "సమదృష్టి యందు సంపూర్ణ మనస్సుతో స్థితులైనవారు, ఈ జన్మ లోనే జన్మ-మరణ చక్రమును జయిస్తారు. వారు భగవంతుని యొక్క దోషరహిత గుణములను కలిగిఉంటారు కాబట్టి పరమ సత్యము నందే స్థితులై ఉంటారు.",
                        "description": [
                            {
                                "des": "ఇహైవ తైర్జితః సర్గో యేషాం సామ్యే స్థితం మనః ।"
                            },
                            {
                                "des": "నిర్దోషం హి సమం బ్రహ్మ తస్మాద్ బ్రహ్మణి తే స్థితాః ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "భగవంతుని యందే స్థితులై, దివ్య ఆధ్యాత్మిక జ్ఞానము నందు ధృడమైన అవగాహన కలిగి ఉండి మరియు భ్రమకు లోనుకాకుండా ఉన్నవారు, ప్రియమైనవి జరిగితే/లభిస్తే పొంగిపోరు లేదా ఏవేని అప్రియమైనవి జరిగితే క్రుంగిపోరు.",
                        "description": [
                            {
                                "des": "న ప్రహృష్యేత్ ప్రియం ప్రాప్య నోద్విజేత్ ప్రాప్య చాప్రియమ్ ।"
                            },
                            {
                                "des": "స్థిరబుద్ధిరసమ్మూఢో బ్రహ్మవిద్ బ్రహ్మణి స్థితః ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "బాహ్యమైన ఇంద్రియ సుఖాలపై మమకారాసక్తులు లేనివాడు, ఆత్మ యందే దివ్యానందాన్ని అనుభవిస్తాడు. యోగం ద్వారా భగవంతునితో ఐక్యమై, అంతులేని ఆనందాన్ని అనుభవిస్తారు.",
                        "description": [
                            {
                                "des": "బాహ్యస్పర్శేష్వసక్తాత్మా విందత్యాత్మని యత్సుఖమ్ ।"
                            },
                            {
                                "des": "స బ్రహ్మయోగయుక్తాత్మా సుఖమక్షయమశ్నుతే ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఇంద్రియ వస్తు-విషయ సంపర్కం వలన కలిగే భోగాలు, ప్రాపంచిక మనస్తత్వం ఉన్నవారికి ఆనందదాయకంగా అనిపించినా, అవి యథార్థముగా దుఃఖ హేతువులే. ఓ కుంతీ పుత్రుడా, ఇటువంటి సుఖాలకు ఒక ఆది-అంతం (మొదలు-చివర) ఉంటాయి, కాబట్టి జ్ఞానులు వీటి యందు రమించరు.",
                        "description": [
                            {
                                "des": "యే హి సంస్పర్శజా భోగా దుఃఖయోనయ ఏవ తే ।"
                            },
                            {
                                "des": "ఆద్యంతవంతః కౌంతేయ న తేషు రమతే బుధః ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఈ శరీరమును విడిచి పెట్టక ముందే ఎవరైతే కామ-క్రోధ శక్తులను నియంత్రణ చేయగలరో వారు యోగులు మరియు వారు మాత్రమే నిజమైన సుఖసంతోషములు గలవారు.",
                        "description": [
                            {
                                "des": "శక్నోతీహైవ యః సోఢుం ప్రాక్శరీర విమోక్షణాత్ ।"
                            },
                            {
                                "des": "కామక్రోధోద్భవం వేగం స యుక్తః స సుఖీ నరః ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "ఎవరైతే తమలో తాము ఆనందంగా (రమిస్తూ) ఉంటారో, లోనున్న పరమాత్మ యొక్క ఆనందాన్ని ఆస్వాదిస్తూ ఉండి, అంతర్గత జ్ఞాన వెలుగు చే ప్రకాశిస్తూ ఉంటారో, అటువంటి యోగులు, భగవంతునితో ఏకమై, భౌతిక ప్రాపంచిక అస్తిత్వము నుండి విముక్తులవుతారు.",
                        "description": [
                            {
                                "des": "యోఽoతః సుఖోఽoతరారామః తథాంతర్జ్యోతిరేవ యః ।"
                            },
                            {
                                "des": "స యోగీ బ్రహ్మనిర్వాణం బ్రహ్మభూతోఽధిగచ్ఛతి ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "ఎవరి పాపములు నశించినవో, ఎవరి సందేహములన్నీ నిర్మూలింపబడినవో, ఎవరి మనస్సులు నియమబద్ధమైనవో, ఎవరైతే సమస్త ప్రాణుల సంక్షేమం కోసం నిమగ్నమవుతారో, అట్టి పవిత్రమైన వ్యక్తులు భౌతిక జగత్తు నుండి విముక్తి పొంది, భగవంతుడిని పొందుతారు.",
                        "description": [
                            {
                                "des": "లభంతే బ్రహ్మనిర్వాణమ్ ఋషయః క్షీణకల్మషాః ।"
                            },
                            {
                                "des": "ఛిన్నద్వైధా యతాత్మానః సర్వభూతహితే రతాః ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "నిరంతర ప్రయాస ద్వారా కామ-క్రోధముల నుండి బయట పడిన వారు, మనస్సుని నిగ్రహించిన వారు, ఆత్మ-జ్ఞానం లో ఉన్నవారు అయినటువంటి సన్యాసులకు ఇహ పర లోకాలలో భౌతిక అస్థిత్వం నుండి విముక్తి లభిస్తుంది.",
                        "description": [
                            {
                                "des": "కామక్రోధవియుక్తానాం యతీనాం యతచేతసామ్ ।"
                            },
                            {
                                "des": "అభితో బ్రహ్మనిర్వాణం వర్తతే విదితాత్మనామ్ ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27-28 వరకు",
                        "bhavam": "అన్నిబాహ్యమైన భోగ విషయముల తలంపులను త్యజించి, దృష్టి కనుబొమ్మల మధ్యే కేంద్రీకరించి, నాసికా రంధ్రములలో లోనికి వచ్చే, బయటకు వెళ్ళే గాలిని సమముగా నిలిపి, ఈ విధంగా ఇంద్రియములు, మనస్సు, బుద్ధిని నిగ్రహించి, కామ-క్రోధ-భయ రహితుడైన ముని సర్వదా మోక్ష స్థితి యందే వసించును.",
                        "description": [
                            {
                                "des": "స్పర్శాన్ కృత్వా బహిర్బాహ్యాన్ చక్షుశ్చైవాంతరే భ్రువోః ।"
                            },
                            {
                                "des": "ప్రాణాపానౌ సమౌ కృత్వా నాసాభ్యంతరచారిణౌ ।। 27 ।।"
                            },
                            {
                                "des": "యతేంద్రియమనోబుద్ధిః మునిర్మోక్షపరాయణః ।"
                            },
                            {
                                "des": "విగతేఛ్చాభయక్రోధో యః సదా ముక్త ఏవ సః ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "సమస్త యజ్ఞములకు, తపస్సులకు భోక్తని నేనే అని, సమస్త లోకములకు అధిపతిని అని మరియు సర్వ ప్రాణుల యొక్క నిస్వార్థ మిత్రుడను అని తెలుసుకొనిన పిదప, నా భక్తుడు శాంతిని పొందును.",
                        "description": [
                            {
                                "des": "భోక్తారం యజ్ఞతపసాం సర్వలోకమహేశ్వరమ్ ।"
                            },
                            {
                                "des": "సుహృదం సర్వభూతానాం జ్ఞాత్వా మాం శాంతిమృచ్ఛతి ।। 29 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "ధ్యాన యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/06.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/06.png'),
                "index":6,
                "introduction": [
                    {
                        "para": "ఈ అధ్యాయంలో, శ్రీ కృష్ణుడు, ఐదవ అధ్యాయం లో నుండీ ఉన్న వస్తున్న ' కర్మ యోగ' (ప్రాపంచిక విధులు నిర్వర్తిస్తూనే ఆధ్యాత్మిక అభ్యాసం చేయటం) మరియు 'కర్మ సన్యాస' (సన్యాస ఆశ్రమంలో ఆధ్యాత్మికత అభ్యాసం చేయటం) మార్గాలను పోల్చి, విశ్లేషణను కొనసాగిస్తూనే, మొదటి మార్గాన్నే సిఫారసు చేస్తున్నాడు. మనం కర్మలను భక్తితో చేసినప్పుడు, అది మన మనస్సుని పవిత్రం చేసి మన ఆధ్యాత్మిక విజ్ఞానాన్ని స్థిర పరుస్తుంది. అప్పుడు మనస్సు ప్రశాంతత పొందిన తరువాత, ధ్యానము, మన ఉన్నతికి ప్రధాన ఉపకరణము అవుతుంది. ధ్యానము ద్వారా యోగులు తమ మనస్సుని జయించటానికి శ్రమిస్తారు, ఎందుకంటే అశిక్షితమైన నిగ్రహింపని మనస్సు మన ప్రధాన శత్రువు, కానీ, సుశిక్షితమైన నియంత్రణ లో ఉన్న మనస్సు మన మంచి మిత్రుడు. తీవ్రమైన కఠిన నిష్ఠలు పాటించటం ద్వారా ఒక వ్యక్తి ఆధ్యాత్మిక పథంలో పురోగతి సాధించలేడని శ్రీ కృష్ణుడు అర్జునుడిని హెచ్చరిస్తున్నాడు; కాబట్టి తినటంలో, పనిలో, వినోదంలో మరియు నిద్రలో మిత సంయమనం పాటించాలని ఉపదేశించాడు. తదుపరి, మనస్సుని భగవంతుని తో ఏకం (సంయోగం) చేయటానికి 'సాధన' ని వివరిస్తాడు. ఎలాగైతే గాలి వీచని చోట దీపం నిశ్చలంగా ఉంటుందో, అదే విధంగా సాధకుడు మనస్సుని ధ్యానం యందు నిలకడతో ఉంచాలి. నియంత్రణ చేయటానికి మనస్సు నిజానికి చాలా క్లిష్టమైనది, కానీ, అభ్యాసము, వైరాగ్యంతో దీనిని నియంత్రించవచ్చు. కాబట్టి, మనస్సు ఎక్కడికి పోయినా, దానిని తిరిగి తెచ్చి, భగవంతుని వైపే విడువకుండ కేంద్రీకరించాలి. ఎప్పుడైతే మనస్సు పరిశుద్ధమవుతుందో, అది అలౌకిక స్థితి లో నిలుస్తుంది. ఈ యొక్క 'సమాధి' అన్న పరమానంద స్థితి లో వ్యక్తి అనంతమైన దివ్యానందాన్ని అనుభవిస్తాడు."
                    },
                    {
                        "para": "అర్జునుడు తదుపరి శ్రీ కృష్ణుడిని, ఆధ్యాత్మిక మార్గంలో ప్రారంభమయ్యి కూడా చంచలమైన మనస్సు వల్ల లక్ష్యాన్ని చేరుకోలేని సాధకుడి గతి ఏమిటి అని ప్రశిస్తాడు. భగవత్ ప్రాప్తి కోసం ప్రయాస పడే వ్యక్తి ఎప్పుడూ చెడిపోడు అని శ్రీ కృష్ణుడు హామీ ఇస్తాడు. భగవంతుడు ఎల్లప్పుడూ మన అన్ని పూర్వ జన్మల ఆధ్యాత్మిక పురోగతి లెక్క చూసుకుని, దానిని మళ్ళీ తదుపరి జన్మలలో పునరుత్తేజింప చేస్తాడు; దీనితో మనం ఎక్కడ విడిచిపెట్టామో అక్కడ నుండి తిరిగి ప్రయాణం మొదలు పెట్టవచ్చు. ఎన్నో జన్మల నుండి పోగైన సాధన ఫలంగా యోగులు ఈ జన్మ లోనే భగవంతుడిని చేరుకుంటారు."
                    },
                    {
                        "para": "తపస్వీలు (మునులు), జ్ఞానులు (చదువుకున్నవారు, వేద శాస్త్ర పండితులు), మరియు కర్మీల కంటే యోగులే (భగవంతునితో ఏక మవ్వటానికి పరిశ్రమించే వారు) శ్రేష్ఠమైన వారు అని ప్రకటిస్తూ ఈ అధ్యాయం ముగుస్తుంది. ఇంకా, యోగులందరిలో కెల్లా, ప్రేమ యుక్త భక్తిలో నిమగ్నమయ్యే వారే అత్యున్నతమైన వారు."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "భగవంతుడు పలికెను: ఫలాపేక్ష లేకుండా కర్తవ్య కర్మలను (చేయవలసిన విధులను), చేసిన వారే నిజమైన సన్యాసులు, యోగులు. అంతేకాని, కేవలం అగ్ని హోత్ర యజ్ఞం వంటివి చేయటం ఆపివేసిన వారు లేదా శారీరిక క్రియలు త్యజించిన వారు కాదు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "అనాశ్రితః కర్మఫలం కార్యం కర్మ కరోతి యః ।"
                            },
                            {
                                "des": "స సన్న్యాసీ చ యోగీ చ న నిరగ్నిర్నచాక్రియః ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "సన్యాసము అని అందరూ అనుకునేది, యోగము కంటే వేరైనది కాదు. ఎందుకంటే, ఎవ్వరూ కూడా ప్రాపంచిక కోరికలను త్యజించకుండా యోగి కాలేరు.",
                        "description": [
                            {
                                "des": "యం సన్న్యాసమితి ప్రాహుః యోగం తం విద్ధి పాండవ ।"
                            },
                            {
                                "des": "న హ్యసంన్యస్త సంకల్పో యోగీ భవతి కశ్చన ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "యోగం లో పరిపూర్ణత సాధించే యత్నంలో ఉన్న (ప్రారంభ-దశ) జీవాత్మకు ఫలాపేక్ష లేకుండా పని చేయటమే సాధనం అంటారు; యోగంలో ఉన్నత స్థాయి చేరుకున్న మునికి ధ్యానంలో ప్రశాంతతయే సాధనం అంటారు.",
                        "description": [
                            {
                                "des": "ఆరురుక్షోర్మునేర్యోగం కర్మ కారణముచ్యతే ।"
                            },
                            {
                                "des": "యోగారూఢస్య తస్యైవ శమః కారణముచ్యతే ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "ఎప్పుడైతే వ్యక్తి ఇంద్రియ వస్తు-విషయముల పట్ల మరియు కర్మల పట్ల ఆసక్తి రహితముగా ఉంటాడో ఆ వ్యక్తి యోగ శాస్త్రంలో ఉన్నతమైన స్థానం పొందినట్టు; ఎందుకంటే అతడు సమస్త కర్మ ఫలములను అనుభవించాలనే కోరికలను త్యజించాడు కావున.",
                        "description": [
                            {
                                "des": "యదా హి నేంద్రియార్థేషు న కర్మస్వనుషజ్జతే ।"
                            },
                            {
                                "des": "సర్వసంకల్పసన్న్యాసీ యోగారూఢస్తదోచ్యతే ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "నీ మనస్సు యొక్క శక్తి చే నిన్ను నీవు ఉద్దరించుకోనుము, అంతేకాని పతనమైపోవద్దు. ఎందుకంటే మనస్సే మన మిత్రుడు మరియు మనస్సే మన శత్రువు అవ్వచ్చు.",
                        "description": [
                            {
                                "des": "ఉద్ధరేదాత్మనాత్మానం నాత్మానమవసాదయేత్ ।"
                            },
                            {
                                "des": "ఆత్మైవ హ్యాత్మనో బంధుః ఆత్మైవ రిపురాత్మనః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "మనస్సుని జయించినవారికి అది వారి మిత్రుడు. అలా చేయలేని వాడికి, మనస్సు ఒక శత్రువు వలె పనిచేస్తుంది.",
                        "description": [
                            {
                                "des": "బంధురాత్మాత్మనస్తస్య యేనాత్మైవాత్మనా జితః ।"
                            },
                            {
                                "des": "అనాత్మనస్తు శత్రుత్వే వర్తేతాత్మైవ శత్రువత్  ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "మనస్సుని జయించిన యోగులు - శీతోష్ణములు, సుఖదుఃఖములు, మానాపమానములు - ఈ ద్వందములకు అతీతంగా ఉన్నతమైన స్థానంలో ఉంటారు. ఇటువంటి యోగులు ప్రశాంతతతో, భగవత్ భక్తి యందు స్థిర చిత్తముతో ఉంటారు.",
                        "description": [
                            {
                                "des": "జితాత్మనః ప్రశాంతస్య పరమాత్మా సమాహితః।"
                            },
                            {
                                "des": "శీతోష్ణసుఖదుఃఖేషు తథా మానాపమానయోః ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "జ్ఞానము, విజ్ఞానవిచక్షణ కలిగి తృప్తి తో ఉన్నయోగులు, ఇంద్రియములను జయించిన వారై, అన్ని పరిస్థితులలో ప్రశాంతంగా ఉంటారు. వారు – మట్టి, రాళ్ళు మరియు బంగారము – వీటన్నిటిని ఒకే దృష్టి తో చూస్తారు.",
                        "description": [
                            {
                                "des": "జ్ఞానవిజ్ఞాన తృప్తాత్మా కూటస్థొ విజితేంద్రియః ।"
                            },
                            {
                                "des": "యుక్త ఇత్యుచ్యతే యోగీ సమలోష్టాశ్మకాంచనః ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "శ్రేయోభిలాషులను, మిత్రులను, శత్రువులను, సాధువులను మరియు పాపులను - యోగులు నిష్పక్షపాత బుద్ధితో చూస్తారు. మిత్రుల, సహచరుల, శత్రువుల పట్ల సమబుద్ధి తో ఉంటూ, శత్రువుల, బంధువుల పట్ల తటస్థంగా, మరియు, పుణ్యాత్ములు, పాపాత్ముల పట్ల పక్షపాతం లేకుండా - ఉన్న యోగి మానవులలో సర్వ శ్రేష్ఠుడు గా పరిగణించబడుతాడు.",
                        "description": [
                            {
                                "des": "సుహృన్మిత్రార్యుదాసీనమధ్యస్థద్వేష్యబంధుషు ।"
                            },
                            {
                                "des": "సాధుష్వపి చ పాపేషు సమబుద్ధిర్విశిష్యతే ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "యోగ స్థితిని పొందగోరే వారు, నియంత్రించబడిన మనస్సు-శరీరంతో భగవత్ ధ్యానంలో, కోరికలను, భోగవస్తువులను త్యజించి, ఏకాంతంలో ఉండాలి.",
                        "description": [
                            {
                                "des": "యోగీ యుంజీత సతతమాత్మానం రహసి స్థితః ।"
                            },

                            {
                                "des": "ఏకాకీ యతచిత్తాత్మా నిరాశీరపరిగ్రహః  ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "యోగాభ్యాసము చేయటానికి, శుభ్రమైన ప్రదేశంలో ఆసనం తయారుచేసుకోవాలి; దీనిని కుశ గడ్డి, జింక చర్మము మరియు ఒక వస్త్రమును ఒక దానిపై మరొకటి వేసుకోవాలి. ఈ ఆసనము మరీ ఎక్కువ ఎత్తులో ఉండకూడదు లేదా మరీ తక్కువ ఎత్తులో ఉండకూడదు.",
                        "description": [
                            {
                                "des": "శుచౌ దేశే ప్రతిష్ఠాప్య స్థిరమాసనమాత్మనః ।"
                            },
                            {
                                "des": "నాత్యుఛ్చ్రితం నాతినీచం చైలాజినకుశోత్తరమ్ ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12-13 శ్లోకాలు",
                        "bhavam": "దానిపై స్థిరముగా కూర్చొని, ఒకే ఏకాగ్రత గల ధ్యానములో, అన్ని ఆలోచనలను, కార్యకలాపాలను నిగ్రహించి - యోగి తన మనస్సుని పరిశుద్ధమొనర్చుకోవటానికి పరిశ్రమించాలి. అతను శరీరమును, మెడను, మరియు శిరస్సుని స్థిరముగా ఒకే క్రమములో ఉంచి, కళ్ళను అటూఇటూ తిప్పకుండా, నాసికాగ్రము మీదే చూపుని కేంద్రీకరించాలి.",
                        "description": [
                            {
                                "des": "తత్రైకాగ్రం మనః కృత్వా యతచిత్తేంద్రియక్రియః ।"
                            },
                            {
                                "des": "ఉపవిశ్యాసనే యుంజ్యాత్ యోగమాత్మవిశుద్ధయే ।। 12 ।।"
                            },
                            {
                                "des": "సమం కాయశిరోగ్రీవం ధారయన్నచలం స్థిరః ।"
                            },
                            {
                                "des": "సంప్రేక్ష్య నాసికాగ్రం స్వం దిశశ్చానవలోకయన్  ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఈ విధంగా, ప్రశాంతతతో, భయరహితంగా మరియు నిశ్చల మనస్సుతో మరియు బ్రహ్మచర్య వ్రతంలో దృఢ సంకల్పంతో, సావధానుడైన యోగి, నేనే పరమ లక్ష్యంగా, నా పై ధ్యానం చేయాలి.",
                        "description": [
                            {
                                "des": "ప్రశాంతాత్మా విగతభీః బ్రహ్మచారివ్రతే స్థితః ।"
                            },
                            {
                                "des": "మనః సంయమ్య మచ్చిత్తో యుక్త ఆసీత మత్పరః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఈ విధంగా, నిరంతరం మనస్సుని నాయందే నిలిపి, క్రమశిక్షణ మనస్సు కలిగిన యోగి 'నిర్వాణమును' పొందును మరియు నా యందే పరమ శాంతి తో స్థితుడై ఉండును.",
                        "description": [
                            {
                                "des": "యుంజన్నేవం సదాత్మానం యోగీ నియతమానసః  ।"
                            },
                            {
                                "des": "శాంతిం నిర్వాణపరమాం మత్సంస్థామధిగఛ్చతి  ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, ఎవరైతే మరీ ఎక్కువ తింటారో లేదా మరీ తక్కువ తింటారో; మరీ ఎక్కువ నిద్ర పోతారో లేదా మరీ తక్కువ నిద్ర పోతారో - వారు యోగములో విజయం సాధించలేరు.",
                        "description": [
                            {
                                "des": "నాత్యశ్నతస్తు యోగోఽస్తి న చైకాంతమనశ్నతః ।"
                            },
                            {
                                "des": "న చాతిస్వప్నశీలస్య జాగ్రతో నైవ చార్జున ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "కానీ ఎవరైతే తినటంలో మరియు వినోదాలలో మితంగా ఉంటారో, పనిలో సమతుల్యత తో, నిద్రలో క్రమబద్ధత తో ఉంటారో, వారు యోగాభ్యాసముతో అన్ని దుఖములను ఉపశమింపచేయవచ్చు.",
                        "description": [
                            {
                                "des": "యుక్తాహారవిహారస్య యుక్తచేష్టస్య కర్మసు ।"
                            },
                            {
                                "des": "యుక్తస్వప్నావబోధస్య యోగో భవతి దుఃఖహా ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "వారు సంపూర్ణ క్రమశిక్షణతో, మనస్సుని అన్ని స్వార్థ పూరిత వాంఛల నుండి వెనక్కి మరల్చి, పరమ శ్రేష్ఠమైన ఆత్మ శ్రేయస్సు మీదనే లగ్నం చేస్తారు. ఇటువంటి వారు యోగములో ఉన్నారు అని చెప్పబడతారు, మరియు వారు సమస్త ఇంద్రియ కోరికలకు అతీతంగా ఉంటారు.",
                        "description": [
                            {
                                "des": "యదా వినియతం చిత్తమాత్మన్యేవావతిష్ఠతే ।"
                            },
                            {
                                "des": "నిఃస్పృహః సర్వకామేభ్యో యుక్త ఇత్యుచ్యతే తదా ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "గాలి వీచని ప్రదేశంలో దీపము ఎలాగైతే నిశ్చలంగా ఉండునో, యోగికి వశమునందున్న మనస్సు ఈశ్వర ధ్యానములో స్థిరముగా ఉండును.",
                        "description": [
                            {
                                "des": "యథా దీపో నివాతస్థో నేంగతే సోపమా స్మృతా ।"
                            },
                            {
                                "des": "యోగినో యతచిత్తస్య యుంజతో యోగమాత్మనః ।। 19 ।। "
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఎప్పుడైతే, మనస్సు, భౌతికమైన కార్యకలాపాల నుండి నిగ్రహింపబడి, యోగాభ్యాసము ద్వారా నిశ్చలంగా ఉండునో, అప్పుడు ఆ యోగి పరిశుద్ధమైన మనస్సు ద్వారా ఆత్మను దర్శించగలడు మరియు ఆత్మానందములోనే రమించును.",
                        "description": [
                            {
                                "des": "యత్రోపరమతే చిత్తం నిరుద్ధం యోగసేవయా ।"
                            },
                            {
                                "des": "యత్ర చైవాత్మనాత్మానం పశ్యన్నాత్మని తుష్యతి ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "సమాధి అనబడే ఆ పరమానంద యోగ స్థితిలో, వ్యక్తి అపరిమితమైన దివ్య ఆనందాన్ని అనుభవిస్తాడు. ఈ విధమైన స్థితిలో ఉన్న యోగి, నిత్య పరమ సత్యము నుండి ఎన్నటికీ విచలితుడు కానే కాడు.",
                        "description": [
                            {
                                "des": "సుఖమాత్యంతికం యత్తత్ బుద్ధిగ్రాహ్యమతీంద్రియమ్ ।"
                            },
                            {
                                "des": "వేత్తి యత్ర న చైవాయం స్థితశ్చలతి తత్త్వతః ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఆ స్థితిని పొందిన తరువాత మరింక ఏదీ అంతకంటే గొప్పది కాదు అని భావిస్తాడు. ఈ విధంగా స్థితమై ఉన్నవాడు, ఎంత తీవ్ర దుఃఖాలలో అయినా ఏమాత్రం చలింపడు.",
                        "description": [
                            {
                                "des": "యం లబ్ద్వా చాపరం లాభం మన్యతే నాధికం తతః ।"
                            },
                            {
                                "des": "యస్మిన్ స్థితో న దుఃఖేన గురుణాపి విచాల్యతే ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "దుఃఖముల నుండి విముక్తి పొందిన స్థితినే యోగమని అందురు. ఈ యోగమును ధృడ సంకల్పముతో ఎలాంటి నిరాశావాదం/అపనమ్మకం లేకుండా అభ్యాసం చేయవలెను;",
                        "description": [
                            {
                                "des": "తం విద్యాద్ దుఃఖసంయోగవియోగం యోగసంజ్ఞితమ్ ।"
                            },
                            {
                                "des": "స నిశ్చయేన యోక్తవ్యో యోగోఽనిర్విణ్ణచేతసా  ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24-25 శ్లోకాలు",
                        "bhavam": "ప్రాపంచిక తలంపులతో నుండి వచ్చిన అన్ని కోరికలను త్యజించి, ఇంద్రియములను అన్ని వైపులనుండీ మనస్సుతో నిగ్రహించవలెను. క్రమక్రమముగా మరియు నిశ్చయముగా, బుద్ధి లో దృఢవిశ్వాసం తో మనస్సు భగవంతుని యందే స్థితమగును, మరేదాన్ని గురించి ఇక ఆలోచించదు.",
                        "description": [
                            {
                                "des": "సంకల్పప్రభవాన్ కామాన్ త్యక్త్వా సర్వానశేషతః ।"
                            },
                            {
                                "des": "మనసైవేంద్రియగ్రామం వినియమ్య సమంతతః ।। 24 ।।"
                            },
                            {
                                "des": "శనైః శనైరుపరమేత్ బుద్ధ్యా ధృతిగృహీతయా ।"
                            },
                            {
                                "des": "ఆత్మసంస్థం మనః కృత్వా న కించిదపి చింతయేత్ ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "ఎప్పుడెప్పుడైతే ఎక్కడెక్కడికైతే ఈ చంచలమైన నిలకడ లేని మనస్సు పరిభ్రమిస్తుందో దానిని తిరిగి తెచ్చి నిరంతరం భగవంతుని మీదనే కేంద్రీకరించాలి.",
                        "description": [
                            {
                                "des": "యతో యతో నిశ్చరతి మనశ్చంచలమస్థిరం ।"
                            },
                            {
                                "des": "తతస్తతో నియమ్యైతదాత్మన్యేవ వశం నయేత్।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "మనస్సు ప్రశాంతంగా ఉన్నవాడు, ఆవేశ-ఉద్వేగాలు శాంతించినవాడు, పాపరహితుడు, అన్నిటినీ భగవత్ సంబంధముగా చూసేవాడు – అయిన యోగికి అత్యున్నత అలౌకిక ఆనందం లభిస్తుంది.",
                        "description": [
                            {
                                "des": "ప్రశాంతమనసం హ్యేనం యోగినం సుఖముత్తమమ్ ।"
                            },
                            {
                                "des": "ఉపైతి శాంతరజసం బ్రహ్మభూతమకల్మషమ్ ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "స్వీయ-నిగ్రహం కలిగిన యోగి, ఆత్మను భగవంతునితో ఏకం చేసి, భౌతిక మలినముల నుండి స్వేచ్చ పొందుతాడు, మరియు ఎల్లప్పుడూ పరమాత్మతో సంయోగంతో ఉండుటచే, సంపూర్ణ ఆనందం యొక్క అత్యున్నత స్థాయిని పొందుతాడు.",
                        "description": [
                            {
                                "des": "యుంజన్నేవం సదాత్మానం యోగీ విగతకల్మషః ।"
                            },
                            {
                                "des": "సుఖేన బ్రహ్మసంస్పర్శ మత్యంతం సుఖమశ్నుతే ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "నిజమైన యోగులు, అంతర్బుద్ధిని భగవంతుని యందే ఏకం చేసి, సర్వ భూతములను భగవంతుని యందు మరియు భగవంతుడిని సర్వ భూతములయందు దర్శిస్తారు.",
                        "description": [
                            {
                                "des": "సర్వభూతస్థమాత్మానం సర్వభూతాని చాత్మని ।"
                            },
                            {
                                "des": "ఈక్షతే యోగయుక్తాత్మా సర్వత్ర సమదర్శనః ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "ఎవరైతే నన్ను అంతటా దర్శిస్తారో, అన్నిటినీ నా యందే దర్శిస్తారో, వారు నన్ను కోల్పోరు, నేను వారిని కోల్పోను.",
                        "description": [
                            {
                                "des": "యో మాం పశ్యతి సర్వత్ర సర్వం చ మయి పశ్యతి ।"
                            },
                            {
                                "des": "తస్యాహం న ప్రణశ్యామి స చ మే న ప్రణశ్యతి ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "నా యందే ఏకత్వం తో స్థితుడై ఉండి, నన్నే సర్వ భూతముల యందు స్థితుడై ఉన్న పరమాత్మ గా ఆరాధించిన యోగి, అన్ని రకాల కార్య కలాపములు చేస్తున్నా, నా యందే నివసించును.",
                        "description": [
                            {
                                "des": "సర్వభూతస్థితం యో మాం భజత్యేకత్వమాస్థితః ।"
                            },
                            {
                                "des": "సర్వథా వర్తమానోఽపి స యోగీ మయి వర్తతే ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "సర్వ ప్రాణులను సమానముగా దర్శిస్తూ, ఇతరుల సుఖాలకు, దుఃఖాలకు, అవి తనకే అయినట్టు స్పందించేవారిని, పరిపూర్ణ యోగులుగా పరిగణిస్తాను.",
                        "description": [
                            {
                                "des": "ఆత్మౌపమ్యేన సర్వత్ర సమం పశ్యతి యోఽర్జున।"
                            },
                            {
                                "des": "సుఖం వా యది వా దుఃఖం స యోగీ పరమో మతః ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను: ఓ మధుసూదనా, నీవు చెప్పిన ఈ యోగ విధానము, ఈ చంచలమైన మనస్సు వలన, నాకు ఆచరింపశక్యముకానిది మరియు అసాధ్యమైనది అనిపిస్తున్నది.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ  ।"
                            },
                            {
                                "des": "యోఽయం యోగస్త్వయా ప్రోక్తః సామ్యేన మధుసూదన  ।"
                            },
                            {
                                "des": "ఏతస్యాహం న పశ్యామి చంచలత్వాత్ స్థితిం స్థిరామ్ ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఈ మనస్సు చాలా చంచలమైనది, అల్లకల్లోలమైనది, బలమైనది మరియు మూర్ఖపు పట్టుగలది. దీనిని నిగ్రహించటం వీచేగాలిని నియంత్రించటం కన్నా ఎక్కువ కష్టంగా అనిపిస్తున్నది, ఓ కృష్ణా.",
                        "description": [
                            {
                                "des": "చంచలం హి మనః కృష్ణ ప్రమాథి బలవద్ధృడమ్ ।"
                            },
                            {
                                "des": "తస్యాహం నిగ్రహం మన్యే వాయోరివ సుదుష్కరమ్ ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "శ్రీ కృష్ణ పరమాత్మ అన్నాడు: ఓ మహా బాహువులు కల కుంతీ పుత్రుడా, నీవు చెప్పింది నిజమే; మనస్సు అనేది నిగ్రహించటానికి నిజముగా చాలా కష్టమైనది. కానీ, అభ్యాసము మరియు వైరాగ్యములచే దానిని నిగ్రహించవచ్చు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "అసంశయం మహాబాహో మనో దుర్నిగ్రహం చలమ్ ।"
                            },
                            {
                                "des": "అభ్యాసేన తు కౌంతేయ వైరాగ్యేణ చ గృహ్యతే ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "మనస్సు అదుపు లో లేనివానికి యోగము కష్టతరమైనది. కానీ, మనస్సుని నిగ్రహించటం నేర్చుకున్నవారు, మరియు సరియైన పద్దతిలో పరిశ్రమ చేసేవారు, యోగములో పరిపూర్ణత సాధించవచ్చు. ఇది నా అభిప్రాయము",
                        "description": [
                            {
                                "des": "అసంయతాత్మనా యోగో దుష్ప్రాప ఇతి మే మతిః ।"
                            },
                            {
                                "des": "వశ్యాత్మనా తు యతతా శక్యోఽవాప్తుముపాయతః ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : ఈ మార్గంలో శ్రద్ధ తో ప్రయాణం ప్రారంభించి కూడా, చంచలమైన మనస్సు కారణంచే, తగినంతగా పరిశ్రమించక, యోగ లక్ష్యము యొక్క అంతిమ విజయాన్ని ఈ జన్మ లోనే సాధించలేక పోయిన యోగి యొక్క గతి ఏమిటి ?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "అయతిః శ్రద్ధయోపేతో యోగాచ్చలితమానసః ।"
                            },
                            {
                                "des": "అప్రాప్య యోగసంసిద్ధిం కాం గతి కృష్ణ గచ్ఛతి ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "ఓ మహా బాహువులు గల కృష్ణా, యోగ మార్గం నుండి దారి తప్పిపోయిన వ్యక్తి భౌతిక మరియు ఆధ్యాత్మిక విజయాల రెండింటి నుండి భ్రష్టుడై పోడా? అతడు విడిపోయి చెదిరిన మేఘం వలె ఉభయభ్రష్టుడై ఎటూకాకుండా పోడా?",
                        "description": [
                            {
                                "des": "కచ్చిన్నోభయవిభ్రష్టః ఛిన్నాభ్రమివ నశ్యతి ।"
                            },
                            {
                                "des": "అప్రతిష్ఠో మహాబాహో విమూఢో బ్రహ్మణః పథి   ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "ఓ కృష్ణా, నా ఈ సందేహమును పూర్తిగా నివృత్తి చేయుము, మరి ఇక నీ కన్నా ఇది చేయగలవారు ఎవరున్నారు?",
                        "description": [
                            {
                                "des": "ఏతన్మే సంశయం కృష్ణ ఛేత్తుమర్హస్యశేషతః ।"
                            },
                            {
                                "des": "త్వదన్యః సంశయస్యాస్య ఛేత్తా న హ్యుపపద్యతే ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "ఓ పార్థా, ఆధ్యాత్మిక పథంలో ఉన్న వాడు ఈ లోకం లో కాని, పర లోకంలో కాని చెడిపోడు. ప్రియ మిత్రమా, భగవత్ ప్రాప్తి కోసం ప్రయత్నం చేసే వాడు ఎన్నటికీ దుర్గతి పాలుకాడు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "పార్థ నైవేహ నాముత్ర వినాశస్తత్య విద్యతే ।"
                            },
                            {
                                "des": "న హి కల్యాణకృత్కశ్చిత్ దుర్గతిం తాత గచ్ఛతి ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41-42 శ్లోకాలు",
                        "bhavam": "యోగ భ్రష్టులైన వారు (ఈ జన్మ లో యోగములో సాఫల్యత సాధించలేకపోయిన వారు), పుణ్య లోకాలకు వెళతారు. అక్కడ చాలా కాలం నివసించిన పిదప, వారు తిరిగి భూలోకంలో, ధర్మపరాయణుల, సంపన్నుల కుటుంబంలో జన్మిస్తారు. లేదా, ఏంతో కాలం యోగ అభ్యాసము వలన వైరాగ్యం వృద్ధి చెందిన వారయితే, దివ్య జ్ఞాన సంపన్నుల కుటుంబంలో జన్మిస్తారు. ఇటువంటి జన్మ చాలా దుర్లభము.",
                        "description": [
                            {
                                "des": "ప్రాప్య పుణ్యకృతాం లోకానుషిత్వా శాశ్వతీః సమాః ।"
                            },
                            {
                                "des": "శుచీనాం శ్రీమతాం గేహే యోగభ్రష్టోఽభిజాయతే ।। 41 ।।"
                            },
                            {
                                "des": "అథవా యోగినామేవ కులే భవతి ధీమతామ్ ।"
                            },
                            {
                                "des": "ఏతద్ది దుర్లభతరం లోకే జన్మ యదీదృశమ్ ।। 42 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "43 వ శ్లోకం",
                        "bhavam": "ఇటువంటి జన్మ పొందిన తరువాత, ఓ కురు వంశస్తుడా, వారు తమ పూర్వ జన్మల విజ్ఞానాన్ని తిరిగి మేలుకొలిపి, యోగములో పరిపూర్ణత కొరకు మరింత పరిశ్రమ చేస్తారు.",
                        "description": [
                            {
                                "des": "తత్ర తం బుద్ధిసంయోగం లభతే పౌర్వదేహికమ్ ।"
                            },
                            {
                                "des": "యతతే చ తతో భూయః సంసిద్ధౌ కురునందన ।। 43 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "44 వ శ్లోకం",
                        "bhavam": "వారు, తమ ఇష్టానుసారం కాకపోయినా, పూర్వ జన్మల సాధనా బలంచే ఖచ్చితంగా భగవంతుని వైపు ఆకర్శించబడుతారు. ఇటువంటి సాధకులు వేదములలో చెప్పబడిన కర్మ కాండల సూత్రాలకు సహజంగానే అతీతంగా ఎదుగుతారు.",
                        "description": [
                            {
                                "des": "పూర్వాభ్యాసేన తేనైవ హ్రియతే హ్యవశోఽపి సః ।"
                            },
                            {
                                "des": "జిజ్ఞాసురపి యోగస్య శబ్దబ్రహ్మాతివర్తతే।। 44 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "45 వ శ్లోకం",
                        "bhavam": "అనేక పూర్వ జన్మల నుండి సంపాదించుకుంటూ వచ్చిన యోగ్యతలతో, ఎప్పుడైతే ఈ యోగులు మనఃపూర్వకంగా మరింత పురోగతి కోసం శ్రమిస్తారో, అప్పుడు వారు ప్రాపంచిక కోరికల నుండి పవిత్రమై (స్వేచ్ఛ పొంది), ఈ జన్మ లోనే సిద్ది (పరిపూర్ణత) పొందుతారు.",
                        "description": [
                            {
                                "des": "ప్రయత్నాద్యతమానస్తు యోగీ సంశుద్ధకిల్బిశః ।"
                            },
                            {
                                "des": "అనేకజన్మసంసిద్ధః తతో యాతి పరాం గతిమ్ ।। 45 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "46 వ శ్లోకం",
                        "bhavam": "ఒక యోగి తపస్వి కంటే ఉన్నతమైన వాడు, జ్ఞాని కంటే ఉన్నతమైనవాడు, ఇంకా కర్మీ కంటే కూడా ఉన్నతమైనవాడు. కాబట్టి, ఓ అర్జునా, నీవు యోగి అవ్వటానికి ప్రయత్నించుము.",
                        "description": [
                            {
                                "des": "తపస్విభ్యోఽధికో యోగీ "
                            },
                            {
                                "des": "జ్ఞానిభ్యోఽపి మతోఽధికః  ।"
                            },
                            {
                                "des": "కర్మిభ్యశ్చాధికో యోగీ "
                            },
                            {
                                "des": "తస్మాద్యోగీ భవార్జున।। 46 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "47 వ శ్లోకం",
                        "bhavam": "అందరి యోగులలో కెల్లా, ఎవరి మనస్సు ఎల్లప్పుడూ నాయందే నిమగ్నమై ఉంటుందో, ఎవరు నా యందు ధృఢ విశ్వాసం తో భక్తితో ఉంటారో, వారిని అత్యున్నతమైన వారిగా పరిగణిస్తాను.",
                        "description": [
                            {
                                "des": "యోగినామపి సర్వేషాంమద్గతేనాంతరాత్మనా ।"
                            },
                            {
                                "des": "శ్రద్ధావాన్ భజతే యో మాం స మే యుక్తతమో మతః ।। 47 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "జ్ఞాన విజ్ఞాన యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/07.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/07.png'),
                "index":7,
                "introduction": [
                    {
                        "para": "భగవంతుని శక్తుల యొక్క భౌతిక మరియు ఆధ్యాత్మిక విస్తారాన్ని వివరించటంతో ఈ అధ్యాయం మొదలవుతుంది. ఇవన్నీ కూడా తన నుండే ఉద్భవించాయని, దారం లో గుచ్చబడిన పూసల వలె తన యందే స్థితమై ఉన్నాయని శ్రీ కృష్ణుడు వివరిస్తున్నాడు. ఆయనే ఈ సమస్త సృష్టికి మూలము, మరియు తిరిగి ఇదంతా ఆయనలోకే తిరిగి లయమైపోతుంది. ఆయన యొక్క భౌతిక ప్రకృతి శక్తి, మాయ, బలీయమైనది దానిని అధిగమించటం చాలా కష్టము, కానీ, ఆయనకి శరణాగతి చేసినవారు ఆయన కృప కు పాత్రులై, మాయను సునాయాసముగా దాటిపోగలరు. తనకు శరణాగతి చేయని నాలుగు రకాల మనుష్యుల గూర్చి, మరియు తన యందు భక్తి లో నిమగ్నమయ్యే నాలుగు రకాల మనుష్యుల గురించి శ్రీ కృష్ణుడు వివరిస్తాడు. తన భక్తులలో, ఎవరైతే జ్ఞానముతో తనను భజిస్తారో, తమ మనోబుద్ధులను ఆయనతో ఐక్యం చేస్తారో, వారు తనకు అత్యంత ప్రియమైన వారిగా పరిగణిస్తాను అని అంటున్నాడు. తమ బుద్ధి ప్రాపంచిక కోరికలతో కొట్టుకోపోయిన కొందరు, దేవతలకు శరణాగతి చేస్తారు. కానీ, ఈ దేవతలు కేవలం తాత్కాలిక భౌతిక ఫలాలని మాత్రమే ఇవ్వగలరు, వాటిని కూడా తమకు భగవంతుడు ప్రసాదించిన శక్తి ద్వారానే ఇస్తారు. అందుకే, మనం భక్తి పూర్వకంగా ఉండటానికి, భగవంతుడే అత్యంత యోగ్యుడు. సర్వజ్ఞత, సర్వవ్యాపకత్వము మరియు సర్వశక్తిమత్వం వంటి దివ్య గుణములను కలిగి ఉండి, తనే పరమ సత్యమని మరియు అంతిమ లక్ష్యమని, శ్రీ కృష్ణుడు వక్కాణిస్తున్నాడు. కానీ, ఆయన నిజ వ్యక్తిత్వం, తన యోగమాయా శక్తి యొక్క తెరచే కప్పివేయబడి ఉంది, అందుకే తన యొక్క దివ్య మంగళ స్వరూపము యొక్క నిత్య శాశ్వతమైన స్వభావం అందరికీ తెలియదు. ఆయనను మనం ఆశ్రయిస్తే, ఆయనే తన గురించి జ్ఞానాన్ని ప్రసాదిస్తాడు మరియు ఆయనను తెలుసుకున్న తరువాత మనకు కూడా ఆత్మ జ్ఞానము మరియు కర్మ క్షేత్రము గురించి జ్ఞానం, అవగతమవుతుంది."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "భగవంతుడు పలికెను : ఓ అర్జునా, నాయందు మాత్రమే మనస్సు నిలిపి, భక్తి యోగ అభ్యాసము ద్వారా నాకు శరణాగతి చేసి నీవు ఎట్లయితే నన్ను సంపూర్ణముగా, సందేహానికి తావు లేకుండా తెలుసుకొనగలవో, ఇప్పుడు వినుము.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "మయ్యాసక్తమనాః పార్థ యోగం యుంజన్ మదాశ్రయః ।"
                            },
                            {
                                "des": "అసంశయం సమగ్రం మాం యథా జ్ఞాస్యసి తచ్ఛృణు ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "ఏ జ్ఞానాన్ని, విజ్ఞానాన్ని తెలుసుకున్న పిదప ఇంకా ఏమీ తెలుసుకోవటానికి ఈ లోకంలో మిగిలి ఉండదో, దానిని నేను నీకు సంపూర్ణముగా తెలియచేస్తాను.",
                        "description": [
                            {
                                "des": "జ్ఞానం తేఽహం సవిజ్ఞానమిదం వక్ష్యామ్యశేషతః ।"
                            },
                            {
                                "des": "యత్ జ్ఞాత్వా నేహ భూయోఽన్యత్ జ్ఞాతవ్యమ్ అవశిష్యతే ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "వేల మందిలో ఏ ఒక్కరో పరిపూర్ణ సిద్ది కోసం ప్రయత్నిస్తారు; మరియు పరిపూర్ణ సిద్ది సాధించిన వారిలో ఎవరో ఒకరు మాత్రమే నన్ను యదార్థముగా తెలుసుకుంటారు.",
                        "description": [
                            {
                                "des": "మనుష్యాణాం సహస్రేషు కశ్చిద్యతతి సిద్ధయే ।"
                            },
                            {
                                "des": "యతతామపి సిద్ధానాం కశ్చిన్మాం వేత్తి తత్త్వతః ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "భూమి, నీరు, అగ్ని, వాయువు, ఆకాశము, మనస్సు, బుద్ధి మరియు అహంకారము - ఇవి నా భౌతిక ప్రాకృతిక శక్తి యొక్క ఎనిమిది అంగములు.",
                        "description": [
                            {
                                "des": "భూమిరాపోఽనలో వాయుః ఖం మనో బుద్ధిరేవ చ ।"
                            },
                            {
                                "des": "అహంకార ఇతీయం మే భిన్నా ప్రకృతిరష్టధా ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "ఇది నాయొక్క తక్కువ స్థాయి శక్తి. కానీ, దానికి అతీతంగా, ఓ గొప్ప బాహువులు కలవాడా, అర్జునా, నాకు ఒక ఉన్నతమైన శక్తి ఉంది. అదే జీవ-ఆత్మ శక్తి, ఇది ఈ జగత్తు యందు ఉన్న జీవరాశులకు మూలాధారమైన జీవాత్మలను కలిగి ఉంటుంది.",
                        "description": [
                            {
                                "des": "అపరేయమితస్త్వన్యాం ప్రకృతిం విద్ధి మే పరామ్ ।"
                            },
                            {
                                "des": "జీవభూతాం మహాబాహో యయేదం ధార్యతే జగత్ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "సమస్త జీవ రాశులు నా యొక్క ఈ రెండు శక్తుల ద్వారానే వ్యక్తమవుతాయి అని తెలుసుకొనుము. నేనే ఈ సమస్త సృష్టికి మూల ఉత్పతిస్థానము మరియు నా లోనికే ఇది అంతా లయమై పోతుంది.",
                        "description": [
                            {
                                "des": "ఏతద్యోనీని భూతాని సర్వాణీత్యుపధారయ ।"
                            },
                            {
                                "des": "అహం కృత్స్నస్య జగతః ప్రభవః ప్రలయస్తథా ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "నా కంటే ఉన్నతమైనది ఏదీ లేదు, ఓ అర్జునా. పూసలన్నీ దారము పై గుచ్చి ఉన్నట్టు సమస్తమూ నా యందే ఆధారపడి ఉన్నవి.",
                        "description": [
                            {
                                "des": "మత్తః పరతరం నాన్యత్ కించిదస్తి ధనంజయ ।"
                            },
                            {
                                "des": "మయి సర్వమిదం ప్రోతం సూత్రే మణిగణా ఇవ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "నీటి యందు రుచిని నేను, ఓ కుంతీ పుత్రుడా, మరియు సూర్య చంద్రుల యొక్క తేజస్సుని నేను. వేదములలో నేను పవిత్ర 'ఓం' కారమును (ప్రణవము); ఆకాశములో శబ్దమును మరియు మనుష్యులలో వారి సామర్ధ్యమును.",
                        "description": [
                            {
                                "des": "రసోఽహమప్సు కౌంతేయ ప్రభాస్మి శశిసూర్యయోః ।"
                            },
                            {
                                "des": "ప్రణవః సర్వవేదేషు శబ్దః ఖే పౌరుషం నృషు ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "భూమి యొక్క స్వచ్చమైన వాసన ను నేను మరియు అగ్ని లోని తేజస్సును నేనే. సమస్త ప్రాణులలో జీవశక్తిని నేనే, మరియు తాపసులలో తపస్సును నేనే.",
                        "description": [
                            {
                                "des": "పుణ్యో గంధః పృథివ్యాం చ తేజశ్చాస్మి విభావసౌ ।"
                            },
                            {
                                "des": "జీవనం సర్వభూతేషు తపశ్చాస్మి తపస్విషు ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, సమస్త ప్రాణులకూ సనాతనమైన మూల బీజము నేనే అని తెలుసుకొనుము. ప్రజ్ఞావంతులలో ప్రజ్ఞను నేనే, తేజోవంతులలో తేజస్సుని నేనే.",
                        "description": [
                            {
                                "des": "బీజం మాం సర్వభూతానాం విద్ధి పార్థ సనాతనమ్ ।"
                            },
                            {
                                "des": "బుద్ధిర్బుద్ధిమతామస్మి తేజస్తేజస్వినామహమ్ ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "భరత వంశీయులలో శ్రేష్టుడా, బలవంతులలో కామరాగరహితమైన బలము నేను. ధర్మ విరుద్ధము కాని లైంగిక క్రియలను నేనే.",
                        "description": [
                            {
                                "des": "బలం బలవతాం చాహం కామరాగవివర్జితమ్ ।"
                            },
                            {
                                "des": "ధర్మావిరుద్ధో భూతేషు కామోఽస్మి భరతర్షభ ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "భౌతిక ప్రకృతి యొక్క త్రిగుణములు – సత్త్వము, రజస్సు, తమస్సు – నా శక్తి వల్లనే వ్యక్తమయినాయి. అవి నా యందే ఉన్నాయి కానీ నేను వాటికి అతీతుడను.",
                        "description": [
                            {
                                "des": "యే చైవ సాత్త్వికా భావా రాజసాస్తామసాశ్చ యే।"
                            },
                            {
                                "des": "మత్త ఏవేతి తాన్విద్ధి న త్వహం తేషు తే మయి ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "మాయ యొక్క త్రిగుణములచే భ్రమకు లోనై (మోహితులై), ఈ లోకంలోని జనులు, అనశ్వరమైన మరియు సనాతనమైన నా గురించి తెలుసుకోలేకున్నారు.",
                        "description": [
                            {
                                "des": "త్రిభిర్గుణమయైర్భావైరేభిః సర్వమిదం జగత్ ।"
                            },
                            {
                                "des": "మోహితం నాభిజానాతి మామేభ్యః పరమవ్యయమ్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ప్రకృతి త్రిగుణాత్మకమైన నా దైవీ శక్తి, 'మాయ', అధిగమించుటకు చాలా కష్టతరమైనది. కానీ, నాకు శరణాగతి చేసిన వారు దానిని సునాయాసముగా దాటిపోగలరు.",
                        "description": [
                            {
                                "des": "దైవీ హ్యేషా గుణమయీ మమ మాయా దురత్యయా ।"
                            },
                            {
                                "des": "మామేవ యే ప్రపద్యంతే మాయామేతాం తరంతి తే ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "నాలుగు రకాల మనుష్యులు నాకు శరణాగతి చేయరు - జ్ఞానము లేని వారు, నన్ను తెలుసుకునే సామర్ధ్యం ఉన్నా సోమరితనం తో తమ నిమ్న స్థాయి స్వభావాన్ని అనుసరించేవారు, బుద్ధి భ్రమకు గురైనవారు, ఆసురీ ప్రవుత్తి కలవారు.",
                        "description": [
                            {
                                "des": "న మాం దుష్కృతినో మూఢాః ప్రపద్యంతే నరాధమాః ।"
                            },
                            {
                                "des": "మాయయాపహృతజ్ఞానా ఆసురం భావమాశ్రితాః ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ఓ భరతులలో శ్రేష్టుడా, నాలుగు రకాలైన ధర్మ-పరాయణులు నా పట్ల భక్తి తో నిమగ్నమవుతారు – ఆపదలో ఉన్నవారు, జ్ఞాన సముపార్జన కోసం ప్రయత్నించేవారు, ప్రాపంచిక వస్తువుల సంపాదన కోసం చూసేవారు, మరియు జ్ఞానము నందు స్థితులై ఉన్న వారు.",
                        "description": [
                            {
                                "des": "చతుర్విధా భజంతే మాం జనాః సుకృతినోఽర్జున ।"
                            },
                            {
                                "des": "ఆర్తో జిజ్ఞాసురర్థార్థీ జ్ఞానీ చ భరతర్షభ ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "వీరందరిలో కెల్లా, జ్ఞానం తో నన్ను పూజించే వారు, మరియు నా పట్ల ధృడ సంకల్పముతో మరియు అనన్య భక్తితో ఉన్నవారిని అందరి కంటే, శ్రేష్ఠమైన వారిగా పరిగణిస్తాను. నేను వారికి ప్రియమైనవాడిని మరియు వారు నాకు ప్రియమైనవారు.",
                        "description": [
                            {
                                "des": "తేషాం జ్ఞానీ నిత్యయుక్త ఏకభక్తిర్విశిష్యతే ।"
                            },
                            {
                                "des": "ప్రియో హి జ్ఞానినోఽత్యర్థమహం స చ మమ ప్రియః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "నా యందు భక్తితో ఉన్నవారందరూ నిజముగా ఉత్తములే. కానీ, జ్ఞానముతో, ధృడ నిశ్చయముతో ఉండి, బుద్ధి నా యందు ఐక్యమై, కేవలం నన్ను మాత్రమే వారి పరమ లక్ష్యంగా కలిగిఉన్నవారు, స్వయంగా నా స్వరూపమే అని నేను పరిగణిస్తాను.",
                        "description": [
                            {
                                "des": "ఉదారాః సర్వ ఏవైతే జ్ఞానీ త్వాత్మైవ మే మతమ్ ।"
                            },
                            {
                                "des": "ఆస్థితః స హి యుక్తాత్మా మామేవానుత్తమాం గతిమ్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఎన్నో జన్మల ఆధ్యాత్మిక సాధన తరువాత, జ్ఞాన సంపన్నుడు, ఉన్నదంతా నేనే (వాసుదేవుడే) అని తెలుసుకొని, నాకు శరణాగతి చేస్తాడు. అటువంటి మహాత్ముడు నిజముగా చాలా అరుదు.",
                        "description": [
                            {
                                "des": "బహూనాం జన్మనామంతే జ్ఞానవాన్ మాం ప్రపద్యతే ।"
                            },
                            {
                                "des": "వాసుదేవః సర్వమితి స మహాత్మా సుదుర్లభః ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "భౌతిక ప్రాపంచిక కోరికలతో జ్ఞానం కొట్టుకొని పోయినవారు అన్య దేవతలకు శరణాగతి చేస్తారు. వారి స్వీయ స్వభావాన్ని అనుసరిస్తూ అన్య దేవతలను ఆరాధిస్తారు; ఆయా దేవతలను ప్రసన్నం చేసుకోవటానికి ఆయా కర్మ కాండలను ఆచరిస్తారు.",
                        "description": [
                            {
                                "des": "కామైస్తైస్తైర్హృతజ్ఞానాః ప్రపద్యంతేఽన్యదేవతాః ।"
                            },
                            {
                                "des": "తం తం నియమమాస్థాయ ప్రకృత్యా నియతాః స్వయా ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "భక్తుడు విశ్వాసంతో ఏ ఏ దేవతా స్వరూపాన్ని ఆరాధించాలని కోరుకుంటాడో, ఆ భక్తుడికి ఆయా స్వరూపం మీదనే శ్రద్ధ నిలబడేటట్టు చేస్తాను.",
                        "description": [
                            {
                                "des": "యో యో యాం యాం తనుం భక్తః శ్రద్ధయార్చితుమిచ్ఛతి ।"
                            },
                            {
                                "des": "తస్య తస్యాచలాం శ్రద్ధాం తామేవ విదధామ్యహమ్ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "శ్రద్ధా విశ్వాసము కలిగి ఉన్న ఆ భక్తుడు ఆ దేవతనే ఆరాధించును మరియు కోరుకున్న సామాగ్రిని పొందును. కానీ, నిజానికి ఆ ప్రయోజనాలని సమకూర్చి పెట్టేది నేనే.",
                        "description": [
                            {
                                "des": "స తయా శ్రద్ధయా యుక్తః తస్యారాధనమీహతే ।"
                            },
                            {
                                "des": "లభతే చ తతః కామాన్మయైవ విహితాన్హి తాన్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "కానీ ఈ అల్ప-జ్ఞానము కలిగిన జనులు పొందే ఫలము తాత్కాలికమైనది. దేవతలను ఆరాధించే వారు ఆయా దేవతల లోకానికి వెళతారు, అదే సమయంలో, నా భక్తులు మాత్రం నన్నే చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "అంతవత్తు ఫలం తేషాం తద్భవత్యల్పమేధసామ్ ।"
                            },
                            {
                                "des": "దేవాన్ దేవయజో యాంతి మద్భక్తా యాంతి మామపి ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "పరమేశ్వరుడైన నన్ను, శ్రీ కృష్ణుడిని - ఒకప్పుడు నిరాకార అవ్యక్తముగా ఉండి ఇప్పుడు ఒక రూపాన్ని తీసుకున్నానని అల్ప జ్ఞానము కలవారు అనుకుంటారు. అక్షరమైన, సర్వోత్కృష్టమైన ఈ నాయొక్క సాకార రూపాన్ని వారు అర్థం చేసుకోలేకున్నారు.",
                        "description": [
                            {
                                "des": "అవ్యక్తం వ్యక్తిమాపన్నం మన్యంతే మామబుద్ధయః ।"
                            },
                            {
                                "des": "పరం భావమజానంతో మమావ్యయమనుత్తమమ్ ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "నా యోగమాయా శక్తి ద్వారా కప్పబడి ఉన్న నేను అందరికీ వ్యక్తమవ్వను. కాబట్టి జ్ఞానము లేని వారు నేను పుట్టుక లేని వాడినని మరియు మార్పుచెందని వాడినని తెలుసుకోలేరు.",
                        "description": [
                            {
                                "des": "నాహం ప్రకాశః సర్వస్య యోగమాయాసమావృతః ।"
                            },
                            {
                                "des": "మూఢోఽయం నాభిజానాతి లోకో మామజమవ్యయమ్ ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "అర్జునా! నాకు భూత, వర్తమాన, భవిష్యత్తు అంతా తెలుసు, మరియు సమస్త ప్రాణులు అన్నీ తెలుసు; కానీ నేను ఎవరికీ తెలియదు.",
                        "description": [
                            {
                                "des": "వేదాహం సమతీతాని వర్తమానాని చార్జున ।"
                            },
                            {
                                "des": "భవిష్యాణి చ భూతాని మాం తు వేద న కశ్చన ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "ఓ భరత వంశస్తుడా - రాగ, ద్వేషములనే ద్వందములు, మోహము (భ్రాంతి) నుండే పుట్టుచున్నవి. ఓ శత్రువులను జయించేవాడా, ఈ భౌతిక జగత్తులో ఉన్న ప్రతి ప్రాణి కూడా పుట్టుక నుండే వీటిచే భ్రమింపజేయబడుచున్నది.",
                        "description": [
                            {
                                "des": "ఇచ్ఛాద్వేషసముత్థేన ద్వందమోహేన భారత ।"
                            },
                            {
                                "des": "సర్వభూతాని సమ్మోహం సర్గే యాంతి పరంతప ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "పుణ్య కార్యములు ఆచరించుటచే ఎవరి పాపములు అయితే పూర్తిగా నశించిపోయినవో, వారు ఈ ద్వంద్వముల మోహము నుండి విముక్తి పొందుతారు. అటువంటి వారు నన్ను ధృడ సంకల్పము తో పూజిస్తారు.",
                        "description": [
                            {
                                "des": "యేషాం త్వంతగతం పాపం జనానాం పుణ్యకర్మణామ్ ।"
                            },
                            {
                                "des": "తే ద్వంద్వమోహనిర్ముక్తా భజంతే మాం దృఢవ్రతాః ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "ముసలితనము మరియు మరణము నుండి విముక్తి పొందటానికి పరిశ్రమిస్తూ, నన్ను ఆశ్రయించిన వారు, బ్రహ్మంను, తమ ఆత్మ తత్త్వమును, సమస్త కర్మ క్షేత్రమును తెలుసుకుంటారు.",
                        "description": [
                            {
                                "des": "జరామరణమోక్షాయ మామాశ్రిత్య యతంతి యే ।"
                            },
                            {
                                "des": "తే బ్రహ్మ తద్విదుః కృత్స్నమధ్యాత్మం కర్మ చాఖిలమ్ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "సమస్త అధిభూత (పదార్థ క్షేత్రము), అధిదైవ (దేవతలు), మరియు అధియజ్ఞము (యజ్ఞములకు ఈశ్వరుడు) లకు అధిపతిని నేనే అని తెలుసుకున్న జ్ఞానోదయమయిన జీవాత్మలు, మరణ సమయంలో కూడా పూర్తిగా నా యందే స్థితమై ఉంటారు.",
                        "description": [
                            {
                                "des": "సాధిభూతాధిదైవం మాం సాధియజ్ఞం చ యే విదుః ।"
                            },
                            {
                                "des": "ప్రయాణకాలేఽపి చ మాం తే విదుర్యుక్తచేతసః ।। 30 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "అక్షర బ్రహ్మ యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/08.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/08.png'),
                "index":8,
                "introduction": [
                    {
                        "para": "ఉపనిషత్తులలో విస్తారంగా చెప్పబడిన చాలా పదాలని మరియు విషయాలని ఈ అధ్యాయం క్లుప్తంగా వివరిస్తుంది. మరణం తరువాత ఆత్మ యొక్క గమ్యాన్ని కూడా ఇది విశదీకరిస్తుంది. మనం మరణ సమయంలో భగవంతుడిని స్మరించగలిగితే, ఆయనను ఖచ్చితంగా పొందగలము. కాబట్టి, రోజువారి పనులు చేస్తూనే, ఆయనను అన్ని సమయాల్లో స్మరిస్తూనే ఉండాలి. ఆ స్వామి యొక్క గుణములు, లక్షణములు మరియు మహిమలు గుర్తు చేసుకుంటూ ఆయనను స్మరించవచ్చు. ధృడ సంకల్పము తో యోగ ధ్యానములో మనస్సుని నామ సంకీర్తన ద్వారా ఆయనపైనే కేంద్రీకరించాలి. మన మనస్సుని సంపూర్ణంగా అనన్య భక్తి తో ఆయన పైనే నిమగ్నం చేసినప్పుడు మనము ఈ భౌతిక జగత్తుకి అతీతంగా ఆధ్యాత్మిక స్థాయిలోనికి వెళతాము."
                    },
                    {
                        "para": "ఆ తర్వాత, ఈ అధ్యాయం, భౌతిక జగత్తు లోని రకరకాల లోకాల గురించి ప్రస్తావిస్తుంది. సృష్టి క్రమంలో, ఈ లోకాలు మరియు వాటిలో అసంఖ్యాకమైన జీవ రాశులు ఎలా వచ్చాయో, మరలా ప్రళయ కాలంలో ఎలా తిరిగి లయం అవుతాయో, ఈ అధ్యాయం చెపుతుంది. కానీ, ఈ యొక్క వ్యక్త, అవ్యక్త సృష్టికి అతీతంగా, భగవంతుని దివ్య ధామము ఉంటుంది. ప్రకాశవంతమైన మార్గాన్ని అనుసరించినవారు, అంతిమంగా దివ్య ధామాన్ని చేరుకుంటారు, మరియు ఈ మృత్యు లోకానికి తిరిగిరారు; చీకటి మార్గాన్ని అనుసరించేవారు, ఈ జన్మ, వ్యాధి, వృద్దాప్యం మరియు మృత్యువు యొక్క అంతం లేని చక్రం లో పడి తిరుగుతూనే ఉంటారు."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1-2 శ్లోకాలు",
                        "bhavam": "అర్జునుడు పలికెను: ఓ పరమేశ్వరా, బ్రహ్మన్ (పరమ సత్యము) అనగా ఏమిటి? అధ్యాత్మము (ఆత్మ) అనగా ఏమిటి? మరియు కర్మ అనగా ఏమిటి? దేనిని అధిభూతము అంటారు? మరియు ఎవరిని అధిదైవము అంటారు? శరీరంలో అధియజ్ఞ అంటే ఎవరు మరియు ఆయనే అధియజ్ఞము ఎట్లా అయినాడు? ఓ కృష్ణా, ధృడ సంకల్పముతో ఉన్నవారికి మరణ సమయంలో నీవు తెలియటానికి ఎలా సాధ్యము?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "కిం తద్బ్రహ్మ కిమధ్యాత్మం కిం కర్మ పురుషోత్తమ ।"
                            },
                            {
                                "des": "అధిభూతం చ కిం ప్రోక్తమధిదైవం కిముచ్యతే ।। 1 ।।"
                            },
                            {
                                "des": " అధియజ్ఞః కథం కోఽత్ర దేహేఽస్మిన్మధుసూదన  ।"
                            },
                            {
                                "des": "ప్రయాణకాలే చ కథం జ్ఞేయోఽసి నియతాత్మభిః ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: సర్వోన్నతమైన, నాశములేని తత్త్వమునే బ్రహ్మన్ అందురు; వ్యక్తి యొక్క ఆత్మ తత్త్వమునే అధ్యాత్మ అంటారు. ప్రాణుల భౌతిక తత్త్వమునకు మరియు వాటి అభివృద్దికి సంబంధించిన పనులనే కర్మ లేదా ఫలాపేక్ష తో ఉన్న చర్యలు అంటారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "అక్షరం బ్రహ్మ పరమం స్వభావోఽధ్యాత్మముచ్యతే ।"
                            },
                            {
                                "des": "భూతభావోద్భవకరో విసర్గః కర్మసంజ్ఞితః ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "నిరంతరం మారుతునే ఉండే ఈ భౌతిక సృష్టినే అదిభూత అంటారు; సృష్టిలో దేవతల అధిపతిగా ఉండే భగవంతుని విశ్వ రూపమునే అధిదైవము అంటారు; సర్వ భూతముల హృదయములలో నివసించే నేను అధియజ్ఞము, అంటే సమస్త యజ్ఞములకు ప్రభువు, అని పిలువబడుతాను.",
                        "description": [
                            {
                                "des": "అధిభూతం క్షరో భావః పురుషశ్చాధిదైవతమ్ ।"
                            },
                            {
                                "des": "అధియజ్ఞోఽహమేవాత్ర దేహే దేహభృతాం వర ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "మరణ సమయంలో నన్ను స్మరిస్తూ దేహాన్ని విడిచిపెట్టిన వాడు నన్నే చేరుకుంటాడు. ఈ విషయంలో ఎలాంటి సందేహానికి తావు లేదు.",
                        "description": [
                            {
                                "des": "అంతకాలే చ మామేవ స్మరన్ ముక్త్వా కలేవరమ్ ।"
                            },
                            {
                                "des": "యః ప్రయాతి స మద్భావం యాతి నాస్త్యత్ర సంశయః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "మరణ కాలంలో శరీరాన్ని విడిచిపెట్టే సమయంలో దేనినైతే గుర్తుచేసుకుంటాడో, ఓ కుంతీ పుత్రుడా, ఎప్పుడూ అదే ధ్యాసలో ఉండటం వలన అతను ఆ స్థితినే పొందును.",
                        "description": [
                            {
                                "des": "యం యం వాపి స్మరన్ భావం త్యజత్యంతే కలేవరమ్ ।"
                            },
                            {
                                "des": "తం తమేవైతి కౌంతేయ సదా తద్భావభావితః  ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "కాబట్టి, సర్వ కాలముల యందు నన్ను స్మరిస్తూనే ఉండుము మరియు నీ కర్తవ్యమైన యుద్ధము కూడా చేయుము. నీ మనస్సు-బుద్ధి నాకు శరణాగతి చేసి సమర్పించినచో, నీవు తప్పకుండా నన్నే పొందుదువు; ఈ విషయంలో సందేహం లేదు.",
                        "description": [
                            {
                                "des": "తస్మాత్ సర్వేషు కాలేషు మామనుస్మర యుధ్య చ ।"
                            },
                            {
                                "des": "మయ్యర్పితమనోబుద్ధిః మామేవైష్యస్యసంశయమ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "అభ్యాసము తో, ఓ పార్థా, నిరంతరంగా మనస్సుని, ఎటూ పోనీయక, పరమేశ్వరుడైన నన్ను స్మరించుట యందే నిమగ్నం చేస్తే, నీవు తప్పకుండా నన్ను పొందగలవు.",
                        "description": [
                            {
                                "des": "అభ్యాసయోగయుక్తేన చేతసా నాన్యగామినా ।"
                            },
                            {
                                "des": "పరమం పురుషం దివ్యం యాతి పార్థానుచింతయన్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 -10 శ్లోకాలు",
                        "bhavam": "భగవంతుడు సర్వజ్ఞుడు, అత్యంత ప్రాచీనుడు, అందరినీ శాసించేవాడు, సూక్ష్మము కంటే సూక్ష్మమైన వాడు, అన్నింటికీ ఆధారమైన వాడు, ఊహాకందని దివ్య స్వరూపం కలవాడు; ఆయన సూర్యుడి కంటే తేజోవంతుడు మరియు సమస్త అజ్ఞానపు చీకట్లకీ అతీతుడు. ఎవరైతే మరణ సమయంలో, యోగ అభ్యాసము చేత లభించిన అచంచలమైన మనస్సుతో, ప్రాణములను కనుబొమల మధ్యే నిలిపి, నిశ్చలంగా దివ్య మంగళ భగవంతుడిని అత్యంత భక్తితో స్మరిస్తారో, వారు ఖచ్చితంగా ఆయనను పొందుతారు.",
                        "description": [
                            {
                                "des": "కవిం పురాణమనుశాసితారమ్"
                            },
                            {
                                "des": "అణోరణీయాంసమనుస్మరేద్యః ।"
                            },
                            {
                                "des": "సర్వస్య ధాతారమచింత్యరూపమ్"
                            },
                            {
                                "des": "ఆదిత్యవర్ణం తమసః పరస్తాత్ ।। 9 ।।"
                            },
                            {
                                "des": "ప్రయాణకాలే మనసాచలేన"
                            },
                            {
                                "des": "భక్త్యా యుక్తో యోగబలేన చైవ"
                            },
                            {
                                "des": "భ్రువోర్మధ్యే ప్రాణమావేశ్య సమ్యక్"
                            },
                            {
                                "des": "స తం పరం పురుషముపైతి దివ్యమ్ ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "వేద పండితులు ఆయనను నాశము (క్షయము) చెందని వాడు అని చెప్తారు; ఆయనలో ప్రవేశించటానికి, మహోన్నత ఋషులు బ్రహ్మచర్యము పాటిస్తూ, ప్రాపంచిక భోగాలను త్యజిస్తారు. ఇప్పుడు ఆ లక్ష్యం యొక్క మార్గాన్ని క్లుప్తముగా విశదపరుస్తాను.",
                        "description": [
                            {
                                "des": "యదక్షరం వేదవిదో వదంతి "
                            },
                            {
                                "des": "విశంతి యద్యతయో వీతరాగాః ।"
                            },
                            {
                                "des": "యదిచ్ఛంతో బ్రహ్మచర్యం చరంతి "
                            },
                            {
                                "des": "తత్తే పదం సంగ్రహేణ ప్రవక్ష్యే ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "శరీరము యొక్క అన్ని ద్వారములను నియంత్రించి, మనస్సుని హృదయ స్థానము యందే నిలిపి, ప్రాణములను మూర్ద్న్యా (తల) స్థానములోకి లాగి, వ్యక్తి ఏకాగ్రతతో యోగ ధ్యానములో స్థితుడై ఉండవలెను.",
                        "description": [
                            {
                                "des": "సర్వద్వారాణి సంయంమ్య మనో హృది నిరుధ్య చ ।"
                            },
                            {
                                "des": "మూర్ద్న్యాధాయాత్మనః ప్రాణమ్ ఆస్థితో యోగధారణామ్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "పరమేశ్వరుడినైన నన్ను స్మరిస్తూ, ఓం కారమును జపిస్తూ, శరీరము నుండి వెళ్ళిపోయిన వాడు పరమ గతిని పొందును.",
                        "description": [
                            {
                                "des": "ఓమిత్యేకాక్షరం బ్రహ్మ వ్యాహరన్మామనుస్మరన్ ।"
                            },
                            {
                                "des": "యః ప్రయాతి త్యజన్ దేహం స యాతి పరమాం గతిమ్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఓ పార్థా, అనన్య చిత్తముతో నన్నే ఎల్లప్పుడూ స్మరిస్తూ ఉండే యోగులకు, నేను సులభముగానే దొరుకుతాను ఎందుకటే వారు నిరంతరం నా యందే నిమగ్నమై ఉంటారు కాబట్టి.",
                        "description": [
                            {
                                "des": "అనన్యచేతాః సతతం యో మాం స్మరతి నిత్యశః ।"
                            },
                            {
                                "des": "తస్యాహం సులభః పార్థ నిత్యయుక్తస్య యోగినః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "నన్ను పొందిన పిదప, మహాత్ములకు, ఈ దుఃఖముల నిలయము మరియు తాత్కాలికము అయిన ఈ లోకంలో పునర్జన్మ ఉండదు, ఎందుకంటే వారు సర్వోత్కృష్టమైన పరిపూర్ణతను సాధించారు.",
                        "description": [
                            {
                                "des": "మాముపేత్య పునర్జన్మ దుఃఖాలయమశాశ్వతమ్ ।"
                            },
                            {
                                "des": "నాప్నువంతి మహాత్మానః సంసిద్ధిమ్ పరమాం గతాః   ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "బ్రహ్మలోక పర్యంతమూ, ఈ భౌతిక సృష్టి యొక్క లోకములు అన్నిటిలో, నీవు పునర్జన్మకు గురవుతూనే ఉంటావు, ఓ అర్జునా. కానీ నా ధామమునకు చేరిన పిదప, ఓ కుంతీ పుత్రుడా, ఇక మరల పునర్జన్మ ఉండదు.",
                        "description": [
                            {
                                "des": "ఆబ్రహ్మభువనాల్లోకాః పునరావర్తినోఽర్జున ।"
                            },
                            {
                                "des": "మాముపేత్య తు కౌంతేయ పునర్జన్మ న విద్యతే ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "వెయ్యి చతుర్యుగము (మహాయుగము) ల కాలము, బ్రహ్మ దేవునికి ఒక రోజు (కల్పము) అవుతుంది మరియు ఆయన ఒక రాత్రి కూడా అంతే సమయం ఉంటుంది. దీనిని అర్థం చేసుకున్న వివేకవంతులు పగలు రాత్రి యొక్క యదార్థాన్ని అర్థం చేసుకుంటారు.",
                        "description": [
                            {
                                "des": "సహస్రయుగపర్యంతమ్ అహర్యద్బ్రహ్మణో విదుః ।"
                            },
                            {
                                "des": "రాత్రిం యుగసహస్రాంతాం తేఽహోరాత్రవిదో జనాః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "బ్రహ్మ యొక్క పగలు ప్రారంభంకాగానే, సమస్త ప్రాణులు అవ్యక్త మూలం నుండి ఉద్భవిస్తాయి. మరియు ఆయన రాత్రి మొదలైనంతనే, అన్ని జీవాత్మలూ తమ అవ్యక్త రూపంలోకి లీనమై పోతాయి.",
                        "description": [
                            {
                                "des": "అవ్యక్తాద్వ్యక్తయః సర్వాః ప్రభవంత్యహరాగమే ।"
                            },
                            {
                                "des": "రాత్ర్యాగమే ప్రలీయంతే తత్రైవావ్యక్తసంజ్ఞకే ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "బ్రహ్మ యొక్క పగలు మొదలవగానే సమస్త జీవ రాశులు పదే పదే పుట్టడం ప్రారంభమవుతుంది, మరియు బ్రహ్మరాత్రి ప్రారంభమవగానే అవి తిరిగి లయమైపోతాయి. మరల మరుసటి బ్రహ్మపగలు మొదలవగానే అవన్నీ అప్రయత్నపూర్వకంగానే వ్యక్తమవుతాయి.",
                        "description": [
                            {
                                "des": "భూతగ్రామః స ఏవాయం భూత్వా భూత్వా ప్రలీయతే ।"
                            },
                            {
                                "des": "రాత్ర్యాగమేఽవశః పార్థ ప్రభవత్యహరాగమే ।। 19 ।। "
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఈ యొక్క వ్యక్తమయిన మరియు అవ్యక్తమయిన సృష్టి కంటెను అలౌకికమైన మరియొక సనాతనమైన అవ్యక్త అస్థిత్వం కలదు. మిగతా అన్ని నశించిపోయినా, ఆ లోకము మాత్రము నిత్యము, నశించదు.",
                        "description": [
                            {
                                "des": "పరస్తస్మాత్తు భావోఽన్యోఽవ్యక్తోఽవ్యక్తాత్ సనాతనః ।"
                            },
                            {
                                "des": "యః స సర్వేషు భూతేషు నశ్యత్సు న వినశ్యతి ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "ఆ యొక్క అవ్యక్తమైన విస్తారమే సర్వోన్నత లక్ష్యము, మరియు దానిని చేరిన తరువాత వ్యక్తి ఈ లౌకిక (మర్త్య) లోకానికి తిరిగిరాడు. అది నా యొక్క పరంధామము.",
                        "description": [
                            {
                                "des": "అవ్యక్తోఽక్షర ఇత్యుక్తస్తమాహుః పరమాం గతిమ్ ।"
                            },
                            {
                                "des": "యం ప్రాప్య న నివర్తంతే తద్ధామ పరమం మమ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "సర్వోత్కృష్ట పరమ పురుషుడే అన్నింటికన్నా సర్వోన్నతుడు. ఆయన సర్వ వ్యాప్తుడు మరియు సర్వ ప్రాణులు ఆయన యందే స్థితమై ఉన్నా, ఆయన కేవలం భక్తి చేత మాత్రమే తెలుసుకోబడుతాడు.",
                        "description": [
                            {
                                "des": "పురుషః స పరః పార్థ భక్త్యా లభ్యస్త్వనన్యయా ।"
                            },
                            {
                                "des": "యస్యాంతఃస్థాని భూతాని యేన సర్వమిదం తతమ్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23-26 శ్లోకాలు",
                        "bhavam": "ఈ లోకం నుండి వెళ్లి పోవటానికి ఉన్న వివిధ రకాల మార్గాలను నేను ఇప్పుడు నీకు వివరిస్తాను, ఓ భరత వంశీయులలో శ్రేష్ఠుడా, దీనిలో ఒకటి మోక్షమునకు మార్గము మరియొకటి పునర్జన్మకు దారితీస్తుంది. సర్వోన్నత బ్రహ్మం గురించి తెలుసుకొని, ఉత్తరాయణ ఆరు మాసాల కాలంలో, శుక్ల పక్షంలో, పగటి పూట ఈ లోకాన్ని విడిచి వెళ్ళిన వారు పరమ పదాన్ని చేరుకుంటారు. వైదిక కర్మ కాండలని ఆచరిస్తున్నవారు, దక్షిణాయన ఆరు మాసాల్లో, కృష్ణ పక్షంలో, ధూమ్ర కాలంలో, రాత్రిపూట, ఈ లోకాన్ని విడిచి వెళ్ళినవారు - స్వర్గాది లోకాలను పొందుతారు. స్వర్గ సుఖాలని అనుభవించిన తరువాత, తిరిగి ఈ భూలోకానికి వస్తారు. ఈ రెండు - ప్రకాశవంతమైన మరియు చీకటి, మార్గాలూ ఈ లోకంలో ఎప్పుడూ ఉంటాయి. తేజోవంతమైన మార్గము మోక్షానికి మరియు చీకటి మార్గము పునర్జన్మకి దారి తీస్తుంది.",
                        "description": [
                            {
                                "des": "యత్ర కాలే త్వనావృత్తిం ఆవృత్తిం చైవ యోగినః ।"
                            },
                            {
                                "des": "ప్రయాతా యాంతి తం కాలం వక్ష్యామి భరతర్షభ ।। 23 ।।"
                            },
                            {
                                "des": "అగ్నిర్జ్యోతిరహః శుక్లః షణ్మాసా ఉత్తరాయణమ్ ।"
                            },
                            {
                                "des": "తత్ర ప్రయాతా గచ్ఛంతి బ్రహ్మ బ్రహ్మవిదో జనాః ।। 24 ।।"
                            },
                            {
                                "des": "ధూమో రాత్రిస్తథా కృష్ణః షణ్మాసా దక్షిణాయనమ్ ।"
                            },
                            {
                                "des": "తత్ర చాంద్రమసం జ్యోతిర్యోగీ ప్రాప్య నివర్తతే ।। 25 ।।"
                            },
                            {
                                "des": "శుక్లకృష్ణే గతీ హ్యేతే జగతః శాశ్వతే మతే ।"
                            },
                            {
                                "des": "ఏకయా యాత్యనావృత్తిమ్ అన్యయావర్తతే పునః ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "ఈ రెండు మార్గముల యొక్క రహస్యం తెలిసిన యోగులు, ఓ పార్థా, ఎన్నటికీ మోహమునకు గురి కారు. కాబట్టి, సర్వదా (అన్ని సమయాల్లో) యోగములో స్థితుడవై (భగవంతునితో ఏకమై) ఉండుము.",
                        "description": [
                            {
                                "des": "నైతే సృతీ పార్థ జానన్యోగీ ముహ్యతి కశ్చన ।"
                            },
                            {
                                "des": "తస్మాత్ సర్వేషు కాలేషు యోగయుక్తో భవార్జున ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "ఈ రహస్యం తెలిసిన యోగులు - వైదిక కర్మ కాండల ఆచరణ, వేదాధ్యయనము, యజ్ఞములను ఆచరించుట, తపస్సు చేయుట మరియు దానధర్మాలు చేయుట - వీటన్నిటి పుణ్య ఫలముల కంటేనూ ఎక్కువ ఫలమును పొందుతారు. ఇటువంటి యోగులు పరమ పదమును పొందెదరు.",
                        "description": [
                            {
                                "des": "వేదేషు యజ్ఞేషు తపఃసు చైవ"
                            },
                            {
                                "des": "దానేషు యత్పుణ్యఫలం ప్రదిష్టమ్ ।"
                            },
                            {
                                "des": "అత్యేతి తత్సర్వమిదం విదిత్వా"
                            },
                            {
                                "des": "యోగీ పరం స్థానముపైతి చాద్యమ్ ।। 28 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "రాజ విద్యా యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/09.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/09.png'),
                "index":9,
                "introduction": [
                    {
                        "para": "7వ మరియు 8వ అధ్యాయాలలో శ్రీ కృష్ణుడు యోగ ప్రాప్తికి, భక్తియే అన్నింటికన్నా సులువైన మార్గమని, భక్తియే అత్యున్నత యోగ విధానమని ప్రకటించి ఉన్నాడు. 9వ అధ్యాయంలో - మనలో విస్మయాన్నీ, పూజ్యభావాన్నీ మరియు భక్తినీ ఉత్పన్నం చేసే - తన యొక్క సర్వోత్కృష్ట మహిమలను గురించి చెప్తున్నాడు. తాను అర్జునుడి ముందు తన సాకార రూపంలో నిలబడి ఉన్నా, తాను ఒక సామాన్య మానవుడినే అని అపోహ పడవద్దని తెలియచేస్తున్నాడు. తాను ఏ విధంగా, తన ఈ యొక్క భౌతిక శక్తిని ఆధీనంలో ఉంచుకొని, సృష్టి ప్రారంభంలో అనేకానేక జీవ రాశులను సృష్టించి, ప్రళయ సమయంలో తిరిగి వాటిని తనలోకే లయం చేసుకుంటాడో మరియు తదుపరి సృష్టి చక్రంలో మరల వాటిని వ్యక్తపరుస్తాడో, వివరిస్తాడు. అంతటా బ్రహ్మాండంగా వీచే గాలి కూడా ఆకాశంలోనే ఎలా స్థితమై ఉంటుందో, అలాగే సమస్త జీవ రాశులూ ఆయన యందే నివసిస్తూ ఉంటాయి. అయినా, తన దివ్య యోగ మాయా శక్తి ద్వారా, ఆయన తటస్థంగా, నిర్లిప్తంగా, ఈ అన్ని కార్యక్రమాలకు కేవలం సాక్షిగా, అన్నీ గమనిస్తూ ఉండిపోతాడు."
                    },
                    {
                        "para": "హిందూ ధర్మంలో ఉన్న ఎంతో మంది దేవుళ్ళ/దేవతల అయోమయాన్ని శ్రీ కృష్ణుడు ఇక్కడ - ఆరాధనా విషయముగా కేవలం ఒకే భగవంతుడు ఉంటాడు - అని వివరించటం ద్వారా పరిష్కరిస్తున్నాడు. ఆయనే లక్ష్యము, ఆధారము, ఆశ్రయము మరియు సర్వ భూతముల నిజమైన స్నేహితుడు. వేదాలలో పేర్కొనబడిన కర్మ కాండల పట్ల ఆసక్తి ఉన్నవారు స్వర్గాది లోకాలను పొందుతారు, మరియు వారి పుణ్య ఫలం క్షయం అయిపోయిన తరువాత తిరిగి భూలోకానికి చేరుకుంటారు. కానీ, ఆ పరమేశ్వరుని పట్ల అనన్య భక్తితో నిమగ్నమై ఉన్నవారు ఆయన పరంధామమునకే చేరుకుంటారు. ఈ విధంగా శ్రీ కృష్ణుడు తన పట్ల ఉండే స్వచ్చ మైన భక్తి యొక్క సర్వోన్నత శ్రేష్ఠతను ఎంతగానో కొనియాడాడు. ఇటువంటి భక్తిలో, మన దగ్గర ఉన్నదంతా ఆయనకే సమర్పించి మరియు ప్రతిదీ ఆయనకోసమే చేస్తూ, మనము భగవంతుని చిత్తముతో సంపూర్ణంగా ఏకమై నివసించాలి. ఇటువంటి స్వచ్ఛమైన పవిత్రమైన భక్తిచే, మనము కర్మ బంధాలనుండి విడిపింపబడి, భగవంతునితో ఆధ్యాత్మిక ఏకత్వం పొందుతాము."
                    },
                    {
                        "para": "ఇంకా, తను ఒకరి పట్ల అనుకూలంగా, మరొకరి పట్ల ప్రతికూలంగా ఉండను అంటున్నాడు - ఆయన సమస్త ప్రాణుల పట్ల నిష్పక్షపాతంగా వ్యవహరిస్తాడు. పరమ పాపిష్టి వారు అయినా సరే ఆయనను ఆశ్రయిస్తే, ఆయన వారిని ఆహ్వానించి, స్వీకరించి వారిని శీఘ్రముగా పుణ్యాత్ములుగా, పవిత్రులుగా తీర్చిదిద్దుతాడు. తన భక్తులు ఎన్నటికీ నశింపరు అని ఆయన హామీ ఇస్తున్నాడు. ఆయన వారి యందే స్థితమై ఉండి, వారికి లేనివి సమకూర్చి పెడతాడు, మరియు, వారికి ఉన్నవాటిని సంరక్షిస్తాడు. అందుకే, మనం సర్వదా ఆయనను స్మరించాలి, ఆరాధించాలి, మన మనస్సు-శరీరమును ఆయనకు సమర్పించాలి, ఆయన్నే సర్వోన్నత లక్ష్యంగా చేసుకోవాలి."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: ఓ అర్జునా, నీకు నామీద అసూయ లేదు కాబట్టి, ఈ యొక్క అత్యంత రహస్యమైన జ్ఞానాన్ని మరియు అనుభవపూర్వక విజ్ఞానాన్ని ఇప్పుడు నేను నీకు తెలియజేస్తాను; ఇది తెలుసుకున్న తరువాత నీవు భౌతికసంసార బాధల నుండి విముక్తి చేయబడుతావు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ఇదం తు తే గుహ్యతమం ప్రవక్ష్యామ్యనసూయవే ।"
                            },
                            {
                                "des": "జ్ఞానం విజ్ఞానసహితం యద్ జ్ఞాత్వా మోక్ష్యసేఽశుభాత్ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "ఈ జ్ఞానము అన్ని విద్యలకు రారాజు మరియు అత్యంత గోప్యమయినది. ఇది విన్న వారిని పవిత్రం చేస్తుంది. ఇది నేరుగా అనుభవపూర్వకంగా తెలుసుకోవటానికి వీలైనది, ధర్మ బద్ధమైనది, ఆచరించటానికి సులువైనది, శాశ్వతమైన ఫలితమును ఇచ్చేటటువంటిది.",
                        "description": [
                            {
                                "des": "రాజవిద్యా రాజగుహ్యం పవిత్రమిదముత్తమమ్ ।"
                            },
                            {
                                "des": "ప్రత్యక్ష్యావగమం ధర్మ్యం సుసుఖం కర్తుమవ్యయమ్ ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "ఈ ధర్మము యందు విశ్వాసము లేని జనులు, నన్ను పొందలేకున్నారు, ఓ శత్రువులను జయించేవాడా. వారు పదేపదే జనన-మరణ చక్రంలో ఈ లోకానికి తిరిగి వస్తుంటారు.",
                        "description": [
                            {
                                "des": "అశ్రద్దధానాః పురుషా ధర్మస్యాస్య పరంతప ।"
                            },
                            {
                                "des": "అప్రాప్య మాం నివర్తంతే మృత్యుసంసారవర్త్మని ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "ఈ సమస్త విశ్వమూ నా అవ్యక్త స్వరూపంచే వ్యాపింపబడి ఉన్నది. సమస్త ప్రాణులు నా యందే స్థితమై ఉన్నాయి కాని నేను వాటి యందు స్థితుడనుకాను.",
                        "description": [
                            {
                                "des": "మయా తతమిదం సర్వం జగదవ్యక్త మూర్తినా ।"
                            },
                            {
                                "des": "మత్-స్థాని సర్వభూతాని న చాహం తేష్వవస్థితః ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "అయినా సరే, ప్రాణులు నాలో స్థిరముగా ఉండవు. నా దివ్య శక్తి యొక్క అద్భుతమును తిలకించుము! నేనే సమస్త ప్రాణుల సృష్టి కర్తను మరియు నిర్వాహకుడను అయినా, నేను వాటిచే కానీ లేదా భౌతిక ప్రకృతి చే కానీ ప్రభావితము కాను.",
                        "description": [
                            {
                                "des": "న చ మత్ స్థాని భూతాని పశ్య మే యోగమైశ్వరమ్ ।"
                            },
                            {
                                "des": "భూతభృన్న చ భూతస్థో మమాత్మా భూతభావనః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "అంతటా వీచే ప్రబలమైన గాలి కూడా, ఎల్లప్పుడూ ఆకాశంలోనే స్థితమై ఉన్నట్టు, అదే విధంగా, సర్వ ప్రాణులు కూడా ఎల్లప్పుడూ నా యందే స్థితమై ఉంటాయి.",
                        "description": [
                            {
                                "des": "యథాకాశస్థితో నిత్యం వాయుః సర్వత్రగో మహాన్ ।"
                            },
                            {
                                "des": "తథా సర్వాణి భూతాని మత్స్థానీత్యుపధారయ ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7-8 శ్లోకాలు",
                        "bhavam": "కల్పాంతరమున (ఒక కల్పము చివరన), సమస్త ప్రాణులు నా యొక్క ఆదిమమైన ప్రకృతి శక్తి యందు విలీనమవుతాయి. తదుపరి సృష్టి ప్రారంభంలో, ఓ కుంతీ పుత్రుడా, నేను వాటిని మరల వ్యక్తపరుస్తాను. నా ప్రాకృతిక (భౌతిక) శక్తిని అధీనంలో ఉంచుకొని, ఈ అసంఖ్యాకమైన జీవ రాశులను, వాటి వాటి స్వభావాల అనుగుణంగా, మరల మరల ఉత్పత్తిచేయుచున్నాను.",
                        "description": [
                            {
                                "des": "సర్వభూతాని కౌంతేయ ప్రకృతిం యాంతి మామికామ్ ।"
                            },
                            {
                                "des": "కల్పక్షయే పునస్తాని కల్పాదౌ విసృజామ్యహమ్ ।। 7 ।।"
                            },
                            {
                                "des": "ప్రకృతిం స్వామవష్టభ్య విసృజామి పునః పునః ।"
                            },
                            {
                                "des": "భూతగ్రామమిమం కృత్స్నమ్ అవశం ప్రకృతేర్వశాత్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "ఓ సిరి-సంపదలను జయించే వాడా, ఈ కార్యములు ఏవీ నన్ను బంధించలేవు. నేను ఒక తటస్థ పరిశీలకుడిగా, ఈ కర్మలు ఏవీ నన్ను అంటకుండా అనాసక్తత తో ఉంటాను.",
                        "description": [
                            {
                                "des": "న చ మాం తాని కర్మాణి నిబధ్నంతి ధనంజయ ।"
                            },
                            {
                                "des": "ఉదాసీనవదాసీనమసక్తం తేషు కర్మసు ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "నా యొక్క నిర్దేశంలో పని చేస్తూ, ఈ భౌతిక శక్తి, సమస్త చరాచర భూతములను జనింపచేయును, ఓ కుంతీ పుత్రుడా. ఈ కారణం వలన, భౌతిక జగత్తు మార్పుకు లోనగుచుండును (సృష్టి, స్థితి మరియు లయములు).",
                        "description": [
                            {
                                "des": "మయాధ్యక్షేణ ప్రకృతిః సూయతే సచరాచరమ్ ।"
                            },
                            {
                                "des": "హేతునానేన కౌంతేయ జగద్విపరివర్తతే ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "నేను నా సాకారమనుష్య రూపంలో అవతరించినప్పుడు, మూఢులు నన్ను గుర్తించలేకున్నారు. సకల భూతములకు మహేశ్వరుడైన నా వ్యక్తిత్వం యొక్క దివ్యత్వము వారికి తెలియదు.",
                        "description": [
                            {
                                "des": "అవజానంతి మాం మూఢా మానుషీం తనుమాశ్రితమ్ ।"
                            },
                            {
                                "des": "పరం భావమజానంతో మమ భూతమహేశ్వరమ్ ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "భౌతిక మాయా శక్తి చే భ్రమకు లోనైనటువంటి జనులు ఆసురీ మరియు నాస్తిక భావాలను పెంపొందించుకుంటారు. ఆ అయోమయ స్థితిలో, అభ్యుదయం/సంక్షేమం కోసం వారి ఆశలు వ్యర్థమవుతాయి, వారు ఫలాసక్తితో చేసే కర్మలు అన్ని నిష్ఫలమే మరియు వారి జ్ఞానము అయోమయ స్థితిలో ఉంటుంది.",
                        "description": [
                            {
                                "des": "మోఘాశా మోఘకర్మాణో మోఘజ్ఞానా విచేతసః ।"
                            },
                            {
                                "des": "రాక్షసీమాసురీం చైవ ప్రకృతిం మోహినీం శ్రితాః ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఓ పార్థ, నా యొక్క దివ్యమైన శక్తి ని ఆశ్రయించిన మహాత్ములు, నన్నే, శ్రీ కృష్ణ పరమాత్మనే, సమస్త సృష్టికి ఆది మూలమని తెలుసుకుంటారు. అనన్య చిత్తముతో, కేవలం నాయందే మనస్సు లగ్నం చేసి వారు నా భక్తిలో నిమగ్నమౌతారు.",
                        "description": [
                            {
                                "des": "మహాత్మానస్తు మాం పార్థ దైవీం ప్రకృతిమాశ్రితాః ।"
                            },
                            {
                                "des": "భజంత్యనన్యమనసో జ్ఞాత్వా భూతాదిమవ్యయమ్ ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఎల్లప్పుడూ నా దివ్య లీలలను గానం చేస్తూ, ధృడ సంకల్పముతో పరిశ్రమిస్తూ, వినయముతో నా ముందు ప్రణమిల్లుతూ, నిరంతరం వారు నన్ను ప్రేమ యుక్త భక్తి తో ఆరాధిస్తుంటారు.",
                        "description": [
                            {
                                "des": "సతతం కీర్తయంతో మాం యతంతశ్చ దృఢవ్రతాః ।"
                            },
                            {
                                "des": "నమస్యంతశ్చ మాం భక్త్యా నిత్యయుక్తా ఉపాసతే ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "మరికొందరు, జ్ఞాన సముపార్జనా యజ్ఞములో నిమగ్నమై, నన్ను చాలా రకాలుగా ఆరాధిస్తారు. కొందరు నన్ను తమతో అబేధమైన ఏకత్వముగా చూస్తారు, మరికొందరు నన్ను తమకంటే వేరుగా పరిగణిస్తారు. ఇంకా కొందరు నా యొక్క విశ్వ రూపము యొక్క అనంతమైన ఆవిర్భావములలో ఆరాధిస్తారు.",
                        "description": [
                            {
                                "des": "జ్ఞానయజ్ఞేన చాప్యన్యే యజంతో మాముపాసతే ।"
                            },
                            {
                                "des": "ఏకత్వేన పృథక్త్వేన బహుధా విశ్వతోముఖమ్ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16-17 శ్లోకాలు",
                        "bhavam": "నేనే వైదిక క్రతువును, నేనే యజ్ఞమును మరియు పితృదేవతలకు సమర్పించే నైవేద్యమును. నేనే ఔషధము, నేనే వేద మంత్రమును. నేనే (ఆజ్యము) నెయ్యి, నేనే అగ్ని, నేనే సమర్పించే కార్యమును. ఈ జగత్తుకి నేనే తండ్రి. జగత్తుకి నేనే తల్లిని, సంరక్షకుడిని నేనే; పితామహుడుని నేనే; నేనే పవిత్రం చేసేవాడిని; జ్ఞానం యొక్క లక్ష్యమును, పవిత్ర శబ్దము ఓం కారమును నేనే, ఋగ్వేదమును, సామవేదమును మరియు యజుర్వేదమును నేనే.",
                        "description": [
                            {
                                "des": "అహం క్రతురహం యజ్ఞః స్వధాహమహమౌషధమ్ ।"
                            },
                            {
                                "des": "మంత్రోఽహమహమేవాజ్యమ్ అహమగ్నిరహం హుతమ్ ।। 16 ।।"
                            },
                            {
                                "des": "పితాహమస్య జగతో మాతా ధాతా పితామహః ।"
                            },
                            {
                                "des": "వేద్యం పవిత్రమోంకార ఋక్సామ యజురేవ చ ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "నేనే సమస్త భూతముల సర్వోన్నత లక్ష్యమును, మరియు నేనే వారి యొక్క నిర్వాహకుడను, స్వామి, సాక్షి, నివాసము, ఆశ్రయము మరియు స్నేహితుడను. నేనే సృష్టికి మూలము, అంతము, మరియు ఆధారము; నేనే శాశ్వతస్థానమును మరియు సనాతన బీజమును.",
                        "description": [
                            {
                                "des": "గతిర్భర్తా ప్రభుః సాక్షీ నివాసః శరణం సుహృత్ ।"
                            },
                            {
                                "des": "ప్రభవః ప్రలయః స్థానం నిధానం బీజమవ్యయమ్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "నేను సూర్యుని రూపంలో వేడిమిని ప్రసరిస్తాను. నేనే వర్షమును ఆపుతాను, కురిపిస్తాను. నేనే అమరత్వమును మరియు నేనే మృత్యు రూపంలో వస్తాను. ఓ అర్జునా, నేనే శాశ్వతమైన ఆత్మను, తాత్కాలికమైన పదార్ధమును కూడా నేనే.",
                        "description": [
                            {
                                "des": "తపామ్యహమహం వర్షం నిగృహ్ణామ్యుత్సృజామి చ ।"
                            },
                            {
                                "des": "అమృతం చైవ మృత్యుశ్చ సదసచ్చాహమర్జున ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "వేదములలో చెప్పబడిన సకామ కర్మకాండల పట్ల మొగ్గుచూపేవారు, నన్ను యజ్ఞ యాగాదులచే పూజిస్తారు. యజ్ఞ శేషము అయిన సోమ రస పానము చేయటం ద్వారా పాపాలన్నీ పోయి, పవిత్రులైన వీరు, స్వర్గ లోకాలకు పోవటానికి ఆశిస్తారు. వారి పుణ్య కర్మల ఫలంగా, వారు స్వర్గాధిపతి అయిన ఇంద్రుని లోకానికి వెళతారు, మరియు, దేవతల విలాసాల భోగాలన్నీ అనుభవిస్తారు.",
                        "description": [
                            {
                                "des": "త్రైవిద్యా మాం సోమపాః పూతపాపా।"
                            },
                            {
                                "des": "యజ్ఞైరిష్ట్వా స్వర్గతిం ప్రార్థయంతే ।"
                            },
                            {
                                "des": "తే పుణ్యమాసాద్య సురేంద్రలోకమ్"
                            },
                            {
                                "des": "అశ్నంతి దివ్యాన్ దివి దేవభోగాన్ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "స్వర్గ లోకము యొక్క విశాలమైన భోగములు అనుభవించుట చే వారి పుణ్య ఫలము అంతా తరిగిపోయిన తరువాత వారు తిరిగి భూలోకానికి వస్తారు. ఈ విధంగా భోగ వస్తు ప్రాప్తికై వైదిక కర్మ కాండలను ఆచరించే వారు భూలోకానికి పదేపదే వచ్చి పోతుంటారు.",
                        "description": [
                            {
                                "des": "తే తం భుక్త్వా స్వర్గలోకం విశాలం"
                            },
                            {
                                "des": "క్షీణే పుణ్యే మర్త్యలోకం విశంతి ।"
                            },
                            {
                                "des": "ఏవం త్రయీధర్మమనుప్రపన్నా"
                            },
                            {
                                "des": "గతాగతం కామకామా లభంతే ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఎల్లప్పుడూ నన్నే స్మరిస్తూ మరియు నా యందు అనన్య భక్తిలో నిమగ్నమైన వారుంటారు, అలా నా యందే సతతమూ మనస్సు నిలిపిన వారికి, వారికి లేనిదేదో అది సమకూర్చి పెడతాను మరియు వారికి ఉన్నదాన్ని సంరక్షిస్తాను.",
                        "description": [
                            {
                                "des": "అనన్యాశ్చింతయంతో మాం యే జనాః పర్యుపాసతే ।"
                            },
                            {
                                "des": "తేషాం నిత్యాభియుక్తానాం యోగక్షేమం వహామ్యహమ్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఓ కుంతీ పుత్రుడా, ఇతర దేవతలను శ్రద్ధతో ఆరాధించే వారు కూడా నన్నే పూజిస్తారు. కానీ, అది వారు తప్పు పద్దతి లో చేసినట్టు.",
                        "description": [
                            {
                                "des": "యేఽప్యన్యదేవతా భక్తా యజంతే శ్రద్ధయాన్వితాః ।"
                            },
                            {
                                "des": "తేఽపి మామేవ కౌంతేయ యజంత్యవిధిపూర్వకమ్ ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "సమస్త యజ్ఞములకు భోక్తను, ఏకైక స్వామిని నేనే. కానీ, నా ఈ యొక్క పరమేశ్వర తత్త్వమును తెలుసుకొనని వారు తిరిగి పుట్టవలసినదే.",
                        "description": [
                            {
                                "des": "అహం హి సర్వయజ్ఞానాం భోక్తా చ ప్రభురేవ చ ।"
                            },
                            {
                                "des": "న తు మామభిజానంతి తత్త్వేనాతశ్చ్యవంతి తే ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "దేవతలను పూజించే వారు దేవతల యందు జన్మిస్తారు, పితృదేవతలను ఆరాధించేవారు పితృదేవతల దగ్గరకి వెళ్తారు, భూతప్రేతములను అర్చించువారు అలాంటి వాటిల్లో పుడతారు, మరియు నా భక్తులు నన్నే చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "యాంతి దేవవ్రతా దేవాన్ పితౄన్ యాంతి పితృవ్రతాః ।"
                            },
                            {
                                "des": "భూతాని యాంతి భూతేజ్యా యాంతి మద్యాజినోఽపి మామ్ ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "నాకు ఎవరైనా భక్తితో ఒక ఆకుగాని, ఒక పువ్వు గాని, ఒక పండు గాని, లేదా నీరైనా గాని సమర్పిస్తే, ఆ స్వచ్ఛమైన మనస్సుగల నా భక్తుని చే ప్రేమతో ఇవ్వబడిన దానిని, నేను సంతోషంగా ఆరగిస్తాను.",
                        "description": [
                            {
                                "des": "పత్రం పుష్పం ఫలం తోయం యో మే భక్త్యా ప్రయచ్ఛతి ।"
                            },
                            {
                                "des": "తదహం భక్త్యుపహృతమ్ అశ్నామి ప్రయతాత్మనః ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "నీవు ఏ పని చేసినా, నీవు ఏది తిన్నా, నీవు యజ్ఞములో అగ్నికి ఏది సమర్పించినా, నీవు ఏది బహుమతిగా దానం ఇచ్చినా, మరియు ఏ నిష్ఠలను ఆచరించినా, ఓ కుంతీ పుత్రుడా, వాటిని నాకు సమర్పించినట్టుగా చెయుము.",
                        "description": [
                            {
                                "des": "యత్కరోషి యదశ్నాసి యజ్జుహోషి దదాసి యత్ ।"
                            },
                            {
                                "des": "యత్తపస్యసి కౌంతేయ తత్కురుష్వ మదర్పణమ్ ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "అన్ని పనులను నాకే అర్పితం చేయటం ద్వారా, నీవు శుభ-అశుభ ఫలితముల బంధనముల నుండి విముక్తి చేయబడుతావు. సన్యాసముచే నీ మనస్సు నా యందే లగ్నమై, నీవు విముక్తి చేయబడుతావు మరియు నన్ను చేరుకుంటావు.",
                        "description": [
                            {
                                "des": "శుభాశుభఫలైరేవం మోక్ష్యసే కర్మబంధనైః ।"
                            },
                            {
                                "des": "సంన్యాసయోగయుక్తాత్మా విముక్తో మాముపైష్యసి ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "నేను సర్వ ప్రాణుల యందు సమత్వ బుద్ధి తో ఉంటాను, నేను ఎవరి పట్ల పక్షపాతం తో కానీ లేదా విరోధ భావం తో కానీ ఉండను. కానీ, ప్రేమతో నన్ను ఆరాధించే భక్తులు నాయందే నివసిస్తారు మరియు నేను వారి యందు నివసిస్తాను.",
                        "description": [
                            {
                                "des": "సమోఽహం సర్వభూతేషు న మే ద్వేష్యోఽస్తి న ప్రియః ।"
                            },
                            {
                                "des": "యే భజంతి తు మాం భక్త్యామయి తే తేషు చాప్యహమ్ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "పరమ పాపిష్ఠివారు అయినా సరే, నన్ను అనన్య భక్తి తో పూజిస్తే, వారిని ధర్మాత్ములుగానే పరిగణించాలి, ఎందుకంటే వారు సరియైన నిర్ణయం తీసుకున్నారు కాబట్టి.",
                        "description": [
                            {
                                "des": "అపి చేత్సుదురాచారో భజతే మామనన్యభాక్ ।"
                            },
                            {
                                "des": "సాధురేవ స మంతవ్యః సమ్యగ్వ్యవసితో హి సః ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "త్వరితగతిన వారు ధర్మాత్ములుగా అవుతారు, మరియు శాశ్వతమైన శాంతిని పొందుతారు. ఓ కుంతీ పుత్రుడా, నా భక్తుడు ఎన్నటికీ నష్టమునకు గురికాడు అని ధైర్యముగా ప్రకటించుము.",
                        "description": [
                            {
                                "des": "క్షిప్రం భవతి ధర్మాత్మా శశ్వ చ్ఛాంతిం నిగచ్ఛతి ।"
                            },
                            {
                                "des": "కౌంతేయ ప్రతిజానీహి న మే భక్తః ప్రణశ్యతి ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "వారి జన్మ, జాతి, కులము ఏదైనా, లింగభేదం లేకుండా, సమాజము అసహ్యించుకునేవారయినా, నన్నుశరణు పొందిన వారంతా పరమ పదమును పొందుతారు.",
                        "description": [
                            {
                                "des": "మాం హి పార్థ వ్యపాశ్రిత్య యేఽపి స్యుః పాపయోనయః ।"
                            },
                            {
                                "des": "స్త్రియో వైశ్యాస్తథాశూద్రాః తేఽ పి యాంతి పరాం గతిమ్ ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "ఇక పుణ్యాత్ములైన రాజులు, మునుల గురించి ఏమి చెప్పాలి? కాబట్టి, తాత్కాలికమైన మరియు సుఖంలేని ఈ ప్రపంచం లోకి వచ్చాక, ఇక, నా యందు భక్తి తో నిమగ్నమవ్వుము.",
                        "description": [
                            {
                                "des": "కిం పునర్బ్రాహ్మణాః పుణ్యా భక్తా రాజర్షయస్తథా ।"
                            },
                            {
                                "des": "అనిత్యమసుఖం లోకమిమం ప్రాప్య భజస్వ మామ్ ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఎల్లప్పుడూ నన్నే స్మరించుము, నా పట్ల భక్తితో ఉండుము, నన్ను ఆరాధించుము మరియు నాకు ప్రణామములు అర్పించుము. నీ మనస్సు మరియు శరీరము నాకు సమర్పించిన పిదప నీవు నా వద్దకు నిస్సందేహముగా వచ్చెదవు.",
                        "description": [
                            {
                                "des": "మన్మనా భవ మద్భక్తో మద్యాజీ మాం నమస్కురు ।"
                            },
                            {
                                "des": "మామేవైష్యసి యుక్త్వైవమ్ ఆత్మానం మత్పరాయణః ।। 34 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "విభూతి యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/10.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/10.png'),
                "index":10,
                "introduction": [
                    {
                        "para": "భగవంతుని యొక్క వైభవోపేతమైన మరియు దేదీప్యమానమైన మహిమలను గుర్తుచేసుకుంటూ ఆయనపై ధ్యానం చేయటానికి సహాయముగా అర్జునుడికి ఈ అధ్యాయము శ్రీ కృష్ణుడిచే చెప్పబడినది. తొమ్మిదవ అధ్యాయంలో శ్రీ కృష్ణుడు భక్తి శాస్త్రాన్ని తెలియపరిచాడు మరియు తన యొక్క కొన్ని వైభవాలని వివరించాడు. ఇక్కడ ఇక, అర్జునుడి భక్తిని మరింత ఇనుమడింపచేయాలని తన అనంతమైన మహిమలని మరింత వివరిస్తున్నాడు శ్రీ కృష్ణుడు. ఈ శ్లోకాలు, చదవటానికి కమనీయంగా మరియు వినటానికి మనోరంజకంగా ఉంటాయి."
                    },
                    {
                        "para": "ఈ జగత్తులో ఉన్న ప్రతిదానికీ తనే మూలము అని తెలియచెప్తున్నాడు శ్రీ కృష్ణుడు. మానవులలో ఉన్న విభిన్న లక్షణములు ఆయన నుండే ఉద్భవించాయి. సప్తర్షులు, నలుగురు మహాత్ములు మరియు పద్నాలుగు మనువులు ఆయన మనస్సు నుండే జనించారు మరియు వారి నుండే ఈ ప్రపంచంలోని అందరు మనుష్యులూ అవతరించారు. సమస్తమూ ఆయన నుండే ఉద్భవించాయి అన్న విషయం తెలుసుకున్నవారు ఆయన పట్ల భక్తితో ధృఢ విశ్వాసంతో నిమగ్నమౌతారు. ఇటువంటి భక్తులు ఆయన మహిమల గురించి చర్చిస్తూ, ఇతరులకు ఆయన గురించి తెలియచేస్తూ ఎంతో తృప్తిని అనుభవిస్తారు. వారి మనస్సులు ఆయనతో ఏకమై పోవటం వలన, వారి హృదయములోనే వసించే భగవంతుడు, వారికి దివ్య జ్ఞానము అనుగ్రహిస్తాడు, దానిచే ఆయనను వారు సునాయాసముగానే పొందుతారు."
                    },
                    {
                        "para": "అర్జునుడు, ఇది విన్న పిదప, శ్రీ కృష్ణుని యొక్క సర్వోన్నత స్థాయిని గురించి తాను సంపూర్ణముగా విశ్వసిస్తున్నానని ప్రకటిస్తాడు; మరియు శ్రీ కృష్ణుడే సర్వోత్కృష్ట పరమేశ్వరుడని చాటిచెప్పాడు. వినటానికి అమృతములా ఉండే ఆయన యొక్క కీర్తి విశేషాలని మరింత చెప్పమని భగవంతుడిని ప్రార్ధిస్తాడు. సమస్త పదార్ధములకు కృష్ణుడే ఆది, మధ్య, అంతము కావున, ఉన్నదంతా ఆయన యొక్క శక్తి స్వరూపమే అని శ్రీ కృష్ణుడు తెలియచేస్తున్నాడు. సౌందర్యము, యశస్సు, శక్తి, జ్ఞానము మరియు ఐశ్వర్యములు అనంతమైన పరిమాణం లో కలిగిన భాండాగారము, శ్రీ కృష్ణుడు. ఎప్పుడైనా మనము మహాద్భుతమైన వైభవమును ఎక్కడైనా గమనిస్తే, ఏదైనా మనలను ఆశ్చర్యచకితులను చేస్తే, మనము పారవశ్యములో మునిగిపోతే మరియు ఏదైనా మనకు పరమానందమును కలుగచేస్తే, అది శ్రీ కృష్ణుడి వైభవోపేతమైన ఐశ్వర్యములో ఒక చిన్న భాగమే అని తెలుసుకోవాలి. సమస్త ప్రాణులు మరియు వస్తువులు తమతమ శక్తిసామర్ధ్యాలను ఆయన యొక్క మూలశక్తి భాండాగారము నుండే పొందుతాయి. ఈ అధ్యాయం మిగతా భాగములో, తన ఐశ్వర్యమును చక్కగా వివరించే వస్తువులు, వ్యక్తిత్వాలు మరియు కార్యకలాపములను వివరిస్తాడు శ్రీ కృష్ణుడు. చివరికి, తన యొక్క ఐశ్వర్యము, వైభవము యొక్క పరిమాణము, కేవలం ఇప్పుడు చెప్పిన దాని యొక్క మొత్తంగా మాత్రమే అనుకోవద్దు అని ఆయన అంటాడు - ఎందుకంటే, అసంఖ్యాకమైన విశ్వములను తన అస్తిత్వం లోని అతి చిన్న భాగంతోనే నిలబెట్టి సంరక్షిస్తుంటాడు, శ్రీ కృష్ణుడు. అందుకే, ఆ సమస్త ఐశ్వర్యమునకు మూలమైన భగవంతుడినే మన ఆరాధనా విషయముగా చేసుకోవాలి."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను : నా దివ్య ఉపదేశాన్ని మళ్లీ వినుము, ఓ గొప్ప బాహువులు కలవాడా. నీవు నా ప్రియ సఖుడవు కావున, నీ హితము కోరి నేను నీకు వాటికి తెలియపరుస్తాను.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "భూయ ఏవ మహాబాహో శృణు మే పరమం వచః ।"
                            },
                            {
                                "des": "యత్తేఽహం ప్రీయమాణాయ వక్ష్యామి హితకామ్యయా ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "దేవతలకు గానీ, మహర్షులకు గానీ నా మూల స్థానము తెలియదు. దేవతలకు మరియు మహర్షులకు మూల ఉత్పత్తి స్థానమును నేనే.",
                        "description": [
                            {
                                "des": "న మే విదుః సురగణాః ప్రభవం న మహర్షయః ।"
                            },
                            {
                                "des": "అహమాదిర్హి దేవానాం మహర్షీణాం చ సర్వశః  ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "నేను జన్మరహితుడను మరియు ఆది(మొదలు) లేనివాడిని అని మరియు సర్వ లోక మహేశ్వరుడను అని తెలుసుకున్న మనుష్యులు మోహమునకు గురికారు మరియు వారు సమస్త పాపముల నుండి విముక్తి చేయబడుతారు.",
                        "description": [
                            {
                                "des": "యో మామజమనాదిం చ వేత్తి లోకమహేశ్వరమ్ ।"
                            },

                            {
                                "des": "అసమ్మూఢః స మర్త్యేషు సర్వపాపైః ప్రముచ్యతే ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4-5 శ్లోకాలు",
                        "bhavam": "బుద్ధి కుశలత, జ్ఞానము, ఆలోచనలో స్పష్టత, దయ, నిజాయితీ, మనస్సు-ఇంద్రియ నిగ్రహణ, సుఖ-దుఃఖాలు, జనన-మరణాలు, భయము-ధైర్యము, అహింస, సమత్వం, తృప్తి, తపస్సు, దానము, కీర్తి-అపకీర్తి మొదలగు - మనుష్యులలో ఉండే గుణములలోని వైవిధ్యములు వివిధములైన నా నుండే జనించాయి.",
                        "description": [
                            {
                                "des": "బుద్ధిః జ్ఞానమసమ్మోహః క్షమా సత్యం దమః శమః ।"
                            },
                            {
                                "des": "సుఖం దుఃఖం భవోఽభావో భయం చాభయమేవ చ ।। 4 ।।"
                            },
                            {
                                "des": "అహింసా సమతా తుష్టిస్తపో దానం యశోఽయశః ।"
                            },
                            {
                                "des": "భవంతి భావా భూతానాం మత్త ఏవ పృథగ్విధాః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "సప్త ఋషులు, వారి పూర్వం నలుగురు మహాత్ములు, పద్నాలుగు మనువులు – వీరందరూ నా మనస్సు నుండే జన్మించారు. వారి నుండే ఈ లోకం లోని సమస్త ప్రజలు అవతరించారు.",
                        "description": [
                            {
                                "des": "మహర్షయః సప్త పూర్వే చత్వారో మనవస్తథా ।"
                            },
                            {
                                "des": "మద్భావా మానసా జాతా యేషాం లోక ఇమాః ప్రజాః  ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "నా మహిమలను (విభూతులను) మరియు దివ్య శక్తులను యదార్థముగా తెలిసినవారు నిశ్చలమైన భక్తి యోగము ద్వారా నాతో ఏకమై పోతారు. ఈ విషయంలో ఎలాంటి సందేహానికీ తావు లేదు.",
                        "description": [
                            {
                                "des": "ఏతాం విభూతిం యోగం చ మమ యో వేత్తి తత్త్వతః ।"
                            },
                            {
                                "des": "సోఽవికంపేన యోగేన యుజ్యతే నాత్ర సంశయః ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "నేనే సమస్త సృష్టికి మూల ఉత్పత్తి స్థానమును. నా వలననే అన్నీ కొనసాగుతున్నవి. దీనిని సంపూర్ణముగా తెలుసుకున్న జ్ఞానులు నన్ను అత్యంత భక్తి విశ్వాసములతో ఆరాధిస్తారు.",
                        "description": [
                            {
                                "des": "అహం సర్వస్య ప్రభవో మత్తః సర్వం ప్రవర్తతే ।"
                            },
                            {
                                "des": "ఇతి మత్వా భజంతే మాం బుధా భావసమన్వితాః ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "వారి మనస్సులు నా యందే లగ్నం చేసి, వారి జీవితాలని శరణాగతితో నాకే అర్పించి, నా భక్తులు ఎల్లప్పుడూ నా యందే సంతుష్టులై ఉంటారు. ఒకరినొకరు నా గురించి తెలుపుకుంటూ మరియు నా వైభవాల గురించి చర్చించుకుంటూ అత్యంత తృప్తిని, పరమానందమునూ అనుభవిస్తుంటారు.",
                        "description": [
                            {
                                "des": "మచ్చిత్తా మద్గతప్రాణా బోధయంతః పరస్పరమ్ ।"
                            },
                            {
                                "des": "కథయంతశ్చ మాం నిత్యం తుష్యంతి చ రమంతి చ ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "మనస్సు సదా ప్రేమ పూర్వక భక్తి తో నాతో ఏకమై ఉన్న వారికి, నేను దివ్య జ్ఞానమును ప్రసాదిస్తాను దానిచే వారు నన్ను పొందవచ్చు.",
                        "description": [
                            {
                                "des": "తేషాం సతతయుక్తానాం భజతాం ప్రీతిపూర్వకమ్ ।"
                            },

                            {
                                "des": "దదామి బుద్ధియోగం తం యేన మాముపయాంతి తే  ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "వారి మీద వాత్సల్యంతో, వారి హృదయములోనే ఉండే నేను, అజ్ఞానముచే ఏర్పడిన చీకటిని, ప్రకాశవంతమైన జ్ఞాన దీపముచే నాశనం చేస్తాను.",
                        "description": [
                            {
                                "des": "తేషామేవానుకంపార్థమ్ అహమజ్ఞానజం తమః ।"
                            },
                            {
                                "des": "నాశయామ్యాత్మభావస్థొ జ్ఞానదీపేన భాస్వతా ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12-13 శ్లోకాలు",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు: నీవే పరబ్రహ్మము, పరంధాముడవు, సర్వోన్నతమైన పవిత్రమొనర్చే వాడివి, నిత్యసనాతన భగవంతుడివి, ఆది పురుషుడివి, జన్మ రహితుడివి మరియు అత్యున్నతమైన వాడివి. మహర్షులైన నారదుడు, అసితుడు, దేవలుడు మరియు వ్యాసుడు వంటివారు ఇది చాటిచెప్పారు, ఇప్పుడు స్వయముగా నీవే నాకు ఈ విషయాన్ని ప్రకటిస్తున్నావు.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "పరం బ్రహ్మ పరం ధామ పవిత్రం పరమం భవాన్ ।"
                            },
                            {
                                "des": "పురుషం శాశ్వతం దివ్యమ్ ఆదిదేవమజం విభుమ్ ।। 12 ।।"
                            },
                            {
                                "des": "ఆహుస్త్వామృషయః సర్వే దేవర్షిర్నారదస్తథా ।"
                            },
                            {
                                "des": "అసితో దేవలో వ్యాసః స్వయం చైవ బ్రవీషి మే ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "ఓ కృష్ణా, నీవు చెప్పినదంతా సత్యమేనని నేను ధృడ విశ్వాసంతో నమ్ముతున్నాను. ఓ ప్రభూ, దేవతలు కానీ, దానవులు గానీ, నీ యదార్థ స్వరూపమును తెలుసుకోలేరు.",
                        "description": [
                            {
                                "des": "సర్వమేతదృతం మన్యే యన్మాం వదసి కేశవ ।"
                            },
                            {
                                "des": "న హి తే భగవన్ వ్యక్తిం విదుర్దేవా న దానవాః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఓ పురుషోత్తమా, సకలభూతముల సృష్టికర్త అయినవాడా, సర్వభూతేశా, దేవదేవా, జగత్పతే ! నిజానికి, నిన్ను నీవు మాత్రమే నీ అతీంద్రీయమైన శక్తి ద్వారా ఎరుగుదువు.",
                        "description": [
                            {
                                "des": "స్వయమేవాత్మనాత్మానం వేత్థ త్వం పురుషోత్తమ ।"
                            },
                            {
                                "des": "భూతభావన భూతేశ దేవదేవ జగత్పతే ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16-17 శ్లోకాలు",
                        "bhavam": "నీవు సమస్త జగత్తుల యందు వ్యాపించి వాటి యందు వసించి ఉండే నీ దివ్య విభూతులను దయచేసి నాకు వివరించుము. ఓ యోగేశ్వారా, నేను నిన్ను ఎలా తెలుసుకోగలను మరియు ఎలా స్మరిస్తూఉండేను? మరియు ధ్యానం చేస్తున్నప్పుడు ఏ ఏ స్వరూపాలలో నిన్ను చింతన చేయగలను, ఓ భగవంతుడా?",
                        "description": [
                            {
                                "des": "వక్తుమర్హస్యశేషేణ దివ్యా హ్యాత్మవిభూతయః ।"
                            },
                            {
                                "des": "యాభిర్విభూతిభిర్లోకాన్ ఇమాంస్త్వం వ్యాప్య తిష్ఠసి ।। 16 ।।"
                            },
                            {
                                "des": "కథం విద్యామహం యోగిన్ త్వాం సదా పరిచింతయన్ ।"
                            },
                            {
                                "des": "కేషు కేషు చ భావేషు చింత్యోఽసి భగవన్మయా ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "మరల విస్తారముగా నీ యొక్క దివ్య మహిమలను మరియు అవతారములను చెప్పుము, ఓ జనార్ధనా. నీ అమృతమును వింటూ ఉంటే ఎన్నటికీ తనివితీరదు.",
                        "description": [
                            {
                                "des": "విస్తరేణాత్మనో యోగం విభూతిం చ జనార్ధన ।"
                            },
                            {
                                "des": "భూయః కథయ తృప్తిర్హి శృణ్వతో నాస్తి మేఽమృతమ్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను : ఇప్పుడు నా యొక్క దివ్య విభూతులను నీకు క్లుప్తంగా వివరిస్తాను, ఓ కురు శ్రేష్ఠ, ఎందుకంటే వాటి వివరణకి అంతమే లేదు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "హంత తే కథయిష్యామి దివ్యా హ్యత్మవిభూతయః ।"
                            },
                            {
                                "des": "ప్రాధాన్యతః కురుశ్రేష్ఠ నాస్త్యంతో విస్తరస్య మే ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, నేను సర్వ భూతముల హృదయములలో కూర్చుని ఉన్నాను. నేనే సర్వ ప్రాణుల ఆది, మధ్యము మరియు అంత్యము.",
                        "description": [
                            {
                                "des": "అహమాత్మా గుడాకేశ సర్వభూతాశయస్థితః ।"
                            },
                            {
                                "des": "అహమాదిశ్చ మధ్యం చ భూతానామంత ఏవ చ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "అదితి యొక్క పన్నెండుగురు పుత్రులలో నేను విష్ణువుని; ప్రకాశవంతమైన వస్తువులలో నేను సూర్యుడిని. మరుత్తులలో మరీచుడను మరియు రాత్రి పూట ఆకాశ నక్షత్రాలలో చంద్రుడను నేను.",
                        "description": [
                            {
                                "des": "ఆదిత్యానామహం విష్ణుః జ్యోతిషాం రవిరంశుమాన్ ।"
                            },
                            {
                                "des": "మరీచిర్మరుతామస్మి నక్షత్రాణామహం శశీ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "నేను వేదములలో సామ వేదమును, దేవతలలో ఇంద్రుడను. ఇంద్రియములలో మనస్సును; ప్రాణులలో చైతన్యమును.",
                        "description": [
                            {
                                "des": "వేదానాం సామవేదోఽస్మి దేవానామస్మి వాసవః ।"
                            },
                            {
                                "des": "ఇంద్రియాణాం మనశ్చాస్మి భూతానామస్మి చేతనా ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "రుద్రులలో నేను శంకరుడను; అసురులలో కుబేరుడను; వసువులలో అగ్నిని మరియు పర్వతాలలో మేరు పర్వతమును.",
                        "description": [
                            {
                                "des": "రుద్రాణాం శంకరశ్చాస్మి విత్తేశో యక్షరక్షసామ్ ।"
                            },
                            {
                                "des": "వసూనాం పావకశ్చాస్మి మేరుః శిఖరిణామహమ్ ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "పురోహితులలో నేను బృహస్పతిని; సేనాపతులలో నేను కార్తికేయుడను; మరియు జలాశయాల్లో నేను సముద్రమని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "పురోధసాం చ ముఖ్యం మాం విద్ధి పార్థ బృహస్పతిమ్ ।"
                            },
                            {
                                "des": "సేనానీనామహం స్కందః సరసామస్మి సాగరః ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "మహర్షులలో భృగు మహర్షిని నేను మరియు శబ్దములలో అలౌకికమైన 'ఓం' కారమును. జపములలో (యజ్ఞములలో) భగవన్నామమును మరలమరల జపించటమే నేను; స్థావరములలో హిమాలయమును నేను;",
                        "description": [
                            {
                                "des": "మహార్షీణాం భృగురహం గిరామస్మ్యేకమక్షరమ్ ।"
                            },
                            {
                                "des": "యజ్ఞానాం జపయజ్ఞోఽస్మి స్థావరాణాం హిమాలయః ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "వృక్షములలో నేను రావి చెట్టును; దేవర్షులలో నారదుడను. గంధర్వులలో చిత్రరథుడను, సిద్దులలో నేను కపిల మునిని.",
                        "description": [
                            {
                                "des": "అశ్వత్థః సర్వవృక్షాణాం దేవర్షీణాం చ నారదః ।"
                            },
                            {
                                "des": "గంధర్వాణాం చిత్రరథః సిద్ధానాం కపిలో మునిః ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "గుఱ్ఱములలో నేను, అమృత సముద్రమును చిలకటం ద్వారా జనించిన, ఉచ్చైఃశ్రవసమును. గజేంద్రములలో నేను ఐరావతమును మరియు మనుష్యులలో రాజును.",
                        "description": [
                            {
                                "des": "ఉచ్చైఃశ్రవసమశ్వానాం విద్ధి మామమృతోద్భవమ్ ।"
                            },
                            {
                                "des": "ఐరావతం గజేంద్రాణాం నరాణాం చ నరాధిపమ్ ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "ఆయుధములలో వజ్రాయుధమును మరియు ఆవులలో కామధేనువును. సంతానోత్పత్తికి కారణములలో కామదేవుడను (మన్మథుడు) నేనే; సర్పములలో వాసుకిని నేను.",
                        "description": [
                            {
                                "des": "ఆయుధానామహం వజ్రం ధేనూనామస్మి కామధుక్ ।"
                            },
                            {
                                "des": "ప్రజనశ్చాస్మి కందర్పః సర్పాణామస్మి వాసుకిః ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "నాగులలో నేను అనంతుడను; నీటిలో వసించే వాటిలో వరుణుడను. పితృగణములో నేను అర్యముడను; న్యాయ-ధర్మ పాలన అందిచే వారిలో నేను యమధర్మరాజుడను.",
                        "description": [
                            {
                                "des": "అనంతశ్చాస్మి నాగానాం వరుణో యాదసామహమ్ ।"
                            },
                            {
                                "des": "పితౄణామర్యమా చాస్మి యమః సంయమతామహమ్ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "దైత్యులలో నేను ప్రహ్లాదుడను; అన్నింటినీ నియంత్రించే వాటిలో నేను కాలమును. నేనే, మృగములలో సింహమును మరియు పక్షులలో గరుత్మంతుడను అని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "ప్రహ్లాదశ్చాస్మి దైత్యానాం కాలః కలయతామహమ్ ।"
                            },
                            {
                                "des": "మృగాణాం చ మృగేంద్రోఽహం వైనతేయశ్చ పక్షిణామ్ ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "పవిత్రమొనర్చే వాటిలో నేను వాయువును; శస్త్రధారులలో రాముడను. జల జంతువులలో మకరమును (మొసలి), మరియు ప్రవహించే నదులలో గంగా నదిని.",
                        "description": [
                            {
                                "des": "పవనః పవతామస్మి రామః శస్త్రభృతామహమ్ ।"
                            },
                            {
                                "des": "ఝషాణాం మకరశ్చాస్మి స్రోతసామస్మి జాహ్నవీ ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, నేనే సమస్త సృష్టికి ఆది, మధ్య మరియు అంతము, అని తెలుసుకొనుము. విద్యలలో నేను ఆధ్యాత్మిక విద్యని, మరియు సంవాదములలో తర్కబద్ద నిర్ణయమును నేనే.",
                        "description": [
                            {
                                "des": "సర్గాణామాదిరంతశ్చ మధ్యం చైవాహమర్జున ।"
                            },
                            {
                                "des": "అధ్యాత్మ విద్యా విద్యానాం వాదః ప్రవదతామహమ్ ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "అక్షరములలో అ-కారమును; సమాసములలో ద్వంద్వ సమాసమును. నేనే అపరిమితమైన కాలమును, మరియు సృష్టికర్తలలో బ్రహ్మను.",
                        "description": [
                            {
                                "des": "అక్షరాణామకారోఽస్మి ద్వంద్వః సామాసికస్య చ ।"
                            },
                            {
                                "des": "అహమేవాక్షయః కాలో ధాతాహం విశ్వతోముఖః ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "సర్వమునూ కబళించే మృత్యువును, నేనే, ఇకముందు భవిష్యత్తులో వచ్చే వాటికి కూడా నేనే ఉత్పత్తిస్థానమును. స్త్రీ లక్షణములో నేను కీర్తిని, సిరిసంపదను, చక్కటి వాక్కును, జ్ఞాపకశక్తిని, మేధస్సు, ధైర్యము మరియు క్షమాగుణమును.",
                        "description": [
                            {
                                "des": "మృత్యుః సర్వహరశ్చాహమ్ ఉద్భవశ్చ భవిష్యతామ్ ।"
                            },
                            {
                                "des": "కీర్తిః శ్రీర్వాక్చ నారీణాం స్మృతిర్మేధా ధృతిః క్షమా ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "సామ వేద మంత్రములలో నేనే బృహత్సామము అని తెలుసుకొనుము; ఛందస్సులలో గాయత్రీఛందస్సు నేనే. హైందవ పంచాగము లో మార్గశీర్ష మాసమును, మరియు ఋతువులలో పుష్పములను తెచ్చే వసంత ఋతువును.",
                        "description": [
                            {
                                "des": "బృహత్సామ తథా సామ్నాం గాయత్రీ ఛందసామహమ్ ।"
                            },
                            {
                                "des": "మాసానాం మార్గశీర్షోఽహమ్ ఋతూనాం కుసుమాకరః ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "మోసగాళ్ళలో జూదమును నేను; తేజోవంతులలో తేజస్సును నేను. విజయులలో విజయమును నేను మరియు సంకల్పము కలవారిలో ధృడసంకల్పమును, ధర్మపరాయణులలో సద్గుణమును నేనే.",
                        "description": [
                            {
                                "des": "ద్యూతం ఛలయతామస్మి తేజస్తేజస్వినామహమ్ ।"
                            },
                            {
                                "des": "జయోఽస్మి వ్యవసాయోఽస్మి సత్త్వం సత్త్వవతామహమ్ ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "వృష్ణి వంశస్థులలో నేను కృష్ణుడుని మరియు పాండవులలో అర్జునుడిని. మునులలో వేద వ్యాసుడను అని తెలుసుకొనుము మరియు గొప్ప ఆలోచనాపరులలో శుక్రాచార్యుడను.",
                        "description": [
                            {
                                "des": "వృష్ణీనాం వాసుదేవోఽస్మి పాండవానాం ధనంజయః ।"
                            },
                            {
                                "des": "మునీనామప్యహం వ్యాసః కవీనాముశనా కవిః ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "న్యాయరాహిత్యాన్ని నివారించటానికి ఉన్న విధానాలలో నేను ధర్మబద్దమైన శిక్షను, జయాభిలాష కలవారిలో సత్ప్రవర్తనను. రహస్యములలో నేను మౌనమును. జ్ఞానులలో జ్ఞానమును నేనే.",
                        "description": [
                            {
                                "des": "దండో దమయతామస్మి నీతిరస్మి జిగీషతామ్ ।"
                            },
                            {
                                "des": "మౌనం చైవాస్మి గుహ్యానాం జ్ఞానం జ్ఞానవతామహమ్ ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "సర్వ భూతముల సృష్టికి మూల ఉత్పాదక బీజమును నేనే, అర్జునా. చరాచర ప్రాణి ఏదీ కూడా నేను లేకుండా ఉండలేదు.",
                        "description": [
                            {
                                "des": "యచ్చాపి సర్వభూతానాం బీజం తదహమర్జున ।"
                            },
                            {
                                "des": "న తదస్తి వినా యత్ స్యాన్మయా భూతం చరాచరమ్ ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "నా దివ్య విభూతులకు అంతము లేదు, ఓ పరంతపా. నేను ఇప్పటివరకు చెప్పింది నా అనంతమైన వైభవములలో ఒక చిన్న భాగము మాత్రమే.",
                        "description": [
                            {
                                "des": "నాంతోఽస్తి మమ దివ్యానాం విభూతీనాం పరంతప ।"
                            },
                            {
                                "des": "ఏష తూద్దేశతః ప్రోక్తో విభూతేర్విస్తరో మయా ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "నీవు ఏదైనా అందమైన దాన్ని కానీ, అద్భుతమైన దాన్ని కానీ, లేదా శక్తివంతమైన దాన్ని కానీ చూస్తే, అది నా శోభ యొక్క తళుకుగా తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "యద్యద్ విభూతిమత్సత్వం శ్రీమద్ ఊర్జితమేవ వా ।"
                            },
                            {
                                "des": "తత్ తత్ దేవావగచ్చ త్వం మమ తేజోఽశసంభవమ్  ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42 వ శ్లోకం",
                        "bhavam": "ఈ విస్తారమైన జ్ఞానం ఏం అవసరం, ఓ అర్జునా? ఇంత మాత్రం తెలుసుకో చాలు, కేవలం నా యొక్క ఒక్క చిన్న అంశ తోనే, సమస్త జగత్తు యందు వ్యాపించి మరియు దాన్ని పోషిస్తూ/నిర్వహిస్తూ ఉన్నాను.",
                        "description": [
                            {
                                "des": "అథవా బహునైతేన కిం జ్ఞాతేన తవార్జున ।"
                            },
                            {
                                "des": "విష్టభ్యాహమిదం కృత్స్నమ్ ఏకాంశేన స్థితో జగత్ ।। 42 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "విశ్వ రూప దర్శన యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/11.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/11.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/11.png'),
                "index":11,
                "introduction": [
                    {
                        "para": "ఇంతకు క్రితం అధ్యాయంలో, అర్జునుడి భక్తిని మరింత వికసింపచేయటానికి, శ్రీ కృష్ణుడు తన దివ్య విభూతులను వివరించి ఉన్నాడు. సుందరమైనవి, మహాద్భుతమైనవి మరియు శక్తివంతమైనవి అన్నీ కూడా తన వైభవములోని చిన్న తళుకులే అని చివరికి సూచనప్రాయంగా తన విశ్వ రూపము గురించి ప్రస్తావించాడు. ఈ అధ్యాయంలో, అర్జునుడు శ్రీ కృష్ణుడి విశ్వ రూపమునుని చూడాలని ప్రార్ధిస్తున్నాడు, అది సమస్త విశ్వములు తనలోనే కలిగి ఉన్న అనంతమైన విశ్వ రూపము. శ్రీ కృష్ణుడు దానికి ఒప్పుకుని, అతనికి దివ్య దృష్టి ప్రసాదిస్తాడు. అర్జునుడు అప్పుడు సమస్త సృష్టిని ఆ దేవ దేవుని శరీరము యందే దర్శిస్తాడు. ఆయన అనంతమైన ముఖములను, కళ్ళను, బాహువులను మరియు ఉదరములను ఆ యొక్క మహాద్భుతమైన మరియు అనంతమైన భగవంతుని రూపంలో దర్శిస్తాడు. ఆ స్వరూపమునకు ఎలాంటి మొదలు లేదా తుది లేదు మరియు అన్ని దిశలయందు అనంతమైన పరిమాణంలో వ్యాపించి ఉంది. ఆ యొక్క విశ్వ రూప తేజస్సు, వెయ్యి సూర్యులు ఒక్క సారిగా ఆకాశములో వెలిగిన కాంతి కంటే తేజోవంతముగా ఉన్నది. ఆ దర్శనం అర్జునుడి వెంట్రుకలను నిక్కబోడుచుకునేలా చేసింది. ముల్లోకాలూ భగవంతుని శాసనానికి భయంతో వణకటం గమనిస్తాడు. దేవతలు ఆయన యందే ఆశ్రయం పొంది ఉండటం మరియు మహర్షులు శ్లోకాలు, కీర్తనలతో ఆయనను స్తుతించటం ప్రత్యక్షంగా చూస్తాడు. పురుగులు మంటలోనికి పడిపోయి భస్మమైపోతునట్టు, ధృతరాష్ట్రుడి కుమారులందరూ, వారి అనుబంధ రాజులతో సహా, తలక్రిందులుగా ఆ భయంకర స్వరూపము నోటిలోనికి దూసుకెళ్లటం చూస్తాడు. ఆ విశ్వ రూపమును దర్శించటం తో గుండె భయంతో దడదడలాడి పోతున్నదని, మానసిక ప్రశాంతత పోయినదని ఒప్పుకుంటాడు. అర్జునుడు భీతిల్లిపోయి, ఈ మహోన్నత భగవంతుడు నిజానికి ఎవరు అని తెసుకోవాలనుకుంటాడు, ఎందుకంటే ఈ రూపానికీ మరియు తనకు తెలిసిన గురువు మరియు సఖుడైన కృష్ణునికి ఏమాత్రం పోలిక లేదు. శ్రీ కృష్ణుడు దీనికి సమాధానముగా, తానే కాల రూపములో ముల్లోకాలను నాశనం చేసేవాడను అని చెప్తాడు. కౌరవ మహా యోధులు అందరూ తనచే పూర్వమే సంహరింపబడ్డారు కాబట్టి విజయం నిశ్చితమైనది కాబట్టి అర్జునుడు ఇక లేచి యుద్ధం చేయాలని అంటాడు."
                    },
                    {
                        "para": "దీనికి ప్రతిస్పందనగా, అర్జునుడు శ్రీ కృష్ణుడిని అనంతమైన శక్తి సామర్ద్యములు కలిగిన ఈశ్వరునిగా స్తుతించి ఆయనకు పదేపదే నమస్కరిస్తాడు. తమ సుదీర్ఘ మైత్రిలో తను ఎప్పుడైనా కృష్ణుడిని సామాన్య మానవునిగా పొరపాటుగా అనుకుని ఆయన మనస్సు నొప్పించేట్టు ఏదైనా తప్పు చేస్తే క్షమించమని అడుగుతాడు. కృప కోసం ప్రార్ధించి మరొక్కసారి తిరిగి మనోహరమైన భగవంతుని మామూలు రూపాన్ని చూపమని అడుగుతాడు. శ్రీ కృష్ణుడు అతని కోరికను మన్నించి మొదట చతుర్భుజ రూపమునకు వచ్చి, తదుపరి, తన సుకుమారమైన మరియు రమ్యమైన రెండు-భుజముల స్వరూపములోనికి వస్తాడు. అర్జునుడు ఏ విధమైన భగవత్ స్వరూపాన్ని దర్శనం చేసాడో ఆ దర్శనం లభించటం ఎంత దుర్లభమో అర్జునుడికి చెప్తాడు. వేదములు అభ్యసించటం వలన, తపస్సులు ఆచరించటం చేత, దానధర్మాల చేత లేదా యజ్ఞములు చేయటం ద్వారా కానీ ఆయన నిజ స్వరూపమును దర్శించలేము. నిష్కల్మషమైన భక్తిచే మాత్రమే ఆయనను అర్జునుడు ఎదుటే ఉన్నవాడిలా, నిజరూపములో తెలుసుకోగలము, మరియు ఆయనతో ఏకమవ్వగలము."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "నా మీద దయచే నీవు తెలియపరచిన ఈ యొక్క పరమ రహస్యమైన ఆధ్యాత్మిక జ్ఞానము విన్న తరువాత, నా మోహము ఇప్పుడు తొలగిపోయినది.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "మదనుగ్రహాయ పరమం గుహ్యమధ్యాత్మసంజ్ఞితమ్ ।"
                            },
                            {
                                "des": "యత్త్వయోక్తం వచస్తేన మోహోఽయం విగతో మమ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "సర్వ ప్రాణులు ఉత్పత్తి మరియు అవ్యక్తమైపోవటము విషయము గురించి విస్తారముగా నీ నుండి విన్నాను, ఓ తామర వంటి నేత్రములు కలవాడా, నిత్య శాశ్వతమైన నీ మహాత్మ్యము కూడా విన్నాను",
                        "description": [
                            {
                                "des": "భవాప్యయౌ హి భూతానాం శ్రుతౌ విస్తరశో మయా ।"
                            },
                            {
                                "des": "త్వత్తః కమలపత్రాక్ష మాహాత్మ్యమపి చావ్యయమ్ ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "ఓ ప్రభూ, నీవెవరో నీవే చెప్పినట్టు, నీవు సరిగ్గా అటువంటి దివ్య స్వరూపానివే. ఇప్పుడు నాకు, నీ యొక్క దివ్య విశ్వరూపమును చూడాలనే కోరిక కలుగుతున్నది, ఓ పురుషోత్తమా.",
                        "description": [
                            {
                                "des": "ఏవమేతద్యథాత్థ త్వమాత్మానం పరమేశ్వర ।"
                            },
                            {
                                "des": "ద్రష్టుమిచ్ఛామి తే రూపమైశ్వరం పురుషోత్తమ ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "ఓ యోగేశ్వరా, నాకు దాన్ని దర్శించగలిగే శక్తి ఉంది అని నీవు అనుకుంటే, దయచేసి ఆ యొక్క నిత్య శాశ్వతమైన విశ్వ రూపమును నాకు చూపించుము.",
                        "description": [
                            {
                                "des": "మన్యసే యది తచ్ఛక్యం మయా ద్రష్టుమితి ప్రభో ।"
                            },
                            {
                                "des": "యోగేశ్వర తతో మే త్వం దర్శయాత్మానమవ్యయమ్ ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను : వివిధములైన ఆకృతులు, పరిమాణములు మరియు వర్ణములతో ఉన్న వందల వేల అద్భుతమైన నా యొక్క స్వరూపములను, ఇదిగో తిలకించుము ఓ పార్థ.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "పశ్య మే పార్థ రూపాణి శతశోఽథ సహస్రశః ।"
                            },
                            {
                                "des": "నానావిధాని దివ్యాని నానావర్ణాకృతీని చ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "నాలో పరికించుము ఓ భరత వంశీయుడా, (పన్నెండుగురు) అదితి పుత్రులను, (ఎనిమిది మంది) వసువులను, (పదకొండు) రుద్రులను, (ఇద్దరు) అశ్వినీ కుమారులను, అంతే కాక, (నలభైతొమ్మిది) మరుత్తులు మరియు మరెన్నెన్నో ఇంతకు పూర్వం తెలియపరచబడని అద్భుతములను కూడా చూడుము.",
                        "description": [
                            {
                                "des": "పశ్యాదిత్యాన్ వసూన్ రుద్రాన్ అశ్వినౌ మరుతస్తథా ।"
                            },
                            {
                                "des": "బహూన్యదృష్టపూర్వాణి పశ్యాశ్చర్యాణి భారత ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఒక్కచోటే కూడిఉన్న సమస్త చరాచరములను కలిగిఉన్న జగత్తును, నా విశ్వ రూపము యందే దర్శించుము ఇప్పుడు ఓ అర్జునా. ఇంకా మరేదైనా చూడదలుచుకున్నా వాటన్నిటినీ నా విశ్వ రూపము యందే తిలకించుము.",
                        "description": [
                            {
                                "des": "ఇహైకస్థం జగత్ కృత్స్నం పశ్యాద్య సచరాచరమ్ ।"
                            },
                            {
                                "des": "మమ దేహే గుడాకేశ యచ్చాన్యద్ద్రష్టుమిచ్ఛసి ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "కానీ, నా యొక్క విశ్వ రూపమును నీ ప్రాకృతిక కళ్ళతో చూడలేవు. కాబట్టి, నీకు దివ్య దృష్టిని ప్రసాదిస్తున్నాను. నా యొక్క మహాద్భుత వైభవమును దర్శించుము.",
                        "description": [
                            {
                                "des": "న తు మాం శక్యసే ద్రష్టుమనేనైవ స్వచక్షుషా ।"
                            },
                            {
                                "des": "దివ్యం దదామి తే చక్షుః పశ్య మే యోగమైశ్వరమ్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను: ఓ మహారాజా, ఇట్లు పలికిన పిదప, ఆ యోగేశ్వరుడైన శ్రీ కృష్ణుడు, తన యొక్క దివ్యమైన మరియు వైభవోపేతమైన రూపమును అర్జునుడికి చూపెను.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఏవముక్త్వా తతో రాజన్ మహాయోగేశ్వరో హరిః ।"
                            },
                            {
                                "des": "దర్శయామాస పార్థాయ పరమం రూపమైశ్వరమ్ ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10-11 శ్లోకాలు",
                        "bhavam": "ఆ యొక్క విశ్వ రూపములో, అర్జునుడు అనంతమైన ముఖములు మరియు కనులను దర్శించాడు. అవి ఎన్నెన్నో దివ్యమైన ఆభరణములను మరియు అనేక రకాల దివ్య ఆయుధములను కలిగి ఉన్నాయి. ఆ స్వరూపము తన శరీరం పై అనేక మాలలను కలిగి ఉంది మరియు దివ్య సుగంధ పరిమళభూరితమై గుబాళిస్తున్నది. మహాద్భుతమైన అనంతమైన ఈశ్వరునిగా సర్వత్రా తన ముఖముతో తనను తాను వ్యక్తపరుచుకున్నాడు.",
                        "description": [
                            {
                                "des": "అనేకవక్త్రనయనమ్ అనేకాద్భుతదర్శనమ్ ।"
                            },
                            {
                                "des": "అనేకదివ్యాభరణం దివ్యానేకోద్యతాయుధమ్ ।। 10 ।।"
                            },
                            {
                                "des": "దివ్యమాల్యాంబరధరం దివ్యగంధానులేపనమ్ ।"
                            },
                            {
                                "des": "సర్వాశ్చర్యమయం దేవమనంతం విశ్వతోముఖం ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "ఆకాశములో వెయ్యి మంది సూర్యులు ఒకే సమయంలో ప్రకాశించినా, ఆ మహోన్నత రూపము యొక్క తేజస్సుకు సాటి రావు.",
                        "description": [
                            {
                                "des": "దివి సూర్య సహస్రస్య భవేద్యుగపదుత్థితా ।"
                            },
                            {
                                "des": "యది భాః సదృశీ సా స్యాత్ భాసస్తస్య మహాత్మనః ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "అక్కడ, ఆ దేవదేవుని శరీరము యందు, సమస్త బ్రహ్మాండములన్నీ ఒక్క చోటే ఉన్నట్టు అర్జునుడు దర్శించాడు.",
                        "description": [
                            {
                                "des": "తత్రైకస్థం జగత్ కృత్స్నం ప్రవిభక్తమనేకధా ।"
                            },
                            {
                                "des": "అపశ్యద్దేవదేవస్య శరీరే పాండవస్తదా ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "అప్పుడు, పరామాశ్చర్యమునకు లోనయ్యి, రోమములు నిక్కబోడుచుకున్నవాడైన అర్జునుడు, చేతులు జోడించి తలవంచి నమస్కరిస్తూ, భగవంతుడుని ఈ విధంగా స్తుతించాడు.",
                        "description": [
                            {
                                "des": "తతః స విస్మయావిష్టో హృష్టరోమా ధనంజయః ।"
                            },
                            {
                                "des": "ప్రణమ్య శిరసా దేవం కృతాంజలిరభాషత ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా చెప్పెను, ఓ శ్రీ కృష్ణా, నీ దేహము యందు నేను - సకల దేవతలనూ, ఎన్నెనో ప్రాణికోటి సమూహములను, కమలము యందు కూర్చుని ఉన్న బ్రహ్మ దేవుడిని, శివుడిని, అందరు ఋషులను, మరియు దివ్య సర్పములను - చూచుచున్నాను.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "పశ్యామి దేవాంస్తవ దేవ దేహే।"
                            },
                            {
                                "des": "సర్వాంస్తథా భూతవిశేషసంఘాన్"
                            },
                            {
                                "des": "బ్రహ్మాణమీశం కమలాసనస్థమ్"
                            },
                            {
                                "des": "ఋషీంశ్చ సర్వానురగాంశ్చ దివ్యాన్ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "అసంఖ్యాకమైన చేతులతో, ఉదరములతో, ముఖములతో మరియు కళ్ళతో ఉన్న నీ యొక్క అనంతమైన రూపములను అన్ని దిశలలో చూస్తున్నాను. ఓ విశ్వేశ్వరా, విశ్వమే నీ యొక్క స్వరూపముగా కలవాడా, నీ యందు ఎటువంటి ఆదిమధ్యాంతరములు చూడలేకున్నాను.",
                        "description": [
                            {
                                "des": "అనేకబాహూదరవక్త్రనేత్రం"
                            },
                            {
                                "des": "పశ్యామి త్వాం సర్వతోఽనంతరూపమ్ ।"
                            },
                            {
                                "des": "నాంతం న మధ్యం న పునస్తవాదిం"
                            },
                            {
                                "des": "పశ్యామి విశ్వేశ్వర విశ్వరూప ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "కిరీటముతో, చక్ర-గద ఆయుధములు కలిగి సర్వత్రా ప్రకాశించుచున్న నీ యొక్క స్వరూపమును దర్శిస్తున్నాను. సూర్యునిలా అన్ని దిశలలో అగ్నిని విరజిమ్ముతున్న నీ తేజస్సుచే నిన్ను చూడటానికి కష్టతరంగా ఉన్నది.",
                        "description": [
                            {
                                "des": "కిరీటినం గదినం చక్రిణం చ"
                            },
                            {
                                "des": "తేజోరాశిం సర్వతో దీప్తిమంతమ్"
                            },
                            {
                                "des": "పశ్యామి త్వాం దుర్నిరీక్ష్యం సమంతాత్"
                            },
                            {
                                "des": "దీప్తానలార్క ద్యుతిమప్రమేయమ్ ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "నీవే అనశ్వరమైన పరమేశ్వరుడవు అని, వేదములచే ప్రతిపాదింపబడిన పరమ సత్యము అని తెలుసుకున్నాను. నీవే సమస్త సృష్టికి ఆధారము; నీవే సనాతన ధర్మమునకు నిత్య రక్షకుడవు; నీవే నిత్య శాశ్వతమైన సర్వోత్కృష్ట భగవంతుడవు.",
                        "description": [
                            {
                                "des": "త్వమక్షరం పరమం వేదితవ్యం"
                            },
                            {
                                "des": "త్వమస్య విశ్వస్య పరం నిధానమ్"
                            },
                            {
                                "des": "త్వమవ్యయః శాశ్వతధర్మగోప్తా"
                            },
                            {
                                "des": "సనాతనస్త్వం పురుషో మతో మే ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "నీవు ఆది-మధ్య-అంతము లేనివాడవు; నీ శక్తులు అపరిమితమైనవి. నీకు అనంతమైన బాహువులు కలవు; సూర్యచంద్రులు నీ నేత్రములు వంటివి మరియు అగ్నినీ నోరు వంటిది. సమస్త సృష్టిని నీ తేజస్సుచే వెచ్చగా ఉత్తేజ పరుచుతున్నటువంటి, నిన్ను , నేను దర్శిస్తున్నాను.",
                        "description": [
                            {
                                "des": "అనాదిమధ్యాంతమనంత వీర్యమ్"
                            },
                            {
                                "des": "అనంతబాహుం శశిసూర్యనేత్రమ్ ।"
                            },
                            {
                                "des": "పశ్యామి త్వాం దీప్తహుతాశవక్త్రం"
                            },
                            {
                                "des": "స్వతేజసా విశ్వమిదం తపంతమ్ ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "దివి నుండి భువి వరకు గల మధ్య ప్రదేశమంతా మరియు అన్ని దిశలలో కూడా నీవే వ్యాపించి ఉన్నావు. ఓ మహత్మా, నీ యొక్క అద్భుతమైన మరియు భయంకరమైన స్వరూపమును దర్శిస్తూ, ముల్లోకములూ భయంతో కపించిపోవటం నేను గమనిస్తున్నాను.",
                        "description": [
                            {
                                "des": "ద్యావాపృథివ్యోరిదమంతరం హి"
                            },
                            {
                                "des": "వ్యాప్తం త్వయైకేన దిశశ్చ సర్వాః ।"
                            },
                            {
                                "des": "దృష్ట్వాద్భుతం రూపముగ్రం తవేదం"
                            },
                            {
                                "des": "లోకత్రయం ప్రవ్యథితం మహాత్మన్ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "దేవతలందరూ నీలో ప్రవేశిస్తూ నీ యొక్క ఆశ్రయం పొందుతున్నారు. కొందరు భీతులై చేతులు జోడించి నిన్ను కీర్తిస్తున్నారు. మహర్షులు, సిద్ధులు మంగళకరమైన స్తోత్రములతో, కీర్తనలతో నిన్ను స్తుతిస్తున్నారు.",
                        "description": [
                            {
                                "des": "అమీ హి త్వాం సురసంఘా విశంతి"
                            },
                            {
                                "des": "కేచిద్భీతాః ప్రాంజలయో గృణంతి ।"
                            },
                            {
                                "des": "స్వస్తీత్యుక్త్వా మహర్షిసిద్ధసంఘాః"
                            },
                            {
                                "des": "స్తువంతి త్వాం స్తుతిభిః పుష్కలాభిః ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "రుద్రులు, ఆదిత్యులు, వసువులు, సాధ్యులు, విశ్వదేవతలు, అశ్వినీ కుమారులు, మరుత్తులు, పితరులు, గంధర్వులు, యక్షులు, అసురులు మరియు సిద్ధులు అందరూ కూడా సంభ్రమాశ్చర్యములతో నిన్నే తిలకిస్తున్నారు.",
                        "description": [
                            {
                                "des": "రుద్రాదిత్యా వసవో యే చ సాధ్యా"
                            },
                            {
                                "des": "విశ్వేఽశ్వినౌ మరుతశ్చోష్మపాశ్చ ।"
                            },
                            {
                                "des": "గంధర్వయక్షాసురసిద్ధసంఘా"
                            },
                            {
                                "des": "వీక్షంతే త్వాం విస్మితాశ్చైవ సర్వే ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఓ మహా ప్రభూ, ఎన్నెన్నో నోర్లు, చేతులు, ఊరువులు, కాళ్ళు, ఉదరములు మరియు భయంకరమైన పళ్ళతో ఉన్న నీ మహాద్భుతమైన స్వరూపము పట్ల పూజ్యభావంతో, సమస్త లోకములు మరియు నేను కూడా భయకంపితమైఉన్నాము.",
                        "description": [
                            {
                                "des": "రూపం మహత్తే బహువక్త్రనేత్రం"
                            },
                            {
                                "des": "మహాబాహో బహుబాహూరుపాదమ్ ।"
                            },
                            {
                                "des": "బహూదరం బహుదంష్ట్రాకరాళం"
                            },
                            {
                                "des": "దృష్ట్వా లోకాః ప్రవ్యథితాస్తథాహమ్ ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "హే విష్ణో - ఆకాశమును తాకుతూ, ఎన్నెన్నో వర్ణములతో ప్రకాశిస్తూ, పెద్దగా తెరిచిఉన్న నోర్లతో, విశాలమైన అగ్ని గుండముల వంటి నీ కన్నులతో ఉన్న - నీ స్వరూపమును చూస్తున్న నాకు, భయముతో గుండె అదిరిపొతున్నది. నేను ధైర్యమును మరియు మానసిక ప్రశాంతతను కోల్పోయాను.",
                        "description": [
                            {
                                "des": "నభఃస్పృశం దీప్తమనేకవర్ణం"
                            },
                            {
                                "des": "వ్యాత్తాననం దీప్తవిశాలనేత్రమ్ ।"
                            },
                            {
                                "des": "దృష్ట్వా హి త్వాం ప్రవ్యథితాంతరాత్మా"
                            },
                            {
                                "des": "ధృతిం న విందామి శమం చ విష్ణో ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "భయంకరమైన దంతములతో ఉన్న ఎన్నో నోర్లతో, ప్రళయ కాల సమయంలో కనిపించేటటువంటి ప్రజ్వలించే అగ్నిలా, ఉన్న నిన్ను, చూసిన పిదప, నేను ఎక్కడున్నానో మరియు ఎక్కడికి పోవాలో మర్చిపోతున్నాను. ఓ దేవ దేవా, నీవే జగత్తుకి ఆశ్రయము; దయ చేసి నామీద కృప చూపుము.",
                        "description": [
                            {
                                "des": "దంష్ట్రాకరాళాని చ తే ముఖాని"
                            },
                            {
                                "des": "దృష్ట్వైవ కాలానలసన్నిభాని ।"
                            },
                            {
                                "des": "దిశో న జానే న లభే చ శర్మ"
                            },
                            {
                                "des": "ప్రసీద దేవేశ జగన్నివాస ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26-27 శ్లోకాలు",
                        "bhavam": "ధృతరాష్ట్రుడి కుమారులందరూ, వారి సహచర రాజులతో సహా, భీష్ముడు, ద్రోణాచార్యుడు, కర్ణుడు ఇంకా మన పక్షమున ఉన్న యోధులు కూడా తలక్రిందులుగా నీ భయంకరమైన నోళ్లలోనికి త్వరితగతిన ప్రవేశిస్తున్నారు. కొందరి తలలు నీ భీకరమైన పళ్ళ మధ్యలో చితికిపోయినట్టు నేను చూస్తున్నాను.",
                        "description": [
                            {
                                "des": "అమీ చ త్వాం ధృతరాష్ట్రస్య పుత్రాః"
                            },
                            {
                                "des": "సర్వే సహైవావనిపాలసంఘైః।"
                            },
                            {
                                "des": "భీష్మో ద్రోణః సూతపుత్రస్తథాసౌ"
                            },
                            {
                                "des": "సహాస్మదీయైరపి యోధముఖ్యైః ।। 26 ।।"
                            },
                            {
                                "des": "వక్త్రాణి తే త్వరమాణా విశంతి"
                            },
                            {
                                "des": "దంష్ట్రాకరాళాని భయానకాని ।"
                            },
                            {
                                "des": "కేచిద్విలగ్నా దశనాంతరేషు"
                            },
                            {
                                "des": "సందృశ్యంతే చూర్ణితైరుత్తమాంగైః ।। 27 ।।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28-29 శ్లోకాలు",
                        "bhavam": "ఎన్నో నదుల నీటి తరంగాలు సముద్రములోనికి పారుతూ వచ్చి కలిసి పోయినట్లు, ఈ గొప్పగొప్ప యోధులు అందరూ నీ ప్రజ్వలించే ముఖముల లోనికి ప్రవేశిస్తున్నారు. అగ్గిపురుగులు ఎలాగైతే అత్యంత వేగముతో వచ్చి మంటలో పడి నాశనం అయిపొతాయో, ఈ యొక్క సైన్యములు కూడా నీ నోర్లలోనికి ప్రవేశిస్తున్నారు.",
                        "description": [
                            {
                                "des": "యథా నదీనాం బహవోఽమ్బువేగాః"
                            },
                            {
                                "des": "సముద్రమేవాభిముఖా ద్రవంతి ।"
                            },
                            {
                                "des": "తథా తవామీ నరలోకవీరా"
                            },
                            {
                                "des": "విశంతి వక్త్రాణ్యభివిజ్వలంతి ।। 28 ।।"
                            },
                            {
                                "des": "యథా ప్రదీప్తం జ్వలనం పతంగా"
                            },
                            {
                                "des": "విశంతి నాశాయ సమృద్ధవేగాః।"
                            },
                            {
                                "des": "తథైవ నాశాయ విశంతి లోకాః"
                            },
                            {
                                "des": "తవాపి వక్త్రాణి సమృద్ధవేగాః ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "నీ యొక్క భయంకరమైన నాలుకలతో ఎన్నెన్నో ప్రాణులను అన్ని దిక్కులా చప్పరించిపారేస్తూ నీ యొక్క ప్రజ్వలిత నోళ్ళతో వారిని గ్రసించి వేస్తున్నావు. హే విష్ణో! నీవు సమస్త జగత్తును నీయొక్క భయంకరమైన, సర్వ వ్యాప్తమైన తేజో కిరణాలతో తపింపచేయుచున్నావు.",
                        "description": [
                            {
                                "des": "లేలిహ్యసే గ్రసమానః సమంతాత్"
                            },
                            {
                                "des": "లోకాన్ సమగ్రాన్ వదనైర్జ్వలద్భిః ।"
                            },
                            {
                                "des": "తేజోభిరాపూర్య జగత్సమగ్రం"
                            },
                            {
                                "des": "భాసస్తవోగ్రాః ప్రతపంతి విష్ణో ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "నీవెవరో తెలియచేయుము ఓ భయంకర రూపము కలవాడా. ఓ దేవదేవా, నీ ముందు ప్రణమిల్లుతున్నాను; దయచేసి నాపై కృప చూపుము. సమస్త సృష్టికీ ముందే ఉన్న నీ గురించి, నీవెవరో తెలుసుకోగోరుతున్నాను, ఎందుకంటే నీ స్వభావము మరియు వ్యవహారమును నేను అర్థం చేసుకోలేకున్నాను.",
                        "description": [
                            {
                                "des": "ఆఖ్యాహి మే కో భవానుగ్రరూపో"
                            },
                            {
                                "des": "నమోఽస్తు తే దేవవర ప్రసీద ।"
                            },
                            {
                                "des": "విజ్ఞాతుమిచ్ఛామి భవంతమాద్యం"
                            },
                            {
                                "des": "న హి ప్రజానామి తవ ప్రవృత్తిమ్ ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను : నేనే మహాకాలమును, సమస్త లోకములను సర్వనాశనము చేసే మూలకారణమును. నీ యొక్క ప్రమేయం లేకున్ననూ, ప్రతిపక్షమున నిలిచి ఉన్న యోధులు ఎవ్వరూ మిగలరు (నశిస్తారు).",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "కాలోఽస్మి లోకక్ష్యయకృత్ ప్రవృద్దో"
                            },
                            {
                                "des": "లోకాన్ సమాహర్తుమిహ ప్రవృత్తః"
                            },
                            {
                                "des": "ఋతేఽపి త్వాం న భవిష్యంతి సర్వే"
                            },
                            {
                                "des": "యేఽవస్థితాః ప్రత్యనీకేషు యోధాః ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "కాబట్టి, ఓ సవ్యసాచీ, లెమ్ము, కీర్తిని పొందుము! శత్రువులను జయించుము మరియు సర్వసంపదలతో ఉన్న సామ్రాజ్యమును అనుభవించుము. ఈ యోధులు ఇంతకు పూర్వమే నా చే సంహరింపబడి ఉన్నారు, కేవలం నా పనిలో ఒక పనిముట్టుగా ఉండగలవు.",
                        "description": [
                            {
                                "des": "తస్మాత్ త్వముత్తిష్ఠ యశో లభస్వ"
                            },
                            {
                                "des": "జిత్వా శత్రూన్ భుంక్ష్వ రాజ్యం సమృద్ధమ్"
                            },
                            {
                                "des": "మయైవైతే నిహతాః పూర్వమేవ"
                            },
                            {
                                "des": "నిమిత్తమాత్రం భవ సవ్యసాచిన్ ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ద్రోణాచార్యుడు, భీష్ముడు, జయద్రథుడు, కర్ణుడు ఇంకా ఇంతర వీర యోధులు అందరూ నాచే ఇప్పటికే సంహరింపబడ్డారు. కాబట్టి, వ్యాకుల పడకుండా వారిని అంతం చేయుము. కేవలం పోరాడుము, నీవు ఈ యుద్ధములో శత్రువులపై విజయం సాధిస్తావు.",
                        "description": [
                            {
                                "des": "ద్రోణం చ భీష్మం చ జయద్రథం చ"
                            },
                            {
                                "des": "కర్ణం తథాన్యానపి యోధవీరాన్ ।"
                            },
                            {
                                "des": "మయా హతాంస్త్వం జహి మా వ్యథిష్ఠా"
                            },
                            {
                                "des": "యుధ్యస్వ జేతాసి రణే సపత్నాన్ ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను : కేశవుడు పలికిన మాటలు విన్న తరువాత అర్జునుడు భీతితో వణికిపోయాడు. చేతులు జోడించి, శ్రీ కృష్ణుడి ఎదుట వంగి నమస్కరిస్తూ భయము ఆవరించి గద్గద స్వరముతో ఇలా పలికెను.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ।"
                            },
                            {
                                "des": "ఏతచ్చ్రుత్వా వచనం కేశవస్య"
                            },
                            {
                                "des": "కృతాంజలిర్వేపమానః కిరీటీ ।"
                            },
                            {
                                "des": "నమస్కృత్వా భూయ ఏవాహ కృష్ణం"
                            },
                            {
                                "des": "సగద్గదం భీతభీతః ప్రణమ్య ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : హే హృషీకేశా (ఇంద్రియములకు అధిపతి), సమస్త జగత్తు నిన్ను కీర్తించుచూ ఆనందహర్షములతో ఉన్నది, నీ పట్ల ప్రేమతో నిండిపొయినది. ఇది సముచితమే. రాక్షసులు భయముతో భీతిల్లి నీ నుండి దూరముగా అన్ని దిక్కులలో పారిపోవుతున్నారు మరియు ఎంతో మంది సిద్ధగణములు నీకు ప్రణమిల్లుతున్నారు.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "స్థానే హృషీకేశ తవ ప్రకీర్త్యా"
                            },
                            {
                                "des": "జగత్ప్రహృష్యత్యనురజ్యతే చ"
                            },
                            {
                                "des": "రక్షాంసి భీతాని దిశో ద్రవంతి"
                            },
                            {
                                "des": "సర్వే నమస్యంతి చ సిద్ధసంఘాః ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "ఓ మహాత్మా, మూల సృష్టికర్త బ్రహ్మదేవుని కంటే ఉన్నతమైన వారు కూడా నీ ముందు ఎందుకు ప్రణమిల్లకూడదు? ఓ అనంతుడా, ఓ దేవతల ప్రభూ, ఓ జగత్తుకి ఆశ్రయమైన వాడా, నీవు వ్యక్త-అవ్యక్తములకూ అతీతమైన అక్షరుడవు.",
                        "description": [
                            {
                                "des": "కస్మాచ్చ తే న నమేరన్మహాత్మన్"
                            },
                            {
                                "des": "గరీయసే బ్రహ్మణోఽప్యాదికర్త్రే ।"
                            },
                            {
                                "des": "అనంత దేవేశ జగన్నివాస"
                            },
                            {
                                "des": "త్వమక్షరం సదసత్ తత్పరం యత్ ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "నీవే సనాతనమైన భగవంతుడవు మరియు ఆది దేవుడవు; నీవే విశ్వమంతటికీ ఉన్న ఒకేఒక్క ఆధారము, ఆశ్రయము. నీవు సర్వజ్ఞుడవు మరియు తెలుసుకోబడవలసిన వాడవు. నీవే పరంధాముడవు. ఓ అనంతరూపా, నీవే సమస్త జగత్తుయందు వ్యాపించి ఉన్నవాడవు.",
                        "description": [
                            {
                                "des": "త్వమాదిదేవః పురుషః పురాణః"
                            },
                            {
                                "des": "త్వమస్య విశ్వస్య పరం నిధానమ్"
                            },
                            {
                                "des": "వేత్తాసి వేద్యం చ పరం చ ధామ"
                            },
                            {
                                "des": "త్వయా తతం విశ్వమనంతరూప ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "నీవే వాయుదేవుడవు, యమధర్మరాజువు, అగ్ని దేవుడవు, వరుణ దేవుడవు మరియు చంద్రుడవు. నీవే సృష్టికర్త బ్రహ్మవు మరియు సర్వ భూతముల పితామహుడవు. నీకు నేను వేలసార్లు నమస్కరిస్తున్నాను, మరల మరల నమస్కరిస్తున్నాను.",
                        "description": [
                            {
                                "des": "వాయుర్యమోఽగ్నిర్వరుణః శశాంకః"
                            },
                            {
                                "des": "ప్రజాప్రతిస్త్వం ప్రపితామహశ్చ ।"
                            },
                            {
                                "des": "నమో నమస్తేఽస్తు సహస్రకృత్వః"
                            },
                            {
                                "des": "పునశ్చ భూయోఽపి నమో నమస్తే ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "అనంతమైన శక్తిసామర్ధ్యములు కల ప్రభూ, నీకు ఎదురుగా ఉండి మరియు వెనుక ఉండి కూడా నమస్కరిస్తున్నాను, నిజానికి అన్ని వైపులనుండీ నమస్కరిస్తున్నాను! నీవు అనంతమైన సామర్ధ్యము, పరాక్రమము కలిగినవాడివై అన్నింటా వ్యాపించి ఉన్నావు, అందుకే సమస్తమూ నీ స్వరూపమే.",
                        "description": [
                            {
                                "des": "నమః పురస్తాదథ పృష్ఠతస్తే"
                            },
                            {
                                "des": "నమోఽస్తు తే సర్వత ఏవ సర్వ ।"
                            },
                            {
                                "des": "అనంతవీర్యామితవిక్రమస్త్వం"
                            },
                            {
                                "des": "సర్వం సమాప్నోషి తతోఽసి సర్వః ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41-42 శ్లోకాలు",
                        "bhavam": "నీవు నా సఖుడవు (మిత్రుడవు) అనుకుంటూ, అతి చనువుతో నిన్ను, ఓ కృష్ణా, ఓ యాదవా, ఓ నా ప్రియ మిత్రమా అని పిలిచాను. నీ మహిమ తెలియక, నిర్లక్షముగా, అతి చనువుతో ప్రవర్తించాను. ఆడుతున్నప్పుడు కానీ, విశ్రాంతి తీసుకుంటున్నప్పుడు కానీ, కూర్చున్నప్పుడు కానీ, భోజనం చేస్తున్నప్పుడు కానీ, ఏకాంతముగా ఉన్నప్పుడు కానీ లేదా ఇతరుల సమక్షంలో కానీ, ఒకవేళ నీ పట్ల హాస్యానికైనా నేను అమర్యాదతో ప్రవర్తించినట్లయితే, దానికి నేను క్షమాపణలను వేడుకుంటున్నాను",
                        "description": [
                            {
                                "des": "సఖేతి మత్వా ప్రసభం యదుక్తం"
                            },
                            {
                                "des": "హే కృష్ణ హే యాదవ హే సఖేతి ।"
                            },
                            {
                                "des": "అజానతా మహిమానం తవేదం"
                            },
                            {
                                "des": "మయా ప్రమాదాత్ ప్రణయేన వాపి ।। 41 ।।"
                            },
                            {
                                "des": "యచ్చావహాసార్థమసత్కృతోఽసి"
                            },
                            {
                                "des": "విహారశయ్యాసనభోజనేషు ।"
                            },
                            {
                                "des": "ఏకోఽథ వాప్యచ్యుత తత్సమక్షం"
                            },
                            {
                                "des": "తత్ క్షామయే త్వామహమప్రమేయమ్ ।। 42 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "43 వ శ్లోకం",
                        "bhavam": "నీవే సమస్త విశ్వమునకు, చరాచర ప్రాణులన్నిటికీ తండ్రివి. నీవే సర్వశ్రేష్ఠమైన ఆరాధ్య యోగ్యుడవు మరియు సర్వోత్కృష్ట ఆధ్యాత్మిక గురుడవు. ఓ అసమానమైన శక్తి కలిగినవాడా, ముల్లోకాలలో నీకు సమానులే లేనప్పుడు, నిన్ను మించిన వారు మాత్రం ఎవరుంటారు?",
                        "description": [
                            {
                                "des": "పితాసి లోకస్య చరాచరస్య"
                            },
                            {
                                "des": "త్వమస్య పూజ్యశ్చ గురుర్గరీయాన్ ।"
                            },
                            {
                                "des": "న త్వత్సమోఽస్త్యభ్యధికః కుతోఽన్యో।"
                            },
                            {
                                "des": "లోకత్రయేఽప్యప్రతిమప్రభావ ।। 43 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "44 వ శ్లోకం",
                        "bhavam": "అందుకే ఓ ప్రభూ, నీకు ప్రణమిల్లుతూ సాష్టాంగ ప్రణామం అర్పిస్తూ, నీ కృప వేడుకుంటున్నాను. ఒక తండ్రి కొడుకుని సహించినట్టుగా, ఒక మిత్రుడు తన మిత్రుడిని క్షమించినట్టుగా, ప్రేమించినవారిని ప్రేమికుడు మన్నించినట్టుగా, దయచేసి నా అపరాధములను మన్నింపుము.",
                        "description": [
                            {
                                "des": "తస్మాత్ ప్రణమ్య ప్రణిధాయ కాయం"
                            },
                            {
                                "des": "ప్రసాదయే త్వామహమీశమీడ్యమ్ ।"
                            },
                            {
                                "des": "పితేవ పుత్రస్య సఖేవ సఖ్యుః"
                            },
                            {
                                "des": "ప్రియః ప్రియాయార్హసి దేవ సోఢుమ్ ।। 44 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "45 వ శ్లోకం",
                        "bhavam": "ఇంతకు మునుపెన్నడూ చూడని నీ యొక్క విశ్వ రూపమును చూసిన పిదప, నేను పరమానందమును అనుభవిస్తున్నాను. అయినా సరే, నా మనస్సు భయముతో వణుకుచున్నది. దయచేసి నాపై కృప చేయుము మరియు తిరిగి మరల నీ యొక్క ప్రసన్నమైన స్వరూపమును చూపుము, ఓ దేవ దేవా, ఓ జగత్తుకు ఆశ్రయమును ఇచ్చేవాడా.",
                        "description": [
                            {
                                "des": "అదృష్టపూర్వం హృషితోఽస్మి దృష్ట్వా"
                            },
                            {
                                "des": "భయేన చ ప్రవ్యథితం మనో మే ।"
                            },
                            {
                                "des": "తదేవ మే దర్శయ దేవరూపం।"
                            },
                            {
                                "des": "ప్రసీద దేవేశ జగన్నివాస ।। 45 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "46 వ శ్లోకం",
                        "bhavam": "ఓ వెయ్యి చేతులు కలవాడా, నీవే మూర్తీభవించిన విశ్వము అయినా, నిన్ను, కిరీటము ధరించి, చక్రమును, గదను కలిగిఉన్న నీ యొక్క చతుర్భుజ రూపములో చూడగోరుతున్నాను.",
                        "description": [
                            {
                                "des": "కిరీటినం గదినం చక్రహస్తమ్"
                            },
                            {
                                "des": "ఇచ్ఛామి త్వామ్ ద్రష్టుమహం తథైవ ।"
                            },
                            {
                                "des": "తేనైవ రూపేణ చతుర్భుజేన"
                            },
                            {
                                "des": "సహస్రబాహో భవ విశ్వమూర్తే ।। 46 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "47 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను : అర్జునా, నీ చేత ప్రసన్నుడనై, నా యోగమాయా శక్తి ద్వారా, నా యొక్క తేజోవంతమయిన, అనంతమైన మరియు సనాతనమైన మూల విశ్వ రూపమును నేను నీకు చూపించితిని. నీ కంటే ముందు ఈ రూపమును ఎవ్వరూ చూడలేదు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "మయా ప్రసన్నేన తవార్జునేదం"
                            },
                            {
                                "des": "రూపం పరం దర్శితమాత్మయోగాత్ ।"
                            },
                            {
                                "des": "తేజోమయం విశ్వమనంతమాద్యం"
                            },
                            {
                                "des": "యన్మే త్వదన్యేన న దృష్టపూర్వమ్ ।। 47 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "48 వ శ్లోకం",
                        "bhavam": "వేదముల అధ్యయనం వలన కానీ, యజ్ఞయాగాదులు చేయటం వలన కానీ, తపస్సులు, దానాల వలన కానీ, తీవ్ర నియమనిష్ఠ లను ఆచరించటం వలన కానీ, ఏ మానవుడు కూడా నీవు చూసిన దాన్ని ఇప్పటివరకు చూడలేదు, ఓ కురు యోధ శ్రేష్ఠుడా.",
                        "description": [
                            {
                                "des": "న వేద యజ్ఞాధ్యయనైర్న దానైః"
                            },
                            {
                                "des": "న చ క్రియాభిర్న తపోభిరుగ్రైః"
                            },
                            {
                                "des": "ఏవంరూపః శక్య అహం నృలోకే"
                            },
                            {
                                "des": "ద్రష్టుం త్వదన్యేన కురుప్రవీర ।। 48 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "49 వ శ్లోకం",
                        "bhavam": "నా యొక్క ఆ భయంకర రూపమును చూసి భయపడవద్దు, భ్రాంతికి లోను కావద్దు. భయరహితముగా ప్రసన్నచిత్తముతో మరొకసారి నా యొక్క వ్యక్తిగత రూపమును చూడుము.",
                        "description": [
                            {
                                "des": "మా తే వ్యథా మా చ విమూఢభావో"
                            },
                            {
                                "des": "దృష్ట్వా రూపం ఘోరమీదృఙ్మమేదమ్ ।"
                            },
                            {
                                "des": "వ్యపేతభీః ప్రీతమనాః పునస్త్వం"
                            },
                            {
                                "des": "తదేవ మే రూపమిదం ప్రపశ్య ।। 49 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "50 వ శ్లోకం",
                        "bhavam": "సంజయుడు ఇలా పలికెను: ఈ విధముగా పలికిన పిదప దయాళువైన వసుదేవుని తనయుడు తన యొక్క (చతుర్భుజ) సాకార రూపమును మరల చూపించెను. తదుపరి, సౌమ్యమైన (రెండు భుజముల) రూపమును స్వీకరించి, భీతిల్లిన అర్జునుడిని మరింత శాంతింపచేసెను.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఇత్యర్జునం వాసుదేవస్తథోక్త్వా"
                            },
                            {
                                "des": "స్వకం రూపం దర్శయామాస భూయః ।"
                            },
                            {
                                "des": "ఆశ్వాసయామాస చ భీతమేనం"
                            },
                            {
                                "des": "భూత్వా పునః సౌమ్యవపుర్మహాత్మా ।। 50 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "51 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు : ఓ శ్రీ కృష్ణా, నీ యొక్క సౌమ్యమైన (రెండు చేతుల) మనుష్య రూపము చూసి, నా ప్రశాంతత ను మళ్ళీ పొందాను మరియు నా మనస్సు సహజ స్థితికి వచ్చినది.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "దృష్ట్వేదం మానుషం రూపం తవ సౌమ్యం జనార్దన ।"
                            },
                            {
                                "des": "ఇదానీమస్మి సంవృత్తః సచేతాః ప్రకృతిం గతః ।। 51 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "52-53 శ్లోకాలు",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: నీవు చూసే నా ఈ యొక్క రూపము దర్శనం పొందటం ఎంతో దుర్లభమయినది. దేవతలు కూడా దీనిని చూడాలని ఆకాంక్షిస్తుంటారు. వేదాధ్యయనము వలన కానీ, తపస్సులవలన కానీ, దానధర్మాల వలన కానీ లేదా యజ్ఞముల వలన కానీ, నేను, నీవు ఇందాక చూసినట్టుగా కనిపించను.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "సుదుర్దర్శమిదం రూపం దృష్టవానసి యన్మమ ।"
                            },
                            {
                                "des": "దేవా అప్యస్య రూపస్య నిత్యం దర్శనకాంక్షిణః ।। 52 ।।"
                            },
                            {
                                "des": "నాహం వేదైర్న తపసా న దానేన న చేజ్యయా ।"
                            },
                            {
                                "des": "శక్య ఏవంవిధో ద్రష్టుం దృష్టవానసి మాం యథా ।। 53 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "54 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, అనన్యమైన భక్తి చేత మాత్రమే నేను నీ ముందే నిల్చుని ఉన్న నన్నుగా యదార్ధముగా తెలుసుకోబడుతాను. ఓ పరంతపా, అందువలన నా దివ్య దృష్టిని పొందిన పిదప నాతో ఏకీభావ స్థితిని పొందవచ్చు.",
                        "description": [
                            {
                                "des": "భక్త్యా త్వనన్యయా శక్య అహమేవంవిధోఽర్జున ।"
                            },
                            {
                                "des": "జ్ఞాతుం ద్రష్టుం చ తత్వేన ప్రవేష్టుం చ పరంతప ।। 54 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "55 వ శ్లోకం",
                        "bhavam": "ఎవరైతే అన్ని కర్మలనూ నా కొరకే చేస్తారో, నా పైనే ఆధారపడతారో మరియు నా పట్ల భక్తి తో ఉంటారో, మమకారాసక్తులు లేకుండా ఉంటారో, సర్వ భూతముల పట్ల విరోధభావము లేకుండా ఉంటారో, అటువంటి భక్తులు తప్పకుండా నన్నే చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "మత్కర్మకృన్మత్పరమో మద్భక్తః సంగవర్జితః ।"
                            },
                            {
                                "des": "నిర్వైరః సర్వభూతేషు యః స మామేతి పాండవ ।। 55 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "భక్తి యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/12.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/12.png'),
                "index":12,
                "introduction": [
                    {
                        "para": "ఈ చిన్న అధ్యాయము, మిగతా అన్ని ఆధ్యాత్మిక మార్గముల కన్నా, ప్రేమ యుక్త భక్తి మార్గము యొక్క సర్వోన్నత ఉత్కృష్టతని నొక్కివక్కాణిస్తుంది. యోగములో ఎవరిని ఎక్కువ శ్రేష్ఠులుగా కృష్ణుడు పరిగణిస్తాడు అని అర్జునుడు అడగటంతో ఈ అధ్యాయము ప్రారంభమవుతుంది - భగవంతుని సాకార రూపము పట్ల భక్తితో ఉండేవారా లేక నిరాకార బ్రహ్మాం ను ఉపాసించే వారా అని. ఈ రెండు మార్గాలు కూడా భగవత్ ప్రాప్తి కే దారితీస్తాయి అని శ్రీ కృష్ణుడు సమాధానమిస్తాడు. కానీ, తన సాకార రూపమును ఆరాధించేవారే అత్యుత్తమ యోగులని ఆయన భావిస్తాడు. నిరాకార, అవ్యక్త భగవత్ తత్వముపై ధ్యానం చేయటం చాలా ఇబ్బందులతో కూడి ఉన్నది మరియు అది బద్ద జీవులకు చాలా కష్టతరమైనది అని వివరిస్తాడు. సాకార రూప భక్తులు, తమ అంతఃకరణ ఆయనతో లీనమై పోయినవారు, తమ అన్ని కార్యములను ఆయనకే అర్పించిన వారు, త్వరితగతిన జనన-మరణ చక్రము నుండి విముక్తి చేయబడతారు. శ్రీ కృష్ణుడు ఈ విధంగా అర్జునుడిని, అతని బుధ్ధిని తనకు అర్పించి, మనస్సుని అనన్య ప్రేమయుక్త భక్తి తో తన యందే లగ్నం చేయమని ప్రార్ధిస్తాడు."
                    },
                    {
                        "para": "కానీ, తరచుగా, ఇటువంటి ప్రేమ, ప్రయాసపడే జీవాత్మ లో కనిపించదు. కాబట్టి, శ్రీ కృష్ణుడు ఇతర పద్దతులను కూడా సూచించాడు, ఒకవేళ అర్జునుడు తక్షణమే భగవంతుని యందు మనస్సుని పూర్తిగా నిమగ్నం చేసే స్థాయిని చేరుకోకలేకపోతే, అతను ఆ యొక్క దోషరహిత పరిపూర్ణ స్థాయిని చేరుకోవటానికి పరిశ్రమించాలి. భక్తి అనేది ఏదో ఒక నిగూఢమైన బహుమానం కాదు, దానిని నిరంతర అభ్యాసము ద్వారా పెంపొందించుకోవచ్చు. ఒకవేళ అర్జునుడు ఇది కూడా చేయలేకపోతే, అతను ఓటమిని ఒప్పుకోకూడదు; సరికదా భక్తితో శ్రీ కృష్ణుడి ప్రీతికోసం పని చేయటం నేర్చుకోవాలి. ఒకవేళ ఇది కూడా సాధ్యం కాకపోతే, అతను తన కర్మ ఫలములను త్యజించి మరియు ఆత్మయందే స్థితమై ఉండాలి. కృష్ణుడు ఇంకా ఏమంటున్నాడంటే, యాంత్రికమైన అభ్యాసం కన్నా జ్ఞానాన్ని పెంపొందించుకోవటం ఉన్నతమైనది, జ్ఞానాన్ని పెంపొందించుకోవడం కంటే ధ్యానం ఉన్నతమైనది; ధ్యానం కంటే ఉన్నతమైనది కర్మ ఫలములను త్యజించటం, ఇది తక్షణమే ఎంతో శాంతిని కలుగ చేస్తుంది. ఈ అధ్యాయం యొక్క మిగతా శ్లోకాలు భగవంతునికి చాలా ప్రియమైన, ఆయన భక్తుల యొక్క మహోన్నతమైన గుణములను విశదీకరిస్తాయి."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అడిగెను: ఎల్లప్పుడూ నీ యొక్క సాకార రూపము పట్ల భక్తితో ఉండేవారు మరియు నిరాకార బ్రహ్మం ను ఉపాసించే వారు - ఈ రెండు రకాల వారిలో, యోగములో ఎవరు ఎక్కువ శ్రేష్ఠులు అని నీవు పరిగణిస్తావు?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "ఏవం సతత యుక్తా యే భక్త్యాస్త్వాం పర్యుపాసతే ।"
                            },
                            {
                                "des": "యే చాప్యక్షరమవ్యక్తం తేషాం కే యోగవిత్తమాః ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను: నా పైనే తమ మనస్సులను లగ్నం చేసి మరియు సతతమూ నా పట్ల దృఢ విశ్వాసంతో భక్తి లో నిమగ్నమైన వారు అత్యుత్తమ యోగులని నేను పరిగణిస్తాను.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "మయ్యావేశ్య మనో యే మాం నిత్యయుక్తా ఉపాసతే ।"
                            },
                            {
                                "des": "శ్రద్ధయా పరాయోపేతాస్తే మే యుక్తతమా మతాః ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3-4 శ్లోకాలు",
                        "bhavam": "నాశరహితుడూ, అనిర్వచనీయమైన వాడు, అవ్యక్తమూ, సర్వవ్యాపి, మనోబుద్ధులకు అతీతుడు, మార్పు లేనివాడు, నిత్యశాశ్వతుడూ మరియు నిశ్చలమైన వాడునూ - అయిన పరమ సత్యము యొక్క నిరాకర తత్త్వాన్ని - ఇంద్రియములను నిగ్రహించి, సర్వత్రా సమబుద్ధి తో ఉంటూ, సర్వభూతముల సంక్షేమం కోసం నిమగ్నమై ఉంటూ - ఆరాధించేవారు కూడా నన్ను పొందుతారు.",
                        "description": [
                            {
                                "des": "యే త్వక్షరమనిర్దేశ్యమవ్యక్తం పర్యుపాసతే ।"
                            },
                            {
                                "des": "సర్వత్రగమచింత్యం చ కూటస్థమచలం ధ్రువమ్ ।। 3 ।।"
                            },
                            {
                                "des": "సన్నియమ్యేంద్రియగ్రామం సర్వత్ర సమబుద్దయః ।"
                            },
                            {
                                "des": "తే ప్రాప్నువంతి మామేవ సర్వభూతహితే రతాః ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "మనస్సు యందు అవ్యక్తము పట్ల ఆసక్తి ఉన్నవారికి, సిద్ధి పథము చాలా కష్టములతో కూడుకున్నది. అవ్యక్తమును ఆరాధించటం అనేది శరీరబద్ధులైన జీవులకు చాలా కష్టతరమైనది.",
                        "description": [
                            {
                                "des": "క్లేశోఽధికతరస్తేషామ్ అవ్యక్తాసక్తచేతసామ్ ।"
                            },
                            {
                                "des": "అవ్యక్తా హి గతిర్దుఃఖం దేహవద్భిరవాప్యతే ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6-7 శ్లోకాలు",
                        "bhavam": "కానీ, తాము చేసే కర్మలన్నింటినీ నాకే సమర్పిస్తూ, నన్నే పరమ లక్ష్యముగా భావిస్తూ, నన్నే ఆరాధిస్తూ మరియు అనన్య భక్తితో నా మీదే ధ్యానం చేసే వారిని, ఓ పార్థా, నేను వారిని శీఘ్రముగానే ఈ మృత్యుసంసారసాగరము నుండి విముక్తి చేస్తాను, ఏలనన వారి అంతఃకరణ నా యందే ఏకమైపోయి ఉంటుంది.",
                        "description": [
                            {
                                "des": "యే తు సర్వాణి కర్మాణి మయి సన్న్యస్య మత్పరః ।"
                            },
                            {
                                "des": "అనన్యేనైవ యోగేన మాం ధ్యాయంత ఉపాసతే ।। 6 ।।"
                            },
                            {
                                "des": "తేషామహం సముద్ధర్తా మృత్యుసంసారసాగరాత్ ।"
                            },
                            {
                                "des": "భవామి నచిరాత్ పార్థ మయ్యావేశితచేతసామ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "నీ మనస్సుని నామీదే లగ్నం చేయుము మరియు నీ బుద్ధిని నాకు అర్పించుము. ఆ తరువాత, నీవు సర్వదా నాలోనే నివసిస్తావు. దీనిపై ఎలాంటి సంశయము వద్దు.",
                        "description": [
                            {
                                "des": "మయ్యేవ మన ఆధత్స్వ మయి బుద్ధిం నివేశయ ।"
                            },
                            {
                                "des": "నివసిష్యసి మయ్యేవ అత ఊర్ధ్వం న సంశయః ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "ఒకవేళ నీవు మనస్సును నా యందే నిశ్చలముగా లగ్నం చేయలేక పోతే, ఓ అర్జునా, మనస్సును ప్రాపంచిక విషయాల నుండి నిగ్రహిస్తూ, నన్ను భక్తితో స్మరించటడానికి అభ్యాసము చేయుము.",
                        "description": [
                            {
                                "des": "అథ చిత్తం సమాధాతుం న శక్నోషి మయి స్థిరమ్ ।"
                            },
                            {
                                "des": "అభ్యాసయోగేన తతో మామిచ్ఛాప్తుం ధనంజయ ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "నన్ను భక్తితో స్మరించే అభ్యాసం చేయలేకపోతే నాకోసమే పనులు చెయ్యటానికి ప్రయత్నం చేయుము. ఈ విధంగా భక్తి యుక్త సేవ చేయటం వలన నీవు పరిపూర్ణ స్థాయిని చేరుకోగలవు.",
                        "description": [
                            {
                                "des": "అభ్యాసేఽప్యసమర్థోఽసి మత్కర్మపరమో భవ ।"
                            },
                            {
                                "des": "మదర్థమపి కర్మాణి కుర్వన్ సిద్ధిమవాప్స్యసి ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "ఒకవేళ నీవు నా కొరకై భక్తి తో పని చేయుట చేయలేకపోతే, నీ కర్మ ఫలములను త్యజించుటకు ప్రయత్నించుము మరియు ఆత్మయందే స్థితుడవై ఉండుము",
                        "description": [
                            {
                                "des": "అథైతదప్యశక్తోఽసి కర్తుం మద్యోగమాశ్రితః।"
                            },
                            {
                                "des": "సర్వకర్మఫలత్యాగం తతః కురు యతాత్మవాన్ ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "యాంత్రికమైన అభ్యాసము కంటే జ్ఞానము మంచిది; జ్ఞానము కంటే ధ్యానము శ్రేష్ఠమయినది. ధ్యానము కంటే కర్మ ఫల త్యాగము మంచిది, ఎందుకంటే ఇటువంటి త్యాగము చేసిన వెంటనే శాంతి లభించును.",
                        "description": [
                            {
                                "des": "శ్రేయో హి జ్ఞానమభ్యాసాత్ జ్ఞానాద్ధ్యానం విశిష్యతే ।"
                            },
                            {
                                "des": "ధ్యానాత్ కర్మఫలత్యాగః త్యాగాచ్ఛాంతిరనంతరమ్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13-14 శ్లోకాలు",
                        "bhavam": "ఏ భక్తులైతే, సమస్త ప్రాణుల పట్ల ద్వేషభావన లేకుండా, మైత్రితో/స్నేహపూరితముగా, కారుణ్యముతో ఉంటారో, వారు నాకు చాలా ప్రియమైన వారు. వారు ఆస్తి/ధనము పై మమకార/ఆసక్తి రహితముగా ఉంటారు మరియు అహంకారము లేకుండా, సుఖ-దుఃఖముల రెండింటి యందు ఒకే విధంగా ఉంటారు మరియు సర్వదా క్షమించే మనస్సుతో ఉంటారు. వారు ఎల్లప్పుడూ తృప్తితో, భక్తితో నాతోనే ఏకమై, ఆత్మ-నిగ్రహంతో, ధృడ సంకల్పంతో మరియు మనోబుద్ధులను నాకే అర్పించి ఉంటారు",
                        "description": [
                            {
                                "des": "అద్వేష్టా సర్వభూతానాం మైత్రః కరుణ ఏవ చ ।"
                            },
                            {
                                "des": "నిర్మమో నిరహంకారః సమదుఃఖసుఖః క్షమీ ।। 13 ।।"
                            },
                            {
                                "des": "సంతుష్టః సతతం యోగీ యతాత్మా దృఢనిశ్చయః ।"
                            },
                            {
                                "des": "మయ్యర్పితమనోబుద్ధిర్యో మధ్భక్తః స మే ప్రియాః ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "లోకమున ఎవ్వరినీ బాధ(క్షోభ) పెట్టని వాడు మరియు ఎవరి చేత ఉద్వేగమునకు గురి కాని వాడు, సుఖాల్లో-బాధల్లో ఒక్కలాగే ఉంటూ, మరియు భయము, ఆందోళన రహితముగా ఉన్నటువంటి నా భక్తులు నాకు చాలా ప్రియమైన వారు.",
                        "description": [
                            {
                                "des": "యస్మాన్నోద్విజతే లోకో లోకాన్నోద్విజతే చ యః ।"
                            },
                            {
                                "des": "హర్షామర్షభయోద్వేగైః ముక్తో యః స చ మే ప్రియ: ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ప్రాపంచిక లాభముల పట్ల అనాసక్తతతో ఉండి, బాహ్య-ఆంతరములో పవిత్రంగా ఉండి, దక్షతతో, ఉదాసీనంగా, కలతలు లేకుండా మరియు అన్ని వ్యవహారములలో స్వార్ధచింతన లేకుండా ఉన్నటువంటి నా భక్తులు నాకు చాలా ప్రియమైన వారు.",
                        "description": [
                            {
                                "des": "అనపేక్షః శుచిర్దక్ష ఉదాసీనో గతవ్యథః ।"
                            },
                            {
                                "des": "సర్వారంభపరిత్యాగీ యో మద్భక్తః స మే ప్రియః ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "ఎవరైతే లౌకిక సుఖాల పట్ల ఆనందించకుండా మరియు ప్రాపంచిక కష్టాల పట్ల బాధ పడకుండా ఉంటారో, ఎవరైతే నష్టం జరిగినా బాధ పడరో లేదా లాభం కోసం ప్రాకులాడరో, శుభ-అశుభ పనులను రెంటినీ త్యజిస్తారో, అటువంటి జనులు, భక్తితో నిండి ఉన్న వారు నాకు చాలా ప్రియమైనవారు.",
                        "description": [
                            {
                                "des": "యో న హృష్యతి న ద్వేష్టి న శోచతి న కాంక్షతి ।"
                            },
                            {
                                "des": "శుభాశుభపరిత్యాగీ భక్తిమాన్యః స మే ప్రియః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18-19 శ్లోకాలు",
                        "bhavam": "ఎవరైతే, మిత్రులపట్ల మరియు శత్రువుల పట్ల ఒక్కలాగే ఉంటారో, గౌరవము-అపమానముల ఎడ, చలి-వేడిమి పట్ల, సుఖ-దుఖః ముల పట్ల సమబుద్ధితో ఉంటారో, మరియు చెడు సాంగత్యము ను విడిచి ఉంటారో; దూషణ మరియు పొగడ్తని ఒక్కలాగే తీసుకుంటారో, మౌనముగా చింతన చేస్తుంటారో, తమకు లభించిన దానితో తృప్తిగా ఉంటారో, నివాసస్థానము పట్ల మమకారాసక్తి లేకుండా ఉంటారో, ఎవరి బుద్ధి స్థిరముగా నా యందే లగ్నమై ఉన్నదో, ఎవరైతే నాయందు భక్తితో నిండిపోయి ఉన్నారో, అటువంటి వ్యక్తులు నాకు చాలా ప్రియమైనవారు.",
                        "description": [
                            {
                                "des": "సమః శత్రౌ చ మిత్రే చ తథా మానాపమానయోః ।"
                            },
                            {
                                "des": "శీతోష్ణసుఖదుఃఖేషు సమః సంగవివర్జితః ।। 18 ।।"
                            },
                            {
                                "des": "తుల్యనిందాస్తుతిర్మౌనీ సంతుష్టో యేన కేనచిత్ ।"
                            },
                            {
                                "des": "అనికేతః స్థిరమతిర్భక్తిమాన్ మే ప్రియో నరః ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఎవరైతే ఇక్కడ ప్రకటించబడిన ఈ జ్ఞానామృతమును గౌరవించి, నాపై విశ్వాసముతో మరియు నేనే పరమ లక్ష్యముగా భక్తితో ఉంటారో, వారు నాకు అత్యంత ప్రియమైన వారు.",
                        "description": [
                            {
                                "des": "యే తు ధర్మ్యామృతమిదం యథోక్తం పర్యుపాసతే ।"
                            },
                            {
                                "des": "శ్రద్ధధానా మత్పరమా భక్తాస్తేఽతీవ మే ప్రియాః ।। 20 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "క్షేత్ర క్షేత్రజ్ఞ విభాగ యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/13.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/13.png'),
                "index":13,
                "introduction": [
                    {
                        "para": "భగవద్గీతలో ఉన్న పద్దెనిమిది అధ్యాయాలు, మూడు విభాగాలుగా ఉన్నట్టు భావించవచ్చు. ఆరు అధ్యాయముల మొదటి భాగము కర్మ యోగాన్ని విశదీకరిస్తుంది. రెండవ భాగము, భక్తి యొక్క మహత్వమును, మరియు భక్తిని పెంపొందించటానికి భగవంతుని యొక్క విభూతులను కూడా (ఐశ్వర్యములను) తెలియపరుస్తుంది. మిగతా ఆరు అధ్యాయముల మూడవ భాగము, తత్త్వ జ్ఞానమునకు అర్థవివరణ చేస్తుంది. ఈ ప్రస్తుత అధ్యాయము, మూడవ భాగము లోని మొదటి అధ్యాయము; ఇది రెండు పదాలను మనకు పరిచయం చేస్తున్నది - క్షేత్రము మరియు క్షేత్రజ్ఞుడు (క్షేత్రమును తెలిసినవాడు). క్షేత్రము అంటే ఈ శరీరము అని మరియు క్షేత్రజ్ఞుడు (క్షేత్రమును ఎరిగినవాడు) అంటే అందులో ఉండే ఆత్మ అని అనుకోవచ్చు. కానీ ఇది విషయాన్ని చాలా సరళీకరణం చేసినట్టే, ఎందుకంటే క్షేత్రము అంటే దానిలో చాలా ఉంటాయి - మనస్సు, బుద్ధి, అహంకారము మరియు మన వ్యక్తిత్వములో ఉండే భౌతిక శక్తి యొక్క అన్ని స్వరూపాలు. ఈ విశాలమైన అర్థంలో, ఆత్మ తప్ప, మన వ్యక్తిత్వమును నిర్ణయించే మిగతా అన్ని అస్తిత్వాలను కలిపి శరీర క్షేత్రము అనవచ్చు. ఆత్మను క్షేత్రమును తెలిసినవాడు, లేదా క్షేత్రజ్ఞుడు అంటారు."
                    },
                    {
                        "para": "ఎలాగైతే, ఒక రైతు తన క్షేత్రములో విత్తనములు వేసి, దాని నుండి పంటను పొందుతాడో, మన శరీరము అనే క్షేత్రములో మంచి లేదా చెడు తలపులు మరియు కార్యములు వేసి, తద్వారా మన భవిష్యత్తుని పొందుతాము. బుద్ధుడు ఇలా వివరించాడు: మనం ఇప్పుడు ఉన్నదంతా మన ఆలోచనల/తలపుల ఫలితమే; అది మన తలంపుల మీదనే ఆధారపడి ఉన్నది; మరియు అది మన ఆలోచనలతోనే తయారు చేయబడినది. కాబట్టి, మన ఆలోచనలు ఎట్లా ఉంటే మనం అట్లానే అవుతాము. ప్రఖ్యాత అమెరికన్ తత్వవేత్త రాల్ఫ్ వాల్డో ఎమెర్సన్, ఇలా అన్నాడు: ప్రతి పని యొక్క వెనుక మూలకారణం ఒక ఆలోచన ఉంటుంది. (The ancestor of every action is thought), అందుకే, మన క్షేత్రమును మంచి ఆలోచనలు మరియు చర్యలతో ఉంచుకునే కళను మనం నేర్చుకోవాలి. దీనికి క్షేత్రము మరియు క్షేత్రజ్ఞుడుల తేడాను స్పష్టంగా చూపించే జ్ఞానము అవసరము. ఈ ప్రస్తుత అధ్యాయములో, శ్రీ కృష్ణుడు ఈ యొక్క విషయంపై విస్తారమైన విశ్లేషణను అందిస్తున్నాడు. శరీర క్షేత్రములో ఉన్న భౌతిక ప్రాకృతిక మూలకాలన్నింటినీ ఇక్కడ పేర్కొంటున్నాడు. భావాలు, ఉద్వేగాలు మరియు మానసిక స్థితుల రూపములో క్షేత్రములో జనించే మార్పులు/కదలికలను ఆయన వివరిస్తాడు. క్షేత్రమును పవిత్రం చేసి, దానిని జ్ఞాన దీపముచే ప్రకాశం చేసే గుణములు మరియు లక్షణములను శ్రీ కృష్ణుడు పేర్కొంటాడు. ఇటువంటి జ్ఞానము మనకు క్షేత్రజ్ఞుడైన ఆత్మను అనుభవము లోనికి తెస్తుంది. ఆ తరువాత ఈ అధ్యాయము, సమస్త ప్రాణుల క్షేత్రములను సంపూర్ణముగా తెలిసినవాడైన భగవంతుడి గురించి మనకు వివరిస్తుంది. ఆ సర్వోన్నత భగవానుడు ఒకేసమయంలో పరస్పర విరుద్ధమైన లక్షణములను కలిగి ఉంటాడు, అంటే, ఒకే సమయంలో విరుద్ధమైన గుణములను కలిగి ఉండటం. అందుకే, సృష్టిలో సర్వవ్యాప్తిగా ఉంటాడు, మరియు సర్వ భూతముల హృదయములో కూర్చుని కూడా ఉంటాడు. కాబట్టి, అందుకే ఆయన సమస్త ప్రాణులకు పరమాత్మ."
                    },
                    {
                        "para": "ఆత్మ, పరమాత్మ, మరియు ప్రకృతి -లను వివరించిన పిదప, శ్రీ కృష్ణుడు, జీవ రాశులు చేసే పనులకు వీటిలో ఏది కారణమో వివరిస్తాడు; అంతేకాక, స్థూలంగా ఈ ప్రపంచంలో కారణము మరియు కార్యములకు ఏది మూలమో కూడా వివరిస్తాడు. ఎవరైతే వీటిని స్పష్టంగా వేర్వేరుగా చూడగలుగుతారో మరియు సరిగా నిక్కచ్చిగా కార్యము యొక్క కారణము చూడగలరో, వారే నిజముగా చూసినట్టు; వారే నిజముగా జ్ఞానములో స్థితమై ఉన్నట్టు. వారు ప్రతి ప్రాణిలో ఉన్న పరమాత్మను గమనించగలరు, అందుకే వారి మనస్సు వల్ల తమని తామే నీచ స్థాయికి దిగజార్చుకోరు. విభిన్నమైన జీవరాశులు ఒకే ప్రకృతి యందు స్థితమై ఉన్నట్టు చూడగలరు. సమస్త సృష్టిలో అంతర్లీనంగా వ్యాప్తమై ఉన్న ఒకే ఒక ఆధ్యాత్మిక అస్తిత్వమును చూడగలిగిన తరుణంలో వారు బ్రహ్మ జ్ఞానమును పొందుతారు."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు, ఓ కేశవా, ప్రకృతి మరియు పురుషుడు అంటే ఏమిటి, క్షేత్రము మరియు క్షేత్రజ్ఞుడు అంటే ఏమి? అని తెలుసుకోగోరుచున్నాను. నిజమైన జ్ఞానము ఏమిటి మరియు అటువంటి జ్ఞానము యొక్క లక్ష్యము ఏమిటి? అని కూడా తెలుసుకోగోరుచున్నాను.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "ప్రకృతిం పురుషం చైవ క్షేత్రం క్షేత్రజ్ఞమేవ చ ।"
                            },
                            {
                                "des": "ఏతద్వేదితుమిచ్ఛామి జ్ఞానం జ్ఞేయం చ కేశవ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "సర్వోత్కృష్ట దివ్య భగవానుడు ఇలా పలికెను: ఓ అర్జునా, ఈ దేహము క్షేత్రము అని, మరియు ఈ దేహమును గూర్చి తెలిసిన దానిని క్షేత్రజ్ఞుడు అని - ఈ రెండింటి గురించి బాగా తెలిసిన ఋషులచే చెప్పబడినది.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ఇదం శరీరం కౌంతేయ క్షేత్రమిత్యభిధీయతే ।"
                            },
                            {
                                "des": "ఏతద్యో వేత్తి తం ప్రాహుః క్షేత్రజ్ఞ ఇతి తద్విదః ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "ఓ భరత వంశీయుడా, నేను కూడా ప్రతి ఒక్క క్షేత్రమును ఎఱింగిన వాడినే. ఈ శరీరమును క్షేత్రమని (కార్యకలాపాలు జరిగే స్థానము) మరియు ఆత్మ, పరమాత్మ క్షేత్రజ్ఞులని (క్షేత్రమునెరింగినవారు) తెలుసుకోవటమే, నిజమైన జ్ఞానముగా నేను పరిగణిస్తాను.",
                        "description": [
                            {
                                "des": "క్షేత్రజ్ఞం చాపి మాం విద్ధి సర్వక్షేత్రేషు భారత ।"
                            },
                            {
                                "des": "క్షేత్రక్షేత్రజ్ఞయోః జ్ఞానం యత్తద్ జ్ఞానం మతం మమ ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "వినుము, క్షేత్రము అంటే ఏమిటో దాని స్వభావం ఏమిటో నేను నీకు వివరిస్తాను. దానిలో మార్పు ఎలా సంభవిస్తుందో, అది దేనిచే సృష్టించబడినదో, క్షేత్రజ్ఞుడు ఎవరో, వాని శక్తిసామర్ధ్యము ఏమిటో కూడా వివరిస్తాను.",
                        "description": [
                            {
                                "des": "తత్ క్షేత్రం యచ్చ యాదృక్చయద్వికారి యతశ్చ యత్ ।"
                            },
                            {
                                "des": "స చ యో యత్ప్రభావశ్చ తత్సమాసేన మే శృణు ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "మహాత్ములైన ఋషులు క్షేత్రమును గూర్చి మరియు క్షేత్రజ్ఞుని గురించి సత్యమును పెక్కువిధముల వివరించి ఉన్నారు. ఎన్నోవేద మంత్రములలో కూడా ఇది తెలుపబడినది, ప్రత్యేకముగా బ్రహ్మ సూత్రములలో ఇది సహేతుకముగా మరియు నిశ్చయాత్మకముగా తెలుపబడినది.",
                        "description": [
                            {
                                "des": "ఋషిభిర్బహుధా గీతం ఛందోభిర్వివిధైః పృథక్ ।"
                            },
                            {
                                "des": "బ్రహ్మసూత్రపదైశ్చైవ హేతుమద్భిర్వినిశ్చితైః ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "పంచ మహా భూతములు, అహంకారము, బుద్ధి, అవ్యక్త మూల ప్రకృతి, పదకొండు ఇంద్రియములు (ఐదు జ్ఞానేంద్రియములు, ఐదు కర్మేంద్రియములు, మనస్సు), మరియు ఐదు ఇంద్రియ గ్రాహ్య విషయములతో ఈ యొక్క క్షేత్రము ఉన్నది.",
                        "description": [
                            {
                                "des": "మహాభూతాన్యహంకారో బుద్ధిరవ్యక్తమేవ చ ।"
                            },
                            {
                                "des": "ఇంద్రియాణి దశైకం చ పంచ చేంద్రియగోచరాః ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఇచ్ఛ మరియు ద్వేషము, సంతోషము మరియు దుఃఖము, శరీరము, చైతన్యము, మనోబలము - ఇవన్నీ కలిపి క్షేత్రము మరియు దాని మార్పులు (వికారములు) అనబడుతాయి.",
                        "description": [
                            {
                                "des": "ఇచ్ఛా ద్వేషః సుఖం దుఃఖం సంఘాతశ్చేతనా ధృతిః ।"
                            },
                            {
                                "des": "ఏతత్ క్షేత్రం సమాసేన సవికారముదాహృతమ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8-12 శ్లోకాలు",
                        "bhavam": "నమ్రత; దంభము (కృత్తిమ బుద్ధి) లేకుండా ఉండుట; అహింస; క్షమా గుణము; సరళత; గురు సేవ; శరీర-మనస్సుల పరిశుద్ధత; నిశ్చల బుద్ధి; మరియు ఆత్మ-నిగ్రహము; ఇంద్రియభోగ వస్తువిషయములపై అనాసక్తి; అహంకారము లేకుండుట; జన్మ, మృత్యు, జరా, వ్యాధుల దురవస్థను గుర్తుచేసుకోవటం; మమకారరాహిత్యం; భార్య(భర్త), పిల్లలు, ఇల్లు వంటి వాటిని అంటుకొని (యావ) లేకుండా ఉండుట; జీవితంలో అనుకూల లేదా ప్రతికూల పరిస్థితులలో సమత్వ బుద్ధితో ఉండుట; నా పట్ల నిశ్చలమైన మరియు అనన్య భక్తి కలిగి ఉండుట; ఏకాంత ప్రదేశాల్లో ఉండటానికే ఇష్టపడుట మరియు ప్రాపంచిక సమాజం పట్ల అనాసక్తి; ఆధ్యాత్మిక జ్ఞానములో అచంచల విశ్వాసం; మరియు పరమ సత్యముకై తత్త్వాన్వేషణ - ఇవన్నిటినీ నేను జ్ఞానముగా పరిగణిస్తాను, మరియు వీటికి వ్యతిరేకమైనవే అజ్ఞానము అని అంటాను.",
                        "description": [
                            {
                                "des": "అమానిత్వమదంభిత్వమ్ అహింసా క్షాంతిరార్జవమ్ ।"
                            },
                            {
                                "des": "ఆచార్యోపాసనం శౌచం స్థైర్యమాత్మవినిగ్రహః ।। 8 ।।"
                            },
                            {
                                "des": "ఇంద్రియార్థేషు వైరాగ్యమనహంకార ఏవ చ ।"
                            },
                            {
                                "des": "జన్మమృత్యుజరావ్యాధిదుఃఖదోషానుదర్శనమ్ ।। 9 ।।"
                            },
                            {
                                "des": "అసక్తిరనభిష్వంగః పుత్రదారగృహాదిషు ।"
                            },
                            {
                                "des": "నిత్యం చ సమచిత్తత్వమ్ ఇష్టానిష్టోపపత్తిషు ।। 10 ।।"
                            },
                            {
                                "des": "మయి చానన్యయోగేన భక్తిరవ్యభిచారిణీ ।"
                            },
                            {
                                "des": "వివిక్తదేశసేవిత్వమ్ అరతిర్జనసంసది ।। 11 ।।"
                            },
                            {
                                "des": "అధ్యాత్మజ్ఞాననిత్యత్వం తత్త్వజ్ఞానార్థదర్శనమ్ ।"
                            },
                            {
                                "des": "ఏతద్ జ్ఞానమితి ప్రోక్తమ్ అజ్ఞానం యదతోఽన్యథా ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఏది తప్పకుండా తెలుసుకొనబడాలో, నీకు దానిని ఇప్పుడు నేను తెలియచేస్తాను, అది తెలుసుకున్న తరువాత, వ్యక్తి అమరత్వం పొందుతాడు. అదియే, సత్, అసత్ లకు అతీతముగా ఉండే ఆదిరహిత బ్రహ్మాం.",
                        "description": [
                            {
                                "des": "జ్ఞేయం యత్తత్ ప్రవక్ష్యామి యద్ జ్ఞాత్వామృతమశ్నుతే ।"
                            },
                            {
                                "des": "అనాదిమత్పరం బ్రహ్మ న సత్తన్నాసదుచ్యతే ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "సర్వత్రా ఆయన పాదములు, కన్నులు, శిరస్సులు మరియు ముఖములు ఉన్నాయి. ఆయన చెవులు కూడా అన్ని ప్రదేశాలలో ఉన్నాయి, ఎందుకంటే ఆయన ఈ జగత్తు అంతా నిండి నిబిడీకృతమై ఉన్నాడు.",
                        "description": [
                            {
                                "des": "సర్వతః పాణిపాదం తత్సర్వతోఽక్షిశిరోముఖమ్ ।"
                            },
                            {
                                "des": "సర్వతః శ్రుతిమల్లోకే సర్వమావృత్య తిష్ఠతి ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఇంద్రియ వస్తువిషయములను అన్నింటినీ ఆయన తెలుసుకొనగలిగినా, ఆయన ఇంద్రియ రహితుడు. ఆయనకు దేనిపట్ల కూడా మమకారానుబంధము లేదు, అయినా ఆయనే అన్నింటిని సంరక్షించి పోషించేవాడు. ఆయన నిర్గుణుడు అయినా, ప్రకృతి త్రిగుణములకు భోక్త ఆయనే.",
                        "description": [
                            {
                                "des": "సర్వేంద్రియగుణాభాసం సర్వేంద్రియవివర్జితమ్ ।"
                            },
                            {
                                "des": "అసక్తం సర్వభృచ్చైవ నిర్గుణం గుణభోక్తృ చ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ఆయన సమస్త చరాచర భూతముల బయట మరియు లోపల కూడా స్థితమై ఉన్నాడు. ఆయన సూక్షమైన వాడు, కాబట్టి ఆయనను మనం అర్థం చేసుకోలేము. చాలా దూరంలో ఉన్నాడు కానీ చాలా దగ్గరగా కూడా ఉన్నాడు.",
                        "description": [
                            {
                                "des": "బహిరంతశ్చ భూతానామ్ అచరం చరమేవ చ ।"
                            },
                            {
                                "des": "సూక్ష్మత్వాత్ తదవిజ్ఞేయం దూరస్థం చాంతికే చ తత్ ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "ఆయన విభజించుటకు వీలులేని వాడు, అయినా సర్వప్రాణులలో వేర్వేరుగా కనిపిస్తూ ఉంటాడు. ఆ పరమేశ్వరుడే, సమస్త భూతములకు (ప్రాణులకు) సంరక్షకుడు-పోషకుడు, లయకారకుడు మరియు సృష్టికర్త అని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "అవిభక్తం చ భూతేషు విభక్తమివ చ స్థితమ్ ।"
                            },
                            {
                                "des": "భూతభర్తృ చ తద్ జ్ఞేయం గ్రసిష్ణు ప్రభవిష్ణు చ ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "అన్ని తేజోమయవస్తువుల్లో ఆయనే ప్రకాశానికి మూలము, మరియు అజ్ఞానపు చీకటికి పరమ అతీతుడు. జ్ఞానము ఆయనే, జ్ఞాన విషయము ఆయనే, మరియు జ్ఞాన లక్ష్యము ఆయనే. ఆయన సమస్త ప్రాణుల హృదయములలో ఉంటాడు.",
                        "description": [
                            {
                                "des": "జ్యోతిషామపి తజ్జ్యోతిస్తమసః పరముచ్యతే ।"
                            },
                            {
                                "des": "జ్ఞానం జ్ఞేయం జ్ఞానగమ్యం హృది సర్వస్య విష్ఠితమ్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఈ ప్రకారముగా నీకు క్షేత్రము యొక్క స్వభావమును, జ్ఞానము యొక్క అర్థమును, మరియు జ్ఞాన విషయమును, నేను తెలియచేసాను. నా భక్తులు మాత్రమే దీనిని యదార్థముగా అర్థం చేసుకోగలరు, అలా చేసిన పిదప, వారు నా దివ్య స్వభావమునే పొందుతారు.",
                        "description": [
                            {
                                "des": "ఇతి క్షేత్రం తథా జ్ఞానం జ్ఞేయం చోక్తం సమాసతః ।"
                            },
                            {
                                "des": "మద్భక్త ఏతద్విజ్ఞాయ మద్భావాయోపపద్యతే ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ప్రకృతి (భౌతిక ప్రకృతి) మరియు పురుషుడు (ఆత్మలు) రెండూ కూడా అనాదియైనవి (సనాతనమైనవి). శరీరములోని అన్ని మార్పులూ మరియు ప్రకృతి త్రిగుణములూ కూడా, భౌతిక శక్తి చే సంభవిస్తున్నాయని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "ప్రకృతిం పురుషం చైవ విద్ధ్యనాదీ ఉభావపి ।"
                            },
                            {
                                "des": "వికారాంశ్చ గుణాంశ్చైవ విద్ధి ప్రకృతిసంభవాన్ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "సృష్టిలో కార్యమునకు కారణమునకు భౌతిక శక్తియే హేతువని; సుఖ దుఃఖములను అనుభూతి చెందుటలో, జీవాత్మ యే బాధ్యుడు అని చెప్పబడినది.",
                        "description": [
                            {
                                "des": "కార్యకారణకర్తృత్వే హేతుః ప్రకృతిరుచ్యతే ।"
                            },
                            {
                                "des": "పురుషః సుఖదుఃఖానాం భోక్తృత్వే హేతురుచ్యతే ।। 21"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "ఎప్పుడైతే ప్రకృతిలో (భౌతిక శక్తి) లో స్థితమై ఉన్న పురుషుడు (జీవాత్మ) త్రిగుణములను సుఖించదలచాడో, వాటి పట్ల మమకారాసక్తియే, ఆ జీవాత్మకు ఉన్నతమైన జన్మ మరియు నీచ జన్మలకు కారణమగును.",
                        "description": [
                            {
                                "des": "పురుషః ప్రకృతిస్థో హి భుంక్తే ప్రకృతిజాన్గుణాన్ ।"
                            },
                            {
                                "des": "కారణం గుణసంగోఽస్య సదసద్యోనిజన్మసు ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "దేహములోనే ఆ సర్వోన్నత భగవానుడు కూడా ఉంటాడు. ఆయన, సర్వసాక్షి, సర్వ నియామకుడు, ధరించి పోషించేవాడు, అలౌకిక భోక్త, సర్వోత్కృష్ట అధికారి మరియు పరమాత్మ, అని చెప్పబడుతాడు.",
                        "description": [
                            {
                                "des": "ఉపద్రష్టానుమంతా చ భర్తా భోక్తా మహేశ్వరః ।"
                            },
                            {
                                "des": "పరమాత్మేతి చాప్యుక్తో దేహేఽస్మిన్ పురుషః పరః ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "పరమాత్మ, జీవాత్మ, భౌతిక ప్రకృతి మరియు ప్రకృతి త్రిగుణముల మధ్య సహచర్యముల గురించి యదార్ధమును అర్థం చేసుకున్న వారు, మళ్ళీ ఇక ఇక్కడ పుట్టరు. వారి ప్రస్తుత పరిస్థితి ఎలాఉన్నా వారు విముక్తి చేయబడతారు.",
                        "description": [
                            {
                                "des": "య ఏవం వేత్తి పురుషం ప్రకృతిం చ గుణైః సహ ।"
                            },
                            {
                                "des": "సర్వథా వర్తమానోఽపి న స భూయోఽభిజాయతే ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "కొందరు ధ్యానము ద్వారా తమ హృదయములో ఉన్న పరమాత్మను దర్శించటానికి ప్రయత్నిస్తారు; మరియు ఇతరులు దీనినే జ్ఞాన సముపార్జన ద్వారా పొందటానికి ప్రయత్నిస్తారు, ఇంకా మరికొందరు ఈ విజ్ఞానమును కర్మ మార్గము ద్వారా సాధించుటకు పరిశ్రమిస్తుంటారు.",
                        "description": [
                            {
                                "des": "ధ్యానేనాత్మని పశ్యంతి కేచిదాత్మానమాత్మనా ।"
                            },
                            {
                                "des": "అన్యే సాంఖ్యేన యోగేన కర్మయోగేన చాపరే ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "ఇంకా కొందరు ఈ ఆధ్యాత్మిక మార్గముల గురించి తెలియనివారు, వాటి గురించి వేరే వారి దగ్గర విని, ఆ సర్వోన్నత భగవానుని ఆరాధించటం మొదలుపెడతారు. ఇలా భక్తితో మహాత్ముల దగ్గర శ్రవణం చేయటం చేత, వారు కూడా క్రమక్రమంగా ఈ జనన-మరణ సంసార సాగరాన్ని దాటగలరు.",
                        "description": [
                            {
                                "des": "అన్యే త్వేవమజానంతః శ్రుత్వాన్యేభ్య ఉపాసతే ।"
                            },
                            {
                                "des": "తేఽపి చాతితరంత్యేవ మృత్యుం శ్రుతిపరాయణాః ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "ఓ భరత వంశీయులలో శ్రేష్ఠుడా, నీవు ఈ సమస్త చరాచర ప్రాణులు, ఈ క్షేత్రము మరియు క్షేత్రజ్ఞుడు యొక్క కలయిక వలననే ఉన్నాయని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "యావత్సంజాయతే కించిత్ సత్త్వం స్థావరజంగమమ్ ।"
                            },
                            {
                                "des": "క్షేత్రక్షేత్రజ్ఞసంయోగాత్ తద్విద్ధి భరతర్షభ ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "సమస్త ప్రాణులలో వాటి ఆత్మ తో పాటుగా ఉన్న పరమాత్మను చూసినవాడే, మరియు ఆ రెంటినీ ఈ నశ్వరమైన శరీరంలో అనశ్వరమైన వాటిగా చూసినవాడే, నిజముగా చూసినట్టు.",
                        "description": [
                            {
                                "des": "సమం సర్వేషు భూతేషు తిష్ఠంతం పరమేశ్వరమ్ ।"
                            },
                            {
                                "des": "వినశ్యత్స్వవినశ్యంతం యః పశ్యతి స పశ్యతి ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "సర్వ ప్రాణులలో సమానముగా, పరమాత్మ గా ఉన్న ఆ భగవంతుడిని చూసేవారు, తమ మనస్సుచే తమను తామే దిగజార్చుకోరు. తద్వారా, వారు పరమ పదమునకు చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "సమం పశ్యన్ హి సర్వత్ర సమవస్థితమీశ్వరమ్ ।"
                            },
                            {
                                "des": "న హినస్త్యాత్మనాత్మానం తతో యాతి పరాం గతిమ్ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "(శరీరము యొక్క) అన్ని కార్యములు చేసేది భౌతిక ప్రకృతియే, జీవాత్మ నిజానికి ఏపనీ చేయదు - అని అర్థంచేసుకున్నవాడు నిజముగా చూసినట్టు.",
                        "description": [
                            {
                                "des": "ప్రకృత్యైవ చ కర్మాణి క్రియమాణాని సర్వశః ।"
                            },
                            {
                                "des": "యః పశ్యతి తథాత్మానమ్ అకర్తారం స పశ్యతి ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "విభిన్న వైధ్యములతో కూడిన జీవరాశులు అన్నీ ఒకే ప్రకృతిలో స్థితమై ఉన్నట్టు చూసినప్పుడు, మరియు అవన్నీ దానినుండే ఉద్భవించినవి అని అర్థం చేసుకున్నప్పుడు, వారు బ్రహ్మజ్ఞానమును పొందుతారు.",
                        "description": [
                            {
                                "des": "యదా భూతపృథగ్భావమ్ ఏకస్థమనుపశ్యతి ।"
                            },
                            {
                                "des": "తత ఏవ చ విస్తారం బ్రహ్మ సంపద్యతే తదా ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "ఓ కుంతీ తనయుడా, పరమాత్మ నాశములేనివాడు, అనాదియైనవాడు, భౌతిక లక్షణములు ఏవీ లేనివాడు. దేహములోనే స్థితమై ఉన్నా, ఆయన ఏమీ చేయడు, మరియు, భౌతిక శక్తి చే ఏమాత్రం కళంకితము కాడు.",
                        "description": [
                            {
                                "des": "అనాదిత్వాన్నిర్గుణత్వాత్ పరమాత్మాయమవ్యయః ।"
                            },
                            {
                                "des": "శరీరస్థోఽపి కౌంతేయ న కరోతి న లిప్యతే ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "ఆకాశము (ఖాళీ జాగా) అన్నింటిని తనలోనే కలిగిఉంటుంది, కానీ సూక్ష్మమైనది కావటం వలన, తనలో కలిగి ఉన్న వాటిచే కళంకితముకాదు. అదే విధముగా, దేహములో దాని చైతన్యమంతా వ్యాపించి ఉన్నా, ఆత్మ అనేది శరీరము యొక్క గుణములచే ప్రభావితము కాదు.",
                        "description": [
                            {
                                "des": "యథా సర్వగతం సౌక్ష్మ్యాత్ ఆకాశం నోపలిప్యతే ।"
                            },
                            {
                                "des": "సర్వత్రావస్థితో దేహే తథాత్మా నోపలిప్యతే ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఎలాగైతే ఒక్క సూర్యుడే సమస్త సౌరకుటుంబమును ప్రకాశింపచేయునో, అలాగే ఒక్క ఆత్మ యే మొత్తం శరీరమును (చైతన్యము చే) ప్రకాశింపచేయును.",
                        "description": [
                            {
                                "des": "యథా ప్రకాశయత్యేకః కృత్స్నం లోకమిమం రవిః ।"
                            },
                            {
                                "des": "క్షేత్రం క్షేత్రీ తథా కృత్స్నం ప్రకాశయతి భారత ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "జ్ఞాన-చక్షువులచే ఈ క్షేత్రము మరియు క్షేత్రజ్ఞుడు యొక్క భేదమును గమనించేవారు, మరియు భౌతిక ప్రకృతి నుండి విముక్తి పొందే పద్దతి తెలిసినవారు, పరమ పదమును చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "క్షేత్రక్షేత్రజ్ఞయోరేవమ్ అంతరం జ్ఞానచక్షుషా ।"
                            },
                            {
                                "des": "భూతప్రకృతిమోక్షం చ యే విదుర్యాంతి తే పరమ్ ।। 35 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "గుణత్రయ విభాగ యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/14.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/14.png'),
                "index":14,
                "introduction": [
                    {
                        "para": "ఆత్మ మరియు భౌతిక శరీరమునకు మధ్య తేడాని గత అధ్యాయము విపులంగా విశదీకరించింది. ఈ అధ్యాయము, దేహము మరియు దాని మూలకముల యొక్క మూలశక్తి అయిన భౌతిక శక్తి యొక్క స్వభావమును వివరిస్తుంది; ఇదే మనస్సు మరియు పదార్ధమునకు మూలము. భౌతిక ప్రకృతి మూడు విధములుగా ఉంటుంది అని శ్రీ కృష్ణుడు వివరిస్తున్నాడు - సత్త్వము, రజస్సు , మరియు తమస్సు. భౌతిక శక్తి చే తయారు అయిన శరీరమనోబుద్ధులు కూడా ఈ మూడు గుణములను కలిగి ఉంటాయి; ఈ మూడు గుణముల కలయిక మనలో ఏ పాళ్ళలో ఉన్నది అన్నదాని బట్టి మన వ్యక్తిత్వము ఆధారపడి ఉంటుంది. సత్త్వ గుణము - శాంతి, సదాచారము, సద్గుణము మరియు ప్రసన్నత తో ఉంటుంది. రజో గుణము వలన అంతులేని కోరికలు మరియు ప్రాపంచిక అభ్యున్నతి కోసం తృప్తినొందని తృష్ణ, కలుగుతాయి. మరియు తమో గుణము వలన భ్రమ, సోమరితనం, మత్తు మరియు నిద్ర కలుగుతాయి. ఆత్మ జ్ఞానోదయం పొందేవరకూ, ప్రకృతి యొక్క ఈ బలీయమైన శక్తులతో వ్యవహరించటం నేర్చుకోవాలి. ఈ త్రి-గుణములకు అతీతముగా వెళ్ళటమే మోక్షము."
                    },
                    {
                        "para": "ఈ త్రి-గుణముల బంధనమును ఛేదించి వెళ్లిపోవటానికి ఒక సరళమైన ఉపాయం తెలియచేస్తాడు శ్రీ కృష్ణుడు. సర్వోత్కృష్ట భగవానుడు ఈ మూడు గుణములకు అతీతుడు, ఒకవేళ మనం ఆయనతో అనుసంధానం అయిపోతే, ఆ తదుపరి, మన మనస్సు కూడా దివ్యమైన స్థాయికి ఎదుగుతుంది. ఈ తరుణంలో, అర్జునుడు, త్రిగుణములకు అతీతముగా ఎదిగిన వారి లక్షణములు ఏమిటి అని అడుగుతాడు. అటువంటి జీవన్ముక్తులైన వారి లక్షణములను శ్రీ కృష్ణుడు క్రమపద్ధతిలో వివరిస్తాడు. జ్ఞానోదయమయిన వారు ఏల్లప్పుడూ సమత్వచిత్తము (సమతౌల్యం) తోనే ఉంటారు అని చెప్తాడు; జగత్తులో ఈ త్రిగుణములు ప్రవర్తిల్లుచున్నప్పుడు, వాటి ప్రభావం మనుష్యులలో, వస్తువులలో, పరిస్థితులలో వ్యక్తమైనప్పుడు వారు ఉద్వేగానికి లోనుకారు. వారు అన్నింటినీ భగవంతుని యొక్క శక్తి ప్రకటితమవుతున్నట్టుగానే చూస్తారు; అన్ని చివరికి ఆయన అధీనములోనే ఉన్నట్టు గమనిస్తారు. అందుకే, ప్రాపంచిక పరిస్థితులు వారిని అతిసంతోషానికి లేదా దుఃఖమునకు గురి చేయవు; చలించిపోకుండా ఉండి వారు ఆత్మ యందే స్థితమై ఉంటారు. త్రిగుణములకు అతీతముగా ఎదగటానికి , భక్తి యొక్క ఔన్నత్యాన్ని, శక్తిని మరల ఒకసారి మనకు శ్రీ కృష్ణ పరమాత్మ గుర్తు చేయటంతో ఈ అధ్యాయం ముగుస్తుంది."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: నేను మళ్ళీ ఒకసారి ఈ యొక్క సర్వశ్రేష్టమైన విద్యను, అన్నింటికన్నా ఉత్తమమైన  జ్ఞానమును నీకు వివరిస్తాను; ఇది తెలుసుకున్న గొప్ప సాధువులందరూ అత్యున్నత పరిపూర్ణతను సాధించారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "పరం భూయః ప్రవక్ష్యామి జ్ఞానానాం జ్ఞానముత్తమమ్ ।"
                            },
                            {
                                "des": "యద్ జ్ఞాత్వా మునయః సర్వే పరాం సిద్ధిమితో గతాః  ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "ఈ జ్ఞానమును ఆశ్రయించిన వారు నన్ను చేరుకుంటారు. వారు, సృష్టి సమయంలో మరలా జన్మించరు లేదా ప్రళయ సమయంలో నాశనం కారు.",
                        "description": [
                            {
                                "des": "ఇదం జ్ఞానముపాశ్రిత్య మమ సాధర్మ్యమాగతాః ।"
                            },
                            {
                                "des": "సర్గేఽపి నోపజాయంతే ప్రలయే న వ్యథంతి చ ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3-4 శ్లోకాలు",
                        "bhavam": "ఈ యొక్క సమస్త భౌతిక ప్రకృతి, గర్భము. దానిలో  నేను వేర్వేరు ఆత్మలను ప్రవేశపెడుతాను, ఆ విధంగా సమస్త జీవరాశులు జనిస్తాయి. ఓ కుంతీ పుత్రుడా, పుట్టిన సమస్త జీవ రాశులకు, ఈ భౌతిక ప్రకృతి యే గర్భము మరియు నేనే బీజమును ఇచ్చే తండ్రిని.",
                        "description": [
                            {
                                "des": "మమ యోనిర్మహద్బ్రహ్మ తస్మిన్గర్భం దధామ్యహమ్ ।"
                            },
                            {
                                "des": "సంభవః సర్వభూతానాం తతో భవతి భారత ।। 3 ।।"
                            },
                            {
                                "des": "సర్వయోనిషు కౌంతేయ మూర్తయః సంభవంతి యాః ।"
                            },
                            {
                                "des": "తాసాం బ్రహ్మ మహద్యోనిః అహం బీజప్రదః పితా ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "ఓ మహా బాహువులు కల అర్జునా, భౌతిక ప్రాకృతిక శక్తి అనేది త్రిగుణములను కలిగి ఉంటుంది - సత్త్వ గుణము, రజో  గుణము, మరియు తమో గుణము. ఈ గుణములే నాశములేని నిత్య జీవాత్మను నాశనమయ్యే దేహమునకు బంధించును.",
                        "description": [
                            {
                                "des": "సత్త్వం రజస్తమ ఇతి గుణాః ప్రకృతిసంభవాః ।"
                            },
                            {
                                "des": "నిబధ్నంతి మహాబాహో దేహే దేహినమవ్యయమ్ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "వీటిలో సత్త్వ గుణము మిగతావాటి కంటే పవిత్రమైనది, ఇది ప్రకాశకమైనది మరియు చాలా క్షేమదాయకమైనది. ఓ పాప రహితుడా, జ్ఞానము మరియు సుఖానుభవము పట్ల ఆసక్తి వలన అది జీవాత్మను బంధించివేస్తుంది.",
                        "description": [
                            {
                                "des": "తత్ర సత్వం నిర్మలత్వాత్ ప్రకాశకమనామయమ్ ।"
                            },
                            {
                                "des": "సుఖ-సంగేన బధ్నాతి జ్ఞానసంగేన చానఘ ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, రజో గుణము మోహావేశ ప్రవృత్తి తో కూడినది. అది ప్రాపంచిక కోరికలు మరియు అనురాగముల వలన జనిస్తుంది మరియు ఆత్మను కామ్య కర్మల పట్ల ఆసక్తి చే బంధించివేస్తుంది.",
                        "description": [
                            {
                                "des": "రజో రాగాత్మకం విద్ధి తృష్ణాసంగసముద్భవమ్ ।"
                            },
                            {
                                "des": "తన్నిబధ్నాతి కౌంతేయ కర్మసంగేన దేహినమ్ ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, అజ్ఞానముచే జనించిన తమో గుణము, జీవాత్మల యొక్క మోహభ్రాంతికి కారణము. అది సమస్త జీవరాశులను నిర్లక్ష్యము, సోమరితనము మరియు నిద్ర చే భ్రమకు గురి చేస్తుంది.",
                        "description": [
                            {
                                "des": "తమస్త్వజ్ఞానజం విద్ధి మోహనం సర్వదేహినామ్ ।"
                            },
                            {
                                "des": "ప్రమాదాలస్యనిద్రాభిః  తన్నిబధ్నాతి భారత ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "సత్త్వము వ్యక్తిని భౌతిక సుఖాలకు కట్టివేస్తుంది; రజో గుణము జీవాత్మను కర్మల పట్ల ఆసక్తి పరుస్తుంది; మరియు తమో గుణము జ్ఞానమును కప్పివేసి వ్యక్తిని మోహభ్రాంతి కి బంధించివేస్తుంది.",
                        "description": [
                            {
                                "des": "సత్త్వం సుఖే సంజయతి రజః కర్మణి భారత ।"
                            },
                            {
                                "des": "జ్ఞానమావృత్య తు తమః ప్రమాదే సంజయత్యుత ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "ఒక్కోసారి రజోతమస్సులపై సత్త్వముది పైచేయిగా ఉంటుంది. ఒక్కోసారి  సత్త్వము మరియు తమోగుణములపై రజో గుణము ఆధిపత్యంతో ఉంటుంది; మరియు ఇంకాకొన్ని సార్లు సత్త్వరజో గుణములను తమోగుణము ఓడిస్తుంది.",
                        "description": [
                            {
                                "des": "రజస్తమశ్చాభిభూయ సత్త్వం భవతి భారత ।"
                            },

                            {
                                "des": "రజః సత్వం తమశ్చైవ తమః సత్త్వం రజస్తథా ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11-13 శ్లోకాలు",
                        "bhavam": "దేహములోని అన్ని ద్వారములు జ్ఞానముచే ప్రకాశితమైనప్పుడు, అది సత్త్వ గుణము యొక్క ప్రకటితము అని తెలుసుకొనుము. రజో గుణము ప్రబలినప్పుడు, ఓ అర్జునా, లోభము (దురాశ), ప్రాపంచిక లాభము కోసం పరిశ్రమ, వ్యాకులత, మరియు యావ పెంపొందుతాయి. ఓ అర్జునా – అజ్ఞానము, జడత్వము, నిర్లక్ష్యము, మరియు మోహము - ఇవి తమో గుణము యొక్క ప్రధానమైన లక్షణములు.",
                        "description": [
                            {
                                "des": "సర్వద్వారేషు దేహేఽస్మిన్ ప్రకాశ ఉపజాయతే ।"
                            },
                            {
                                "des": "జ్ఞానం యదా తదా విద్యాత్ వివృద్ధం సత్త్వమిత్యుత ।। 11 ।।"
                            },
                            {
                                "des": "లోభః ప్రవృత్తిరారంభః కర్మణామశమః స్పృహా ।"
                            },
                            {
                                "des": "రజస్యేతాని జాయంతే వివృద్ధే భరతర్షభ ।। 12 ।।"
                            },
                            {
                                "des": "అప్రకాశోఽప్రవృత్తిశ్చ ప్రమాదో మోహ ఏవ చ ।"
                            },
                            {
                                "des": "తమస్యేతాని జాయంతే వివృద్ధే కురునందన ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14-15 శ్లోకాలు",
                        "bhavam": "సత్త్వ గుణ ప్రధానముగా ఉండి మరణించినవారు, జ్ఞానులు ఉండే పవిత్ర లోకాలను  (రజస్సు, తమస్సు లేనటువంటివి)  చేరుకుంటారు. రజో గుణ ప్రధానముగా ఉంటూ మరణించినవారు పనులతో ప్రేరణ పొందేవారిలో జన్మిస్తారు; తమో గుణ ప్రభావంతో ఉండి మరణించిన వారు జంతువుల జీవరాశిలో పుడతారు.",
                        "description": [
                            {
                                "des": "యదా సత్త్వే పవృద్ధే తు ప్రలయం యాతి దేహభృత్ ।"
                            },
                            {
                                "des": "తదోత్తమవిదాం లోకాన్ అమలాన్ ప్రతిపద్యతే ।। 14 ।।"
                            },
                            {
                                "des": "రజసి ప్రలయం గత్వా కర్మసంగిషు జాయతే ।"
                            },
                            {
                                "des": "తథా ప్రలీనస్తమసి మూఢయోనిషు జాయతే ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "సత్త్వ గుణములో చేసిన కార్యముల ఫలములు పవిత్రమైన ఫలితములను ఇస్తాయి. రజో గుణము లో చేసిన పనులు, దుఃఖాలను కలుగ చేస్తాయి, మరియు, తమో గుణములో చేసిన పనులు అజ్ఞానపు చీకటిని కలుగచేస్తాయి.",
                        "description": [
                            {
                                "des": "కర్మణః సుకృతస్యాహుః సాత్త్వికం నిర్మలం ఫలమ్ ।"
                            },
                            {
                                "des": "రజసస్తు ఫలం దుఃఖమ్  అజ్ఞానం తమసః ఫలమ్  ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "సత్త్వ గుణముచే జ్ఞానము, రజో గుణము చే లోభము(దురాశ), మరియు తమో గుణముచే నిర్లక్ష్యము మరియు మోహము (భ్రాంతి) జనించును.",
                        "description": [
                            {
                                "des": "సత్త్వాత్ సంజాయతే జ్ఞానం రజసో లోభ ఏవ చ।"
                            },
                            {
                                "des": "ప్రమాదమోహౌ తమసో భవతోఽజ్ఞానమేవ చ  ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "సత్త్వ గుణములో స్థితమై ఉన్నవారు ఊర్ధ్వలోకాలకు వెళతారు; రజో గుణములో స్థితమై ఉండేవారు మధ్య (లోకాల) లోనే ఉండిపోతారు; తమో గుణములో స్థితమై ఉండేవారు అధోగతి పాలైతారు.",
                        "description": [
                            {
                                "des": "ఊర్ధ్వం గచ్ఛంతి సత్త్వస్థా మధ్యే తిష్ఠంతి రాజసాః ।"
                            },
                            {
                                "des": "జఘన్యగుణవృత్తిస్థా అధో గచ్ఛంతి తామసాః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "అన్ని పనులలో, చేసేది ఈ త్రి-గుణములే, ఇతర వేరే ఏవీ లేవు, అని ఎప్పుడైతే వివేవవంతులు తెలుసుకుంటారో, మరియు నేను వీటికి అతీతమైనవాడను అని తెలుసుకుంటారో - వారు నా దివ్య స్వభావాన్ని పొందుతారు.",
                        "description": [
                            {
                                "des": "నాన్యం గుణేభ్యః కర్తారం యదా ద్రష్టానుపశ్యతి ।"
                            },
                            {
                                "des": "గుణేభ్యశ్చ పరం వేత్తి మద్భావం సోఽధిగఛ్చతి ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "దేహ సంబంధమయిన ప్రకృతి త్రిగుణములకు అతీతముగా అయిపోవటం వలన, వ్యక్తి, జన్మ, మృత్యువు, వృద్ధాప్యముల దుఃఖముల నుండి విముక్తి పొంది, అమరత్వం పొందుతాడు.",
                        "description": [
                            {
                                "des": "గుణానేతానతీత్య త్రీన్ దేహీ దేహసముద్భవాన్ ।"
                            },
                            {
                                "des": "జన్మమృత్యుజరాదుఃఖైః విముక్తోఽమృతమశ్నుతే  ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అడిగాడు: ప్రకృతి త్రి-గుణములకు అతీతముగా అయినవాడి లక్షణములు ఏ విధంగా ఉంటాయి, ఓ ప్రభూ? వారు ఏవిధంగా ప్రవర్తిస్తారు? వారు త్రి-గుణముల బంధనమునకు అతీతముగా ఎలా అవుతారు?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ  ।"
                            },
                            {
                                "des": "కైర్లింగైః త్రీన్ గుణానేతాన్ అతీతో భవతి ప్రభో ।"
                            },
                            {
                                "des": "కిమాచారః కథం చైతాన్ త్రీన్ గుణానతివర్తతే  ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22-23 శ్లోకాలు",
                        "bhavam": "శ్రీ భగవానుడు పలికెను: ఓ అర్జునా, ఈ త్రిగుణములకు అతీతులైనవారు -  (సత్త్వ గుణ జనితమైన) ప్రకాశమును కానీ, (రజో గుణ జనితమైన) కార్యకలాపములను కానీ, లేదా (తమో గుణ జనితమైన) మోహభ్రాంతిని కానీ - అవి పుష్కలంగా ఉన్నప్పుడు ద్వేషించరు, లేదా, అవి లేనప్పుడు వాటిని కాంక్షించరు. వారు ప్రకృతి గుణముల పట్ల తటస్థముగా, ఉదాసీనంగా ఉండి, వాటిచే అలజడికికి గురికారు. గుణములే ప్రవర్తించుతున్నవని తెలుసుకుని వారు నిశ్చలముగా ఆత్మ యందే స్థితమై  ఉంటారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ప్రకాశం చ ప్రవృత్తిం చ మోహమేవ చ పాండవ ।"
                            },
                            {
                                "des": "న ద్వేష్టి సంప్రవృత్తాని న నివృత్తాని కాంక్షతి ।। 22 ।।"
                            },
                            {
                                "des": "ఉదాసీనవదాసీనో గుణైర్యో న విచాల్యతే ।"
                            },

                            {
                                "des": "గుణా వర్తంత ఇత్యేవం యోఽవతిష్ఠతి నేంగతే  ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24-25 శ్లోకాలు",
                        "bhavam": "సుఖదుఃఖాలలో ఒక్క రీతిగానే ఉండేవారు; ఆత్మ భావన యందే స్థితమై ఉండేవారు; మట్టిముద్ద, రాయి, బంగారము వీటన్నిటినీ ఒకే విలువతో చూసేవారు; అనుకూల లేదా ప్రతికూల పరిస్థితిలో ఒక్కరీతిగానే ఉండేవారు; తెలివైన వారు; నిందాస్తుతులను రెంటినీ సమముగా స్వీకరించేవారు; గౌరవమును, అవమానమును ఒక్క రీతిగానే తీసుకునేవారు; శత్రువుని, మిత్రుడిని ఒకలాగే చూసేవారు; అన్ని యత్నములను విడిచిపెట్టినవారు - వీరు త్రిగుణములకు అతీతులైనవారు అని చెప్పబడుతారు.",
                        "description": [
                            {
                                "des": "సమదుఃఖసుఖః స్వస్థః సమలోష్టాశ్మకాంచనః ।"
                            },
                            {
                                "des": "తుల్యప్రియాప్రియో ధీరః తుల్యనిందాత్మసంస్తుతిః ।। 24 ।।"
                            },
                            {
                                "des": "మానాపమానయోస్తుల్యః తుల్యో మిత్రారిపక్షయోః ।"
                            },
                            {
                                "des": "సర్వారంభపరిత్యాగీ గుణాతీతః స ఉచ్యతే ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "నిష్కల్మషమైన భక్తి ద్వారా నన్ను సేవించిన వారు ప్రకృతి త్రిగుణములకు అతీతులై పోవుదురు మరియు బ్రహ్మం స్థాయికి చేరుతారు.",
                        "description": [
                            {
                                "des": "మాం చ యోఽవ్యభిచారేణ భక్తియోగేన సేవతే ।"
                            },
                            {
                                "des": "స గుణాన్ సమతీత్యైతాన్ బ్రహ్మభూయాయ కల్పతే ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "ఆ యొక్క సనాతనమైన, అవ్యయమైన నిరాకార బ్రహ్మాంమునకు, సనాతనమైన ధర్మమునకు మరియు అఖండమైన దివ్య ఆనందమునకు, నేనే ఆధారము.",
                        "description": [
                            {
                                "des": "బ్రహ్మణో హి ప్రతిష్ఠాహమ్ అమృతస్యావ్యయస్య చ ।"
                            },
                            {
                                "des": "శాశ్వతస్య చ ధర్మస్య సుఖస్యైకాంతికస్య చ ।। 27 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "పురుషోత్తమ యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/15.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/15.png'),
                "index":15,
                "introduction": [
                    {
                        "para": "ఇంతకు క్రితం అధ్యాయములో, ప్రకృతి త్రిగుణములకు అతీతులమవటం ద్వారా భగవత్ లక్ష్యమును చేరుకోవచ్చు అని శ్రీ కృష్ణుడు వివరించి ఉన్నాడు. అనన్య భక్తిలో నిమగ్నమవటమే త్రి-గుణములకు అతీతులమై పోవటానికి ఉన్న అద్భుతమైన పద్దతి అని కూడా చెప్పి ఉన్నాడు. ఇటువంటి భక్తిలో నిమగ్నమవటానికి, మనము మనస్సుని ఈ ప్రపంచం నుండి దూరం చేసి దానిని భగవంతుని యందే నిమగ్నం చేయాలి. అందుకే, ఈ ప్రపంచం యొక్క స్వభావాన్ని తెలుసుకోవటం చాలా ఆవశ్యకం. ఈ అధ్యాయంలో, అర్జునుడికి భౌతిక జగత్తు పట్ల మమకార-ఆసక్తులు తగ్గించటంలో సహాయం చేయటానికి, శ్రీ కృష్ణుడు, ఈ యొక్క భౌతిక జగత్తుని తద్రూప ఉపమానముతో వివరిస్తున్నాడు. భౌతిక జగత్తుని ఒక తల క్రిందులుగా ఉండే అశ్వత్థ వృక్షం (రావిచెట్టు) తో పోల్చుతున్నాడు. బద్ధ జీవాత్మ - ఆ వృక్షం ఎక్కడి నుండి వచ్చినదో, ఎప్పటినుండి ఇది ఉందో, అది ఎట్లా పెరుగుతూనే ఉంటుందో తెలుసుకోకుండానే - ఒక జన్మ నుండి ఇంకో జన్మ కు ఆ చెట్టు కొమ్మలలో పైకీ క్రిందికీ తిరుగుతూనే ఉంటుంది. ఆ చెట్టు యొక్క వేర్లు పైకి ఉంటాయి, ఎందుకంటే దాని యొక్క మూలం భగవంతునిలో ఉంది కాబట్టి. వేదములలో చెప్పబడిన కామ్య కర్మలు ఆ చెట్టుకి ఆకులలాంటివి. ఆ చెట్టుకి పోషణ, ప్రకృతి యొక్క త్రి-గుణములు. ఈ గుణములు ఇంద్రియ విషయములను సృష్టిస్తాయి, అవి ఈ చెట్టుకు అంకురముల (మొగ్గ) వంటివి. ఈ అంకురములు, ఊడలను (aerial roots) ని జనింపచేస్తాయి. అవి వృక్షమును మరింత విస్తరింపచేస్తాయి. ఈ అధ్యాయము, ఈ ఉపమానం ఆధారంగా - భౌతిక ప్రపంచంలో క్లేశములకు గురయ్యే జీవాత్మ, భౌతిక అస్థిత్వములో ఉండే జగత్తు యొక్క నిజ స్వరూపము యొక్క అజ్ఞానము వలన, మరింత దానిలో ఎలా చిక్కుకుని పోతుందో - విస్తారముగా వివరిస్తుంది. వైరాగ్యము అనే గొడ్డలి సహాయంతో ఈ వృక్షాన్ని ఎలా కొట్టివేయాలి అని శ్రీ కృష్ణుడు చెప్తున్నాడు. ఆ తరువాత మనం ఆ చెట్టు యొక్క మూలం కోసం వెతకాలి; అది స్వయంగా భగవంతుడే. ఆ మూలాన్ని తెలుసుకున్న పిదప ఆయనకి ఈ అధ్యాయములో చెప్పబడిన విధముగా శరణాగతి చేయాలి; అప్పుడు మనము ఆ భగవంతుని యొక్క దివ్య ధామముని చేరుకుంటాము, ఆ తదుపరి మళ్ళీ ఇక ఈ భౌతిక జగత్తు లోకి రాము."
                    },
                    {
                        "para": "శ్రీ కృష్ణుడు ఇక తదుపరి, తనయొక్క నిత్య సనాతనమైన అంశలైన, ఈ జగత్తులో ఉన్న జీవాత్మలు, ఎలా దివ్యమైనవో వివరిస్తున్నాడు. కానీ, భౌతిక ప్రకృతి చే బద్ధులైపోయి, మనస్సుతో కలిపిఉన్న ఆరు ఇంద్రియములచే అవి కష్టాలను అనుభవిస్తున్నాయి. జీవాత్మ దివ్యమైనది అయినా, అది ఎలా ఇంద్రియముల యొక్క భౌతిక విషయములను భోగిస్తూ ఉంటుదో వివరిస్తున్నాడు. ఆత్మ మరణ సమయంలో ఇంకొక శరీరములోనికి, తన ప్రస్తుత జన్మ యొక్క మనస్సు మరియు ఇంద్రియములతో సహా, ఎలా ప్రవేశిస్తుందో వివరిస్తాడు. అజ్ఞానులు తమ దేహములోని ఆత్మను గుర్తించరు; మరియు అది మరణ సమయంలో వెళ్లిపోవటాన్ని కూడా గుర్తించరు. కానీ యోగులు తమ యొక్క జ్ఞాన-చక్షువులచే మరియు పవిత్రమైన మనస్సుచే దానిని తెలుసుకుంటారు. అదే విధంగా భగవంతుడు కూడా తన సృష్టిలో అంతటా ఉంటాడు; కానీ ఆయనను జ్ఞాన చక్షువులచే తెలుసుకోవాలి. అంతటా వ్యక్తమయ్యే ఆయన యొక్క విభూతుల ద్వారా జగత్తులో భగవంతుని యొక్క అస్థిత్వమును మనము ఎలా తెలుసుకోవచ్చో శ్రీ కృష్ణుడు తెలియచేస్తాడు. క్షరము, అక్షరము మరియు పురుషోత్తమ అనే పదముల వివరణతో ఈ అధ్యాయం ముగుస్తుంది. 'క్షరము' అంటే భౌతిక జగత్తులోని నశించిపోయే జీవరాశులు. 'అక్షరము' అంటే భగవంతుని దివ్య ధామములో ఉన్న విముక్తి పొందిన జీవులు. 'పురుషోత్తమ' అంటే సర్వోత్క్రుష్ట భగవానుడు, ఆయనే మార్పులేని నియామకుడు మరియు పోషకుడు. ఆయన క్షర మరియు అక్షర జీవులకు అతీతుడు. ఆయన మనసారా ఆరాధించబడాలి."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు పలికెను : వేర్లు పైకి మరియు కొమ్మలు క్రిందికి ఉన్న సనాతనమైన అశ్వత్థ వృక్షము గురించి చెప్తుంటారు. దాని యొక్క ఆకులు వేద మంత్రములు, మరియు ఈ చెట్టు యొక్క రహస్యం తెలిసిన వారు వేదములను తెలుసుకున్నట్టు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "ఊర్ధ్వమూలమధః శాఖమశ్వత్థం ప్రాహురవ్యయమ్ ।"
                            },
                            {
                                "des": "ఛందాంసి యస్య పర్ణాని యస్తం వేద స వేదవిత్ ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "త్రి-గుణములచే పోషించబడి, ఈ చెట్టు యొక్క శాఖలు, పైకి మరియు క్రిందికి విస్తరించి ఉంటాయి, ఇంద్రియ విషయములు వాటికి చిగుళ్ల వలె ఉంటాయి. మానవ రూపంలో కర్మ ప్రవహించటానికి, చెట్టు యొక్క వేర్లు క్రిందికి వేళ్ళాడుతూ ఉంటాయి. క్రిందిన, దాని యొక్క వేర్లు శాఖలుగా విస్తరించి, మనుష్య లోకములో కర్మలను కలుగచేస్తాయి.",
                        "description": [
                            {
                                "des": "అధశ్చోర్ధ్వం ప్రసృతాస్తస్య శాఖా"
                            },
                            {
                                "des": "గుణప్రవృద్ధా విషయప్రవాలాః ।"
                            },
                            {
                                "des": "అధశ్చమూలాన్యనుసంతతాని"
                            },
                            {
                                "des": "కర్మానుబంధీని మనుష్యలోకే ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3-4 శ్లోకాలు",
                        "bhavam": "ఈ వృక్షము యొక్క నిజ స్వరూపము ఈ జగత్తులో తెలియబడదు, దాని యొక్క మొదలు, చివర లేదా సనాతన అస్థిత్వము కూడా అర్థం కాదు. కానీ, ఈ యొక్క లోతైన వేర్లు కల అశ్వత్థ వృక్షమును అనాసక్తి/వైరాగ్యమనే బలమైన గొడ్డలిచే ఖండించివేయాలి. ఆ తరువాత ఆ వృక్షము యొక్క మొదలు వెతకాలి, అదియే ఆ భగవంతుడు, ఆయన నుండే ఈ జగత్తు యొక్క ఉత్పత్తి సనాతన కాలం క్రితం సంభవించినది. ఆయనను ఆశ్రయించిన తరువాత మళ్ళీ మనం ఈ జగత్తు లోనికి రాము.",
                        "description": [
                            {
                                "des": "న రూపమస్యేహ తథోపలభ్యతే"
                            },
                            {
                                "des": "నాంతో న చాదిర్న చ సంప్రతిష్ఠా ।"
                            },
                            {
                                "des": "అశ్వత్థమేనం సువిరూఢమూలమ్"
                            },
                            {
                                "des": "అసంగశస్త్రేణ ధృడేన ఛిత్త్వా ।। 3 ।।"
                            },
                            {
                                "des": "తతః పదం తత్పరిమార్గితవ్యం"
                            },
                            {
                                "des": "యస్మిన్ గతా న నివర్తంతి భూయః ।"
                            },
                            {
                                "des": "తమేవ చాద్యం పురుషం ప్రపద్యే"
                            },
                            {
                                "des": "యతః ప్రవృత్తిః ప్రసృతా పురాణీ ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "దురభిమానము మరియు మోహము లేకుండా ఉన్నవారు, మమకారాసక్తిని జయించినవారు, సతతమూ ఆత్మ, భగవంతుని చింతన లోనే ఉన్నవారు, ఇంద్రియ భోగములను అనుభవించాలని కోరికలు లేని వారు, సుఖదుఃఖములనెడి ద్వందములకు అతీతులై ఉన్నవారు - ఇటువంటి ముక్తజీవులు నా పరమపదమును చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "నిర్మానమోహా జితసంగదోషా"
                            },
                            {
                                "des": "ఆధ్యాత్మనిత్యా వినివృత్తకామాః ।"
                            },
                            {
                                "des": "ద్వంద్వైర్విముక్తాః సుఖదుఃఖసంజ్ఞైః"
                            },
                            {
                                "des": "గచ్ఛంత్యమూఢాః పదమవ్యయం తత్ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "సూర్యుడు కానీ, చంద్రుడు కానీ, అగ్ని కానీ ఇవేవీ నా పరం ధామమును ప్రకాశింపచేయలేవు. అక్కడికి వెళ్లిన పిదప, జనులు మరల ఈ భౌతిక లోకానికి తిరిగిరారు.",
                        "description": [
                            {
                                "des": "న తద్భాసయతే సూర్యో న శశాంకో న పావకః ।"
                            },
                            {
                                "des": "యద్గత్వా న నివర్తంతే తద్ధామ పరమం మమ ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "భౌతిక జగత్తులోఉన్న జీవాత్మలు నా యొక్క సనాతనమైన అంశలే. కానీ, భౌతిక శక్తిచే కట్టివేయబడి, వారు మనస్సుతో కలిపి ఉన్న ఆరు ఇంద్రియములతో ప్రయాస పడుతున్నారు.",
                        "description": [
                            {
                                "des": "మమైవాంశో జీవలోకే జీవభూతః సనాతనః ।"
                            },
                            {
                                "des": "మనః షష్ఠానీంద్రియాణి ప్రకృతిస్థాని కర్షతి ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "ఎలాగైతే గాలి, సుగంధమును ఒకచోటి నుండి ఇంకొక చోటికి తీస్కువెళుతుందో, జీవాత్మ కూడా, పాత శరీరమును విడిచి, కొత్త శరీరంలోనికి ప్రవేశిస్తున్నప్పుడు, మనస్సు మరియు ఇంద్రియములను తనతో పాటుగా తీసుకెళుతుంది.",
                        "description": [
                            {
                                "des": "శరీరం యదవాప్నోతి యచ్చాప్యుత్క్రామతీశ్వరః ।"
                            },
                            {
                                "des": "గృహీత్వైతాని సంయాతి వాయుర్గంధానివాశయాత్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "మనస్సును ఆశ్రయించి ఉన్న ఇంద్రియములు - చెవులు, కన్నులు, చర్మము, నాలుక మరియు ముక్కు - వీటి యొక్క గ్రహణశక్తితో, జీవాత్మ ఇంద్రియ వస్తువిషయములను ఆస్వాదిస్తుంటుంది.",
                        "description": [
                            {
                                "des": "శ్రోత్రం చక్షుః స్పర్శనం చ రసనం ఘ్రాణమేవ చ ।"
                            },
                            {
                                "des": "అధిష్ఠాయ మనశ్చాయం విషయానుపసేవతే ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "జీవాత్మను - అది ఇంద్రియ వస్తువిషములను ఆనందిస్తూ దేహములోనే ఉన్నప్పుడు కానీ లేదా అది దేహమును విడిచివెళ్లినప్పుడు కానీ - అజ్ఞానులు గమనించరు. కానీ జ్ఞాన నేత్రములు కలవారు దానిని దర్శించగలరు.",
                        "description": [
                            {
                                "des": "ఉత్క్రామంతం స్థితం వాపి భుంజానం వా గుణాన్వితమ్ ।"
                            },
                            {
                                "des": "విమూఢా నానుపశ్యంతి పశ్యంతి జ్ఞాన చక్షుషః ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "గట్టిగా పరిశ్రమించే యోగులు కూడా దేహములోనే స్థితమై ఉన్న ఆత్మను తెలుసుకోగలుగుతారు. కానీ, ఎంత ప్రయత్నించినా, అంతఃకరణ శుద్ధి లేని వారు మాత్రం దానిని తెలుసుకొనలేరు.",
                        "description": [
                            {
                                "des": "యతంతో యోగినశ్చైనం పశ్యంత్యాత్మన్యవస్థితమ్ ।"
                            },
                            {
                                "des": "యతంతోఽప్యకృతాత్మానో నైనం పశ్యంత్యచేతసః ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "సమస్త సౌర మండలమును ప్రకాశింపచేసే సూర్యుని తేజస్సుని నేనే అని తెలుసుకొనుము. చంద్రుని యొక్క ప్రకాశము మరియు అగ్ని యొక్క కాంతి నానుండే ఉద్భవిస్తున్నాయని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "యదాదిత్యగతం తేజో జగద్భాసయతేఽఖిలమ్ ।"
                            },
                            {
                                "des": "యచ్చంద్రమసి యాచ్చాగ్నౌ తత్తేజో విద్ధి మామకమ్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "పృథ్వి యందు అంతటా ప్రవేశించి వ్యాపించి ఉండి, నేను సమస్త ప్రాణులను నా శక్తి చే పోషిస్తుంటాను. చంద్రుడిగా ఉండి, సమస్త వృక్షజాతికి పుష్టిని చేకూరుస్తుంటాను.",
                        "description": [
                            {
                                "des": "గామావిశ్య చ భూతాని ధారయామ్యహమోజసా ।"
                            },
                            {
                                "des": "పుష్ణామి చౌషధీః సర్వాః సోమో భూత్వా రసాత్మకః ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "నాలుగు రకాల ఆహారమును జీర్ణము చేసుకుని మరియు ఒంటబట్టించుకొనటానికి, జీవుల ఉదరములలో ప్రాణాపానసంయుక్తమైన జఠరాగ్ని రూపమును నేనే స్వీకరిస్తాను.",
                        "description": [
                            {
                                "des": "అహం వైశ్వానరో భూత్వా ప్రాణినాం దేహమాశ్రితః ।"
                            },
                            {
                                "des": "ప్రాణాపానసమాయుక్తః పచామ్యన్నం చతుర్విధమ్ ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "నేను సమస్త ప్రాణుల హృదయములలో స్థితమై ఉన్నాను, నా నుండే జ్ఞాపకశక్తి, జ్ఞానము, మరియు విస్మృతి (మర్చిపోవుట) కలుగుతాయి. అన్ని వేదముల ద్వారా తెలుసుకోబడవలసిన వాడను నేను మాత్రమే, వేదాంత రచయితను నేనే, మరియు వేదార్ధమును తెలిసినవాడను నేనే.",
                        "description": [
                            {
                                "des": "సర్వస్య చాహం హృది సన్నివిష్టో"
                            },
                            {
                                "des": "మత్తః స్మృతిర్ జ్ఞానమపోహనం చ ।"
                            },
                            {
                                "des": "వేదైశ్చ సర్వైరహమేవ వేద్యో"
                            },
                            {
                                "des": "వేదాంతకృద్వేదవిదేవ చాహమ్ ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "సృష్టిలో రెండు రకాల ప్రాణులు ఉన్నాయి, క్షరములు (నశించేవి) మరియు అక్షరములు (నశించనివి). భౌతిక జగత్తులో ఉన్నవి క్షరములు. అక్షరములు అంటే మోక్షము పొందిన జీవులు",
                        "description": [
                            {
                                "des": "ద్వావిమౌ పురుషౌ లోకే క్షరశ్చాక్షర ఏవ చ ।"
                            },
                            {
                                "des": "క్షరః సర్వాణి భూతాని కూటస్థోఽక్షర ఉచ్యతే ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "ఇవే కాక, నాశరహితమైన పరమాత్మ అయిన, ఆ పురుషోత్తముడు, ఉన్నాడు. ఆయన అవ్యయమైన ఈశ్వరునిగా ముల్లోకములలో ప్రవేశించి, సమస్త ప్రాణులను పోషిస్తూ ఉంటాడు.",
                        "description": [
                            {
                                "des": "ఉత్తమః పురుషస్త్వన్యః పరమాత్మేత్యుదాహృతః ।"
                            },
                            {
                                "des": "యో లోకత్రయమావిశ్య బిభర్త్యవ్యయ ఈశ్వరః ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "నేను నశ్వరమైన ఈ భౌతిక పదార్ధముకంటెనూ, మరియు నాశరహితమైన జీవాత్మ కంటెనూ కూడా అతీతమైనవాడను. కాబట్టి వేదములలో మరియు స్మృతులలో నేనే సర్వోత్కృష్ట దివ్య పురుషుడి గా కీర్తింపబడ్డాను.",
                        "description": [
                            {
                                "des": "యస్మాత్ క్షరమతీతోఽహమక్షరాదపి చోత్తమః ।"
                            },
                            {
                                "des": "ఆతోఽస్మి లోకే వేదే చ ప్రథితః పురుషోత్తమః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "ఎవరైతే సంశయము లేకుండా నన్ను సర్వోత్కృష్ట పురుషోత్తమునిగా తెలుసుకుంటారో, వారికి సంపూర్ణ జ్ఞానము ఉన్నట్టు. ఓ అర్జునా, వారు హృదయపూర్వకముగా నన్నే భజింతురు.",
                        "description": [
                            {
                                "des": "యో మామేవమసమ్మూఢో జానాతి పురుషోత్తమమ్ ।"
                            },
                            {
                                "des": "స సర్వవిద్భజతి మాం సర్వభావేన భారత ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "ఓ పాపరహితుడా, అర్జునా, అత్యంత రహస్యమైన వేద శాస్త్ర మూలతత్త్వమును నేను నీకు తెలియచేసాను. దీనిని అర్థం చేసుకున్న వ్యక్తి జ్ఞాని అవుతాడు, మరియు సాధించవలసినది అంతా నెరవేర్చినవాడు అవుతాడు.",
                        "description": [
                            {
                                "des": "ఇతి గుహ్యతమం శాస్త్రామిదముక్తం మాయానఘ ।"
                            },
                            {
                                "des": "ఏతద్ బుద్ధ్వా బుద్ధిమాన్ స్యాత్ కృతకృత్యశ్చ భారత ।। 20 ।।"
                            } 
                        ]
                    }
                ]
            },
            {
                "title": "దైవాసుర సంపద్విభాగ యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/16.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/16.png'),
                "index":16,
                "introduction": [
                    {
                        "para": "ఈ అధ్యాయములో, శ్రీ కృష్ణుడు, మనుష్యులలో ఉండే రెండు రకాల స్వభావాలను వివరిస్తున్నాడు - దైవీ గుణాలు మరియు ఆసురీ గుణాలు. శాస్త్ర ఉపదేశాలను/నియమాలను పాటించటం, సత్త్వ గుణమును పెంపొందించుకోవటం, మరియు మనస్సుని ఆధ్యాత్మిక సాధనచే శుద్ధి చేసుకోవటం ద్వారా, దైవీ గుణాలు వృద్ధి చెందుతాయి. అది దైవీ సంపత్తి (దేవుని వంటి గుణములు) పెంచుకోవటానికి దోహదపడుతుంది, చిట్ట చివరగా అది భగవత్-ప్రాప్తిని కలిగిస్తుంది. దీనికి విరుద్ధంగా, ఆసురీ ప్రవృత్తి కూడా ఉంది, అది రజో గుణము, తమో గుణములతో అనుసంధానం వలన మరియు భౌతిక ప్రాపంచిక దృక్పథాన్ని అవలంబించటం వలన పెరుగుతుంది. అది మనిషి యొక్క వ్యక్తిత్వములో అపవిత్ర నడవడికను కలిగిస్తుంది, మరియు అంతిమంగా ఆత్మను నరకం వంటి స్థితిలోకి నెట్టివేస్తుంది."
                    },
                    {
                        "para": "ఈ అధ్యాయం, దివ్య స్వభావము కలిగి ఉన్న వారి యొక్క దైవీ గుణములను వివరించటంతో ప్రారంభమవుతుంది. ఆ తదుపరి, ఆసురీ (రాక్షస) గుణములను వివరిస్తుంది; వీటిని మనము జాగురూకతతో విడిచిపెట్టాలి ఎందుకంటే, అవి మన ఆత్మను మరింత అజ్ఞానము లోకి మరియు జనన-మరణ సంసారములోనికి నెట్టివేస్తాయి. శ్రీ కృష్ణుడు ఈ అధ్యాయాన్ని ముగిస్తూ - మన ఏం చేయాలి ఏం చేయకూడదు అన్న విషయం పై శాస్త్రములు చెప్పినవే ప్రమాణములు - అని అంటున్నాడు. శాస్త్ర ఉపదేశాలను మనం అర్థం చేసుకోవాలి మరియు ఆ తరువాతే, ఆ చెప్పబడిన విధంగా ఈ ప్రపంచంలో, కార్య కలాపాలు నిర్వహించాలి."
                    }
                ],
                "subtitle": [
                    {

                        "slokam": "1-3 శ్లోకాలు",
                        "bhavam": "శ్రీ భగవానుడు పలికెను : ఓ భరత వంశీయుడా, దైవీ సంపద కలవాని లక్షణములు ఇవి - నిర్భయత్వము, కల్మషం లేని మనస్సు, ఆధ్యాత్మిక జ్ఞానములో ధృఢసంకల్పము, దానము, ఇంద్రియ నిగ్రహము, యజ్ఞములను చేయుట, పవిత్ర గ్రంధ పఠనం, తపస్సు మరియు నిష్కాపట్యం; అహింస, సత్య సంధత, క్రోధము లేకుండుట, త్యాగము, శాంతి, ఇతరుల దోషములు వెతకకుండా ఉండుట, సర్వ ప్రాణులపట్ల దయ, దురాశ లేకుండుట, సౌమ్యత, అణుకువ మరియు నిశ్చలత్వము; బలము, క్షమాగుణము, మనఃస్థైర్యము, పరిశుభ్రత, ఎవరిపట్లా శత్రుత్వం లేకుండుట మరియు డాంభికము లేకుండుట.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "అభయం సత్త్వసంశుద్ధిః జ్ఞానయోగవ్యవస్థితిః ।"
                            },
                            {
                                "des": "దానం దమశ్చ యజ్ఞశ్చ స్వాధ్యాయస్తప ఆర్జవమ్ ।। 1 ।।"
                            },
                            {
                                "des": "అహింసా సత్యమక్రోధః త్యాగః శాంతిరపైశునమ్ ।"
                            },
                            {
                                "des": "దయా భూతేష్వలోలుప్త్వం మార్దవం హ్రీరచాపలమ్ ।। 2 ।।"
                            },
                            {
                                "des": "తేజః క్షమా ధృతిః శౌచమద్రోహో నాతిమానితా ।"
                            },
                            {
                                "des": "భవంతి సంపదం దైవీమభిజాతస్య భారత ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "ఓ పార్థా, దంభము, దురహంకారము, గర్వము, క్రోధము, మొరటుతనము, మరియు అజ్ఞానము అనేవి ఆసురీ స్వభావము కల వారి గుణములు.",
                        "description": [
                            {
                                "des": "దంభో దర్పోఽభిమానశ్చ క్రోధః పారుష్యమేవ చ ।"
                            },
                            {
                                "des": "అజ్ఞానం చాభిజాతస్య పార్థ సంపదమాసురీమ్ ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "దైవీ గుణములు మోక్షము దిశగా తీసుకువెళతాయి, కానీ, ఆసురీ గుణములు బంధనములో చిక్కుకుపోయి ఉండటానికి కారణమవుతాయి. బాధపడకు అర్జునా, నీవు దైవీ గుణములతోనే జన్మించావు.",
                        "description": [
                            {
                                "des": "దైవీ సంపద్విమోక్షాయ నిబంధాయాసురీ మతా ।"
                            },
                            {
                                "des": "మా శుచః సంపదం దైవీమభిజాతోఽసి పాండవ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "ఈ జగత్తులో రెండు రకాల జీవులు ఉంటారు - దైవీ గుణములు కలిగిఉన్నవారు మరియు ఆసురీ స్వభావము కలిగి ఉన్నవారు. నేను దైవీ గుణములను విస్తారముగా వివరించి ఉన్నాను, ఓ అర్జునా, ఆసురీ స్వభావమును గురించి చెప్తాను, వినుము.",
                        "description": [
                            {
                                "des": "ద్వౌ భూతసర్గౌ లోకేఽస్మిన్ దైవ ఆసుర ఏవ చ ।"
                            },
                            {
                                "des": "దైవో విస్తరశః ప్రోక్త ఆసురం పార్థ మే శృణు ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "ఆసురీ గుణములు కలవారు ఏది మంచి నడవడిక మరియు ఏది చెడు నడవడిక అని అర్థం చేసుకోరు. అందుకే వారు పవిత్రత కానీ, లేదా సత్ప్రవర్తన కానీ లేదా కనీసం సత్యసంధత కూడా కానీ కలిగి ఉండరు.",
                        "description": [
                            {
                                "des": "ప్రవృత్తిం చ నివృత్తిం చ జనా న విదురాసురాః ।"
                            },
                            {
                                "des": "న శౌచం నాపి చాచారో న సత్యం తేషు విద్యతే ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "వారు ఇలా అంటారు, 'ఈ జగత్తులో పరమ సత్యము అనేది ఏదీ లేదు, ఏ రకమైన (నైతిక నియమ) ఆధారము లేదు, మరియు భగవంతుడు (దీనిని సృష్టించింది లేదా నిర్వహించేది) అనేవాడు ఎవరూ లేరు. ఇదంతా స్త్రీ-పురుష సంయోగము వల్లనే ఉద్భవించినది మరియు లైంగిక తృప్తి కంటే వేరే ఏమీ ఇతర ప్రయోజనం లేదు.' అని.",
                        "description": [
                            {
                                "des": "అసత్యమప్రతిష్ఠం తే జగదాహురనీశ్వరమ్ ।"
                            },
                            {
                                "des": "అపరస్పరసంభూతం కిమన్యత్ కామహైతుకమ్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "ఇటువంటి దృక్పథంలో గట్టిగా ఉండి, ఈ తప్పుదోవపట్టిన జీవాత్మలు, అల్ప బుద్ధితో మరియు కౄర (ఉగ్ర) కార్యములతో, ప్రపంచానికి శత్రువులుగా మారి దానిని విధ్వసం చేయభయపెడుతారు.",
                        "description": [
                            {
                                "des": "ఏతాం దృష్టిమవష్టభ్య నష్టాత్మానోఽల్పబుద్ధయః ।"
                            },
                            {
                                "des": "ప్రభవంతి ఉగ్రకర్మాణః క్షయాయ జగతోఽహితాః ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "విపరీత కామము, దంభము, దురభిమానము తో నిండి,  గర్వము మరియు అహంకారంతో, ఈ ఆసురీ లక్షణములు కలవారు తప్పుడు సిద్ధాంతములను పట్టుకునివుంటారు. ఈ విధంగా మోహితులై, వారు తాత్కాలికమైన వాటికి ఆకర్షితమై అపవిత్ర బుద్ధితో ప్రవర్తిస్తారు.",
                        "description": [
                            {
                                "des": "కామమాశ్రిత్య దుష్పూరం దంభమానమదాన్వితాః ।"
                            },
                            {
                                "des": "మోహాద్గృహీత్వాసద్గ్రాహాన్ ప్రవర్తంతేఽశుచివ్రతాః ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "వారు అంతులేని చింతా-ఆందోళనలు చివరికి మరణం తోనే ముగుస్తాయి. అయినా సరే, వాంఛల సంతుష్టి మరియు ఆస్తి కూడగట్టుకోవటమే జీవిత పరమావధి అని నిశ్చయముగా ఉంటారు.",
                        "description": [
                            {
                                "des": "చింతామపరిమేయాం చ ప్రలయాంతాముపాశ్రితాః ।"
                            },
                            {
                                "des": "కామోపభోగపరమా ఏతావదితి నిశ్చితాః ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "వందల కొద్దీ కోరికలచే కట్టివేయబడి, మరియు కామ క్రోధములచే ఆవరించబడి, వారు అన్యాయ పద్దతులలో సంపదను ప్రోగుచేయటానికి శ్రమిస్తారు, ఇదంతా వారి ఇంద్రియ సుఖాల కోసమే.",
                        "description": [
                            {
                                "des": "ఆశాపాశశతైర్బద్ధాః కామక్రోధపరాయణాః ।"
                            },
                            {
                                "des": "ఈహంతే కామభోగార్థమ్ అన్యాయేనార్థసంచయాన్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13-15 శ్లోకాలు",
                        "bhavam": "ఆసురీ లక్షణములు కలిగిన వారు ఇలా ఆలోచిస్తారు, నేను ఈనాటికే చాలా ధనమును సంపాదించాను, నా ఈ కోరికను తీర్చుకుంటాను. ఇదంతా నాదే, రేపు నాకు ఇంకా ఉంటుంది. ఆ శత్రువు నాచే నాశనం అయిపోయాడు, నేను మిగతావారిని కూడా నాశనం చేస్తాను! నేనే స్వయంగా దేవుడి వంటి వాడిని, నేనే ఇదంతా భోగించేది, నేను శక్తిమంతుడను మరియు నేను సుఖంగా ఉన్నాను. నేను ధనవంతుడను మరియు నా బంధువులు గొప్ప హోదాలో ఉన్నారు. నాకు ఇక సాటి ఎవరు? నేను (దేవతలకు) యజ్ఞములు చేస్తాను; దానములు ఇస్తాను; ఆనందిస్తాను. ఈ విధంగా, వారు అజ్ఞానముచే మోహితులై పోతారు.",
                        "description": [
                            {
                                "des": "ఇదమద్య మయా లబ్దమ్ ఇమం ప్రాప్స్యే మనోరథమ్ ।"
                            },
                            {
                                "des": "ఇదమస్తీదమపి మే భవిష్యతి పునర్ధనమ్ ।। 13 ।।"
                            },
                            {
                                "des": "అసౌ మయా హతః శత్రుః హానిష్యే చాపరానపి ।"
                            },
                            {
                                "des": "ఈశ్వరోఽహమహం భోగీ సిద్ధోఽహం బలవాన్ సుఖీ ।। 14 ।।"
                            },
                            {
                                "des": "ఆడ్యోఽభిజనవానస్మి కోఽన్యోఽస్తి సదృశో మయా ।"
                            },
                            {
                                "des": "యక్ష్యే దాస్యామి మోదిష్య ఇత్యజ్ఞానవిమోహితాః ।। 15 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ఇటువంటి ఊహలు, తలపులతో తప్పుదారి పట్టి, మోహమనే వలలో చిక్కుకుపోయి, మరియు ఇంద్రియములను తృప్తి పరచటానికకే బానిసైపోయి, వారు అధోః నరకాలకు పతనమై పోతారు.",
                        "description": [
                            {
                                "des": "అనేకచిత్తవిభ్రాంతాః మోహజాలసమావృతాః ।"
                            },
                            {
                                "des": "ప్రసక్తాః కామభోగేషు పతంతి నరకేఽశుచౌ ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "ఇటువంటి స్వార్ధ-చింతనతో ఉన్న మూర్ఖపు మనుషులు, తమ ధనము, సంపదచే గర్వము, అహంకారముతో నిండి, శాస్త్ర నియమముల పట్ల ఏమాత్రం గౌరవం లేకుండా నామమాత్రంగా ఆడంబరంగా యజ్ఞములు చేస్తారు.",
                        "description": [
                            {
                                "des": "ఆత్మసంభావితాః స్తబ్ధా ధనమానమదాన్వితాః ।"
                            },
                            {
                                "des": "యజంతే నామయజ్ఞైస్తే దంభేనావిధిపూర్వకమ్ ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "అహంకారము, బలము, గర్వము, కామము, మరియు కోపముచే కళ్ళుమూసుకు పోయి, ఈ అసురీ ప్రవృత్తి కలవారు, తమ దేహములో మరియు ఇతరుల దేహములో కూడా ఉన్న నన్ను దుర్భాషలాడుతూ/ద్వేషిస్తూ ఉంటారు.",
                        "description": [
                            {
                                "des": "అహంకారం బలం దర్పం కామం క్రోధం చ సంశ్రితాః ।"
                            },
                            {
                                "des": "మామాత్మపరదేహేషు ప్రద్విషంతోఽభ్యసూయకాః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19-20 శ్లోకాలు",
                        "bhavam": "కౄరులు మరియు ద్వేషపూరిత స్వభావము కలవారు, అధములు, నీచ నరులను, నేను, భౌతిక జగత్తు యొక్క పునర్జన్మ చక్రములో,  పదే పదే అటువంటి ఆసురీ స్వభావము కలవారి గర్భములోనే విసిరివేస్తుంటాను. ఈ మూర్ఖపు ఆత్మలు మళ్ళీ మళ్ళీ ఆసురీ గర్భములలోనే జన్మిస్తుంటాయి. నన్ను చేరుకోలేక, ఓ అర్జునా, అత్యంత నీచ స్థాయి జీవనంలోనికి క్రమేపీ పడిపోతాయి.",
                        "description": [
                            {
                                "des": "తానహం ద్విషతః క్రూరాన్ సంసారేషు నరాధమాన్ ।"
                            },
                            {
                                "des": "క్షిపామ్యజస్రమశుభానాసురీష్వేవ యోనిషు ।। 19 ।।"
                            },
                            {
                                "des": "ఆసురీం యోనిమాపన్నా మూఢా జన్మని జన్మని ।"
                            },
                            {
                                "des": "మామప్రాప్యైవ కౌంతేయ తతో యాంత్యధమాం గతిమ్ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "ఆత్మ వినాశనానికి దారి తీసే నరక ద్వారములు మూడు ఉన్నాయి - కామము, క్రోధము, మరియు లోభము. కాబట్టి, అందరూ వీటిని విడిచిపెట్టాలి.",
                        "description": [
                            {
                                "des": "త్రివిధం నరకస్యేదం ద్వారం నాశనమాత్మనః ।"
                            },
                            {
                                "des": "కామః క్రోధస్తథా లోభస్తస్మాదేతత్త్రయం త్యజేత్ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "చీకటి దిశగా ఉన్న ఈ మూడు ద్వారముల నుండి ముక్తి పొందిన వారు, ఆత్మ శ్రేయస్సుకై పరిశ్రమిస్తారు, తద్వారా  వారు  పరమ లక్ష్యమును పొందుతారు",
                        "description": [
                            {
                                "des": "ఏతైర్విముక్తః కౌంతేయ తమోద్వారైః త్రిభిర్నరః ।"
                            },
                            {
                                "des": "ఆచరత్యాత్మనః శ్రేయః తతో యాతి పరాం గతిమ్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఎవరైతే శాస్త్రములో చెప్పబడిన ఆదేశములను కాదని, కామ ప్రేరితులై ప్రవర్తిస్తారో, వారు పరిపూర్ణ సిద్ధిని  కానీ, సుఖానందమును కానీ, చివరకి జీవిత పరమ లక్ష్యమును కానీ సాధించలేరు.",
                        "description": [
                            {
                                "des": "యః శాస్త్రవిధిముత్సృజ్య వర్తతే కామకారతః ।"
                            },

                            {
                                "des": "న స సిద్ధిమవాప్నోతి న సుఖం న పరాం గతిమ్ ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "కాబట్టి, ఏది చేయాలి ఏది చేయకూడదు అన్న విషయంలో శాస్త్రములనే ప్రమాణముగా తీసుకొనుము. శాస్త్ర విధివిధానాలు, ఉపదేశాలను తెలుసుకొనుము మరియు ఆ విధంగానే ఈ జగత్తులో ప్రవర్తించుము.",
                        "description": [
                            {
                                "des": "తస్మాచ్ఛాస్త్రం ప్రమాణంతే కార్యాకార్యవ్యవస్థితౌ ।"
                            },
                            {
                                "des": "జ్ఞాత్వా శాస్త్రవిధానోక్తం కర్మ కర్తుమిహార్హసి ।। 24 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "శ్రద్ధా త్రయ విభాగ యోగము",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/17.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/17.png'),
                "index":17,
                "introduction": [
                    {
                        "para": "పదునాలుగవ అధ్యాయములో, శ్రీ కృష్ణుడు భౌతిక ప్రకృతి యొక్క త్రిగుణములను వివరించి ఉన్నాడు మరియు అవి మనుష్యులను ఏవిధంగా ప్రభావితం చేస్తాయో కూడా చెప్పాడు. ఈ పదిహేడవ అధ్యాయములో, ఈ త్రిగుణముల యొక్క ప్రభావము గురించి మరింత విస్తారముగా వివరిస్తున్నాడు. మొదటిగా, విశ్వాసము/శ్రద్ధ అనే విషయం గురించి వివరిస్తూ, ఎవ్వరూ కూడా విశ్వాస రహితముగా ఉండరు అని చెప్తున్నాడు, ఎందుకంటే అది మానవ నైజం యొక్క విడదీయలేని భాగము. కానీ, వారివారి మనస్తత్వం బట్టి, జనుల యొక్క విశ్వాసము (faith) అనేది, సాత్త్విక, రాజసిక , లేదా తామసిక రంగును కలిగిఉంటుంది. వారికి ఏ రకమైన విశ్వాసము ఉంటుందో వారి జీవితం కూడా ఆ రకంగానే ఉంటుంది. జనులకు ఆహారం పట్ల కూడా వారివారి గుణములకు అనుగుణంగానే మక్కువ ఉంటుంది. శ్రీ కృష్ణుడు ఆహారాన్ని మూడు రకాలుగా వర్గీకరిస్తూ, మనపై వీటి యొక్క ప్రభావాన్ని వివరిస్తున్నాడు. ఆ తరువాత, కృష్ణుడు యజ్ఞముల గురించి చెప్తూ, ఈ మూడు ప్రకృతి త్రిగుణముల లో, యజ్ఞములు వేర్వేరు రకాలుగా ఏ విధంగా ఉంటాయో వివరిస్తాడు. ఆ తర్వాత ఈ అధ్యాయము 'తపస్సు' అనే విషయం వైపు వెళుతుంది మరియు శరీర తపస్సు, వాక్ తపస్సు మరియు మనోతపస్సు లను వివరిస్తుంది. ఈ మూడు తపస్సులు సత్త్వ-రజ జ-తమో గుణములచే ప్రభావితం అయినప్పుడు అవి వేర్వేరు స్వరూపములలో మారతాయి. ఆ తరువాత 'దానము' అనే విషయం చర్చించబడుతుంది, మరియు దాని యొక్క మూడు రకాల విభాగములు వివరించబడుతాయి."
                    },
                    {
                        "para": "చివరగా, శ్రీ కృష్ణుడు త్రి-గుణములకు అతీతముగా వెళ్లి, ఓం తత్ సత్ అన్న పదముల యొక్క ప్రాముఖ్యత మరియు అర్థమును వివరిస్తాడు; ఇది పరమ సత్యము యొక్క విభిన్న అస్థిత్వములను సూచిస్తుంది. ఓం అంటే, ఈశ్వరుని నిరాకార తత్వమును సూచిస్తుంది; తత్ అంటే, పరమేశ్వరుని కొరకు చేసే కార్యములు మరియు కర్మ కాండలును పవిత్రం చేయటానికి ఉచ్చరించబడుతుంది. సత్ అంటే, నిత్య సనాతన శుభకరము మరియు మంగళము. ఈ మూడు కలిపి అన్నప్పుడు ఒక అలౌకిక సర్వోత్కృష్టతను కలిగిస్తాయి. శాస్త్ర నియమాలను పట్టించుకోకుండా చేయబడే యజ్ఞము, తపస్సు మరియు దానముల యొక్క నిరర్థకతని వివరిస్తూ ఈ అధ్యాయం ముగుస్తుంది."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "అర్జునుడు ఇలా అన్నాడు : ఓ కృష్ణా, శాస్త్ర విధులను త్యజించి (విస్మరించి) ఉండి, అయినా శ్రద్ధావిశ్వాసములతో పూజలు చేసే వారి యొక్క స్థితి ఎలా ఉంటుంది? వారి యొక్క విశ్వాసము సత్త్వ గుణం లో ఉంటుందా లేదా రజో, తమో గుణములలో ఉంటుందా?",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "యే శాస్త్రవిధిముత్సృజ్య యజంతే శ్రద్దయాన్వితాః ।"
                            },
                            {
                                "des": "తేషాం నిష్ఠా తు కా కృష్ణ సత్వమాహో రజస్తమః ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను : ప్రతి ఒక్క మానవుడు తన సహజసిద్ధ శ్రద్ధ/విశ్వాసము తో జన్మిస్తాడు, ఇది మూడు రకాలుగా - సాత్త్వికము, రాజసము, లేదా తామసము - గా ఉండవచ్చు. ఇప్పుడు ఇక ఈ విషయంపై నానుండి వినుము.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "త్రివిధా భవతి శ్రద్ధా దేహినాం సా స్వభావజా ।"
                            },
                            {
                                "des": "సాత్త్వికీ రాజసీ చైవ తామసీ చేతి తాం శృణు ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "అందరు మనుష్యులు తమ మనస్సు యొక్క స్వభావమునకు తగ్గట్టుగా శ్రద్ధావిశ్వాసములను కలిగి ఉంటారు. అందరికీ శ్రద్ధావిశ్వాసములు ఉంటాయి, మరియు వారి విశ్వాసము ఎట్టిదో అదే వారి వ్యక్తిత్వము గా ఉంటుంది.",
                        "description": [
                            {
                                "des": "సత్త్వానురూపా సర్వస్య శ్రద్ధా భవతి భారత ।"
                            },
                            {
                                "des": "శ్రద్ధామయోఽయం పురుషో యో యచ్చ్రద్ధః స ఏవ సః"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "సత్త్వ గుణములో ఉండేవారు దేవతలను ఆరాధిస్తారు; రజోగుణములో ఉండేవారు యక్షులను, రాక్షసులను పూజిస్తారు; తమో గుణములో ఉండేవారు భూత ప్రేతములను ఆరాధిస్తారు.",
                        "description": [
                            {
                                "des": "యజంతే సాత్త్వికా దేవాన్ యక్షరక్షాంసి రాజసాః ।"
                            },
                            {
                                "des": "ప్రేతాన్ భూతగణాంశ్చాన్యే యజంతే తామసా జనాః ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5-6 శ్లోకాలు",
                        "bhavam": "కొంతమంది జనులు, అత్యంత కఠినమైన తపస్సులను, శాస్త్రవిరుద్ధమైనా, తమ దంభం(కపటత్వం) మరియు అహంకారముచే ప్రేరితులై చేస్తారు. కామము మరియు మమకారముచే ప్రేరితులై, వారు తమ శరీర అవయములనే కాక, వారి శరీరములోనే పరమాత్మగా ఉన్న నన్ను కూడా క్షోభ పెడతారు. ఇటువంటి బుద్ధిహీనులు ఆసురీ గుణసంకల్పంతో ఉన్నవారని తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "అశాస్త్రవిహితం ఘోరం తప్యంతే యే తపో జనాః ।"
                            },
                            {
                                "des": "దంభాహంకారసంయుక్తాః కామరాగబలాన్వితాః ।। 5 ।।"
                            },
                            {
                                "des": "కర్షయంతః శరీరస్థం భూతగ్రామమచేతసః ।"
                            },
                            {
                                "des": "మాం చైవాంతః శరీరస్థం తాన్ విద్ధ్యాసురనిశ్చయాన్ ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "వ్యక్తులు ఇష్టపడే ఆహారము వారి వారి స్వభావానుసారం ఉంటుంది. యజ్ఞములు, తపస్సు, మరియు దానములు కూడా వారియొక్క ప్రవృత్తి బట్టి ఉంటాయి. ఇప్పుడిక ఈ బేధముల గురించి వినుము.",
                        "description": [
                            {
                                "des": "ఆహారస్త్వపి సర్వస్య త్రివిధో భవతి ప్రియః ।"
                            },
                            {
                                "des": "యజ్ఞస్తపస్తథా దానం తేషాం భేదమిమం శృణు ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "సత్త్వగుణ ప్రధానముగా ఉండేవారు - ఆయుష్షుని పెంచేవి, మరియు సౌశీల్యమును, బలమును, ఆరోగ్యమును, సుఖమును, మరియు తృప్తిని పెంచేవాటిని ఇష్టపడుతారు. ఇటువంటి ఆహారము రసముతో, సత్తువతో, పోషకములతో కూడినవై, మరియు సహజంగానే రుచిగా ఉంటాయి.",
                        "description": [
                            {
                                "des": "ఆయుః సత్త్వబలారోగ్యసుఖప్రీతివివర్ధనాః ।"
                            },
                            {
                                "des": "రస్యాః స్నిగ్ధాః స్థిరా హృద్యా ఆహారాః సాత్త్వికప్రియాః ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "అతి చేదుగా, అతి పుల్లగా, ఉప్పగా, చాలా వేడిగా, ఘాటుగా, ఎండిపోయిన మరియు కారంగా ఉన్న ఆహార పదార్ధములు రజో గుణ ప్రధానముగా ఉండే వారికి ఇష్టముగా ఉంటాయి. ఇటువంటి ఆహారములు బాధను, శోకమును మరియి వ్యాధులను కలుగ చేస్తాయి.",
                        "description": [
                            {
                                "des": "కట్వమ్లలవణాత్యుష్ణతీక్ష్ణరూక్షవిదాహినః ।"
                            },
                            {
                                "des": "ఆహారా రాజసస్యేష్టా దుఃఖశోకామయప్రదాః ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "ఎండిపోయిన/మాడిపోయిన ఆహారము, మురిగిపోయిన ఆహారము, కలుషితమైన మరియు అపరిశుద్ధ ఆహారము - తామసీ గుణము ప్రధానముగా ఉన్నవారికి ప్రియముగా ఉంటాయి.",
                        "description": [
                            {
                                "des": "యాతయామం గతరసం పూతి పర్యుషితం చ యత్ ।"
                            },
                            {
                                "des": "ఉచ్ఛిష్టమపి చామేధ్యం భోజనం తామసప్రియమ్ ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "ఫలాపేక్ష లేకుండా శాస్త్ర విధినియమములను పాటిస్తూ, ఇది చేయవలసిన కర్తవ్యము అని మనస్సులో ధృఢ సంకల్పము తో, చేసిన యజ్ఞము సత్త్వ గుణము తో చేయబడినట్టు.",
                        "description": [
                            {
                                "des": "అఫలాకాంక్షిభిర్యజ్ఞో విధిదృష్టో య ఇజ్యతే ।"
                            },
                            {
                                "des": "యష్టవ్యమేవేతి మనః సమాధాయ స సాత్త్వికః ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "ఓ, భరత శ్రేష్ఠుడా, ప్రాపంచిక లాభము కోసము లేదా అహంకారముతో చేయబడిన యజ్ఞము, రజోగుణములో ఉన్నట్టు తెలుసుకొనుము.",
                        "description": [
                            {
                                "des": "అభిసంధాయ తు ఫలం దంభార్థమపి చైవ యత్ ।"
                            },
                            {
                                "des": "ఇజ్యతే భరతశ్రేష్ఠ తం యజ్ఞం విద్ధి రాజసమ్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "శ్రద్ధావిశ్వాసములు లేకుండా మరియు శాస్త్ర నియమాల విరుద్ధంగా, ప్రసాదవితరణ చేయకుండా, మంత్రములు జపించకుండా, మరియు దక్షిణ ఇవ్వకుండా చేయబడిన యజ్ఞము, తమో గుణములో ఉన్నది అని పరిగణించబడును.",
                        "description": [
                            {
                                "des": "విధిహీనమసృష్టాన్నం మంత్రహీనమదక్షిణమ్ ।"
                            },
                            {
                                "des": "శ్రద్ధావిరహితం యజ్ఞం తామసం పరిచక్షతే ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "పరమేశ్వరుడు, బ్రాహ్మణులు, ఆధ్యాత్మిక గురువు, జ్ఞానులు మరియు పెద్దలు - వీరి ఆరాధన, శుచి, నిష్కాపట్యము, బ్రహ్మచర్యం, అహింస ఆచరిస్తూ ఎప్పుడైతే చేయబడుతాయో - అది శారీరిక తపస్సు అని చెప్పబడును.",
                        "description": [
                            {
                                "des": "దేవద్విజగురుప్రాజ్ఞపూజనం శౌచమార్జవమ్ ।"
                            },
                            {
                                "des": "బ్రహ్మచర్యమహింసా చ శారీరం తప ఉచ్యతే ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15 వ శ్లోకం",
                        "bhavam": "ఉద్వేగమును కలిగించని మాటలు, సత్యములు, కోపము పుట్టించనివి, ప్రియ హితమైనవి మరియు నిత్య వేద శాస్త్రముల పఠనము - ఇవి వాక్కు సంబంధమైన తపస్సు అని చెప్పబడుతున్నది.",
                        "description": [
                            {
                                "des": "అనుద్వేగకరం వాక్యం సత్యం ప్రియహితం చ యత్ ।"
                            },
                            {
                                "des": "స్వాధ్యాయాభ్యసనం చైవ వాజ్ఞ్మయం తప ఉచ్యతే ।। 15 ।।"
                            }
                        ]
                    },
                
                    {
                        "slokam": "16 వ శ్లోకం",
                        "bhavam": "ఆలోచనలో ప్రశాంతత, మృదుత్వము, మౌనము, ఆత్మ-నిగ్రహము మరియు భావములో పవిత్రత - ఇవన్నీ మనస్సు యొక్క తపస్సు అని పేర్కొనబడినాయి.",
                        "description": [
                            {
                                "des": "మనః ప్రసాదః సౌమ్యత్వం మౌనమాత్మవినిగ్రహః ।"
                            },
                            {
                                "des": "భావసంశుద్ధిరిత్యేతత్ తపో మానసముచ్యతే ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "భక్తి శ్రద్ధలు కల వ్యక్తులు అత్యంత విశ్వాసముతో ఈ మూడు తపస్సులను, భౌతిక ప్రతిఫలాలను ఆశించకుండా ఆచరిస్తే, వాటిని సాత్త్విక తపస్సులు అని అంటారు.",
                        "description": [
                            {
                                "des": "శ్రద్ధయా పరయా తప్తం తపస్తత్ త్రివిధం నరైః ।"
                            },
                            {
                                "des": "అఫలాకాంక్షిభిర్యుక్తైః సాత్త్వికం పరిచక్షతే ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "కీర్తిప్రతిష్టలు, గౌరవము, మరియు గొప్పల కోసం, ఆడంబరంగా చేసే తపస్సు/యజ్ఞములు రజో గుణములో ఉన్నట్టు. దాని యొక్క ప్రయోజనములు అస్థిరమైనవి, మరియు తాత్కాలికమైనవి.",
                        "description": [
                            {
                                "des": "సత్కారమానపూజార్థం తపో దంభేన చైవ యత్ ।"
                            },
                            {
                                "des": "క్రియతే తదిహ ప్రోక్తం రాజసం చలమధ్రువమ్ ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "అయోమయ భావాలతో, తమని తామే హింసపెట్టుకుని లేదా ఇతరులకు హాని కలిగించటం కోసం చేయబడే తపస్సు, తమో గుణములో ఉన్నట్టు చెప్పబడినది.",
                        "description": [
                            {
                                "des": "మూఢగ్రాహేణాత్మనో యత్పీడయా క్రియతే తపః ।"
                            },
                            {
                                "des": "పరస్యోత్సాదనార్థం వా తత్తామసముదాహృతమ్ ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "దానము చేయుట కర్తవ్యము (సరియైన పని) అని భావించి, తగిన పాత్రత ఉన్నవాడికి, ప్రతిఫలాపేక్ష లేకుండా, సరియైన సమయంలో, సరియైన ప్రదేశంలో దానము చేయుట అనేది సత్త్వగుణ దానము అని చెప్పబడుతుంది.",
                        "description": [
                            {
                                "des": "దాతవ్యమితి యద్దానం దీయతేఽనుపకారిణే ।"
                            },
                            {
                                "des": "దేశే కాలే చ పాత్రే చ తద్దానం సాత్త్వికం స్మృతమ్ ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "అయిష్టముగా ఇవ్వబడిన దానము, ఎదో తిరిగి వస్తుందనే ఆశతో లేదా ప్రతిఫలము ఆశించి ఇవ్వబడిన దానము రజో గుణములో ఉన్నదని చెప్పబడినది.",
                        "description": [
                            {
                                "des": "యత్తు ప్రత్యుపకారార్థం ఫలముద్దిశ్య వా పునః ।"
                            },
                            {
                                "des": "దీయతే చ పరిక్లిష్టం తద్ధానం రాజసం స్మృతమ్ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "అనుచిత ప్రదేశంలో, సరికాని సమయంలో, అర్హతలేనివారికి (అపాత్రులకు), మర్యాద చూపకుండా, లేదా చులకనగా ఇవ్వబడిన దానము, తామసదానము గా పరిగణించబడుతుంది.",
                        "description": [
                            {
                                "des": "అదేశకాలే యద్ధానమ్ అపాత్రేభ్యశ్చ దీయతే ।"
                            },
                            {
                                "des": "అసత్కృతమవజ్ఞాతం తత్తామసముదాహృతమ్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "'ఓం తత్ సత్' అన్న పదములు, సృష్టి మొదలు నుండి, పరబ్రహ్మమునకు సూచికగా నిర్దేశించబడినవి. వాటి నుండే పురోహితులు, శాస్త్రములు మరియు యజ్ఞములు ఏర్పడినవి.",
                        "description": [
                            {
                                "des": "ఓం తత్సదితి నిర్దేశో బ్రహ్మణస్త్రివిధః స్మృతః ।"
                            },
                            {
                                "des": "బ్రాహ్మణాస్తేన వేదాశ్చ యజ్ఞాశ్చ విహితాః పురా ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "కాబట్టి, యజ్ఞములు చేయటంలో, దానము ఇవ్వటంలో, తపస్సులు ఆచరించటం లో - వేద విదులు, వైదిక ఉపదేశాలను అనుసరిస్తూ, ఎల్లప్పుడూ 'ఓం' అనే శబ్దమును ఉచ్చరిస్తూ ప్రారంభిస్తారు.",
                        "description": [
                            {
                                "des": "తస్మాద్ ఓం ఇత్యుదాహృత్య యజ్ఞదానతపఃక్రియాః ।"
                            },
                            {
                                "des": "ప్రవర్తంతే విధానోక్తాః సతతం బ్రహ్మావాదినామ్ ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "ప్రతి-ఫలములను ఆశించని వారు, కానీ, ఈ భౌతిక బంధనముల నుండి విముక్తి పొందటానికి ప్రయిత్నించే వారు, తపస్సు, యజ్ఞము, మరియు దానము చేసేటప్పుడు 'తత్' అన్న పదమును ఉచ్చరిస్తారు.",
                        "description": [
                            {
                                "des": "తదిత్యనభిసంధాయ ఫలం యఙ్ఞతపఃక్రియాః ।"
                            },
                            {
                                "des": "దానక్రియాశ్చ వివిధాః క్రియంతే మోక్షకాంక్షిభిః ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26-27 శ్లోకాలు",
                        "bhavam": "సత్' అన్న పదానికి అర్థం - సనాతనమైన అస్థిత్వము మరియు మంగళప్రదము అని. ఓ అర్జునా, అది శుభప్రదమైన కార్యమును సూచించటానికి కూడా వాడబడుతుంది. యజ్ఞము, తపస్సు, మరియు దానములు ఆచరించుటలో నిమగ్నమవ్వటాన్ని కూడా ఈ 'సత్' అన్న పదము వివరిస్తుంది. కావున, ఈ ప్రయోజనము తో ఉన్న ఏ పని అయినా 'సత్' అనబడుతుంది.",
                        "description": [
                            {
                                "des": "సద్భావే సాధుభావే చ సదిత్యేతత్ప్రయుజ్యతే ।"
                            },
                            {
                                "des": "ప్రశస్తే కర్మణి తథా సచ్ఛబ్దః పార్థ యుజ్యతే ।। 26 ।।"
                            },
                            {
                                "des": "యజ్ఞే తపసి దానే చ స్థితిః సదితి చోచ్యతే ।"
                            },
                            {
                                "des": "కర్మ చైవ తదర్థీయం సదిత్యేవాభిధీయతే ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "ఓ ప్రిథ పుత్రుడా, అశ్రద్దతో చేయబడిన దానములు కానీ, యజ్ఞములు కానీ 'అసత్' అని చెప్పబడును. అవి ఈ లోకమున కానీ లేదా పరలోకమున కానీ ఎటువంటి ప్రయోజనాన్ని చేకూర్చవు.",
                        "description": [
                            {
                                "des": "అశ్రద్ధయా హుతం దత్తం తపస్తప్తం కృతం చ యత్ ।"
                            },
                            {
                                "des": "అసదిత్యుచ్యతే పార్థ న చ తత్ప్రేత్య నో ఇహ ।। 28 ।।"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "మోక్ష సన్యాస యోగము ",
                "introTitle": "యోగము వివరణ",
                // "Image": require('../../Utils/LoadIcons/18.png'),
                // "PreviewImage":require('../../Utils/ImagePreview/18.png'),
                "index":18,
                "introduction": [
                    {
                        "para": "ఈ భగవద్గీత యొక్క చిట్టచివరి అధ్యాయము మిగతా అన్ని అధ్యాయాల కన్నా దీర్ఘమైనది మరియు ఇది చాలా విషయములను వివరిస్తుంది. అర్జునుడు సన్యాసము అనే విషయాన్ని ప్రారంభిస్తూ, సంస్కృతంలో సాధారణంగా వాడే పదాలైన సన్యాసము (కర్మలను త్యజించటం) మరియు త్యాగము (కోరికలను త్యజించటం) అన్న వాటి గురించి ఒక ప్రశ్న అడుగుతాడు. ఈ రెండు పదాలు త్యజించటం అన్న అర్థం లో ఉన్న మూల పదముల నుండే జనించాయి. సన్యాసి అంటే కుంటుంబపర జీవితంలో పాలుపంచుకోకుండా సాధనా కోసము సమాజము నుండి తనను తాను ఉపసంహరించుకుంటాడు. త్యాగి అంటే కార్యకలాపాలు చేస్తుంటాడు కానీ, కర్మ ఫలములను అనుభవించాలనే స్వార్ధ చింతనను విడిచిపెట్టినవాడు. (భగవద్గీత లో చెప్పబడిన అర్థం ఇది). శ్రీ కృష్ణుడు రెండవ రకం సన్యాసాన్ని సిఫారసు చేస్తున్నాడు. యజ్ఞము, దానము, తపస్సు మరియు ఇతర ధార్మిక కర్తవ్య కార్యములను ఎప్పుడూ త్యజించకూడదు అంటున్నాడు, ఎందుకంటే అవి జ్ఞానోదయులను కూడా పవిత్రం చేస్తాయి. వాటి పట్ల ఫలాసక్తి లేకుండా, అవి చేయబడాలి కాబట్టి వాటిని మన కర్తవ్యంలా భావించి చేయాలి."
                    },
                    {
                        "para": "తదుపరి, శ్రీ కృష్ణుడు కర్మను ప్రేరేపించే మూడు విషయముల గురించి, కర్మ యొక్క మూడు అంగముల గురించి, కర్మ ఫలములను నిర్ణయించే ఐదు విషయముల గురించి విస్తారమైన విశ్లేషణ అందచేస్తాడు. వీటన్నిటిని త్రిగుణముల పరంగా వివరిస్తాడు. అపరిపూర్ణ జ్ఞానము కలవారు, వారే తమ కర్మల (కార్యముల) కారణము (చేస్తున్నది) అని భావిస్తారు. కానీ జ్ఞానోదయమైన మహాత్ములు, అంతఃకరణ శుద్ధి కలవారై, చేసేది తాముకాదు మరియు ఆ కర్మఫలముకు భోక్త తాము కాదు అని తెలుసుకుంటారు. సతతమూ తమ కర్మ ఫలముల పట్ల అనాసక్తత తో ఉంటూ, వారు కర్మ బంధములలో చిక్కుకోరు. జనులు తమ ఉద్దేశాలు, కార్యకలాపాలలో ఎందుకు విభిన్నరకాలుగా ఉంటారో ఈ అధ్యాయం తదుపరి వివరిస్తుంది. భౌతిక ప్రకృతి యొక్క త్రిగుణముల ప్రకారంగా - వివిధ రకాల జ్ఞానములను, వివిధ రకాల పనులను, మరియు అవి చేసే వారి వివిధ రకాల స్వభావములను ఈ అధ్యాయం వివరిస్తుంది. అదే విశ్లేషణను - బుద్ధి, సంకల్పము మరియు ఆనందము - పట్ల కూడా ఈ అధ్యాయం అందిస్తుంది. తదుపరి ఈ అధ్యాయము, ఆధ్యాత్మిక జీవనంలో పరిపూర్ణ సిద్ధి సాధించి, బ్రహ్మ-జ్ఞానము లో స్థితులై ఉన్నవారిని వివరిస్తుంది. అటువంటి పరిపూర్ణ యోగులు కూడా తమ సిద్ధిలో పరిపూర్ణతని భక్తిలో నిమగ్నమవ్వటం ద్వారా అనుభవిస్తారు. ఈ విధంగా, సర్వోన్నత దివ్య మంగళ స్వరూప భగవంతుని యొక్క యదార్థ రహస్యమును ప్రేమయుక్త భక్తి ద్వారా మాత్రమే తెలుసుకోగలము.1"
                    },
                    {
                        "para": "భగవంతుడు సర్వ భూతముల హృదయములో స్థితుడై ఉంటాడని, మరియు వాటి వాటి కర్మానుసారం వారిని త్రిప్పుతుంటాడని, శ్రీ కృష్ణుడు అర్జునుడికి గుర్తుచేస్తాడు. భగవంతుడినే స్మరిస్తూ, మన అన్ని కార్యకలాపములను ఆయనకే అర్పితం చేసి, ఆయనను ఆశ్రయం పొంది, ఆయనే మన పరమ లక్ష్యముగా చేసుకుంటే, ఆ తదుపరి ఆయన కృప ద్వారా మనము అన్ని క్లేశములను, అవరోధాలను అధిగమించగలము. కానీ, దురభిమానంతో, మన ఇష్టంవచ్చినట్టు ప్రవర్తిస్తే, మనకు విజయం/సఫలత లభించదు. చిట్టచివరికి శ్రీ కృష్ణుడు అత్యంత గుహ్యమైన జ్ఞానమును తెలియచేస్తూ, సర్వ ధర్మములనూ త్యజించి కేవలం భగవంతునికే శరణాగతి చేయమంటున్నాడు. కానీ, ఈ జ్ఞానమును సాధుచిత్తులూ, భక్తులు కాని వారికి ఇవ్వకూడదు అని అంటున్నాడు, ఎందుకంటే దానిని వారు తప్పుగా అర్థం చేసుకుని, బాధ్యతారహితముగా కర్మలను పరిత్యాగం చేసే ప్రమాదం ఉంటుంది. కానీ, ఈ రహస్య జ్ఞానమును అర్హులైన జీవులకు అందిస్తే, అది అత్యున్నత ప్రేమతో చేసేపని అవుతుంది మరియు అది భగవంతునికి అత్యంత ప్రీతికరమయినది."
                    },
                    {
                        "para": "తన మోహము/భ్రాంతి నిర్మూలించబడినవి అని, తాను ఇప్పుడు, చెప్పినట్టు చేయటానికి తయారుగా ఉన్నానని అర్జునుడు ఆ తరువాత శ్రీ కృష్ణుడికి తెలియచేస్తాడు. చివరలో, అంధుడైన ధృతరాష్ట్ర మహారాజుకి ఈ (కృష్ణార్జున) సంవాదమును వినిపిస్తున్న సంజయుడు, ఆ దివ్య సంభాషణను వింటూ తాను ఎంత ఆశ్చర్యానికి, దిగ్భ్రమానికి లోనయ్యాడో చెప్తాడు. ఆ యొక్క పవిత్ర సంభాషణని, మరియు మహాద్భుత విశ్వరూపమును గుర్తుచేసుకుంటే ఆయన యొక్క రోమములు మహదానందముతో నిక్కబొడుచుకుంటాయి. భగవంతుడు మరియు ఆయన పరిశుద్ధ భక్తుడు ఎక్కడుంటే, వారి పక్షమే విజయం ఎల్లప్పుడూ ఉంటుంది; అంతేకాక, శుభమూ, విజయమూ, మరియు ఐశ్వర్యమూ కూడా వారి వద్దే ఉంటుంది, ఎందుకంటే అసత్యపు చీకటి ఖచ్చితంగా పరమ సత్యము యొక్క వెలుగుచే నిర్మూలించబడుతుంది - అనే ఒక గంభీరమైన ప్రకటనతో సంజయుడు దీనిని ముగిస్తున్నాడు."
                    }
                ],
                "subtitle": [
                    {
                        "slokam": "1 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : ఓ మహాబాహువులు కల కృష్ణా, 'సన్యాసము' (కర్మలను త్యజించటము) మరియు 'త్యాగము' (కర్మఫలములను భోగించాలనే కోరికను త్యజించటమూ) ల యొక్క స్వభావాన్ని తెలుసుకోవాలనుకుంటున్నాను. ఓ హృషీకేశా, వాటి మధ్య తేడాని కూడా తెలుసుకోవాలని కోరిక ఉన్నది, ఓ కేశినిషూదనా.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "సన్న్యాసస్య మహాబాహో తత్త్వమిచ్ఛామి వేదితుమ్ ।"
                            },
                            {
                                "des": "త్యాగస్య చ హృషీకేశ పృథక్ కేశినిషూదన ।। 1 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "2 వ శ్లోకం",
                        "bhavam": "శ్రీ భగవానుడు ఇలా పలికెను : కోరికలచే ప్రేరితమైన కర్మలను త్యజించటమే సన్యాసము అని జ్ఞానసంపన్నులు అన్నారు. సమస్త కర్మల ఫలములను విడిచిపెట్టటమే పండితులు త్యాగము అని అన్నారు.",
                        "description": [
                            {
                                "des": "శ్రీ భగవానువాచ ।"
                            },
                            {
                                "des": "కామ్యానాం కర్మణాం న్యాసం సన్న్యాసం కవయో విదుః ।"
                            },
                            {
                                "des": "సర్వకర్మఫలత్యాగం ప్రాహుస్త్యాగం విచక్షణాః ।। 2 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "3 వ శ్లోకం",
                        "bhavam": "కొంతమంది జ్ఞానసంపన్నులు అన్ని రకముల కర్మలను దోషభూయిష్టమైనవి అని వాటిని విడిచిపెట్టాలి అంటారు, అదే సమయంలో మరికొంతమంది, యజ్ఞము, దానము మరియు తపస్సు లను ఎన్నడూ విడిచిపెట్టవద్దు అంటారు.",
                        "description": [
                            {
                                "des": "త్యాజ్యం దోషవదిత్యేకే కర్మ ప్రాహుర్మనీషిణః ।"
                            },

                            {
                                "des": "యజ్ఞదానతపఃకర్మ న త్యాజ్యమితి చాపరే ।। 3 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "4 వ శ్లోకం",
                        "bhavam": "త్యాగము అన్న విషయముపై ఇక ఇప్పుడు నా తుది నిర్ణయమును వినుము, ఓ పురుషవ్యాఘ్రమా, త్యాగము అనేది మూడు విధములుగా ఉంటుంది అని చెప్పబడినది.",
                        "description": [
                            {
                                "des": "నిశ్చయం శృణు మే తత్ర త్యాగే భరతసత్తమ ।"
                            },
                            {
                                "des": "త్యాగో హి పురుషవ్యాఘ్ర త్రివిధః సంప్రకీర్తితః ।। 4 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "5 వ శ్లోకం",
                        "bhavam": "యజ్ఞము, దానము మరియు తపస్సుల సంబంధిత కర్మలను ఎప్పుడూ త్యజించరాదు; అవి తప్పకుండా చేయబడాలి. నిజానికి యజ్ఞము, దానము మరియు తపస్సు అనేవి బుద్ధిమంతులను కూడా పవిత్రం చేస్తాయి.",
                        "description": [
                            {
                                "des": "యజ్ఞదానతపఃకర్మ న త్యాజ్యం కార్యమేవ తత్ ।"
                            },
                            {
                                "des": "యజ్ఞో దానం తపశ్చైవ పావనాని మనీషిణామ్ ।। 5 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "6 వ శ్లోకం",
                        "bhavam": "ఫలములపై మమకారాసక్తి లేకుండా మరియు ప్రతిఫలాపేక్ష లేకుండా ఈ కార్యములు చేయబడాలి. ఇదే నా ఖచ్చితమైన మరియు సర్వోత్కృష్ట తీర్పు, ఓ అర్జునా.",
                        "description": [
                            {
                                "des": "ఏతాన్యపి తు కర్మాణి సంగం త్యక్త్వా ఫలాని చ ।"
                            },
                            {
                                "des": "కర్తవ్యానీతి మే పార్థ నిశ్చితం మతముత్తమమ్ ।। 6 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "7 వ శ్లోకం",
                        "bhavam": "విధింపబడిన కర్తవ్య కర్మలను ఎన్నటికీ త్యజించరాదు. ఇటువంటి అయోమయ త్యాగము తామసిక త్యాగము అని చెప్పబడును.",
                        "description": [
                            {
                                "des": "నియతస్య తు సన్న్యాసః కర్మణో నోపపద్యతే ।"
                            },
                            {
                                "des": "మోహాత్తస్య పరిత్యాగస్తామసః పరికీర్తితః ।। 7 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "8 వ శ్లోకం",
                        "bhavam": "విధిగా చేయవలసిన కర్తవ్య కర్మలను, అవి కష్టముగా ఉన్నాయని లేదా శారీరిక అసౌకర్యమును కలిగిస్తున్నాయని తలచి, వాటిని విడిచిపెట్టటాన్ని, రజో గుణ త్యాగము అంటారు. అటువంటి త్యాగము ఎప్పటికీ క్షేమదాయకమైనది కాదు మరియు మన ఉన్నతికి దోహదపడదు.",
                        "description": [
                            {
                                "des": "దుఃఖమిత్యేవ యత్కర్మ కాయక్లేశభయాత్యజేత్ ।"
                            },
                            {
                                "des": "స కృత్వా రాజసం త్యాగం నైవ త్యాగఫలం లభేత్ ।। 8 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "9 వ శ్లోకం",
                        "bhavam": "అర్జునా, కర్తవ్యమునకు అనుగుణముగా ఎప్పుడైతే కర్మలు చేయబడుతాయో, మరియు ఫలాపేక్ష త్యజించబడుతుందో, దానిని సత్త్వగుణ త్యాగము అంటారు.",
                        "description": [
                            {
                                "des": "కార్యమిత్యేవ యత్కర్మ నియతం క్రియతేఽర్జున ।"
                            },
                            {
                                "des": "సంగం త్యక్త్వా ఫలం చైవ స త్యాగః సాత్త్వికో మతః ।। 9 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "10 వ శ్లోకం",
                        "bhavam": "నచ్చని పనులు తప్పించుకోటానికి యత్నించకుండా లేదా ఇష్టమైన/అనుకూలమైన పనుల కోసం ఆశించకుండా ఉండే వారు నిజమైన త్యాగులు. వారు సత్త్వగుణ సంపన్నులు మరియు వారు ఎటువంటి సంశయములు లేనివారు.",
                        "description": [
                            {
                                "des": "న ద్వేష్ట్యకుశలం కర్మ కుశలే నానుషజ్జతే ।"
                            },

                            {
                                "des": "త్యాగీ సత్త్వసమావిష్టో మేధావీ ఛిన్నసంశయః ।। 10 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "11 వ శ్లోకం",
                        "bhavam": "దేహమును కలిగున్న ఏ జీవికి కూడా, కర్మలను పూర్తిగా త్యజించటం శక్యము కాదు. అందుకే, తన కర్మ ఫలములను త్యజించినవాడే నిజమైన త్యాగి అని చెప్పబడును.",
                        "description": [
                            {
                                "des": "న హి దేహభృతా శక్యం త్యక్తుం కర్మాణ్యశేషతః ।"
                            },
                            {
                                "des": "యస్తు కర్మఫలత్యాగీ స త్యాగీత్యభిధీయతే ।। 11 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "12 వ శ్లోకం",
                        "bhavam": "స్వప్రయోజనము పట్ల ఆసక్తితో ఉండేవారికి, మరణించిన పిదప కూడా, - సుఖము, దుఃఖము మరియు ఈ రెంటి మిశ్రమము - ఈ మూడు విధములుగా కర్మ ప్రతిఫలములు ఉండును. కానీ, కర్మఫల త్యాగము చేసిన వారికి అటువంటి ఫలములు ఈ లోకములో కానీ, పరలోకములో కానీ ఉండవు.",
                        "description": [
                            {
                                "des": "అనిష్టమిష్టం మిశ్రం చ త్రివిధం కర్మణః ఫలమ్ ।"
                            },
                            {
                                "des": "భవత్యత్యాగినాం ప్రేత్య న తు సన్న్యాసినాం క్వచిత్ ।। 12 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "13 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, ఏ కార్యము చేయబడాలన్నా వాటి వెనుక ఉన్న ఐదు కారకముల గురించి సాంఖ్య శాస్త్రము ప్రకారం ఏమి చెప్పారో ఇప్పుడు చెప్తాను వినుము, అది కర్మ ప్రతిచర్యలను ఎలా నిరోధించాలో వివరిస్తుంది.",
                        "description": [
                            {
                                "des": "పంచైతాని మహాబాహో కారణాని నిబోధ మే ।"
                            },
                            {
                                "des": "సాంఖ్యే కృతాంతే ప్రోక్తాని సిద్దయే సర్వకర్మణామ్  ।। 13 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "14 వ శ్లోకం",
                        "bhavam": "శరీరము, కర్త, వివిధ ఇంద్రియములు, వివిధ రకాల కృషి, దైవానుగ్రహము - ఇవే కర్మ యొక్క ఐదు అంగములు.",
                        "description": [
                            {
                                "des": "అధిష్ఠానం తథా కర్తా కరణం చ పృథగ్విధమ్ ।"
                            },
                            {
                                "des": "వివిధాశ్చ పృథక్ చేష్టా దైవం చైవాత్ర పంచమమ్ ।। 14 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "15-16 శ్లోకాలు",
                        "bhavam": "శరీరము, వాక్కు, మనస్సులచే ఏ కర్మ/కార్యము జరిగినా, అది మంచిదయినా లేదా చెడయినా, ఈ ఐదు దానికి కారకములు. ఇది అర్థం కాని వారు ఆత్మయే నిజమైన కర్త అనుకుంటారు. మలినబుద్ధి తో ఉన్న అటువంటివారు యదార్ధమును గ్రహింపలేరు.",
                        "description": [
                            {
                                "des": "శరీరవాఙ్మనోభిర్యత్ కర్మ ప్రారభతే నరః ।"
                            },
                            {
                                "des": "న్యాయ్యం వా విపరీతం వా పంచైతే తస్య హేతవః ।। 15 ।।"
                            },
                            {
                                "des": "తత్రైవం సతి కర్తారమ్ ఆత్మానం కేవలం తు యః ।"
                            },
                            {
                                "des": "పశ్యత్యకృతబుద్ధిత్వాత్ న స పశ్యతి దుర్మతిః ।। 16 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "17 వ శ్లోకం",
                        "bhavam": "కర్తృత్వ అహంకార భావమును (చేసేది నేనే అన్న భావమును) విడిచిపెట్టి, బుద్ధి మమకారాసక్తి రహితముగా ఉండే వారు, ప్రాణులను సంహరించినా సరే, వారు చంపినట్టు కాదు మరియు కర్మ బంధనములకు లోనుకారు.",
                        "description": [
                            {
                                "des": "యస్య నాహంకృతో భావో బుద్ధిర్యస్య న లిప్యతే ।"
                            },
                            {
                                "des": "హత్వాఽపి స ఇమాఁల్లోకాన్న హంతి న నిబధ్యతే ।। 17 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "18 వ శ్లోకం",
                        "bhavam": "జ్ఞానము, జ్ఞేయము (జ్ఞాన విషయము), జ్ఞానమును ఎఱింగినవాడు - ఇవి మూడు కర్మను ప్రేరేపించును. కరణము, క్రియ, కర్త, - ఈ మూడు కర్మ యొక్క అంగములు.",
                        "description": [
                            {
                                "des": "జ్ఞానం జ్ఞేయం పరిజ్ఞాతా త్రివిధా కర్మచోదనా ।"
                            },
                            {
                                "des": "కరణం కర్మ కర్తేతి త్రివిధః కర్మసంగ్రహః ।। 18 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "19 వ శ్లోకం",
                        "bhavam": "జ్ఞానము, కర్మ, మరియు కర్త - ఇవి ప్రకృతి త్రి-గుణముల పరముగా ఒక్కోటి మూడు రకాలుగా ఉంటాయని సాంఖ్య శాస్త్రము పేర్కొంటున్నది. నేను ఈ వ్యత్యాసాలు నీకు ఇప్పుడు చెప్తాను వినుము.",
                        "description": [
                            {
                                "des": "జ్ఞానం కర్మ చ కర్తా చ త్రిధైవ గుణభేదతః ।"
                            },
                            {
                                "des": "ప్రోచ్యతే గుణసంఖ్యానే యథావఛ్చృణు తాన్యపి ।। 19 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "20 వ శ్లోకం",
                        "bhavam": "సమస్త విభిన్నమైన జీవరాశులలో ఒకే అవిభక్తమైన అనశ్వరమైన ఒకే అస్థిత్వము ఉన్నట్టు తెలుసుకోనటమే సత్త్వ గుణము లో ఉన్న జ్ఞానము.",
                        "description": [
                            {
                                "des": "సర్వ భూతేశు యేనైకం భావమవ్యయమీక్షతే ।"
                            },
                            {
                                "des": "అవిభక్తం విభక్తేషు తత్ జ్ఞానం విద్ధి సాత్వికం ।। 20 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "21 వ శ్లోకం",
                        "bhavam": "ఏ జ్ఞానము చేతనయితే భిన్నభిన్న దేహములలో ఉన్న వివిధ రకముల ప్రాణులు వేర్వేరుగా, ఒకదానికొకటి సంబంధము లేనట్టుగా చూడబడుతాయో, ఆ జ్ఞానము రాజసికమని (రజోగుణములో ఉన్న) గ్రహించుము.",
                        "description": [
                            {
                                "des": "పృథక్త్వేన తు యత్ జ్ఞానం నానాభావాన్ పృథగ్విధాన్ ।"
                            },
                            {
                                "des": "వేత్తి సర్వేషు భూతేషు తత్ జ్ఞానం విద్ధి రాజసమ్ ।। 21 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "22 వ శ్లోకం",
                        "bhavam": "సంపూర్ణ సృష్టి అంతా ఈ భిన్నభిన్న భాగములే అన్న విషయంలో పూర్తిగా మనిషిని తనమునకలై పోయేట్టు చేసి, తర్కబద్ధముగా లేకుండా మరియు సత్య దూరముగా ఉండే జ్ఞానము, తామసిక జ్ఞానము అని చెప్పబడుతుంది.",
                        "description": [
                            {
                                "des": "యత్తు కృత్స్నవదేకస్మిన్ కార్యే సక్తమహైతుకమ్ ।"
                            },
                            {
                                "des": "అతత్త్వార్థవదల్పం చ తత్తామసముదాహృతమ్ ।। 22 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "23 వ శ్లోకం",
                        "bhavam": "ఏదైతే కర్మ - శాస్త్రబద్దముగా చేయబడినదో, రాగద్వేష రహితముగా ఉన్నదో, మరియు ఫలాపేక్ష లేకుండా చేయబడినదో, అది సత్త్వగుణములో ఉన్నట్టు అని చెప్పబడినది.",
                        "description": [
                            {
                                "des": "నియతం సంగరహితం అరాగద్వేషతః కృతమ్ ।"
                            },

                            {
                                "des": "అఫలప్రేప్సునా కర్మ యత్తత్ సాత్త్వికముచ్యతే ।। 23 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "24 వ శ్లోకం",
                        "bhavam": "స్వార్ధ కోరికచే ప్రేరేపితమై, అహంకారముచే చేయబడినట్టి, మరియు తీవ్ర ప్రయాసతో కూడిన పని రజోగుణములో ఉన్నదని చెప్పబడును.",
                        "description": [
                            {
                                "des": "యత్తు కామేప్సునా కర్మ సాహంకారేణ వా పునః ।"
                            },
                            {
                                "des": "క్రియతే బహుళాయాసం తద్రాజసముదాహృతమ్ ।। 24 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "25 వ శ్లోకం",
                        "bhavam": "మోహభ్రాంతి వల్ల ప్రారంభించి, తమ యొక్క స్వ-శక్తి ఏమిటో తెలుసుకోకుండా, మరియు పరిణామాలు, జరిగే నష్టము మరియు ఇతరులకు జరిగే హాని గురించి ఆలోచించకుండా - చేసే కర్మను తామసిక కర్మ అని అంటారు.",
                        "description": [
                            {
                                "des": "అనుబంధం క్షయం హింసామనపేక్ష్య చ పౌరుషమ్ ।"
                            },
                            {
                                "des": "మోహాదారభ్యతే కర్మ యత్తత్తామసముచ్యతే ।। 25 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "26 వ శ్లోకం",
                        "bhavam": "అహంకారము మరియు సంగ రహితముగా ఉన్నవారు, మరియు ఉత్సాహము, ధృడసంకల్పము కలవారు, జయాపజయముల పట్ల ఉదాసీనముగా ఉన్నవారు సత్త్వగుణ కర్తలు అని చెప్పబడ్డారు.",
                        "description": [
                            {
                                "des": "ముక్త సంగోఽనహంవాదీ ధృత్యుత్సాహసమన్వితః ।"
                            },
                            {
                                "des": "సిద్ద్యసిద్ధ్యోర్నిర్వికారః కర్తా సాత్విక ఉచ్యతే ।। 26 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "27 వ శ్లోకం",
                        "bhavam": "కర్మఫలముల పట్ల ఆసక్తి తో ఉంటూ, దురాశగలవాడై, హింసా-ప్రవృత్తి కలిగి, అపవిత్రతతో ఉండి, మరియు హర్ష-శోకములచే ప్రభావితమవుతూ ఉండే కర్త రజోగుణములో ఉన్నట్టు పరిగణించబడుతాడు.",
                        "description": [
                            {
                                "des": "రాగీ కర్మఫలప్రేప్సుః లుభ్ధో హింసాత్మకోఽశుచిః ।"
                            },
                            {
                                "des": "హర్షశోకాన్వితః కర్తా రాజసః పరికీర్తితః ।। 27 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "28 వ శ్లోకం",
                        "bhavam": "క్రమశిక్షణారాహిత్యంతో ఉన్నవారు, తుచ్చులు, మూర్ఖులు, ధూర్తులు, నీచులు, బద్దకస్తులు, నిరాశతో ఉండేవారు మరియు నిర్లక్ష్యంతో కాలవిలంబన చేసేవారిని - తమోగుణ కర్తలు అనవచ్చు.",
                        "description": [
                            {
                                "des": "అయుక్తః ప్రాకృతః స్తబ్ధః శఠో నైష్కృతికోఽలసః ।"
                            },
                            {
                                "des": "విషాదీ దీర్ఘసూత్రీ చ కర్తా తామస ఉచ్యతే ।। 28 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "29 వ శ్లోకం",
                        "bhavam": "ఇప్పుడు వినుము ఓ అర్జునా, ప్రకృతి త్రిగుణముల ప్రకారంగా బుద్ధి మరియు ధృతిల యందు భేదమును విస్తారముగా వివరిస్తాను.",
                        "description": [
                            {
                                "des": "బుద్ధేర్భేదం ధృతేశ్చైవ గుణతస్త్రివిధం శృణు ।"
                            },
                            {
                                "des": "ప్రోచ్యమానమశేషేణ పృథక్త్వేన ధనంజయ ।। 29 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "30 వ శ్లోకం",
                        "bhavam": "ఓ పార్థా, ఏది సరియైన పని, ఏది చెడు పని; ఏది కర్తవ్యము, ఏది కర్తవ్యము కాదు; దేనికి భయపడాలి, దేనికి భయపడనవసరం లేదు; ఏది బంధకారకము, ఏది మోక్షకారకము అని అర్థమైనప్పుడు బుద్ధి సత్త్వగుణములో ఉన్నది అని చెప్పబడును.",
                        "description": [
                            {
                                "des": " ప్రవృత్తిం చ నివృత్తిం చ కార్యాకార్యే భయాభయే ।"
                            },
                            {
                                "des": " బంధం మోక్షం చ యా వేత్తి బుద్దిః సా పార్థ సాత్త్వికీ ।। 30 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "31 వ శ్లోకం",
                        "bhavam": "ఎప్పుడైతే బుద్ధి ఏది ధర్మము ఏది అధర్మము అన్న అయోమయములో ఉంటుందో, ఏది సరియైన ప్రవర్తన ఏది తప్పుడు ప్రవర్తన తెలుసుకోలేకపోతుందో అప్పుడు ఆ బుద్ధి , రజోగుణములో ఉన్నట్టు.",
                        "description": [
                            {
                                "des": "యయా ధర్మమధర్మం చ కార్యం చాకార్యమేవ చ ।"
                            },
                            {
                                "des": "అయథావత్ప్రజానాతి బుద్ధిః సా పార్థ రాజసీ ।। 31 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "32 వ శ్లోకం",
                        "bhavam": "చీకటితో ఆవృత్తమై, అధర్మమునే ధర్మము అనుకుంటూ, అసత్యమును సత్యము అని భావిస్తూ ఉండే బుద్ధి తమోగుణ బుద్ధి.",
                        "description": [
                            {
                                "des": "అధర్మం ధర్మమితి యా మన్యతే తమసావృతా ।"
                            },
                            {
                                "des": "సర్వార్థాన్విపరీతాంశ్చ బుద్ధిః సా పార్థ తామసీ ।। 32 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "33 వ శ్లోకం",
                        "bhavam": "యోగము ద్వారా పెంపొందించుకున్న ధృడ చిత్త సంకల్పము; మరియు మనస్సు, ప్రాణ వాయువులు, ఇంద్రియముల యొక్క కార్యకలాపములకు ఆధారముగా ఉన్న సంకల్పాన్ని, సత్త్వ గుణ దృఢమనస్కత అంటారు.",
                        "description": [
                            {
                                "des": "ధృత్యా యయా ధారయతే మనఃప్రాణేంద్రియక్రియాః ।"
                            },
                            {
                                "des": " యోగేనావ్యభిచారిణ్యా ధృతిః సా పార్థ సాత్త్వికీ ।। 33 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "34 వ శ్లోకం",
                        "bhavam": "ఫలాపేక్షచే ప్రేరితమై ధర్మము (విధులు), కామము (సుఖములు) మరియు అర్థము(సంపద) పట్ల ఆసక్తితో ఉండే స్థిరచిత్తము రాజసిక ధృతి అని చెప్పబడును.",
                        "description": [
                            {
                                "des": "యయా తు ధర్మకామార్థాన్ ధృత్యా ధారయతేఽర్జున ।"
                            },
                            {
                                "des": "ప్రసంగేన ఫలాకాంక్షీ ధృతిః సా పార్థ రాజసీ  ।। 34 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "35 వ శ్లోకం",
                        "bhavam": "విడువకుండా, పగటికలలు కంటూ, భయపడుతూ, శోకిస్తూ, నిరాశకు లోనవుతూ మరియు దురహంకారముతో ఉండే అల్పబుద్ది సంకల్పమునే తమోగుణ ధృతి అంటారు.",
                        "description": [
                            {
                                "des": "యయా స్వప్నం భయం శోకం విషాదం మదమేవ చ ।"
                            },
                            {
                                "des": "న విముంచతి దుర్మేధా ధృతిః సా పార్థ తామసీ ।। 35 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "36 వ శ్లోకం",
                        "bhavam": "ఇక ఇప్పుడు నా నుండి వినుము, ఓ అర్జునా, జీవాత్మ రమించే మూడు విధముల సుఖముల గురించి, మరియు సర్వ దుఃఖముల నుండి విముక్తి దశ చేరటం గురించి.",
                        "description": [
                            {
                                "des": "సుఖం త్విదానీం త్రివిధం శృణు మే భరతర్షభ ।"
                            },
                            {
                                "des": "అభ్యాసాద్రమతే యత్ర దుఃఖాంతం చ నిగచ్ఛతి ।। 36 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "37 వ శ్లోకం",
                        "bhavam": "మొదట్లో విషంలా అనిపించినా, చివరికి అమృతం లాగా ఉండే సుఖమే సత్త్వ గుణ సుఖము. అది ఆత్మ-జ్ఞానం యందే స్థితమై ఉన్న స్వచ్ఛమైన బుద్ధిచే జనిస్తుంది.",
                        "description": [
                            {
                                "des": "యత్తదగ్రే విషమివ పరిణామేఽమృతోపమమ్ ।"
                            },
                            {
                                "des": "తత్సుఖం సాత్వికం ప్రోక్తమ్ ఆత్మబుద్ధిప్రసాదజమ్ ।। 37 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "38 వ శ్లోకం",
                        "bhavam": "ఇంద్రియములతో ఇంద్రియ వస్తువిషయముల సంపర్కముచేత కలిగిన సుఖమును రాజసిక (రజో గుణ) సుఖము అని అంటారు. ఈ సుఖానందము మొదట్లో అమృతంలా ఉన్నా చివరికి విషంలా ఉంటుంది.",
                        "description": [
                            {
                                "des": "విషయేంద్రియసంయోగాత్ యత్తదగ్రేఽమృతోపమమ్ ।"
                            },
                            {
                                "des": "పరిణామే విషమివ తత్సుఖం రాజసం స్మృతమ్ ।। 38 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "39 వ శ్లోకం",
                        "bhavam": "ఏదైతే ఆనందము - ఆత్మ యొక్క అస్థిత్వమును పూర్తిగా మొదలు నుండి చివర వరకు కప్పివేసి, మరియు నిద్ర, సోమరితనము, మరియు నిర్లక్ష్యము నుండి ఉద్భవించినదో - అది తామసిక (తమోగుణములో) ఆనందము అని చెప్పబడును.",
                        "description": [
                            {
                                "des": "యదగ్రే చానుబంధే చ సుఖం మోహనమాత్మనః ।"
                            },
                            {
                                "des": "నిద్రాలస్యప్రమాదోత్థం తత్తామసముదాహృతమ్ ।। 39 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "40 వ శ్లోకం",
                        "bhavam": "ఈ భౌతిక జగత్తు యందు - భూమిపై కానీ, లేదా, ఊర్ధ్వ స్వర్గాది లోకాలలో కానీ - ఏ ఒక్క ప్రాణి కూడా ఈ ప్రకృతి త్రిగుణముల ప్రభావానికి అతీతము కాదు.",
                        "description": [
                            {
                                "des": "న తదస్తి పృథివ్యాం వా దివి దేవేషు వా పునః ।"
                            },
                            {
                                "des": "సత్త్వం ప్రకృతిజైర్ముక్తం యదేభిః స్యాత్ త్రిభిర్గుణైః ।। 40 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "41 వ శ్లోకం",
                        "bhavam": "బ్రాహ్మణులు, క్షత్రియులు, వైశ్యులు మరియు శూద్రులు - వీరి యొక్క విధులు వారివారి లక్షణములకు అనుగుణంగా, వారి వారి గుణముల ప్రకారంగా కేటాయించబడినవి. (పుట్టుక పరంగా కాదు).",
                        "description": [
                            {
                                "des": "బ్రాహ్మణక్షత్రియవిశాం శూద్రాణాం చ పరంతప ।"
                            },
                            {
                                "des": "కర్మాణి ప్రవిభక్తాని స్వభావప్రభవైర్గుణైః ।। 41 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "42 వ శ్లోకం",
                        "bhavam": "శమము (ప్రశాంతత), దమము (ఇంద్రియ నిగ్రహణ), తపస్సు, స్వచ్చత, సహనం, చిత్తశుద్ధి, జ్ఞానము, విజ్ఞానము, మరియు ఇహపరలోకములపై విశ్వాసము - ఇవి బ్రాహ్మణుల సహజసిద్ధ స్వభావ కర్మ లక్షణములు.",
                        "description": [
                            {
                                "des": "శమో దమస్తపః శౌచం క్షాంతిరార్జవమేవ చ ।"
                            },
                            {
                                "des": "జ్ఞానం విజ్ఞానమాస్తిక్యం బ్రహ్మకర్మ స్వభావజమ్ ।। 42 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "43 వ శ్లోకం",
                        "bhavam": "శౌర్యము, బలము, ధైర్యము, ఆయుధ విద్యలో నైపుణ్యం, యుద్ధంలోనుండి వెనుతిరగని సంకల్పము, విశాల హృదయముతో గల దయాగుణము, మరియు నాయకత్వ సామర్ధ్యము - ఇవి క్షత్రియులకు సహజంగా ఉన్న కర్మ లక్షణములు.",
                        "description": [
                            {
                                "des": "శౌర్యం తేజో ధృతిర్దాక్ష్యం యుద్ధే చాప్యపలాయనమ్ ।"
                            },
                            {
                                "des": "దానమీశ్వరభావశ్చ క్షాత్రం కర్మ స్వభావజమ్ ।। 43 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "44 వ శ్లోకం",
                        "bhavam": "వ్యవసాయం, పాడిపంటలు, మరియు వర్తకవాణిజ్యాలు అనేవి వైశ్య గుణములు ఉన్నవారికి సహజ సిద్ధమైన పనులు. పనులు చేయటం ద్వారా సేవ చేయటం అనేది శూద్ర లక్షణములు కలవారి యొక్క సహజమైన విధి.",
                        "description": [
                            {
                                "des": "కృషిగౌరక్ష్యవాణిజ్యం వైశ్యకర్మస్వభావజమ్ ।"
                            },
                            {
                                "des": "పరిచర్యాత్మకం కర్మ శూద్రస్యాపి స్వభావజమ్ ।। 44 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "45 వ శ్లోకం",
                        "bhavam": "స్వభావసిద్ధ జనితమైన వారి వారి విధులను నిర్వర్తించటం ద్వారా, మానవులు పరిపూర్ణ సిద్ధిని సాధించవచ్చు. ఒక వ్యక్తి తనకు విధింపబడిన విధులను ఆచరిస్తూ/నిర్వర్తిస్తూ పరిపూర్ణత ను ఎలా సాధించగలడో ఇక ఇప్పుడు నానుండి వినుము.",
                        "description": [
                            {
                                "des": "స్వే స్వే కర్మణ్యభిరతః సంసిద్ధిం లభతే నరః ।"
                            },
                            {
                                "des": "స్వకర్మనిరతః సిద్ధిం యథా విందతి తత్ శృణు ।। 45 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "46 వ శ్లోకం",
                        "bhavam": "తన సహజస్వభావ వృత్తిని నిర్వర్తించటం ద్వారా వ్యక్తి - సమస్త భూతములూ ఎవని నుండి ఊద్భవించాయో మరియు ఎవ్వనిచే ఈ జగమంతా నిండి నిబిడీకృతమై ఉన్నదో - వానిని ఆరాధించినట్టు. ఇటువంటి పనులు చేయటం ద్వారా వ్యక్తి సునాయాసముగానే సిద్ధిని పొందుతాడు.",
                        "description": [
                            {
                                "des": "యతః ప్రవృత్తిర్భూతానాం యేన సర్వమిదం తతమ్ ।"
                            },
                            {
                                "des": "స్వకర్మణా తమభ్యర్చ్య సిద్ధిం విందతి మానవః ।। 46 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "47 వ శ్లోకం",
                        "bhavam": "పర (ఇతరుల) ధర్మము చేయుటకంటే, సరిగ్గా చేయలేకపోయినా సరే, తన స్వ-ధర్మము చేయుటయే వ్యక్తికి శ్రేష్ఠము. తన స్వభావ సిద్ధ విధులను చేయుటలో, వ్యక్తికి పాపము అంటదు.",
                        "description": [
                            {
                                "des": "శ్రేయాన్ స్వధర్మో విగుణః పరధర్మాత్ స్వనుష్ఠితాత్ ।"
                            },
                            {
                                "des": "స్వభావనియతం కర్మ కుర్వన్నాప్నోతి కిల్బిషమ్ ।। 47 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "48 వ శ్లోకం",
                        "bhavam": "తన సహజ సిద్ధ స్వభావంచే జనితమైన కర్తవ్యములను, వాటిలో దోషాలు ఉన్నాసరే ఎన్నటికీ విడిచిపెట్టరాదు, ఓ కుంతీ పుత్రా. అగ్ని పొగచే కప్పివేయబడ్డట్టు, సమస్త కర్మ ప్రయాసలూ, ఏదో ఒక దోషముచే ఆవరింపబడి ఉంటాయి.",
                        "description": [
                            {
                                "des": "సహజం కర్మ కౌంతేయ సదోషమపి న త్యజేత్ ।"
                            },
                            {
                                "des": "సర్వారంభా హి దోషేణ ధూమేనాగ్నిరివావృతాః ।। 48 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "49 వ శ్లోకం",
                        "bhavam": "ఎవరి బుద్ధి అంతటా అనాసక్తిగా ఉంటుందో, ఎవరు మనస్సుని జయించారో మరియు సన్న్యాస అభ్యాసముచే కోరికలను త్యజించారో, వారు శ్రేష్ఠమైన నైష్కర్మ్య సిద్ధిని పొందుతారు.",
                        "description": [
                            {
                                "des": "అసక్తబుద్ధిః సర్వత్ర జితాత్మా విగతస్పృహః ।"
                            },
                            {
                                "des": "నైష్కర్మ్యసిద్ధిం పరమాం సన్న్యాసేనాధిగచ్ఛతి ।। 49 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "50 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, పరిపూర్ణ సిద్ధిని (కర్మ సన్న్యాసములో) పొందిన వ్యక్తి, ఏ విధముగా, అలౌకిక ఆధ్యాత్మిక జ్ఞానము యందే స్థితమై ఉండటం ద్వారా, బ్రహ్మాం ను కూడా ఎలా పొందగలడో - వివరిస్తాను, నా నుండి క్లుప్తముగా వినుము.",
                        "description": [
                            {
                                "des": "సిద్ధిం ప్రాప్తో యథా బ్రహ్మ తథాప్నోతి నిబోధ మే ।"
                            },

                            {
                                "des": "సమాసేనైవ కౌంతేయ నిష్ఠా జ్ఞానస్య యా పరా ।। 50 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "51-53 శ్లోకాలు",
                        "bhavam": "వ్యక్తి ఎప్పుడైతే - పరిశుద్ధమైన బుద్ధి కలవాడు అగునో, మరియు ఇంద్రియములను చక్కగా నిగ్రహించి, శబ్దము మరియు ఇతర ఇంద్రియ విషయములను త్యజించి, రాగ ద్వేష రహితముగా ఉండునో, అప్పుడు బ్రహ్మంను పొందుటకు పాత్రుడగును. అటువంటి వ్యక్తి ఏకాంతమును ఇష్టపడుతాడు, మితంగా తింటాడు, శరీరమనోవాక్కులను నియంత్రిస్తాడు, నిత్యమూ ధ్యానములో నిమగ్నమౌతాడు మరియు వైరాగ్యమును అభ్యాసం చేస్తాడు. అహంకారము, హింస, దురభిమానము, కోరికలు, ఆస్తిపాస్తులు తనవే అన్న భావన, స్వార్ధము - లేకుండా ఉన్నటువంటి వ్యక్తి ప్రశాంతంగా ఉన్నవాడై, పరబ్రహం తో ఏకీభావ స్థితిని పొందుటకు అర్హుడవుతాడు. (అంటే, పరమ సత్యమును బ్రహ్మన్ రూపంలో తెలుసుకోవటం).",
                        "description": [
                            {
                                "des": "బుద్ధ్యా విశుద్దయా యుక్తో ధృత్యాత్మానం నియమ్య చ ।"
                            },
                            {
                                "des": "శబ్దాదీన్ విషయాన్ త్యక్త్వా రాగద్వేషౌ వ్యుదస్య చ ।। 51 ।।"
                            },
                            {
                                "des": "వివిక్తసేవీ లఘ్వాశీ యతవాక్కాయమానసః ।"
                            },
                            {
                                "des": "ధ్యానయోగపరో నిత్యం వైరాగ్యం సముపాశ్రితః ।। 52 ।।"
                            },
                            {
                                "des": "అహంకారం బలం దర్పం కామ క్రోధం పరిగ్రహమ్ ।"
                            },
                            {
                                "des": "విముచ్య నిర్మమః శాంతో బ్రహ్మభూయాయ కల్పతే ।। 53 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "54 వ శ్లోకం",
                        "bhavam": "పరబ్రహ్మాంతో ఏకీభావ స్థితిలో ఉన్న వ్యక్తి మానసికంగా ప్రశాంతచిత్తముతో ఉంటాడు, దేనికీ శోకింపడు, దేనినీ కాంక్షింపడు. సర్వ భూతముల పట్ల సమత్వ భావముతో ఉంటూ, అటువంటి యోగి నా పరాభక్తిని పొందును.",
                        "description": [
                            {
                                "des": "బ్రహ్మభూతః ప్రసన్నాత్మా న శోచతి న కాంక్షతి ।"
                            },
                            {
                                "des": "సమః సర్వేషు భూతేషు మద్భక్తిం లభతే పరామ్ ।। 54 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "55 వ శ్లోకం",
                        "bhavam": "కేవలం నా పట్ల ప్రేమ యుక్త భక్తి చేత మాత్రమే, యదార్ధముగా నేను ఎవరో (ఎంతటివాడినో) తెలుకోవచ్చును. నన్ను తెలుసుకున్న పిదప, నా భక్తుడు నా సంపూర్ణ భావనలో లీనమగును.",
                        "description": [
                            {
                                "des": "భక్త్యా మామభిజానాతి యావాన్యశ్చాస్మి తత్త్వతః ।"
                            },
                            {
                                "des": "తతో మాం తత్త్వతో జ్ఞాత్వా విశతే తదనంతరమ్ ।। 55 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "56 వ శ్లోకం",
                        "bhavam": "నా భక్తులు సర్వ కార్యములు చేస్తూనే ఉన్నా, నన్నే పూర్తిగా ఆశ్రయిస్తారు. నా కృపచే వారు నిత్యశాశ్వతమైన మరియు అనశ్వరమైన ధామమును పొందుతారు.",
                        "description": [
                            {
                                "des": "సర్వకర్మాణ్యపి సదా కుర్వాణో మద్వ్యపాశ్రయః ।"
                            },
                            {
                                "des": "మత్ప్రసాదాదవాప్నోతి శాశ్వతం పదమవ్యయమ్ ।। 56 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "57 వ శ్లోకం",
                        "bhavam": "నన్నే నీ యొక్క పరమ లక్ష్యముగా చేసుకుని, నీ యొక్క ప్రతి కర్మను నాకే సమర్పించుము. బుద్ధి యోగమును ఆశ్రయించి, నీ చిత్తమును నా యందే ఎల్లప్పుడూ లగ్నం చేయుము.",
                        "description": [
                            {
                                "des": "చేతసా సర్వకర్మాణి మయి సన్న్యస్య మత్పరః ।"
                            },
                            {
                                "des": "బుద్ధియోగముపాశ్రిత్య మచ్చిత్తః సతతం భవ ।। 57 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "58 వ శ్లోకం",
                        "bhavam": "నీవు ఎల్లప్పుడూ నన్నే స్మరిస్తూ ఉంటే, నా కృపచే అన్ని అడ్డంకులను మరియు కష్టాలను అధిగమించగలవు. కానీ ఒకవేళ, అహంకారముచే, నా సలహా వినకపోతే, నీవు నాశనమైపోతావు.",
                        "description": [
                            {
                                "des": "మచ్చిత్తః సర్వదుర్గాణి మత్ప్రసాదాత్ తరిష్యసి ।"
                            },
                            {
                                "des": "అథ చేత్ త్వమహంకారాత్ న శ్రోష్యసి వినంక్ష్యసి ।। 58 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "59 వ శ్లోకం",
                        "bhavam": "ఒకవేళ నీవు అహంకారముచే ప్రేరితమై , 'నేను యుద్ధం చేయను' అని అనుకుంటే, నీ నిర్ణయం ఎలాగూ వ్యర్ధమై పోతుంది. ఎందుకంటే, నీ యొక్క స్వంత (క్షత్రియ) భౌతిక స్వభావమే నిన్ను యుద్ధము చేయటానికి పురికొల్పుతుంది.",
                        "description": [
                            {
                                "des": "యదహంకారమాశ్రిత్య న యోత్స్య ఇతి మన్యసే ।"
                            },
                            {
                                "des": "మిథ్యైష వ్యవసాయస్తే ప్రకృతిస్త్వాం నియోక్ష్యతి ।। 59 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "60 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, మోహప్రభావముచే నీవు ఏదైతే పనిని చేయను అని అంటున్నావో, నీ యొక్క సహజసిద్ధ స్వభావముచే జనించిన ప్రేరణ చే, ఆ పనినే చేయటానికి ప్రేరేపింపబడుతావు.",
                        "description": [
                            {
                                "des": "స్వభావజేన కౌంతేయ నిబద్ధః స్వేన కర్మణా ।"
                            },
                            {
                                "des": "కర్తుం నేచ్ఛసి యన్మోహాత్ కరిష్యస్యవశోఽపి తత్ ।। 60 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "61 వ శ్లోకం",
                        "bhavam": "ఈశ్వరుడు సమస్త ప్రాణుల హృదయములో స్థితుడై ఉంటాడు, ఓ అర్జునా. భౌతిక శక్తిచే తయారు చేయబడిన యంత్రమును అధిరోహించి ఉన్న జీవాత్మల గతిని, వాటి వాటి కర్మల అనుగుణముగా, ఆయన నిర్దేశిస్తూ ఉంటాడు.",
                        "description": [
                            {
                                "des": "ఈశ్వరః సర్వభూతానాం హృద్దేశేఽర్జున తిష్ఠతి ।"
                            },
                            {
                                "des": "భ్రామయన్ సర్వభూతాని యంత్రారూఢాని మాయయా ।। 61 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "62 వ శ్లోకం",
                        "bhavam": "సంపూర్ణ హృదయ పూర్వకముగా కేవలం ఆయనకే అనన్య శరణాగతి చేయుము, ఓ భరతా. ఆయన కృపచే, నీవు పరమ శాంతిని మరియు నిత్యశాశ్వత ధామమును పొందెదవు.",
                        "description": [
                            {
                                "des": "తమేవ శరణం గచ్ఛ సర్వభావేన భారత ।"
                            },
                            {
                                "des": "తత్ప్రసాదాత్పరాం శాంతిం స్థానం ప్రాప్స్యసి శాశ్వతమ్ ।। 62 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "63 వ శ్లోకం",
                        "bhavam": "ఈ విధంగా నేను నీకు అన్ని రహస్యాలకన్నా పరమ రహస్యమైన జ్ఞానమును తెలియచేసాను. దీనిపై లోతుగా ఆలోచించుము, మరియు నీకు నచ్చిన రీతిలో చేయుము.",
                        "description": [
                            {
                                "des": "ఇతి తే జ్ఞానమాఖ్యాతం గుహ్యాద్గుహ్యతరం మయా ।"
                            },

                            {
                                "des": "విమృశ్యైతదశేషేణ యథేచ్ఛసి తథా కురు ।। 63 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "64 వ శ్లోకం",
                        "bhavam": "నా యొక్క సర్వోత్కృష్ట ఉపదేశమును మళ్ళీ ఒకసారి వినుము, అది సమస్త జ్ఞానములో కెల్లా అత్యంత గోప్యమైనది. నీ హితము కోరి దీనిని తెలియచేస్తున్నాను, ఎందుకంటే నీవు నాకు చాలా ప్రియమైనవాడివి కాబట్టి.",
                        "description": [
                            {
                                "des": "సర్వగుహ్యతమం భూయః శృణు మే పరమం వచః ।"
                            },
                            {
                                "des": "ఇష్టోఽసి మే ధృఢమితి తతో వక్ష్యామి తే హితమ్  ।। 64 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "65 వ శ్లోకం",
                        "bhavam": "ఎల్లప్పుడూ నన్నే స్మరించుము, నా పట్ల భక్తితో ఉండుము, నన్ను పూజించుము మరియు నాకు నమస్కరించుము. ఇలా చేయటం వలన నీవు తప్పకుండా నన్నే చేరుకుందువు. నేను నీకిచ్చే వాగ్దానం ఇది, ఎందుకంటే నీవు నాకు చాలా ప్రియమైనవాడివి.",
                        "description": [
                            {
                                "des": "మన్మనా భవ మద్భక్తో మద్యాజీ మాం నమస్కురు ।"
                            },
                            {
                                "des": "మామేవైష్యసి సత్యం తే ప్రతిజానే ప్రియోఽసి మే ।। 65 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "66 వ శ్లోకం",
                        "bhavam": "అన్ని విధములైన ధర్మములనూ విడిచిపెట్టి, కేవలం నాకే శరణాగతి చేయుము. నేను నిన్ను అన్ని పాపములనుండి విముక్తి చేసెదను, భయపడకుము.",
                        "description": [
                            {
                                "des": "సర్వధర్మాన్ పరిత్యజ్య మామేకం శరణం వ్రజ ।"
                            },
                            {
                                "des": "అహం త్వాం సర్వపాపేభ్యో మోక్షయిష్యామి మా శుచః ।। 66 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "67 వ శ్లోకం",
                        "bhavam": "ఈ ఉపదేశాన్ని ఎప్పుడూ కూడా తపస్సంపన్నుడు కాని వానికి, భక్తి లేని వానికి చెప్పకూడదు. (ఆధ్యాత్మిక విషయములు) వినటం పట్ల ఏవగింపు కలవారికి కూడా దీనిని చెప్పకూడదు, మరియు ప్రత్యేకంగా నాపట్ల అసూయ కలవారికి కూడా దీనిని చెప్పకూడదు",
                        "description": [
                            {
                                "des": "ఇదం తే నాతపస్కాయ నాభక్తాయ కదాచన ।"
                            },
                            {
                                "des": "న చాశుశ్రూషవే వాచ్యం న చ మాం యోఽభ్యసూయతి ।। 67 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "68 వ శ్లోకం",
                        "bhavam": "ఎవరైతే ఈ పరమ గోప్యమైన జ్ఞానమును నా భక్తులలో ఉపదేశిస్తారో, వారు మహోన్నత ప్రేమయుక్త సేవను చేసినట్టు. వారు నిస్సందేహముగా నన్నే చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "య ఇదం పరమం గుహ్యం మద్భక్తేష్వభిధాస్యతి ।"
                            },
                            {
                                "des": "భక్తిం మయి పరాం కృత్వా మామేవైష్యత్యసంశయః ।। 68 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "69 వ శ్లోకం",
                        "bhavam": "వారి కంటే ఎక్కువ ప్రేమయుక్త సేవ నాకు ఎవరూ చేసినట్టు కాదు; వారి కంటే ఎక్కువ ప్రియమైన వారు నాకు ఈ భూమిపై ఎవరూ ఉండబోరు.",
                        "description": [
                            {
                                "des": "న చ తస్మాన్మనుష్యేషు కశ్చిన్మే ప్రియకృత్తమః ।"
                            },
                            {
                                "des": "భవితా న చ మే తస్మాదన్యః ప్రియతరో భువి ।। 69 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "70 వ శ్లోకం",
                        "bhavam": "మన మధ్య జరిగిన ఈ పవిత్ర సంవాదమును పఠించేవారు, జ్ఞాన యజ్ఞముచే (తమ బుద్ధిచే) నన్ను ఆరాధించినట్టు; అని నా అభిప్రాయము.",
                        "description": [
                            {
                                "des": "అధ్యేష్యతే చ య ఇమం ధర్మ్యం సంవాదమావయోః ।"
                            },
                            {
                                "des": "జ్ఞానయజ్ఞేన తేనాహమిష్టః స్యామితి మే మతిః ।। 70 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "71 వ శ్లోకం",
                        "bhavam": "శ్రద్ధా విశ్వాసముతో, అసూయ లేకుండా, ఈ జ్ఞానాన్ని కేవలం విన్న వారు కూడా పాపముల నుండి విముక్తి పొంది, పుణ్యాత్ములు నివసించే పవిత్ర లోకములకు చేరుకుంటారు.",
                        "description": [
                            {
                                "des": "శ్రద్ధావాననసూయశ్చ శృణుయాదపి యో నరః ।"
                            },
                            {
                                "des": "సోఽపి ముక్తః శుభాల్లోకాన్ ప్ర్రాప్నుయాత్ పుణ్యకర్మణామ్ ।। 71 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "72 వ శ్లోకం",
                        "bhavam": "ఓ అర్జునా, నేను చెప్పినది ఏకాగ్రత తో విన్నావా? నీ యొక్క అజ్ఞానము, మోహభ్రాంతి నిర్మూలించబడినవా?",
                        "description": [
                            {
                                "des": "కచ్చిదేతఛ్చ్రుతం పార్థ త్వయైకాగ్రేణ చేతసా ।"
                            },
                            {
                                "des": "కచ్చిదజ్ఞానసమ్మోహః ప్రణష్టస్తే ధనంజయ ।। 72 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "73 వ శ్లోకం",
                        "bhavam": "అర్జునుడు పలికెను : ఓ అచ్యుతా (దోషరహితుడా), నీ కృపచే నా యొక్క మోహభ్రాంతి నిర్మూలించబడినది, మరియు నేను జ్ఞానములో స్థితుడనై ఉన్నాను. నాకు ఇప్పుడు సందేహాలు ఏవీ లేవు, మరియు నీ ఉపదేశాల ప్రకారం చేస్తాను.",
                        "description": [
                            {
                                "des": "అర్జున ఉవాచ ।"
                            },
                            {
                                "des": "నష్టో మోహః స్మృతిర్లబ్ధా త్వత్ప్రసాదాన్మయాచ్యుత ।"
                            },
                            {
                                "des": "స్థితోఽస్మి గతసందేహః కరిష్యే వచనం తవ ।। 73 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "74 వ శ్లోకం",
                        "bhavam": "సంజయుడు పలికెను: ఈ విధంగా, నేను, వాసుదేవుని పుత్రుడు శ్రీ కృష్ణుడికి మరియు మహాత్ముడు, ప్రిథ పుత్రుడూ అయిన అర్జునుడికి మధ్య జరిగిన సంవాదమును విన్నాను. ఇది ఎంత అద్భుతమైనది అంటే నా రోమములు నిక్కబొడుచుకుంటున్నాయి.",
                        "description": [
                            {
                                "des": "సంజయ ఉవాచ ।"
                            },
                            {
                                "des": "ఇత్యహం వాసుదేవస్య పార్థస్య చ మహాత్మనః ।"
                            },
                            {
                                "des": "సంవాదమిమమశ్రౌషమ్ అద్భుతం రోమహర్షణమ్ ।। 74 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "75 వ శ్లోకం",
                        "bhavam": "వేదవ్యాసుని అనుగ్రహం చేత, నేను ఈ యొక్క సర్వోత్కృష్ట పరమ రహస్యమైన యోగమును, స్వయంగా యోగేశ్వరుడైన శ్రీ కృష్ణుడి నుండి తెలుసుకున్నాను.",
                        "description": [
                            {
                                "des": "వ్యాసప్రసాదాఛ్చ్రుతవాన్ ఏతద్గుహ్యమహం పరమ్ ।"
                            },
                            {
                                "des": "యోగం యోగేశ్వరాత్ కృష్ణాత్ సాక్షాత్ కథయతః స్వయమ్ ।। 75 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "76 వ శ్లోకం",
                        "bhavam": "సర్వోత్కృష్ట శ్రీ కృష్ణ భగవానునకు మరియు అర్జునుడికి మధ్య జరిగిన ఈ మహాద్భుతమైన సంవాదమును పదేపదే గుర్తుచేసుకుంటూ నేను మళ్ళీ మళ్ళీ ఆనందిస్తున్నాను",
                        "description": [
                            {
                                "des": "రాజన్ సంస్మృత్య సంస్మృత్య సంవాదమిమమద్భుతమ్ ।"
                            },
                            {
                                "des": "కేశవార్జునయోః పుణ్యం హృష్యామి చ ముహుర్ముహుః ।। 76 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "77 వ శ్లోకం",
                        "bhavam": "మరియు, శ్రీ కృష్ణుడి అత్యద్భుతమైన మరియు ఆశ్చర్యకరమైన విశ్వ రూపమును గుర్తుచేసుకుంటూ, ఆశ్చర్యచకితుడినై, పదేపదే మహదానందముతో పులకించిపోతున్నాను.",
                        "description": [
                            {
                                "des": "తచ్చ సంస్మృత్య సంస్మృత్య రూపమత్యద్భుతం హరేః ।"
                            },
                            {
                                "des": "విస్మయో మే మహాన్ రాజన్ హృష్యామి చ పునఃపునః ।। 77 ।।"
                            }
                        ]
                    },
                    {
                        "slokam": "78 వ శ్లోకం",
                        "bhavam": "ఎక్కడెక్కడైతే యోగేశ్వరుడైన శ్రీ కృష్ణుడు మరియు అత్యున్నత విలుకాడైన అర్జునుడు ఉంటారో, అక్కడ సకల ఐశ్వర్యము, సర్వ విజయము, సకల-సమృద్ధి మరియు ధర్మమూ ఉంటాయి - అని నా నిశ్చిత అభిప్రాయము.",
                        "description": [
                            {
                                "des": "యత్ర యోగేశ్వరః కృష్ణో యత్ర పార్థో ధనుర్ధరః ।"
                            },
                            {
                                "des": " తత్ర శ్రీర్విజయో భూతిః ధ్రువా నీతిర్మతిర్మమ ।। 78 ।।"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export default slokas;
